window.slate = window.slate || {};
window.theme = window.theme || {};

/*!
 * modernizr.min.js
 */
/*! modernizr 3.3.1 (Custom Build) | MIT *
 * https://modernizr.com/download/?-csstransforms-csstransforms3d-flexbox-placeholder-svg-touchevents-domprefixes-prefixes-setclasses-testallprops-testprop-teststyles !*/
!function(e,t,n){function r(e,t){return typeof e===t}function s(){var e,t,n,s,o,i,a;for(var f in w)if(w.hasOwnProperty(f)){if(e=[],t=w[f],t.name&&(e.push(t.name.toLowerCase()),t.options&&t.options.aliases&&t.options.aliases.length))for(n=0;n<t.options.aliases.length;n++)e.push(t.options.aliases[n].toLowerCase());for(s=r(t.fn,"function")?t.fn():t.fn,o=0;o<e.length;o++)i=e[o],a=i.split("."),1===a.length?Modernizr[a[0]]=s:(!Modernizr[a[0]]||Modernizr[a[0]]instanceof Boolean||(Modernizr[a[0]]=new Boolean(Modernizr[a[0]])),Modernizr[a[0]][a[1]]=s),y.push((s?"":"no-")+a.join("-"))}}function o(e){var t=S.className,n=Modernizr._config.classPrefix||"";if(_&&(t=t.baseVal),Modernizr._config.enableJSClass){var r=new RegExp("(^|\\s)"+n+"no-js(\\s|$)");t=t.replace(r,"$1"+n+"js$2")}Modernizr._config.enableClasses&&(t+=" "+n+e.join(" "+n),_?S.className.baseVal=t:S.className=t)}function i(){return"function"!=typeof t.createElement?t.createElement(arguments[0]):_?t.createElementNS.call(t,"http://www.w3.org/2000/svg",arguments[0]):t.createElement.apply(t,arguments)}function a(e,t){return!!~(""+e).indexOf(t)}function f(e){return e.replace(/([a-z])-([a-z])/g,function(e,t,n){return t+n.toUpperCase()}).replace(/^-/,"")}function l(){var e=t.body;return e||(e=i(_?"svg":"body"),e.fake=!0),e}function u(e,n,r,s){var o,a,f,u,d="modernizr",p=i("div"),c=l();if(parseInt(r,10))for(;r--;)f=i("div"),f.id=s?s[r]:d+(r+1),p.appendChild(f);return o=i("style"),o.type="text/css",o.id="s"+d,(c.fake?c:p).appendChild(o),c.appendChild(p),o.styleSheet?o.styleSheet.cssText=e:o.appendChild(t.createTextNode(e)),p.id=d,c.fake&&(c.style.background="",c.style.overflow="hidden",u=S.style.overflow,S.style.overflow="hidden",S.appendChild(c)),a=n(p,e),c.fake?(c.parentNode.removeChild(c),S.style.overflow=u,S.offsetHeight):p.parentNode.removeChild(p),!!a}function d(e,t){return function(){return e.apply(t,arguments)}}function p(e,t,n){var s;for(var o in e)if(e[o]in t)return n===!1?e[o]:(s=t[e[o]],r(s,"function")?d(s,n||t):s);return!1}function c(e){return e.replace(/([A-Z])/g,function(e,t){return"-"+t.toLowerCase()}).replace(/^ms-/,"-ms-")}function m(t,r){var s=t.length;if("CSS"in e&&"supports"in e.CSS){for(;s--;)if(e.CSS.supports(c(t[s]),r))return!0;return!1}if("CSSSupportsRule"in e){for(var o=[];s--;)o.push("("+c(t[s])+":"+r+")");return o=o.join(" or "),u("@supports ("+o+") { #modernizr { position: absolute; } }",function(e){return"absolute"==getComputedStyle(e,null).position})}return n}function h(e,t,s,o){function l(){d&&(delete k.style,delete k.modElem)}if(o=r(o,"undefined")?!1:o,!r(s,"undefined")){var u=m(e,s);if(!r(u,"undefined"))return u}for(var d,p,c,h,v,g=["modernizr","tspan","samp"];!k.style&&g.length;)d=!0,k.modElem=i(g.shift()),k.style=k.modElem.style;for(c=e.length,p=0;c>p;p++)if(h=e[p],v=k.style[h],a(h,"-")&&(h=f(h)),k.style[h]!==n){if(o||r(s,"undefined"))return l(),"pfx"==t?h:!0;try{k.style[h]=s}catch(y){}if(k.style[h]!=v)return l(),"pfx"==t?h:!0}return l(),!1}function v(e,t,n,s,o){var i=e.charAt(0).toUpperCase()+e.slice(1),a=(e+" "+E.join(i+" ")+i).split(" ");return r(t,"string")||r(t,"undefined")?h(a,t,s,o):(a=(e+" "+T.join(i+" ")+i).split(" "),p(a,t,n))}function g(e,t,r){return v(e,n,n,t,r)}var y=[],w=[],x={_version:"3.3.1",_config:{classPrefix:"",enableClasses:!0,enableJSClass:!0,usePrefixes:!0},_q:[],on:function(e,t){var n=this;setTimeout(function(){t(n[e])},0)},addTest:function(e,t,n){w.push({name:e,fn:t,options:n})},addAsyncTest:function(e){w.push({name:null,fn:e})}},Modernizr=function(){};Modernizr.prototype=x,Modernizr=new Modernizr,Modernizr.addTest("svg",!!t.createElementNS&&!!t.createElementNS("http://www.w3.org/2000/svg","svg").createSVGRect);var C=x._config.usePrefixes?" -webkit- -moz- -o- -ms- ".split(" "):["",""];x._prefixes=C;var S=t.documentElement,_="svg"===S.nodeName.toLowerCase(),b="Moz O ms Webkit",T=x._config.usePrefixes?b.toLowerCase().split(" "):[];x._domPrefixes=T;var z="CSS"in e&&"supports"in e.CSS,P="supportsCSS"in e;Modernizr.addTest("supports",z||P),Modernizr.addTest("placeholder","placeholder"in i("input")&&"placeholder"in i("textarea"));var E=x._config.usePrefixes?b.split(" "):[];x._cssomPrefixes=E;var N=x.testStyles=u;Modernizr.addTest("touchevents",function(){var n;if("ontouchstart"in e||e.DocumentTouch&&t instanceof DocumentTouch)n=!0;else{var r=["@media (",C.join("touch-enabled),("),"heartz",")","{#modernizr{top:9px;position:absolute}}"].join("");N(r,function(e){n=9===e.offsetTop})}return n});var j={elem:i("modernizr")};Modernizr._q.push(function(){delete j.elem});var k={style:j.elem.style};Modernizr._q.unshift(function(){delete k.style});x.testProp=function(e,t,r){return h([e],n,t,r)};x.testAllProps=v,x.testAllProps=g,Modernizr.addTest("csstransforms",function(){return-1===navigator.userAgent.indexOf("Android 2.")&&g("transform","scale(1)",!0)}),Modernizr.addTest("csstransforms3d",function(){var e=!!g("perspective","1px",!0),t=Modernizr._config.usePrefixes;if(e&&(!t||"webkitPerspective"in S.style)){var n,r="#modernizr{width:0;height:0}";Modernizr.supports?n="@supports (perspective: 1px)":(n="@media (transform-3d)",t&&(n+=",(-webkit-transform-3d)")),n+="{#modernizr{width:7px;height:18px;margin:0;padding:0;border:0}}",N(r+n,function(t){e=7===t.offsetWidth&&18===t.offsetHeight})}return e}),Modernizr.addTest("flexbox",g("flexBasis","1px",!0)),s(),o(y),delete x.addTest,delete x.addAsyncTest;for(var A=0;A<Modernizr._q.length;A++)Modernizr._q[A]();e.Modernizr=Modernizr}(window,document);


/*!
 * jquery-2.2.3.min.js
 */
/*! jQuery v2.2.3 | (c) jQuery Foundation | jquery.org/license */
!function(a,b){"object"==typeof module&&"object"==typeof module.exports?module.exports=a.document?b(a,!0):function(a){if(!a.document)throw new Error("jQuery requires a window with a document");return b(a)}:b(a)}("undefined"!=typeof window?window:this,function(a,b){var c=[],d=a.document,e=c.slice,f=c.concat,g=c.push,h=c.indexOf,i={},j=i.toString,k=i.hasOwnProperty,l={},m="2.2.3",n=function(a,b){return new n.fn.init(a,b)},o=/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g,p=/^-ms-/,q=/-([\da-z])/gi,r=function(a,b){return b.toUpperCase()};n.fn=n.prototype={jquery:m,constructor:n,selector:"",length:0,toArray:function(){return e.call(this)},get:function(a){return null!=a?0>a?this[a+this.length]:this[a]:e.call(this)},pushStack:function(a){var b=n.merge(this.constructor(),a);return b.prevObject=this,b.context=this.context,b},each:function(a){return n.each(this,a)},map:function(a){return this.pushStack(n.map(this,function(b,c){return a.call(b,c,b)}))},slice:function(){return this.pushStack(e.apply(this,arguments))},first:function(){return this.eq(0)},last:function(){return this.eq(-1)},eq:function(a){var b=this.length,c=+a+(0>a?b:0);return this.pushStack(c>=0&&b>c?[this[c]]:[])},end:function(){return this.prevObject||this.constructor()},push:g,sort:c.sort,splice:c.splice},n.extend=n.fn.extend=function(){var a,b,c,d,e,f,g=arguments[0]||{},h=1,i=arguments.length,j=!1;for("boolean"==typeof g&&(j=g,g=arguments[h]||{},h++),"object"==typeof g||n.isFunction(g)||(g={}),h===i&&(g=this,h--);i>h;h++)if(null!=(a=arguments[h]))for(b in a)c=g[b],d=a[b],g!==d&&(j&&d&&(n.isPlainObject(d)||(e=n.isArray(d)))?(e?(e=!1,f=c&&n.isArray(c)?c:[]):f=c&&n.isPlainObject(c)?c:{},g[b]=n.extend(j,f,d)):void 0!==d&&(g[b]=d));return g},n.extend({expando:"jQuery"+(m+Math.random()).replace(/\D/g,""),isReady:!0,error:function(a){throw new Error(a)},noop:function(){},isFunction:function(a){return"function"===n.type(a)},isArray:Array.isArray,isWindow:function(a){return null!=a&&a===a.window},isNumeric:function(a){var b=a&&a.toString();return!n.isArray(a)&&b-parseFloat(b)+1>=0},isPlainObject:function(a){var b;if("object"!==n.type(a)||a.nodeType||n.isWindow(a))return!1;if(a.constructor&&!k.call(a,"constructor")&&!k.call(a.constructor.prototype||{},"isPrototypeOf"))return!1;for(b in a);return void 0===b||k.call(a,b)},isEmptyObject:function(a){var b;for(b in a)return!1;return!0},type:function(a){return null==a?a+"":"object"==typeof a||"function"==typeof a?i[j.call(a)]||"object":typeof a},globalEval:function(a){var b,c=eval;a=n.trim(a),a&&(1===a.indexOf("use strict")?(b=d.createElement("script"),b.text=a,d.head.appendChild(b).parentNode.removeChild(b)):c(a))},camelCase:function(a){return a.replace(p,"ms-").replace(q,r)},nodeName:function(a,b){return a.nodeName&&a.nodeName.toLowerCase()===b.toLowerCase()},each:function(a,b){var c,d=0;if(s(a)){for(c=a.length;c>d;d++)if(b.call(a[d],d,a[d])===!1)break}else for(d in a)if(b.call(a[d],d,a[d])===!1)break;return a},trim:function(a){return null==a?"":(a+"").replace(o,"")},makeArray:function(a,b){var c=b||[];return null!=a&&(s(Object(a))?n.merge(c,"string"==typeof a?[a]:a):g.call(c,a)),c},inArray:function(a,b,c){return null==b?-1:h.call(b,a,c)},merge:function(a,b){for(var c=+b.length,d=0,e=a.length;c>d;d++)a[e++]=b[d];return a.length=e,a},grep:function(a,b,c){for(var d,e=[],f=0,g=a.length,h=!c;g>f;f++)d=!b(a[f],f),d!==h&&e.push(a[f]);return e},map:function(a,b,c){var d,e,g=0,h=[];if(s(a))for(d=a.length;d>g;g++)e=b(a[g],g,c),null!=e&&h.push(e);else for(g in a)e=b(a[g],g,c),null!=e&&h.push(e);return f.apply([],h)},guid:1,proxy:function(a,b){var c,d,f;return"string"==typeof b&&(c=a[b],b=a,a=c),n.isFunction(a)?(d=e.call(arguments,2),f=function(){return a.apply(b||this,d.concat(e.call(arguments)))},f.guid=a.guid=a.guid||n.guid++,f):void 0},now:Date.now,support:l}),"function"==typeof Symbol&&(n.fn[Symbol.iterator]=c[Symbol.iterator]),n.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "),function(a,b){i["[object "+b+"]"]=b.toLowerCase()});function s(a){var b=!!a&&"length"in a&&a.length,c=n.type(a);return"function"===c||n.isWindow(a)?!1:"array"===c||0===b||"number"==typeof b&&b>0&&b-1 in a}var t=function(a){var b,c,d,e,f,g,h,i,j,k,l,m,n,o,p,q,r,s,t,u="sizzle"+1*new Date,v=a.document,w=0,x=0,y=ga(),z=ga(),A=ga(),B=function(a,b){return a===b&&(l=!0),0},C=1<<31,D={}.hasOwnProperty,E=[],F=E.pop,G=E.push,H=E.push,I=E.slice,J=function(a,b){for(var c=0,d=a.length;d>c;c++)if(a[c]===b)return c;return-1},K="checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",L="[\\x20\\t\\r\\n\\f]",M="(?:\\\\.|[\\w-]|[^\\x00-\\xa0])+",N="\\["+L+"*("+M+")(?:"+L+"*([*^$|!~]?=)"+L+"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|("+M+"))|)"+L+"*\\]",O=":("+M+")(?:\\((('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|((?:\\\\.|[^\\\\()[\\]]|"+N+")*)|.*)\\)|)",P=new RegExp(L+"+","g"),Q=new RegExp("^"+L+"+|((?:^|[^\\\\])(?:\\\\.)*)"+L+"+$","g"),R=new RegExp("^"+L+"*,"+L+"*"),S=new RegExp("^"+L+"*([>+~]|"+L+")"+L+"*"),T=new RegExp("="+L+"*([^\\]'\"]*?)"+L+"*\\]","g"),U=new RegExp(O),V=new RegExp("^"+M+"$"),W={ID:new RegExp("^#("+M+")"),CLASS:new RegExp("^\\.("+M+")"),TAG:new RegExp("^("+M+"|[*])"),ATTR:new RegExp("^"+N),PSEUDO:new RegExp("^"+O),CHILD:new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\("+L+"*(even|odd|(([+-]|)(\\d*)n|)"+L+"*(?:([+-]|)"+L+"*(\\d+)|))"+L+"*\\)|)","i"),bool:new RegExp("^(?:"+K+")$","i"),needsContext:new RegExp("^"+L+"*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\("+L+"*((?:-\\d)?\\d*)"+L+"*\\)|)(?=[^-]|$)","i")},X=/^(?:input|select|textarea|button)$/i,Y=/^h\d$/i,Z=/^[^{]+\{\s*\[native \w/,$=/^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,_=/[+~]/,aa=/'|\\/g,ba=new RegExp("\\\\([\\da-f]{1,6}"+L+"?|("+L+")|.)","ig"),ca=function(a,b,c){var d="0x"+b-65536;return d!==d||c?b:0>d?String.fromCharCode(d+65536):String.fromCharCode(d>>10|55296,1023&d|56320)},da=function(){m()};try{H.apply(E=I.call(v.childNodes),v.childNodes),E[v.childNodes.length].nodeType}catch(ea){H={apply:E.length?function(a,b){G.apply(a,I.call(b))}:function(a,b){var c=a.length,d=0;while(a[c++]=b[d++]);a.length=c-1}}}function fa(a,b,d,e){var f,h,j,k,l,o,r,s,w=b&&b.ownerDocument,x=b?b.nodeType:9;if(d=d||[],"string"!=typeof a||!a||1!==x&&9!==x&&11!==x)return d;if(!e&&((b?b.ownerDocument||b:v)!==n&&m(b),b=b||n,p)){if(11!==x&&(o=$.exec(a)))if(f=o[1]){if(9===x){if(!(j=b.getElementById(f)))return d;if(j.id===f)return d.push(j),d}else if(w&&(j=w.getElementById(f))&&t(b,j)&&j.id===f)return d.push(j),d}else{if(o[2])return H.apply(d,b.getElementsByTagName(a)),d;if((f=o[3])&&c.getElementsByClassName&&b.getElementsByClassName)return H.apply(d,b.getElementsByClassName(f)),d}if(c.qsa&&!A[a+" "]&&(!q||!q.test(a))){if(1!==x)w=b,s=a;else if("object"!==b.nodeName.toLowerCase()){(k=b.getAttribute("id"))?k=k.replace(aa,"\\$&"):b.setAttribute("id",k=u),r=g(a),h=r.length,l=V.test(k)?"#"+k:"[id='"+k+"']";while(h--)r[h]=l+" "+qa(r[h]);s=r.join(","),w=_.test(a)&&oa(b.parentNode)||b}if(s)try{return H.apply(d,w.querySelectorAll(s)),d}catch(y){}finally{k===u&&b.removeAttribute("id")}}}return i(a.replace(Q,"$1"),b,d,e)}function ga(){var a=[];function b(c,e){return a.push(c+" ")>d.cacheLength&&delete b[a.shift()],b[c+" "]=e}return b}function ha(a){return a[u]=!0,a}function ia(a){var b=n.createElement("div");try{return!!a(b)}catch(c){return!1}finally{b.parentNode&&b.parentNode.removeChild(b),b=null}}function ja(a,b){var c=a.split("|"),e=c.length;while(e--)d.attrHandle[c[e]]=b}function ka(a,b){var c=b&&a,d=c&&1===a.nodeType&&1===b.nodeType&&(~b.sourceIndex||C)-(~a.sourceIndex||C);if(d)return d;if(c)while(c=c.nextSibling)if(c===b)return-1;return a?1:-1}function la(a){return function(b){var c=b.nodeName.toLowerCase();return"input"===c&&b.type===a}}function ma(a){return function(b){var c=b.nodeName.toLowerCase();return("input"===c||"button"===c)&&b.type===a}}function na(a){return ha(function(b){return b=+b,ha(function(c,d){var e,f=a([],c.length,b),g=f.length;while(g--)c[e=f[g]]&&(c[e]=!(d[e]=c[e]))})})}function oa(a){return a&&"undefined"!=typeof a.getElementsByTagName&&a}c=fa.support={},f=fa.isXML=function(a){var b=a&&(a.ownerDocument||a).documentElement;return b?"HTML"!==b.nodeName:!1},m=fa.setDocument=function(a){var b,e,g=a?a.ownerDocument||a:v;return g!==n&&9===g.nodeType&&g.documentElement?(n=g,o=n.documentElement,p=!f(n),(e=n.defaultView)&&e.top!==e&&(e.addEventListener?e.addEventListener("unload",da,!1):e.attachEvent&&e.attachEvent("onunload",da)),c.attributes=ia(function(a){return a.className="i",!a.getAttribute("className")}),c.getElementsByTagName=ia(function(a){return a.appendChild(n.createComment("")),!a.getElementsByTagName("*").length}),c.getElementsByClassName=Z.test(n.getElementsByClassName),c.getById=ia(function(a){return o.appendChild(a).id=u,!n.getElementsByName||!n.getElementsByName(u).length}),c.getById?(d.find.ID=function(a,b){if("undefined"!=typeof b.getElementById&&p){var c=b.getElementById(a);return c?[c]:[]}},d.filter.ID=function(a){var b=a.replace(ba,ca);return function(a){return a.getAttribute("id")===b}}):(delete d.find.ID,d.filter.ID=function(a){var b=a.replace(ba,ca);return function(a){var c="undefined"!=typeof a.getAttributeNode&&a.getAttributeNode("id");return c&&c.value===b}}),d.find.TAG=c.getElementsByTagName?function(a,b){return"undefined"!=typeof b.getElementsByTagName?b.getElementsByTagName(a):c.qsa?b.querySelectorAll(a):void 0}:function(a,b){var c,d=[],e=0,f=b.getElementsByTagName(a);if("*"===a){while(c=f[e++])1===c.nodeType&&d.push(c);return d}return f},d.find.CLASS=c.getElementsByClassName&&function(a,b){return"undefined"!=typeof b.getElementsByClassName&&p?b.getElementsByClassName(a):void 0},r=[],q=[],(c.qsa=Z.test(n.querySelectorAll))&&(ia(function(a){o.appendChild(a).innerHTML="<a id='"+u+"'></a><select id='"+u+"-\r\\' msallowcapture=''><option selected=''></option></select>",a.querySelectorAll("[msallowcapture^='']").length&&q.push("[*^$]="+L+"*(?:''|\"\")"),a.querySelectorAll("[selected]").length||q.push("\\["+L+"*(?:value|"+K+")"),a.querySelectorAll("[id~="+u+"-]").length||q.push("~="),a.querySelectorAll(":checked").length||q.push(":checked"),a.querySelectorAll("a#"+u+"+*").length||q.push(".#.+[+~]")}),ia(function(a){var b=n.createElement("input");b.setAttribute("type","hidden"),a.appendChild(b).setAttribute("name","D"),a.querySelectorAll("[name=d]").length&&q.push("name"+L+"*[*^$|!~]?="),a.querySelectorAll(":enabled").length||q.push(":enabled",":disabled"),a.querySelectorAll("*,:x"),q.push(",.*:")})),(c.matchesSelector=Z.test(s=o.matches||o.webkitMatchesSelector||o.mozMatchesSelector||o.oMatchesSelector||o.msMatchesSelector))&&ia(function(a){c.disconnectedMatch=s.call(a,"div"),s.call(a,"[s!='']:x"),r.push("!=",O)}),q=q.length&&new RegExp(q.join("|")),r=r.length&&new RegExp(r.join("|")),b=Z.test(o.compareDocumentPosition),t=b||Z.test(o.contains)?function(a,b){var c=9===a.nodeType?a.documentElement:a,d=b&&b.parentNode;return a===d||!(!d||1!==d.nodeType||!(c.contains?c.contains(d):a.compareDocumentPosition&&16&a.compareDocumentPosition(d)))}:function(a,b){if(b)while(b=b.parentNode)if(b===a)return!0;return!1},B=b?function(a,b){if(a===b)return l=!0,0;var d=!a.compareDocumentPosition-!b.compareDocumentPosition;return d?d:(d=(a.ownerDocument||a)===(b.ownerDocument||b)?a.compareDocumentPosition(b):1,1&d||!c.sortDetached&&b.compareDocumentPosition(a)===d?a===n||a.ownerDocument===v&&t(v,a)?-1:b===n||b.ownerDocument===v&&t(v,b)?1:k?J(k,a)-J(k,b):0:4&d?-1:1)}:function(a,b){if(a===b)return l=!0,0;var c,d=0,e=a.parentNode,f=b.parentNode,g=[a],h=[b];if(!e||!f)return a===n?-1:b===n?1:e?-1:f?1:k?J(k,a)-J(k,b):0;if(e===f)return ka(a,b);c=a;while(c=c.parentNode)g.unshift(c);c=b;while(c=c.parentNode)h.unshift(c);while(g[d]===h[d])d++;return d?ka(g[d],h[d]):g[d]===v?-1:h[d]===v?1:0},n):n},fa.matches=function(a,b){return fa(a,null,null,b)},fa.matchesSelector=function(a,b){if((a.ownerDocument||a)!==n&&m(a),b=b.replace(T,"='$1']"),c.matchesSelector&&p&&!A[b+" "]&&(!r||!r.test(b))&&(!q||!q.test(b)))try{var d=s.call(a,b);if(d||c.disconnectedMatch||a.document&&11!==a.document.nodeType)return d}catch(e){}return fa(b,n,null,[a]).length>0},fa.contains=function(a,b){return(a.ownerDocument||a)!==n&&m(a),t(a,b)},fa.attr=function(a,b){(a.ownerDocument||a)!==n&&m(a);var e=d.attrHandle[b.toLowerCase()],f=e&&D.call(d.attrHandle,b.toLowerCase())?e(a,b,!p):void 0;return void 0!==f?f:c.attributes||!p?a.getAttribute(b):(f=a.getAttributeNode(b))&&f.specified?f.value:null},fa.error=function(a){throw new Error("Syntax error, unrecognized expression: "+a)},fa.uniqueSort=function(a){var b,d=[],e=0,f=0;if(l=!c.detectDuplicates,k=!c.sortStable&&a.slice(0),a.sort(B),l){while(b=a[f++])b===a[f]&&(e=d.push(f));while(e--)a.splice(d[e],1)}return k=null,a},e=fa.getText=function(a){var b,c="",d=0,f=a.nodeType;if(f){if(1===f||9===f||11===f){if("string"==typeof a.textContent)return a.textContent;for(a=a.firstChild;a;a=a.nextSibling)c+=e(a)}else if(3===f||4===f)return a.nodeValue}else while(b=a[d++])c+=e(b);return c},d=fa.selectors={cacheLength:50,createPseudo:ha,match:W,attrHandle:{},find:{},relative:{">":{dir:"parentNode",first:!0}," ":{dir:"parentNode"},"+":{dir:"previousSibling",first:!0},"~":{dir:"previousSibling"}},preFilter:{ATTR:function(a){return a[1]=a[1].replace(ba,ca),a[3]=(a[3]||a[4]||a[5]||"").replace(ba,ca),"~="===a[2]&&(a[3]=" "+a[3]+" "),a.slice(0,4)},CHILD:function(a){return a[1]=a[1].toLowerCase(),"nth"===a[1].slice(0,3)?(a[3]||fa.error(a[0]),a[4]=+(a[4]?a[5]+(a[6]||1):2*("even"===a[3]||"odd"===a[3])),a[5]=+(a[7]+a[8]||"odd"===a[3])):a[3]&&fa.error(a[0]),a},PSEUDO:function(a){var b,c=!a[6]&&a[2];return W.CHILD.test(a[0])?null:(a[3]?a[2]=a[4]||a[5]||"":c&&U.test(c)&&(b=g(c,!0))&&(b=c.indexOf(")",c.length-b)-c.length)&&(a[0]=a[0].slice(0,b),a[2]=c.slice(0,b)),a.slice(0,3))}},filter:{TAG:function(a){var b=a.replace(ba,ca).toLowerCase();return"*"===a?function(){return!0}:function(a){return a.nodeName&&a.nodeName.toLowerCase()===b}},CLASS:function(a){var b=y[a+" "];return b||(b=new RegExp("(^|"+L+")"+a+"("+L+"|$)"))&&y(a,function(a){return b.test("string"==typeof a.className&&a.className||"undefined"!=typeof a.getAttribute&&a.getAttribute("class")||"")})},ATTR:function(a,b,c){return function(d){var e=fa.attr(d,a);return null==e?"!="===b:b?(e+="","="===b?e===c:"!="===b?e!==c:"^="===b?c&&0===e.indexOf(c):"*="===b?c&&e.indexOf(c)>-1:"$="===b?c&&e.slice(-c.length)===c:"~="===b?(" "+e.replace(P," ")+" ").indexOf(c)>-1:"|="===b?e===c||e.slice(0,c.length+1)===c+"-":!1):!0}},CHILD:function(a,b,c,d,e){var f="nth"!==a.slice(0,3),g="last"!==a.slice(-4),h="of-type"===b;return 1===d&&0===e?function(a){return!!a.parentNode}:function(b,c,i){var j,k,l,m,n,o,p=f!==g?"nextSibling":"previousSibling",q=b.parentNode,r=h&&b.nodeName.toLowerCase(),s=!i&&!h,t=!1;if(q){if(f){while(p){m=b;while(m=m[p])if(h?m.nodeName.toLowerCase()===r:1===m.nodeType)return!1;o=p="only"===a&&!o&&"nextSibling"}return!0}if(o=[g?q.firstChild:q.lastChild],g&&s){m=q,l=m[u]||(m[u]={}),k=l[m.uniqueID]||(l[m.uniqueID]={}),j=k[a]||[],n=j[0]===w&&j[1],t=n&&j[2],m=n&&q.childNodes[n];while(m=++n&&m&&m[p]||(t=n=0)||o.pop())if(1===m.nodeType&&++t&&m===b){k[a]=[w,n,t];break}}else if(s&&(m=b,l=m[u]||(m[u]={}),k=l[m.uniqueID]||(l[m.uniqueID]={}),j=k[a]||[],n=j[0]===w&&j[1],t=n),t===!1)while(m=++n&&m&&m[p]||(t=n=0)||o.pop())if((h?m.nodeName.toLowerCase()===r:1===m.nodeType)&&++t&&(s&&(l=m[u]||(m[u]={}),k=l[m.uniqueID]||(l[m.uniqueID]={}),k[a]=[w,t]),m===b))break;return t-=e,t===d||t%d===0&&t/d>=0}}},PSEUDO:function(a,b){var c,e=d.pseudos[a]||d.setFilters[a.toLowerCase()]||fa.error("unsupported pseudo: "+a);return e[u]?e(b):e.length>1?(c=[a,a,"",b],d.setFilters.hasOwnProperty(a.toLowerCase())?ha(function(a,c){var d,f=e(a,b),g=f.length;while(g--)d=J(a,f[g]),a[d]=!(c[d]=f[g])}):function(a){return e(a,0,c)}):e}},pseudos:{not:ha(function(a){var b=[],c=[],d=h(a.replace(Q,"$1"));return d[u]?ha(function(a,b,c,e){var f,g=d(a,null,e,[]),h=a.length;while(h--)(f=g[h])&&(a[h]=!(b[h]=f))}):function(a,e,f){return b[0]=a,d(b,null,f,c),b[0]=null,!c.pop()}}),has:ha(function(a){return function(b){return fa(a,b).length>0}}),contains:ha(function(a){return a=a.replace(ba,ca),function(b){return(b.textContent||b.innerText||e(b)).indexOf(a)>-1}}),lang:ha(function(a){return V.test(a||"")||fa.error("unsupported lang: "+a),a=a.replace(ba,ca).toLowerCase(),function(b){var c;do if(c=p?b.lang:b.getAttribute("xml:lang")||b.getAttribute("lang"))return c=c.toLowerCase(),c===a||0===c.indexOf(a+"-");while((b=b.parentNode)&&1===b.nodeType);return!1}}),target:function(b){var c=a.location&&a.location.hash;return c&&c.slice(1)===b.id},root:function(a){return a===o},focus:function(a){return a===n.activeElement&&(!n.hasFocus||n.hasFocus())&&!!(a.type||a.href||~a.tabIndex)},enabled:function(a){return a.disabled===!1},disabled:function(a){return a.disabled===!0},checked:function(a){var b=a.nodeName.toLowerCase();return"input"===b&&!!a.checked||"option"===b&&!!a.selected},selected:function(a){return a.parentNode&&a.parentNode.selectedIndex,a.selected===!0},empty:function(a){for(a=a.firstChild;a;a=a.nextSibling)if(a.nodeType<6)return!1;return!0},parent:function(a){return!d.pseudos.empty(a)},header:function(a){return Y.test(a.nodeName)},input:function(a){return X.test(a.nodeName)},button:function(a){var b=a.nodeName.toLowerCase();return"input"===b&&"button"===a.type||"button"===b},text:function(a){var b;return"input"===a.nodeName.toLowerCase()&&"text"===a.type&&(null==(b=a.getAttribute("type"))||"text"===b.toLowerCase())},first:na(function(){return[0]}),last:na(function(a,b){return[b-1]}),eq:na(function(a,b,c){return[0>c?c+b:c]}),even:na(function(a,b){for(var c=0;b>c;c+=2)a.push(c);return a}),odd:na(function(a,b){for(var c=1;b>c;c+=2)a.push(c);return a}),lt:na(function(a,b,c){for(var d=0>c?c+b:c;--d>=0;)a.push(d);return a}),gt:na(function(a,b,c){for(var d=0>c?c+b:c;++d<b;)a.push(d);return a})}},d.pseudos.nth=d.pseudos.eq;for(b in{radio:!0,checkbox:!0,file:!0,password:!0,image:!0})d.pseudos[b]=la(b);for(b in{submit:!0,reset:!0})d.pseudos[b]=ma(b);function pa(){}pa.prototype=d.filters=d.pseudos,d.setFilters=new pa,g=fa.tokenize=function(a,b){var c,e,f,g,h,i,j,k=z[a+" "];if(k)return b?0:k.slice(0);h=a,i=[],j=d.preFilter;while(h){c&&!(e=R.exec(h))||(e&&(h=h.slice(e[0].length)||h),i.push(f=[])),c=!1,(e=S.exec(h))&&(c=e.shift(),f.push({value:c,type:e[0].replace(Q," ")}),h=h.slice(c.length));for(g in d.filter)!(e=W[g].exec(h))||j[g]&&!(e=j[g](e))||(c=e.shift(),f.push({value:c,type:g,matches:e}),h=h.slice(c.length));if(!c)break}return b?h.length:h?fa.error(a):z(a,i).slice(0)};function qa(a){for(var b=0,c=a.length,d="";c>b;b++)d+=a[b].value;return d}function ra(a,b,c){var d=b.dir,e=c&&"parentNode"===d,f=x++;return b.first?function(b,c,f){while(b=b[d])if(1===b.nodeType||e)return a(b,c,f)}:function(b,c,g){var h,i,j,k=[w,f];if(g){while(b=b[d])if((1===b.nodeType||e)&&a(b,c,g))return!0}else while(b=b[d])if(1===b.nodeType||e){if(j=b[u]||(b[u]={}),i=j[b.uniqueID]||(j[b.uniqueID]={}),(h=i[d])&&h[0]===w&&h[1]===f)return k[2]=h[2];if(i[d]=k,k[2]=a(b,c,g))return!0}}}function sa(a){return a.length>1?function(b,c,d){var e=a.length;while(e--)if(!a[e](b,c,d))return!1;return!0}:a[0]}function ta(a,b,c){for(var d=0,e=b.length;e>d;d++)fa(a,b[d],c);return c}function ua(a,b,c,d,e){for(var f,g=[],h=0,i=a.length,j=null!=b;i>h;h++)(f=a[h])&&(c&&!c(f,d,e)||(g.push(f),j&&b.push(h)));return g}function va(a,b,c,d,e,f){return d&&!d[u]&&(d=va(d)),e&&!e[u]&&(e=va(e,f)),ha(function(f,g,h,i){var j,k,l,m=[],n=[],o=g.length,p=f||ta(b||"*",h.nodeType?[h]:h,[]),q=!a||!f&&b?p:ua(p,m,a,h,i),r=c?e||(f?a:o||d)?[]:g:q;if(c&&c(q,r,h,i),d){j=ua(r,n),d(j,[],h,i),k=j.length;while(k--)(l=j[k])&&(r[n[k]]=!(q[n[k]]=l))}if(f){if(e||a){if(e){j=[],k=r.length;while(k--)(l=r[k])&&j.push(q[k]=l);e(null,r=[],j,i)}k=r.length;while(k--)(l=r[k])&&(j=e?J(f,l):m[k])>-1&&(f[j]=!(g[j]=l))}}else r=ua(r===g?r.splice(o,r.length):r),e?e(null,g,r,i):H.apply(g,r)})}function wa(a){for(var b,c,e,f=a.length,g=d.relative[a[0].type],h=g||d.relative[" "],i=g?1:0,k=ra(function(a){return a===b},h,!0),l=ra(function(a){return J(b,a)>-1},h,!0),m=[function(a,c,d){var e=!g&&(d||c!==j)||((b=c).nodeType?k(a,c,d):l(a,c,d));return b=null,e}];f>i;i++)if(c=d.relative[a[i].type])m=[ra(sa(m),c)];else{if(c=d.filter[a[i].type].apply(null,a[i].matches),c[u]){for(e=++i;f>e;e++)if(d.relative[a[e].type])break;return va(i>1&&sa(m),i>1&&qa(a.slice(0,i-1).concat({value:" "===a[i-2].type?"*":""})).replace(Q,"$1"),c,e>i&&wa(a.slice(i,e)),f>e&&wa(a=a.slice(e)),f>e&&qa(a))}m.push(c)}return sa(m)}function xa(a,b){var c=b.length>0,e=a.length>0,f=function(f,g,h,i,k){var l,o,q,r=0,s="0",t=f&&[],u=[],v=j,x=f||e&&d.find.TAG("*",k),y=w+=null==v?1:Math.random()||.1,z=x.length;for(k&&(j=g===n||g||k);s!==z&&null!=(l=x[s]);s++){if(e&&l){o=0,g||l.ownerDocument===n||(m(l),h=!p);while(q=a[o++])if(q(l,g||n,h)){i.push(l);break}k&&(w=y)}c&&((l=!q&&l)&&r--,f&&t.push(l))}if(r+=s,c&&s!==r){o=0;while(q=b[o++])q(t,u,g,h);if(f){if(r>0)while(s--)t[s]||u[s]||(u[s]=F.call(i));u=ua(u)}H.apply(i,u),k&&!f&&u.length>0&&r+b.length>1&&fa.uniqueSort(i)}return k&&(w=y,j=v),t};return c?ha(f):f}return h=fa.compile=function(a,b){var c,d=[],e=[],f=A[a+" "];if(!f){b||(b=g(a)),c=b.length;while(c--)f=wa(b[c]),f[u]?d.push(f):e.push(f);f=A(a,xa(e,d)),f.selector=a}return f},i=fa.select=function(a,b,e,f){var i,j,k,l,m,n="function"==typeof a&&a,o=!f&&g(a=n.selector||a);if(e=e||[],1===o.length){if(j=o[0]=o[0].slice(0),j.length>2&&"ID"===(k=j[0]).type&&c.getById&&9===b.nodeType&&p&&d.relative[j[1].type]){if(b=(d.find.ID(k.matches[0].replace(ba,ca),b)||[])[0],!b)return e;n&&(b=b.parentNode),a=a.slice(j.shift().value.length)}i=W.needsContext.test(a)?0:j.length;while(i--){if(k=j[i],d.relative[l=k.type])break;if((m=d.find[l])&&(f=m(k.matches[0].replace(ba,ca),_.test(j[0].type)&&oa(b.parentNode)||b))){if(j.splice(i,1),a=f.length&&qa(j),!a)return H.apply(e,f),e;break}}}return(n||h(a,o))(f,b,!p,e,!b||_.test(a)&&oa(b.parentNode)||b),e},c.sortStable=u.split("").sort(B).join("")===u,c.detectDuplicates=!!l,m(),c.sortDetached=ia(function(a){return 1&a.compareDocumentPosition(n.createElement("div"))}),ia(function(a){return a.innerHTML="<a href='#'></a>","#"===a.firstChild.getAttribute("href")})||ja("type|href|height|width",function(a,b,c){return c?void 0:a.getAttribute(b,"type"===b.toLowerCase()?1:2)}),c.attributes&&ia(function(a){return a.innerHTML="<input/>",a.firstChild.setAttribute("value",""),""===a.firstChild.getAttribute("value")})||ja("value",function(a,b,c){return c||"input"!==a.nodeName.toLowerCase()?void 0:a.defaultValue}),ia(function(a){return null==a.getAttribute("disabled")})||ja(K,function(a,b,c){var d;return c?void 0:a[b]===!0?b.toLowerCase():(d=a.getAttributeNode(b))&&d.specified?d.value:null}),fa}(a);n.find=t,n.expr=t.selectors,n.expr[":"]=n.expr.pseudos,n.uniqueSort=n.unique=t.uniqueSort,n.text=t.getText,n.isXMLDoc=t.isXML,n.contains=t.contains;var u=function(a,b,c){var d=[],e=void 0!==c;while((a=a[b])&&9!==a.nodeType)if(1===a.nodeType){if(e&&n(a).is(c))break;d.push(a)}return d},v=function(a,b){for(var c=[];a;a=a.nextSibling)1===a.nodeType&&a!==b&&c.push(a);return c},w=n.expr.match.needsContext,x=/^<([\w-]+)\s*\/?>(?:<\/\1>|)$/,y=/^.[^:#\[\.,]*$/;function z(a,b,c){if(n.isFunction(b))return n.grep(a,function(a,d){return!!b.call(a,d,a)!==c});if(b.nodeType)return n.grep(a,function(a){return a===b!==c});if("string"==typeof b){if(y.test(b))return n.filter(b,a,c);b=n.filter(b,a)}return n.grep(a,function(a){return h.call(b,a)>-1!==c})}n.filter=function(a,b,c){var d=b[0];return c&&(a=":not("+a+")"),1===b.length&&1===d.nodeType?n.find.matchesSelector(d,a)?[d]:[]:n.find.matches(a,n.grep(b,function(a){return 1===a.nodeType}))},n.fn.extend({find:function(a){var b,c=this.length,d=[],e=this;if("string"!=typeof a)return this.pushStack(n(a).filter(function(){for(b=0;c>b;b++)if(n.contains(e[b],this))return!0}));for(b=0;c>b;b++)n.find(a,e[b],d);return d=this.pushStack(c>1?n.unique(d):d),d.selector=this.selector?this.selector+" "+a:a,d},filter:function(a){return this.pushStack(z(this,a||[],!1))},not:function(a){return this.pushStack(z(this,a||[],!0))},is:function(a){return!!z(this,"string"==typeof a&&w.test(a)?n(a):a||[],!1).length}});var A,B=/^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]*))$/,C=n.fn.init=function(a,b,c){var e,f;if(!a)return this;if(c=c||A,"string"==typeof a){if(e="<"===a[0]&&">"===a[a.length-1]&&a.length>=3?[null,a,null]:B.exec(a),!e||!e[1]&&b)return!b||b.jquery?(b||c).find(a):this.constructor(b).find(a);if(e[1]){if(b=b instanceof n?b[0]:b,n.merge(this,n.parseHTML(e[1],b&&b.nodeType?b.ownerDocument||b:d,!0)),x.test(e[1])&&n.isPlainObject(b))for(e in b)n.isFunction(this[e])?this[e](b[e]):this.attr(e,b[e]);return this}return f=d.getElementById(e[2]),f&&f.parentNode&&(this.length=1,this[0]=f),this.context=d,this.selector=a,this}return a.nodeType?(this.context=this[0]=a,this.length=1,this):n.isFunction(a)?void 0!==c.ready?c.ready(a):a(n):(void 0!==a.selector&&(this.selector=a.selector,this.context=a.context),n.makeArray(a,this))};C.prototype=n.fn,A=n(d);var D=/^(?:parents|prev(?:Until|All))/,E={children:!0,contents:!0,next:!0,prev:!0};n.fn.extend({has:function(a){var b=n(a,this),c=b.length;return this.filter(function(){for(var a=0;c>a;a++)if(n.contains(this,b[a]))return!0})},closest:function(a,b){for(var c,d=0,e=this.length,f=[],g=w.test(a)||"string"!=typeof a?n(a,b||this.context):0;e>d;d++)for(c=this[d];c&&c!==b;c=c.parentNode)if(c.nodeType<11&&(g?g.index(c)>-1:1===c.nodeType&&n.find.matchesSelector(c,a))){f.push(c);break}return this.pushStack(f.length>1?n.uniqueSort(f):f)},index:function(a){return a?"string"==typeof a?h.call(n(a),this[0]):h.call(this,a.jquery?a[0]:a):this[0]&&this[0].parentNode?this.first().prevAll().length:-1},add:function(a,b){return this.pushStack(n.uniqueSort(n.merge(this.get(),n(a,b))))},addBack:function(a){return this.add(null==a?this.prevObject:this.prevObject.filter(a))}});function F(a,b){while((a=a[b])&&1!==a.nodeType);return a}n.each({parent:function(a){var b=a.parentNode;return b&&11!==b.nodeType?b:null},parents:function(a){return u(a,"parentNode")},parentsUntil:function(a,b,c){return u(a,"parentNode",c)},next:function(a){return F(a,"nextSibling")},prev:function(a){return F(a,"previousSibling")},nextAll:function(a){return u(a,"nextSibling")},prevAll:function(a){return u(a,"previousSibling")},nextUntil:function(a,b,c){return u(a,"nextSibling",c)},prevUntil:function(a,b,c){return u(a,"previousSibling",c)},siblings:function(a){return v((a.parentNode||{}).firstChild,a)},children:function(a){return v(a.firstChild)},contents:function(a){return a.contentDocument||n.merge([],a.childNodes)}},function(a,b){n.fn[a]=function(c,d){var e=n.map(this,b,c);return"Until"!==a.slice(-5)&&(d=c),d&&"string"==typeof d&&(e=n.filter(d,e)),this.length>1&&(E[a]||n.uniqueSort(e),D.test(a)&&e.reverse()),this.pushStack(e)}});var G=/\S+/g;function H(a){var b={};return n.each(a.match(G)||[],function(a,c){b[c]=!0}),b}n.Callbacks=function(a){a="string"==typeof a?H(a):n.extend({},a);var b,c,d,e,f=[],g=[],h=-1,i=function(){for(e=a.once,d=b=!0;g.length;h=-1){c=g.shift();while(++h<f.length)f[h].apply(c[0],c[1])===!1&&a.stopOnFalse&&(h=f.length,c=!1)}a.memory||(c=!1),b=!1,e&&(f=c?[]:"")},j={add:function(){return f&&(c&&!b&&(h=f.length-1,g.push(c)),function d(b){n.each(b,function(b,c){n.isFunction(c)?a.unique&&j.has(c)||f.push(c):c&&c.length&&"string"!==n.type(c)&&d(c)})}(arguments),c&&!b&&i()),this},remove:function(){return n.each(arguments,function(a,b){var c;while((c=n.inArray(b,f,c))>-1)f.splice(c,1),h>=c&&h--}),this},has:function(a){return a?n.inArray(a,f)>-1:f.length>0},empty:function(){return f&&(f=[]),this},disable:function(){return e=g=[],f=c="",this},disabled:function(){return!f},lock:function(){return e=g=[],c||(f=c=""),this},locked:function(){return!!e},fireWith:function(a,c){return e||(c=c||[],c=[a,c.slice?c.slice():c],g.push(c),b||i()),this},fire:function(){return j.fireWith(this,arguments),this},fired:function(){return!!d}};return j},n.extend({Deferred:function(a){var b=[["resolve","done",n.Callbacks("once memory"),"resolved"],["reject","fail",n.Callbacks("once memory"),"rejected"],["notify","progress",n.Callbacks("memory")]],c="pending",d={state:function(){return c},always:function(){return e.done(arguments).fail(arguments),this},then:function(){var a=arguments;return n.Deferred(function(c){n.each(b,function(b,f){var g=n.isFunction(a[b])&&a[b];e[f[1]](function(){var a=g&&g.apply(this,arguments);a&&n.isFunction(a.promise)?a.promise().progress(c.notify).done(c.resolve).fail(c.reject):c[f[0]+"With"](this===d?c.promise():this,g?[a]:arguments)})}),a=null}).promise()},promise:function(a){return null!=a?n.extend(a,d):d}},e={};return d.pipe=d.then,n.each(b,function(a,f){var g=f[2],h=f[3];d[f[1]]=g.add,h&&g.add(function(){c=h},b[1^a][2].disable,b[2][2].lock),e[f[0]]=function(){return e[f[0]+"With"](this===e?d:this,arguments),this},e[f[0]+"With"]=g.fireWith}),d.promise(e),a&&a.call(e,e),e},when:function(a){var b=0,c=e.call(arguments),d=c.length,f=1!==d||a&&n.isFunction(a.promise)?d:0,g=1===f?a:n.Deferred(),h=function(a,b,c){return function(d){b[a]=this,c[a]=arguments.length>1?e.call(arguments):d,c===i?g.notifyWith(b,c):--f||g.resolveWith(b,c)}},i,j,k;if(d>1)for(i=new Array(d),j=new Array(d),k=new Array(d);d>b;b++)c[b]&&n.isFunction(c[b].promise)?c[b].promise().progress(h(b,j,i)).done(h(b,k,c)).fail(g.reject):--f;return f||g.resolveWith(k,c),g.promise()}});var I;n.fn.ready=function(a){return n.ready.promise().done(a),this},n.extend({isReady:!1,readyWait:1,holdReady:function(a){a?n.readyWait++:n.ready(!0)},ready:function(a){(a===!0?--n.readyWait:n.isReady)||(n.isReady=!0,a!==!0&&--n.readyWait>0||(I.resolveWith(d,[n]),n.fn.triggerHandler&&(n(d).triggerHandler("ready"),n(d).off("ready"))))}});function J(){d.removeEventListener("DOMContentLoaded",J),a.removeEventListener("load",J),n.ready()}n.ready.promise=function(b){return I||(I=n.Deferred(),"complete"===d.readyState||"loading"!==d.readyState&&!d.documentElement.doScroll?a.setTimeout(n.ready):(d.addEventListener("DOMContentLoaded",J),a.addEventListener("load",J))),I.promise(b)},n.ready.promise();var K=function(a,b,c,d,e,f,g){var h=0,i=a.length,j=null==c;if("object"===n.type(c)){e=!0;for(h in c)K(a,b,h,c[h],!0,f,g)}else if(void 0!==d&&(e=!0,n.isFunction(d)||(g=!0),j&&(g?(b.call(a,d),b=null):(j=b,b=function(a,b,c){return j.call(n(a),c)})),b))for(;i>h;h++)b(a[h],c,g?d:d.call(a[h],h,b(a[h],c)));return e?a:j?b.call(a):i?b(a[0],c):f},L=function(a){return 1===a.nodeType||9===a.nodeType||!+a.nodeType};function M(){this.expando=n.expando+M.uid++}M.uid=1,M.prototype={register:function(a,b){var c=b||{};return a.nodeType?a[this.expando]=c:Object.defineProperty(a,this.expando,{value:c,writable:!0,configurable:!0}),a[this.expando]},cache:function(a){if(!L(a))return{};var b=a[this.expando];return b||(b={},L(a)&&(a.nodeType?a[this.expando]=b:Object.defineProperty(a,this.expando,{value:b,configurable:!0}))),b},set:function(a,b,c){var d,e=this.cache(a);if("string"==typeof b)e[b]=c;else for(d in b)e[d]=b[d];return e},get:function(a,b){return void 0===b?this.cache(a):a[this.expando]&&a[this.expando][b]},access:function(a,b,c){var d;return void 0===b||b&&"string"==typeof b&&void 0===c?(d=this.get(a,b),void 0!==d?d:this.get(a,n.camelCase(b))):(this.set(a,b,c),void 0!==c?c:b)},remove:function(a,b){var c,d,e,f=a[this.expando];if(void 0!==f){if(void 0===b)this.register(a);else{n.isArray(b)?d=b.concat(b.map(n.camelCase)):(e=n.camelCase(b),b in f?d=[b,e]:(d=e,d=d in f?[d]:d.match(G)||[])),c=d.length;while(c--)delete f[d[c]]}(void 0===b||n.isEmptyObject(f))&&(a.nodeType?a[this.expando]=void 0:delete a[this.expando])}},hasData:function(a){var b=a[this.expando];return void 0!==b&&!n.isEmptyObject(b)}};var N=new M,O=new M,P=/^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,Q=/[A-Z]/g;function R(a,b,c){var d;if(void 0===c&&1===a.nodeType)if(d="data-"+b.replace(Q,"-$&").toLowerCase(),c=a.getAttribute(d),"string"==typeof c){try{c="true"===c?!0:"false"===c?!1:"null"===c?null:+c+""===c?+c:P.test(c)?n.parseJSON(c):c;
}catch(e){}O.set(a,b,c)}else c=void 0;return c}n.extend({hasData:function(a){return O.hasData(a)||N.hasData(a)},data:function(a,b,c){return O.access(a,b,c)},removeData:function(a,b){O.remove(a,b)},_data:function(a,b,c){return N.access(a,b,c)},_removeData:function(a,b){N.remove(a,b)}}),n.fn.extend({data:function(a,b){var c,d,e,f=this[0],g=f&&f.attributes;if(void 0===a){if(this.length&&(e=O.get(f),1===f.nodeType&&!N.get(f,"hasDataAttrs"))){c=g.length;while(c--)g[c]&&(d=g[c].name,0===d.indexOf("data-")&&(d=n.camelCase(d.slice(5)),R(f,d,e[d])));N.set(f,"hasDataAttrs",!0)}return e}return"object"==typeof a?this.each(function(){O.set(this,a)}):K(this,function(b){var c,d;if(f&&void 0===b){if(c=O.get(f,a)||O.get(f,a.replace(Q,"-$&").toLowerCase()),void 0!==c)return c;if(d=n.camelCase(a),c=O.get(f,d),void 0!==c)return c;if(c=R(f,d,void 0),void 0!==c)return c}else d=n.camelCase(a),this.each(function(){var c=O.get(this,d);O.set(this,d,b),a.indexOf("-")>-1&&void 0!==c&&O.set(this,a,b)})},null,b,arguments.length>1,null,!0)},removeData:function(a){return this.each(function(){O.remove(this,a)})}}),n.extend({queue:function(a,b,c){var d;return a?(b=(b||"fx")+"queue",d=N.get(a,b),c&&(!d||n.isArray(c)?d=N.access(a,b,n.makeArray(c)):d.push(c)),d||[]):void 0},dequeue:function(a,b){b=b||"fx";var c=n.queue(a,b),d=c.length,e=c.shift(),f=n._queueHooks(a,b),g=function(){n.dequeue(a,b)};"inprogress"===e&&(e=c.shift(),d--),e&&("fx"===b&&c.unshift("inprogress"),delete f.stop,e.call(a,g,f)),!d&&f&&f.empty.fire()},_queueHooks:function(a,b){var c=b+"queueHooks";return N.get(a,c)||N.access(a,c,{empty:n.Callbacks("once memory").add(function(){N.remove(a,[b+"queue",c])})})}}),n.fn.extend({queue:function(a,b){var c=2;return"string"!=typeof a&&(b=a,a="fx",c--),arguments.length<c?n.queue(this[0],a):void 0===b?this:this.each(function(){var c=n.queue(this,a,b);n._queueHooks(this,a),"fx"===a&&"inprogress"!==c[0]&&n.dequeue(this,a)})},dequeue:function(a){return this.each(function(){n.dequeue(this,a)})},clearQueue:function(a){return this.queue(a||"fx",[])},promise:function(a,b){var c,d=1,e=n.Deferred(),f=this,g=this.length,h=function(){--d||e.resolveWith(f,[f])};"string"!=typeof a&&(b=a,a=void 0),a=a||"fx";while(g--)c=N.get(f[g],a+"queueHooks"),c&&c.empty&&(d++,c.empty.add(h));return h(),e.promise(b)}});var S=/[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source,T=new RegExp("^(?:([+-])=|)("+S+")([a-z%]*)$","i"),U=["Top","Right","Bottom","Left"],V=function(a,b){return a=b||a,"none"===n.css(a,"display")||!n.contains(a.ownerDocument,a)};function W(a,b,c,d){var e,f=1,g=20,h=d?function(){return d.cur()}:function(){return n.css(a,b,"")},i=h(),j=c&&c[3]||(n.cssNumber[b]?"":"px"),k=(n.cssNumber[b]||"px"!==j&&+i)&&T.exec(n.css(a,b));if(k&&k[3]!==j){j=j||k[3],c=c||[],k=+i||1;do f=f||".5",k/=f,n.style(a,b,k+j);while(f!==(f=h()/i)&&1!==f&&--g)}return c&&(k=+k||+i||0,e=c[1]?k+(c[1]+1)*c[2]:+c[2],d&&(d.unit=j,d.start=k,d.end=e)),e}var X=/^(?:checkbox|radio)$/i,Y=/<([\w:-]+)/,Z=/^$|\/(?:java|ecma)script/i,$={option:[1,"<select multiple='multiple'>","</select>"],thead:[1,"<table>","</table>"],col:[2,"<table><colgroup>","</colgroup></table>"],tr:[2,"<table><tbody>","</tbody></table>"],td:[3,"<table><tbody><tr>","</tr></tbody></table>"],_default:[0,"",""]};$.optgroup=$.option,$.tbody=$.tfoot=$.colgroup=$.caption=$.thead,$.th=$.td;function _(a,b){var c="undefined"!=typeof a.getElementsByTagName?a.getElementsByTagName(b||"*"):"undefined"!=typeof a.querySelectorAll?a.querySelectorAll(b||"*"):[];return void 0===b||b&&n.nodeName(a,b)?n.merge([a],c):c}function aa(a,b){for(var c=0,d=a.length;d>c;c++)N.set(a[c],"globalEval",!b||N.get(b[c],"globalEval"))}var ba=/<|&#?\w+;/;function ca(a,b,c,d,e){for(var f,g,h,i,j,k,l=b.createDocumentFragment(),m=[],o=0,p=a.length;p>o;o++)if(f=a[o],f||0===f)if("object"===n.type(f))n.merge(m,f.nodeType?[f]:f);else if(ba.test(f)){g=g||l.appendChild(b.createElement("div")),h=(Y.exec(f)||["",""])[1].toLowerCase(),i=$[h]||$._default,g.innerHTML=i[1]+n.htmlPrefilter(f)+i[2],k=i[0];while(k--)g=g.lastChild;n.merge(m,g.childNodes),g=l.firstChild,g.textContent=""}else m.push(b.createTextNode(f));l.textContent="",o=0;while(f=m[o++])if(d&&n.inArray(f,d)>-1)e&&e.push(f);else if(j=n.contains(f.ownerDocument,f),g=_(l.appendChild(f),"script"),j&&aa(g),c){k=0;while(f=g[k++])Z.test(f.type||"")&&c.push(f)}return l}!function(){var a=d.createDocumentFragment(),b=a.appendChild(d.createElement("div")),c=d.createElement("input");c.setAttribute("type","radio"),c.setAttribute("checked","checked"),c.setAttribute("name","t"),b.appendChild(c),l.checkClone=b.cloneNode(!0).cloneNode(!0).lastChild.checked,b.innerHTML="<textarea>x</textarea>",l.noCloneChecked=!!b.cloneNode(!0).lastChild.defaultValue}();var da=/^key/,ea=/^(?:mouse|pointer|contextmenu|drag|drop)|click/,fa=/^([^.]*)(?:\.(.+)|)/;function ga(){return!0}function ha(){return!1}function ia(){try{return d.activeElement}catch(a){}}function ja(a,b,c,d,e,f){var g,h;if("object"==typeof b){"string"!=typeof c&&(d=d||c,c=void 0);for(h in b)ja(a,h,c,d,b[h],f);return a}if(null==d&&null==e?(e=c,d=c=void 0):null==e&&("string"==typeof c?(e=d,d=void 0):(e=d,d=c,c=void 0)),e===!1)e=ha;else if(!e)return a;return 1===f&&(g=e,e=function(a){return n().off(a),g.apply(this,arguments)},e.guid=g.guid||(g.guid=n.guid++)),a.each(function(){n.event.add(this,b,e,d,c)})}n.event={global:{},add:function(a,b,c,d,e){var f,g,h,i,j,k,l,m,o,p,q,r=N.get(a);if(r){c.handler&&(f=c,c=f.handler,e=f.selector),c.guid||(c.guid=n.guid++),(i=r.events)||(i=r.events={}),(g=r.handle)||(g=r.handle=function(b){return"undefined"!=typeof n&&n.event.triggered!==b.type?n.event.dispatch.apply(a,arguments):void 0}),b=(b||"").match(G)||[""],j=b.length;while(j--)h=fa.exec(b[j])||[],o=q=h[1],p=(h[2]||"").split(".").sort(),o&&(l=n.event.special[o]||{},o=(e?l.delegateType:l.bindType)||o,l=n.event.special[o]||{},k=n.extend({type:o,origType:q,data:d,handler:c,guid:c.guid,selector:e,needsContext:e&&n.expr.match.needsContext.test(e),namespace:p.join(".")},f),(m=i[o])||(m=i[o]=[],m.delegateCount=0,l.setup&&l.setup.call(a,d,p,g)!==!1||a.addEventListener&&a.addEventListener(o,g)),l.add&&(l.add.call(a,k),k.handler.guid||(k.handler.guid=c.guid)),e?m.splice(m.delegateCount++,0,k):m.push(k),n.event.global[o]=!0)}},remove:function(a,b,c,d,e){var f,g,h,i,j,k,l,m,o,p,q,r=N.hasData(a)&&N.get(a);if(r&&(i=r.events)){b=(b||"").match(G)||[""],j=b.length;while(j--)if(h=fa.exec(b[j])||[],o=q=h[1],p=(h[2]||"").split(".").sort(),o){l=n.event.special[o]||{},o=(d?l.delegateType:l.bindType)||o,m=i[o]||[],h=h[2]&&new RegExp("(^|\\.)"+p.join("\\.(?:.*\\.|)")+"(\\.|$)"),g=f=m.length;while(f--)k=m[f],!e&&q!==k.origType||c&&c.guid!==k.guid||h&&!h.test(k.namespace)||d&&d!==k.selector&&("**"!==d||!k.selector)||(m.splice(f,1),k.selector&&m.delegateCount--,l.remove&&l.remove.call(a,k));g&&!m.length&&(l.teardown&&l.teardown.call(a,p,r.handle)!==!1||n.removeEvent(a,o,r.handle),delete i[o])}else for(o in i)n.event.remove(a,o+b[j],c,d,!0);n.isEmptyObject(i)&&N.remove(a,"handle events")}},dispatch:function(a){a=n.event.fix(a);var b,c,d,f,g,h=[],i=e.call(arguments),j=(N.get(this,"events")||{})[a.type]||[],k=n.event.special[a.type]||{};if(i[0]=a,a.delegateTarget=this,!k.preDispatch||k.preDispatch.call(this,a)!==!1){h=n.event.handlers.call(this,a,j),b=0;while((f=h[b++])&&!a.isPropagationStopped()){a.currentTarget=f.elem,c=0;while((g=f.handlers[c++])&&!a.isImmediatePropagationStopped())a.rnamespace&&!a.rnamespace.test(g.namespace)||(a.handleObj=g,a.data=g.data,d=((n.event.special[g.origType]||{}).handle||g.handler).apply(f.elem,i),void 0!==d&&(a.result=d)===!1&&(a.preventDefault(),a.stopPropagation()))}return k.postDispatch&&k.postDispatch.call(this,a),a.result}},handlers:function(a,b){var c,d,e,f,g=[],h=b.delegateCount,i=a.target;if(h&&i.nodeType&&("click"!==a.type||isNaN(a.button)||a.button<1))for(;i!==this;i=i.parentNode||this)if(1===i.nodeType&&(i.disabled!==!0||"click"!==a.type)){for(d=[],c=0;h>c;c++)f=b[c],e=f.selector+" ",void 0===d[e]&&(d[e]=f.needsContext?n(e,this).index(i)>-1:n.find(e,this,null,[i]).length),d[e]&&d.push(f);d.length&&g.push({elem:i,handlers:d})}return h<b.length&&g.push({elem:this,handlers:b.slice(h)}),g},props:"altKey bubbles cancelable ctrlKey currentTarget detail eventPhase metaKey relatedTarget shiftKey target timeStamp view which".split(" "),fixHooks:{},keyHooks:{props:"char charCode key keyCode".split(" "),filter:function(a,b){return null==a.which&&(a.which=null!=b.charCode?b.charCode:b.keyCode),a}},mouseHooks:{props:"button buttons clientX clientY offsetX offsetY pageX pageY screenX screenY toElement".split(" "),filter:function(a,b){var c,e,f,g=b.button;return null==a.pageX&&null!=b.clientX&&(c=a.target.ownerDocument||d,e=c.documentElement,f=c.body,a.pageX=b.clientX+(e&&e.scrollLeft||f&&f.scrollLeft||0)-(e&&e.clientLeft||f&&f.clientLeft||0),a.pageY=b.clientY+(e&&e.scrollTop||f&&f.scrollTop||0)-(e&&e.clientTop||f&&f.clientTop||0)),a.which||void 0===g||(a.which=1&g?1:2&g?3:4&g?2:0),a}},fix:function(a){if(a[n.expando])return a;var b,c,e,f=a.type,g=a,h=this.fixHooks[f];h||(this.fixHooks[f]=h=ea.test(f)?this.mouseHooks:da.test(f)?this.keyHooks:{}),e=h.props?this.props.concat(h.props):this.props,a=new n.Event(g),b=e.length;while(b--)c=e[b],a[c]=g[c];return a.target||(a.target=d),3===a.target.nodeType&&(a.target=a.target.parentNode),h.filter?h.filter(a,g):a},special:{load:{noBubble:!0},focus:{trigger:function(){return this!==ia()&&this.focus?(this.focus(),!1):void 0},delegateType:"focusin"},blur:{trigger:function(){return this===ia()&&this.blur?(this.blur(),!1):void 0},delegateType:"focusout"},click:{trigger:function(){return"checkbox"===this.type&&this.click&&n.nodeName(this,"input")?(this.click(),!1):void 0},_default:function(a){return n.nodeName(a.target,"a")}},beforeunload:{postDispatch:function(a){void 0!==a.result&&a.originalEvent&&(a.originalEvent.returnValue=a.result)}}}},n.removeEvent=function(a,b,c){a.removeEventListener&&a.removeEventListener(b,c)},n.Event=function(a,b){return this instanceof n.Event?(a&&a.type?(this.originalEvent=a,this.type=a.type,this.isDefaultPrevented=a.defaultPrevented||void 0===a.defaultPrevented&&a.returnValue===!1?ga:ha):this.type=a,b&&n.extend(this,b),this.timeStamp=a&&a.timeStamp||n.now(),void(this[n.expando]=!0)):new n.Event(a,b)},n.Event.prototype={constructor:n.Event,isDefaultPrevented:ha,isPropagationStopped:ha,isImmediatePropagationStopped:ha,preventDefault:function(){var a=this.originalEvent;this.isDefaultPrevented=ga,a&&a.preventDefault()},stopPropagation:function(){var a=this.originalEvent;this.isPropagationStopped=ga,a&&a.stopPropagation()},stopImmediatePropagation:function(){var a=this.originalEvent;this.isImmediatePropagationStopped=ga,a&&a.stopImmediatePropagation(),this.stopPropagation()}},n.each({mouseenter:"mouseover",mouseleave:"mouseout",pointerenter:"pointerover",pointerleave:"pointerout"},function(a,b){n.event.special[a]={delegateType:b,bindType:b,handle:function(a){var c,d=this,e=a.relatedTarget,f=a.handleObj;return e&&(e===d||n.contains(d,e))||(a.type=f.origType,c=f.handler.apply(this,arguments),a.type=b),c}}}),n.fn.extend({on:function(a,b,c,d){return ja(this,a,b,c,d)},one:function(a,b,c,d){return ja(this,a,b,c,d,1)},off:function(a,b,c){var d,e;if(a&&a.preventDefault&&a.handleObj)return d=a.handleObj,n(a.delegateTarget).off(d.namespace?d.origType+"."+d.namespace:d.origType,d.selector,d.handler),this;if("object"==typeof a){for(e in a)this.off(e,b,a[e]);return this}return b!==!1&&"function"!=typeof b||(c=b,b=void 0),c===!1&&(c=ha),this.each(function(){n.event.remove(this,a,c,b)})}});var ka=/<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\w:-]+)[^>]*)\/>/gi,la=/<script|<style|<link/i,ma=/checked\s*(?:[^=]|=\s*.checked.)/i,na=/^true\/(.*)/,oa=/^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;function pa(a,b){return n.nodeName(a,"table")&&n.nodeName(11!==b.nodeType?b:b.firstChild,"tr")?a.getElementsByTagName("tbody")[0]||a.appendChild(a.ownerDocument.createElement("tbody")):a}function qa(a){return a.type=(null!==a.getAttribute("type"))+"/"+a.type,a}function ra(a){var b=na.exec(a.type);return b?a.type=b[1]:a.removeAttribute("type"),a}function sa(a,b){var c,d,e,f,g,h,i,j;if(1===b.nodeType){if(N.hasData(a)&&(f=N.access(a),g=N.set(b,f),j=f.events)){delete g.handle,g.events={};for(e in j)for(c=0,d=j[e].length;d>c;c++)n.event.add(b,e,j[e][c])}O.hasData(a)&&(h=O.access(a),i=n.extend({},h),O.set(b,i))}}function ta(a,b){var c=b.nodeName.toLowerCase();"input"===c&&X.test(a.type)?b.checked=a.checked:"input"!==c&&"textarea"!==c||(b.defaultValue=a.defaultValue)}function ua(a,b,c,d){b=f.apply([],b);var e,g,h,i,j,k,m=0,o=a.length,p=o-1,q=b[0],r=n.isFunction(q);if(r||o>1&&"string"==typeof q&&!l.checkClone&&ma.test(q))return a.each(function(e){var f=a.eq(e);r&&(b[0]=q.call(this,e,f.html())),ua(f,b,c,d)});if(o&&(e=ca(b,a[0].ownerDocument,!1,a,d),g=e.firstChild,1===e.childNodes.length&&(e=g),g||d)){for(h=n.map(_(e,"script"),qa),i=h.length;o>m;m++)j=e,m!==p&&(j=n.clone(j,!0,!0),i&&n.merge(h,_(j,"script"))),c.call(a[m],j,m);if(i)for(k=h[h.length-1].ownerDocument,n.map(h,ra),m=0;i>m;m++)j=h[m],Z.test(j.type||"")&&!N.access(j,"globalEval")&&n.contains(k,j)&&(j.src?n._evalUrl&&n._evalUrl(j.src):n.globalEval(j.textContent.replace(oa,"")))}return a}function va(a,b,c){for(var d,e=b?n.filter(b,a):a,f=0;null!=(d=e[f]);f++)c||1!==d.nodeType||n.cleanData(_(d)),d.parentNode&&(c&&n.contains(d.ownerDocument,d)&&aa(_(d,"script")),d.parentNode.removeChild(d));return a}n.extend({htmlPrefilter:function(a){return a.replace(ka,"<$1></$2>")},clone:function(a,b,c){var d,e,f,g,h=a.cloneNode(!0),i=n.contains(a.ownerDocument,a);if(!(l.noCloneChecked||1!==a.nodeType&&11!==a.nodeType||n.isXMLDoc(a)))for(g=_(h),f=_(a),d=0,e=f.length;e>d;d++)ta(f[d],g[d]);if(b)if(c)for(f=f||_(a),g=g||_(h),d=0,e=f.length;e>d;d++)sa(f[d],g[d]);else sa(a,h);return g=_(h,"script"),g.length>0&&aa(g,!i&&_(a,"script")),h},cleanData:function(a){for(var b,c,d,e=n.event.special,f=0;void 0!==(c=a[f]);f++)if(L(c)){if(b=c[N.expando]){if(b.events)for(d in b.events)e[d]?n.event.remove(c,d):n.removeEvent(c,d,b.handle);c[N.expando]=void 0}c[O.expando]&&(c[O.expando]=void 0)}}}),n.fn.extend({domManip:ua,detach:function(a){return va(this,a,!0)},remove:function(a){return va(this,a)},text:function(a){return K(this,function(a){return void 0===a?n.text(this):this.empty().each(function(){1!==this.nodeType&&11!==this.nodeType&&9!==this.nodeType||(this.textContent=a)})},null,a,arguments.length)},append:function(){return ua(this,arguments,function(a){if(1===this.nodeType||11===this.nodeType||9===this.nodeType){var b=pa(this,a);b.appendChild(a)}})},prepend:function(){return ua(this,arguments,function(a){if(1===this.nodeType||11===this.nodeType||9===this.nodeType){var b=pa(this,a);b.insertBefore(a,b.firstChild)}})},before:function(){return ua(this,arguments,function(a){this.parentNode&&this.parentNode.insertBefore(a,this)})},after:function(){return ua(this,arguments,function(a){this.parentNode&&this.parentNode.insertBefore(a,this.nextSibling)})},empty:function(){for(var a,b=0;null!=(a=this[b]);b++)1===a.nodeType&&(n.cleanData(_(a,!1)),a.textContent="");return this},clone:function(a,b){return a=null==a?!1:a,b=null==b?a:b,this.map(function(){return n.clone(this,a,b)})},html:function(a){return K(this,function(a){var b=this[0]||{},c=0,d=this.length;if(void 0===a&&1===b.nodeType)return b.innerHTML;if("string"==typeof a&&!la.test(a)&&!$[(Y.exec(a)||["",""])[1].toLowerCase()]){a=n.htmlPrefilter(a);try{for(;d>c;c++)b=this[c]||{},1===b.nodeType&&(n.cleanData(_(b,!1)),b.innerHTML=a);b=0}catch(e){}}b&&this.empty().append(a)},null,a,arguments.length)},replaceWith:function(){var a=[];return ua(this,arguments,function(b){var c=this.parentNode;n.inArray(this,a)<0&&(n.cleanData(_(this)),c&&c.replaceChild(b,this))},a)}}),n.each({appendTo:"append",prependTo:"prepend",insertBefore:"before",insertAfter:"after",replaceAll:"replaceWith"},function(a,b){n.fn[a]=function(a){for(var c,d=[],e=n(a),f=e.length-1,h=0;f>=h;h++)c=h===f?this:this.clone(!0),n(e[h])[b](c),g.apply(d,c.get());return this.pushStack(d)}});var wa,xa={HTML:"block",BODY:"block"};function ya(a,b){var c=n(b.createElement(a)).appendTo(b.body),d=n.css(c[0],"display");return c.detach(),d}function za(a){var b=d,c=xa[a];return c||(c=ya(a,b),"none"!==c&&c||(wa=(wa||n("<iframe frameborder='0' width='0' height='0'/>")).appendTo(b.documentElement),b=wa[0].contentDocument,b.write(),b.close(),c=ya(a,b),wa.detach()),xa[a]=c),c}var Aa=/^margin/,Ba=new RegExp("^("+S+")(?!px)[a-z%]+$","i"),Ca=function(b){var c=b.ownerDocument.defaultView;return c&&c.opener||(c=a),c.getComputedStyle(b)},Da=function(a,b,c,d){var e,f,g={};for(f in b)g[f]=a.style[f],a.style[f]=b[f];e=c.apply(a,d||[]);for(f in b)a.style[f]=g[f];return e},Ea=d.documentElement;!function(){var b,c,e,f,g=d.createElement("div"),h=d.createElement("div");if(h.style){h.style.backgroundClip="content-box",h.cloneNode(!0).style.backgroundClip="",l.clearCloneStyle="content-box"===h.style.backgroundClip,g.style.cssText="border:0;width:8px;height:0;top:0;left:-9999px;padding:0;margin-top:1px;position:absolute",g.appendChild(h);function i(){h.style.cssText="-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;position:relative;display:block;margin:auto;border:1px;padding:1px;top:1%;width:50%",h.innerHTML="",Ea.appendChild(g);var d=a.getComputedStyle(h);b="1%"!==d.top,f="2px"===d.marginLeft,c="4px"===d.width,h.style.marginRight="50%",e="4px"===d.marginRight,Ea.removeChild(g)}n.extend(l,{pixelPosition:function(){return i(),b},boxSizingReliable:function(){return null==c&&i(),c},pixelMarginRight:function(){return null==c&&i(),e},reliableMarginLeft:function(){return null==c&&i(),f},reliableMarginRight:function(){var b,c=h.appendChild(d.createElement("div"));return c.style.cssText=h.style.cssText="-webkit-box-sizing:content-box;box-sizing:content-box;display:block;margin:0;border:0;padding:0",c.style.marginRight=c.style.width="0",h.style.width="1px",Ea.appendChild(g),b=!parseFloat(a.getComputedStyle(c).marginRight),Ea.removeChild(g),h.removeChild(c),b}})}}();function Fa(a,b,c){var d,e,f,g,h=a.style;return c=c||Ca(a),g=c?c.getPropertyValue(b)||c[b]:void 0,""!==g&&void 0!==g||n.contains(a.ownerDocument,a)||(g=n.style(a,b)),c&&!l.pixelMarginRight()&&Ba.test(g)&&Aa.test(b)&&(d=h.width,e=h.minWidth,f=h.maxWidth,h.minWidth=h.maxWidth=h.width=g,g=c.width,h.width=d,h.minWidth=e,h.maxWidth=f),void 0!==g?g+"":g}function Ga(a,b){return{get:function(){return a()?void delete this.get:(this.get=b).apply(this,arguments)}}}var Ha=/^(none|table(?!-c[ea]).+)/,Ia={position:"absolute",visibility:"hidden",display:"block"},Ja={letterSpacing:"0",fontWeight:"400"},Ka=["Webkit","O","Moz","ms"],La=d.createElement("div").style;function Ma(a){if(a in La)return a;var b=a[0].toUpperCase()+a.slice(1),c=Ka.length;while(c--)if(a=Ka[c]+b,a in La)return a}function Na(a,b,c){var d=T.exec(b);return d?Math.max(0,d[2]-(c||0))+(d[3]||"px"):b}function Oa(a,b,c,d,e){for(var f=c===(d?"border":"content")?4:"width"===b?1:0,g=0;4>f;f+=2)"margin"===c&&(g+=n.css(a,c+U[f],!0,e)),d?("content"===c&&(g-=n.css(a,"padding"+U[f],!0,e)),"margin"!==c&&(g-=n.css(a,"border"+U[f]+"Width",!0,e))):(g+=n.css(a,"padding"+U[f],!0,e),"padding"!==c&&(g+=n.css(a,"border"+U[f]+"Width",!0,e)));return g}function Pa(b,c,e){var f=!0,g="width"===c?b.offsetWidth:b.offsetHeight,h=Ca(b),i="border-box"===n.css(b,"boxSizing",!1,h);if(d.msFullscreenElement&&a.top!==a&&b.getClientRects().length&&(g=Math.round(100*b.getBoundingClientRect()[c])),0>=g||null==g){if(g=Fa(b,c,h),(0>g||null==g)&&(g=b.style[c]),Ba.test(g))return g;f=i&&(l.boxSizingReliable()||g===b.style[c]),g=parseFloat(g)||0}return g+Oa(b,c,e||(i?"border":"content"),f,h)+"px"}function Qa(a,b){for(var c,d,e,f=[],g=0,h=a.length;h>g;g++)d=a[g],d.style&&(f[g]=N.get(d,"olddisplay"),c=d.style.display,b?(f[g]||"none"!==c||(d.style.display=""),""===d.style.display&&V(d)&&(f[g]=N.access(d,"olddisplay",za(d.nodeName)))):(e=V(d),"none"===c&&e||N.set(d,"olddisplay",e?c:n.css(d,"display"))));for(g=0;h>g;g++)d=a[g],d.style&&(b&&"none"!==d.style.display&&""!==d.style.display||(d.style.display=b?f[g]||"":"none"));return a}n.extend({cssHooks:{opacity:{get:function(a,b){if(b){var c=Fa(a,"opacity");return""===c?"1":c}}}},cssNumber:{animationIterationCount:!0,columnCount:!0,fillOpacity:!0,flexGrow:!0,flexShrink:!0,fontWeight:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,widows:!0,zIndex:!0,zoom:!0},cssProps:{"float":"cssFloat"},style:function(a,b,c,d){if(a&&3!==a.nodeType&&8!==a.nodeType&&a.style){var e,f,g,h=n.camelCase(b),i=a.style;return b=n.cssProps[h]||(n.cssProps[h]=Ma(h)||h),g=n.cssHooks[b]||n.cssHooks[h],void 0===c?g&&"get"in g&&void 0!==(e=g.get(a,!1,d))?e:i[b]:(f=typeof c,"string"===f&&(e=T.exec(c))&&e[1]&&(c=W(a,b,e),f="number"),null!=c&&c===c&&("number"===f&&(c+=e&&e[3]||(n.cssNumber[h]?"":"px")),l.clearCloneStyle||""!==c||0!==b.indexOf("background")||(i[b]="inherit"),g&&"set"in g&&void 0===(c=g.set(a,c,d))||(i[b]=c)),void 0)}},css:function(a,b,c,d){var e,f,g,h=n.camelCase(b);return b=n.cssProps[h]||(n.cssProps[h]=Ma(h)||h),g=n.cssHooks[b]||n.cssHooks[h],g&&"get"in g&&(e=g.get(a,!0,c)),void 0===e&&(e=Fa(a,b,d)),"normal"===e&&b in Ja&&(e=Ja[b]),""===c||c?(f=parseFloat(e),c===!0||isFinite(f)?f||0:e):e}}),n.each(["height","width"],function(a,b){n.cssHooks[b]={get:function(a,c,d){return c?Ha.test(n.css(a,"display"))&&0===a.offsetWidth?Da(a,Ia,function(){return Pa(a,b,d)}):Pa(a,b,d):void 0},set:function(a,c,d){var e,f=d&&Ca(a),g=d&&Oa(a,b,d,"border-box"===n.css(a,"boxSizing",!1,f),f);return g&&(e=T.exec(c))&&"px"!==(e[3]||"px")&&(a.style[b]=c,c=n.css(a,b)),Na(a,c,g)}}}),n.cssHooks.marginLeft=Ga(l.reliableMarginLeft,function(a,b){return b?(parseFloat(Fa(a,"marginLeft"))||a.getBoundingClientRect().left-Da(a,{marginLeft:0},function(){return a.getBoundingClientRect().left}))+"px":void 0}),n.cssHooks.marginRight=Ga(l.reliableMarginRight,function(a,b){return b?Da(a,{display:"inline-block"},Fa,[a,"marginRight"]):void 0}),n.each({margin:"",padding:"",border:"Width"},function(a,b){n.cssHooks[a+b]={expand:function(c){for(var d=0,e={},f="string"==typeof c?c.split(" "):[c];4>d;d++)e[a+U[d]+b]=f[d]||f[d-2]||f[0];return e}},Aa.test(a)||(n.cssHooks[a+b].set=Na)}),n.fn.extend({css:function(a,b){return K(this,function(a,b,c){var d,e,f={},g=0;if(n.isArray(b)){for(d=Ca(a),e=b.length;e>g;g++)f[b[g]]=n.css(a,b[g],!1,d);return f}return void 0!==c?n.style(a,b,c):n.css(a,b)},a,b,arguments.length>1)},show:function(){return Qa(this,!0)},hide:function(){return Qa(this)},toggle:function(a){return"boolean"==typeof a?a?this.show():this.hide():this.each(function(){V(this)?n(this).show():n(this).hide()})}});function Ra(a,b,c,d,e){return new Ra.prototype.init(a,b,c,d,e)}n.Tween=Ra,Ra.prototype={constructor:Ra,init:function(a,b,c,d,e,f){this.elem=a,this.prop=c,this.easing=e||n.easing._default,this.options=b,this.start=this.now=this.cur(),this.end=d,this.unit=f||(n.cssNumber[c]?"":"px")},cur:function(){var a=Ra.propHooks[this.prop];return a&&a.get?a.get(this):Ra.propHooks._default.get(this)},run:function(a){var b,c=Ra.propHooks[this.prop];return this.options.duration?this.pos=b=n.easing[this.easing](a,this.options.duration*a,0,1,this.options.duration):this.pos=b=a,this.now=(this.end-this.start)*b+this.start,this.options.step&&this.options.step.call(this.elem,this.now,this),c&&c.set?c.set(this):Ra.propHooks._default.set(this),this}},Ra.prototype.init.prototype=Ra.prototype,Ra.propHooks={_default:{get:function(a){var b;return 1!==a.elem.nodeType||null!=a.elem[a.prop]&&null==a.elem.style[a.prop]?a.elem[a.prop]:(b=n.css(a.elem,a.prop,""),b&&"auto"!==b?b:0)},set:function(a){n.fx.step[a.prop]?n.fx.step[a.prop](a):1!==a.elem.nodeType||null==a.elem.style[n.cssProps[a.prop]]&&!n.cssHooks[a.prop]?a.elem[a.prop]=a.now:n.style(a.elem,a.prop,a.now+a.unit)}}},Ra.propHooks.scrollTop=Ra.propHooks.scrollLeft={set:function(a){a.elem.nodeType&&a.elem.parentNode&&(a.elem[a.prop]=a.now)}},n.easing={linear:function(a){return a},swing:function(a){return.5-Math.cos(a*Math.PI)/2},_default:"swing"},n.fx=Ra.prototype.init,n.fx.step={};var Sa,Ta,Ua=/^(?:toggle|show|hide)$/,Va=/queueHooks$/;function Wa(){return a.setTimeout(function(){Sa=void 0}),Sa=n.now()}function Xa(a,b){var c,d=0,e={height:a};for(b=b?1:0;4>d;d+=2-b)c=U[d],e["margin"+c]=e["padding"+c]=a;return b&&(e.opacity=e.width=a),e}function Ya(a,b,c){for(var d,e=(_a.tweeners[b]||[]).concat(_a.tweeners["*"]),f=0,g=e.length;g>f;f++)if(d=e[f].call(c,b,a))return d}function Za(a,b,c){var d,e,f,g,h,i,j,k,l=this,m={},o=a.style,p=a.nodeType&&V(a),q=N.get(a,"fxshow");c.queue||(h=n._queueHooks(a,"fx"),null==h.unqueued&&(h.unqueued=0,i=h.empty.fire,h.empty.fire=function(){h.unqueued||i()}),h.unqueued++,l.always(function(){l.always(function(){h.unqueued--,n.queue(a,"fx").length||h.empty.fire()})})),1===a.nodeType&&("height"in b||"width"in b)&&(c.overflow=[o.overflow,o.overflowX,o.overflowY],j=n.css(a,"display"),k="none"===j?N.get(a,"olddisplay")||za(a.nodeName):j,"inline"===k&&"none"===n.css(a,"float")&&(o.display="inline-block")),c.overflow&&(o.overflow="hidden",l.always(function(){o.overflow=c.overflow[0],o.overflowX=c.overflow[1],o.overflowY=c.overflow[2]}));for(d in b)if(e=b[d],Ua.exec(e)){if(delete b[d],f=f||"toggle"===e,e===(p?"hide":"show")){if("show"!==e||!q||void 0===q[d])continue;p=!0}m[d]=q&&q[d]||n.style(a,d)}else j=void 0;if(n.isEmptyObject(m))"inline"===("none"===j?za(a.nodeName):j)&&(o.display=j);else{q?"hidden"in q&&(p=q.hidden):q=N.access(a,"fxshow",{}),f&&(q.hidden=!p),p?n(a).show():l.done(function(){n(a).hide()}),l.done(function(){var b;N.remove(a,"fxshow");for(b in m)n.style(a,b,m[b])});for(d in m)g=Ya(p?q[d]:0,d,l),d in q||(q[d]=g.start,p&&(g.end=g.start,g.start="width"===d||"height"===d?1:0))}}function $a(a,b){var c,d,e,f,g;for(c in a)if(d=n.camelCase(c),e=b[d],f=a[c],n.isArray(f)&&(e=f[1],f=a[c]=f[0]),c!==d&&(a[d]=f,delete a[c]),g=n.cssHooks[d],g&&"expand"in g){f=g.expand(f),delete a[d];for(c in f)c in a||(a[c]=f[c],b[c]=e)}else b[d]=e}function _a(a,b,c){var d,e,f=0,g=_a.prefilters.length,h=n.Deferred().always(function(){delete i.elem}),i=function(){if(e)return!1;for(var b=Sa||Wa(),c=Math.max(0,j.startTime+j.duration-b),d=c/j.duration||0,f=1-d,g=0,i=j.tweens.length;i>g;g++)j.tweens[g].run(f);return h.notifyWith(a,[j,f,c]),1>f&&i?c:(h.resolveWith(a,[j]),!1)},j=h.promise({elem:a,props:n.extend({},b),opts:n.extend(!0,{specialEasing:{},easing:n.easing._default},c),originalProperties:b,originalOptions:c,startTime:Sa||Wa(),duration:c.duration,tweens:[],createTween:function(b,c){var d=n.Tween(a,j.opts,b,c,j.opts.specialEasing[b]||j.opts.easing);return j.tweens.push(d),d},stop:function(b){var c=0,d=b?j.tweens.length:0;if(e)return this;for(e=!0;d>c;c++)j.tweens[c].run(1);return b?(h.notifyWith(a,[j,1,0]),h.resolveWith(a,[j,b])):h.rejectWith(a,[j,b]),this}}),k=j.props;for($a(k,j.opts.specialEasing);g>f;f++)if(d=_a.prefilters[f].call(j,a,k,j.opts))return n.isFunction(d.stop)&&(n._queueHooks(j.elem,j.opts.queue).stop=n.proxy(d.stop,d)),d;return n.map(k,Ya,j),n.isFunction(j.opts.start)&&j.opts.start.call(a,j),n.fx.timer(n.extend(i,{elem:a,anim:j,queue:j.opts.queue})),j.progress(j.opts.progress).done(j.opts.done,j.opts.complete).fail(j.opts.fail).always(j.opts.always)}n.Animation=n.extend(_a,{tweeners:{"*":[function(a,b){var c=this.createTween(a,b);return W(c.elem,a,T.exec(b),c),c}]},tweener:function(a,b){n.isFunction(a)?(b=a,a=["*"]):a=a.match(G);for(var c,d=0,e=a.length;e>d;d++)c=a[d],_a.tweeners[c]=_a.tweeners[c]||[],_a.tweeners[c].unshift(b)},prefilters:[Za],prefilter:function(a,b){b?_a.prefilters.unshift(a):_a.prefilters.push(a)}}),n.speed=function(a,b,c){var d=a&&"object"==typeof a?n.extend({},a):{complete:c||!c&&b||n.isFunction(a)&&a,duration:a,easing:c&&b||b&&!n.isFunction(b)&&b};return d.duration=n.fx.off?0:"number"==typeof d.duration?d.duration:d.duration in n.fx.speeds?n.fx.speeds[d.duration]:n.fx.speeds._default,null!=d.queue&&d.queue!==!0||(d.queue="fx"),d.old=d.complete,d.complete=function(){n.isFunction(d.old)&&d.old.call(this),d.queue&&n.dequeue(this,d.queue)},d},n.fn.extend({fadeTo:function(a,b,c,d){return this.filter(V).css("opacity",0).show().end().animate({opacity:b},a,c,d)},animate:function(a,b,c,d){var e=n.isEmptyObject(a),f=n.speed(b,c,d),g=function(){var b=_a(this,n.extend({},a),f);(e||N.get(this,"finish"))&&b.stop(!0)};return g.finish=g,e||f.queue===!1?this.each(g):this.queue(f.queue,g)},stop:function(a,b,c){var d=function(a){var b=a.stop;delete a.stop,b(c)};return"string"!=typeof a&&(c=b,b=a,a=void 0),b&&a!==!1&&this.queue(a||"fx",[]),this.each(function(){var b=!0,e=null!=a&&a+"queueHooks",f=n.timers,g=N.get(this);if(e)g[e]&&g[e].stop&&d(g[e]);else for(e in g)g[e]&&g[e].stop&&Va.test(e)&&d(g[e]);for(e=f.length;e--;)f[e].elem!==this||null!=a&&f[e].queue!==a||(f[e].anim.stop(c),b=!1,f.splice(e,1));!b&&c||n.dequeue(this,a)})},finish:function(a){return a!==!1&&(a=a||"fx"),this.each(function(){var b,c=N.get(this),d=c[a+"queue"],e=c[a+"queueHooks"],f=n.timers,g=d?d.length:0;for(c.finish=!0,n.queue(this,a,[]),e&&e.stop&&e.stop.call(this,!0),b=f.length;b--;)f[b].elem===this&&f[b].queue===a&&(f[b].anim.stop(!0),f.splice(b,1));for(b=0;g>b;b++)d[b]&&d[b].finish&&d[b].finish.call(this);delete c.finish})}}),n.each(["toggle","show","hide"],function(a,b){var c=n.fn[b];n.fn[b]=function(a,d,e){return null==a||"boolean"==typeof a?c.apply(this,arguments):this.animate(Xa(b,!0),a,d,e)}}),n.each({slideDown:Xa("show"),slideUp:Xa("hide"),slideToggle:Xa("toggle"),fadeIn:{opacity:"show"},fadeOut:{opacity:"hide"},fadeToggle:{opacity:"toggle"}},function(a,b){n.fn[a]=function(a,c,d){return this.animate(b,a,c,d)}}),n.timers=[],n.fx.tick=function(){var a,b=0,c=n.timers;for(Sa=n.now();b<c.length;b++)a=c[b],a()||c[b]!==a||c.splice(b--,1);c.length||n.fx.stop(),Sa=void 0},n.fx.timer=function(a){n.timers.push(a),a()?n.fx.start():n.timers.pop()},n.fx.interval=13,n.fx.start=function(){Ta||(Ta=a.setInterval(n.fx.tick,n.fx.interval))},n.fx.stop=function(){a.clearInterval(Ta),Ta=null},n.fx.speeds={slow:600,fast:200,_default:400},n.fn.delay=function(b,c){return b=n.fx?n.fx.speeds[b]||b:b,c=c||"fx",this.queue(c,function(c,d){var e=a.setTimeout(c,b);d.stop=function(){a.clearTimeout(e)}})},function(){var a=d.createElement("input"),b=d.createElement("select"),c=b.appendChild(d.createElement("option"));a.type="checkbox",l.checkOn=""!==a.value,l.optSelected=c.selected,b.disabled=!0,l.optDisabled=!c.disabled,a=d.createElement("input"),a.value="t",a.type="radio",l.radioValue="t"===a.value}();var ab,bb=n.expr.attrHandle;n.fn.extend({attr:function(a,b){return K(this,n.attr,a,b,arguments.length>1)},removeAttr:function(a){return this.each(function(){n.removeAttr(this,a)})}}),n.extend({attr:function(a,b,c){var d,e,f=a.nodeType;if(3!==f&&8!==f&&2!==f)return"undefined"==typeof a.getAttribute?n.prop(a,b,c):(1===f&&n.isXMLDoc(a)||(b=b.toLowerCase(),e=n.attrHooks[b]||(n.expr.match.bool.test(b)?ab:void 0)),void 0!==c?null===c?void n.removeAttr(a,b):e&&"set"in e&&void 0!==(d=e.set(a,c,b))?d:(a.setAttribute(b,c+""),c):e&&"get"in e&&null!==(d=e.get(a,b))?d:(d=n.find.attr(a,b),null==d?void 0:d))},attrHooks:{type:{set:function(a,b){if(!l.radioValue&&"radio"===b&&n.nodeName(a,"input")){var c=a.value;return a.setAttribute("type",b),c&&(a.value=c),b}}}},removeAttr:function(a,b){var c,d,e=0,f=b&&b.match(G);if(f&&1===a.nodeType)while(c=f[e++])d=n.propFix[c]||c,n.expr.match.bool.test(c)&&(a[d]=!1),a.removeAttribute(c)}}),ab={set:function(a,b,c){return b===!1?n.removeAttr(a,c):a.setAttribute(c,c),c}},n.each(n.expr.match.bool.source.match(/\w+/g),function(a,b){var c=bb[b]||n.find.attr;bb[b]=function(a,b,d){var e,f;return d||(f=bb[b],bb[b]=e,e=null!=c(a,b,d)?b.toLowerCase():null,bb[b]=f),e}});var cb=/^(?:input|select|textarea|button)$/i,db=/^(?:a|area)$/i;n.fn.extend({prop:function(a,b){return K(this,n.prop,a,b,arguments.length>1)},removeProp:function(a){return this.each(function(){delete this[n.propFix[a]||a]})}}),n.extend({prop:function(a,b,c){var d,e,f=a.nodeType;if(3!==f&&8!==f&&2!==f)return 1===f&&n.isXMLDoc(a)||(b=n.propFix[b]||b,
e=n.propHooks[b]),void 0!==c?e&&"set"in e&&void 0!==(d=e.set(a,c,b))?d:a[b]=c:e&&"get"in e&&null!==(d=e.get(a,b))?d:a[b]},propHooks:{tabIndex:{get:function(a){var b=n.find.attr(a,"tabindex");return b?parseInt(b,10):cb.test(a.nodeName)||db.test(a.nodeName)&&a.href?0:-1}}},propFix:{"for":"htmlFor","class":"className"}}),l.optSelected||(n.propHooks.selected={get:function(a){var b=a.parentNode;return b&&b.parentNode&&b.parentNode.selectedIndex,null},set:function(a){var b=a.parentNode;b&&(b.selectedIndex,b.parentNode&&b.parentNode.selectedIndex)}}),n.each(["tabIndex","readOnly","maxLength","cellSpacing","cellPadding","rowSpan","colSpan","useMap","frameBorder","contentEditable"],function(){n.propFix[this.toLowerCase()]=this});var eb=/[\t\r\n\f]/g;function fb(a){return a.getAttribute&&a.getAttribute("class")||""}n.fn.extend({addClass:function(a){var b,c,d,e,f,g,h,i=0;if(n.isFunction(a))return this.each(function(b){n(this).addClass(a.call(this,b,fb(this)))});if("string"==typeof a&&a){b=a.match(G)||[];while(c=this[i++])if(e=fb(c),d=1===c.nodeType&&(" "+e+" ").replace(eb," ")){g=0;while(f=b[g++])d.indexOf(" "+f+" ")<0&&(d+=f+" ");h=n.trim(d),e!==h&&c.setAttribute("class",h)}}return this},removeClass:function(a){var b,c,d,e,f,g,h,i=0;if(n.isFunction(a))return this.each(function(b){n(this).removeClass(a.call(this,b,fb(this)))});if(!arguments.length)return this.attr("class","");if("string"==typeof a&&a){b=a.match(G)||[];while(c=this[i++])if(e=fb(c),d=1===c.nodeType&&(" "+e+" ").replace(eb," ")){g=0;while(f=b[g++])while(d.indexOf(" "+f+" ")>-1)d=d.replace(" "+f+" "," ");h=n.trim(d),e!==h&&c.setAttribute("class",h)}}return this},toggleClass:function(a,b){var c=typeof a;return"boolean"==typeof b&&"string"===c?b?this.addClass(a):this.removeClass(a):n.isFunction(a)?this.each(function(c){n(this).toggleClass(a.call(this,c,fb(this),b),b)}):this.each(function(){var b,d,e,f;if("string"===c){d=0,e=n(this),f=a.match(G)||[];while(b=f[d++])e.hasClass(b)?e.removeClass(b):e.addClass(b)}else void 0!==a&&"boolean"!==c||(b=fb(this),b&&N.set(this,"__className__",b),this.setAttribute&&this.setAttribute("class",b||a===!1?"":N.get(this,"__className__")||""))})},hasClass:function(a){var b,c,d=0;b=" "+a+" ";while(c=this[d++])if(1===c.nodeType&&(" "+fb(c)+" ").replace(eb," ").indexOf(b)>-1)return!0;return!1}});var gb=/\r/g,hb=/[\x20\t\r\n\f]+/g;n.fn.extend({val:function(a){var b,c,d,e=this[0];{if(arguments.length)return d=n.isFunction(a),this.each(function(c){var e;1===this.nodeType&&(e=d?a.call(this,c,n(this).val()):a,null==e?e="":"number"==typeof e?e+="":n.isArray(e)&&(e=n.map(e,function(a){return null==a?"":a+""})),b=n.valHooks[this.type]||n.valHooks[this.nodeName.toLowerCase()],b&&"set"in b&&void 0!==b.set(this,e,"value")||(this.value=e))});if(e)return b=n.valHooks[e.type]||n.valHooks[e.nodeName.toLowerCase()],b&&"get"in b&&void 0!==(c=b.get(e,"value"))?c:(c=e.value,"string"==typeof c?c.replace(gb,""):null==c?"":c)}}}),n.extend({valHooks:{option:{get:function(a){var b=n.find.attr(a,"value");return null!=b?b:n.trim(n.text(a)).replace(hb," ")}},select:{get:function(a){for(var b,c,d=a.options,e=a.selectedIndex,f="select-one"===a.type||0>e,g=f?null:[],h=f?e+1:d.length,i=0>e?h:f?e:0;h>i;i++)if(c=d[i],(c.selected||i===e)&&(l.optDisabled?!c.disabled:null===c.getAttribute("disabled"))&&(!c.parentNode.disabled||!n.nodeName(c.parentNode,"optgroup"))){if(b=n(c).val(),f)return b;g.push(b)}return g},set:function(a,b){var c,d,e=a.options,f=n.makeArray(b),g=e.length;while(g--)d=e[g],(d.selected=n.inArray(n.valHooks.option.get(d),f)>-1)&&(c=!0);return c||(a.selectedIndex=-1),f}}}}),n.each(["radio","checkbox"],function(){n.valHooks[this]={set:function(a,b){return n.isArray(b)?a.checked=n.inArray(n(a).val(),b)>-1:void 0}},l.checkOn||(n.valHooks[this].get=function(a){return null===a.getAttribute("value")?"on":a.value})});var ib=/^(?:focusinfocus|focusoutblur)$/;n.extend(n.event,{trigger:function(b,c,e,f){var g,h,i,j,l,m,o,p=[e||d],q=k.call(b,"type")?b.type:b,r=k.call(b,"namespace")?b.namespace.split("."):[];if(h=i=e=e||d,3!==e.nodeType&&8!==e.nodeType&&!ib.test(q+n.event.triggered)&&(q.indexOf(".")>-1&&(r=q.split("."),q=r.shift(),r.sort()),l=q.indexOf(":")<0&&"on"+q,b=b[n.expando]?b:new n.Event(q,"object"==typeof b&&b),b.isTrigger=f?2:3,b.namespace=r.join("."),b.rnamespace=b.namespace?new RegExp("(^|\\.)"+r.join("\\.(?:.*\\.|)")+"(\\.|$)"):null,b.result=void 0,b.target||(b.target=e),c=null==c?[b]:n.makeArray(c,[b]),o=n.event.special[q]||{},f||!o.trigger||o.trigger.apply(e,c)!==!1)){if(!f&&!o.noBubble&&!n.isWindow(e)){for(j=o.delegateType||q,ib.test(j+q)||(h=h.parentNode);h;h=h.parentNode)p.push(h),i=h;i===(e.ownerDocument||d)&&p.push(i.defaultView||i.parentWindow||a)}g=0;while((h=p[g++])&&!b.isPropagationStopped())b.type=g>1?j:o.bindType||q,m=(N.get(h,"events")||{})[b.type]&&N.get(h,"handle"),m&&m.apply(h,c),m=l&&h[l],m&&m.apply&&L(h)&&(b.result=m.apply(h,c),b.result===!1&&b.preventDefault());return b.type=q,f||b.isDefaultPrevented()||o._default&&o._default.apply(p.pop(),c)!==!1||!L(e)||l&&n.isFunction(e[q])&&!n.isWindow(e)&&(i=e[l],i&&(e[l]=null),n.event.triggered=q,e[q](),n.event.triggered=void 0,i&&(e[l]=i)),b.result}},simulate:function(a,b,c){var d=n.extend(new n.Event,c,{type:a,isSimulated:!0});n.event.trigger(d,null,b),d.isDefaultPrevented()&&c.preventDefault()}}),n.fn.extend({trigger:function(a,b){return this.each(function(){n.event.trigger(a,b,this)})},triggerHandler:function(a,b){var c=this[0];return c?n.event.trigger(a,b,c,!0):void 0}}),n.each("blur focus focusin focusout load resize scroll unload click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup error contextmenu".split(" "),function(a,b){n.fn[b]=function(a,c){return arguments.length>0?this.on(b,null,a,c):this.trigger(b)}}),n.fn.extend({hover:function(a,b){return this.mouseenter(a).mouseleave(b||a)}}),l.focusin="onfocusin"in a,l.focusin||n.each({focus:"focusin",blur:"focusout"},function(a,b){var c=function(a){n.event.simulate(b,a.target,n.event.fix(a))};n.event.special[b]={setup:function(){var d=this.ownerDocument||this,e=N.access(d,b);e||d.addEventListener(a,c,!0),N.access(d,b,(e||0)+1)},teardown:function(){var d=this.ownerDocument||this,e=N.access(d,b)-1;e?N.access(d,b,e):(d.removeEventListener(a,c,!0),N.remove(d,b))}}});var jb=a.location,kb=n.now(),lb=/\?/;n.parseJSON=function(a){return JSON.parse(a+"")},n.parseXML=function(b){var c;if(!b||"string"!=typeof b)return null;try{c=(new a.DOMParser).parseFromString(b,"text/xml")}catch(d){c=void 0}return c&&!c.getElementsByTagName("parsererror").length||n.error("Invalid XML: "+b),c};var mb=/#.*$/,nb=/([?&])_=[^&]*/,ob=/^(.*?):[ \t]*([^\r\n]*)$/gm,pb=/^(?:about|app|app-storage|.+-extension|file|res|widget):$/,qb=/^(?:GET|HEAD)$/,rb=/^\/\//,sb={},tb={},ub="*/".concat("*"),vb=d.createElement("a");vb.href=jb.href;function wb(a){return function(b,c){"string"!=typeof b&&(c=b,b="*");var d,e=0,f=b.toLowerCase().match(G)||[];if(n.isFunction(c))while(d=f[e++])"+"===d[0]?(d=d.slice(1)||"*",(a[d]=a[d]||[]).unshift(c)):(a[d]=a[d]||[]).push(c)}}function xb(a,b,c,d){var e={},f=a===tb;function g(h){var i;return e[h]=!0,n.each(a[h]||[],function(a,h){var j=h(b,c,d);return"string"!=typeof j||f||e[j]?f?!(i=j):void 0:(b.dataTypes.unshift(j),g(j),!1)}),i}return g(b.dataTypes[0])||!e["*"]&&g("*")}function yb(a,b){var c,d,e=n.ajaxSettings.flatOptions||{};for(c in b)void 0!==b[c]&&((e[c]?a:d||(d={}))[c]=b[c]);return d&&n.extend(!0,a,d),a}function zb(a,b,c){var d,e,f,g,h=a.contents,i=a.dataTypes;while("*"===i[0])i.shift(),void 0===d&&(d=a.mimeType||b.getResponseHeader("Content-Type"));if(d)for(e in h)if(h[e]&&h[e].test(d)){i.unshift(e);break}if(i[0]in c)f=i[0];else{for(e in c){if(!i[0]||a.converters[e+" "+i[0]]){f=e;break}g||(g=e)}f=f||g}return f?(f!==i[0]&&i.unshift(f),c[f]):void 0}function Ab(a,b,c,d){var e,f,g,h,i,j={},k=a.dataTypes.slice();if(k[1])for(g in a.converters)j[g.toLowerCase()]=a.converters[g];f=k.shift();while(f)if(a.responseFields[f]&&(c[a.responseFields[f]]=b),!i&&d&&a.dataFilter&&(b=a.dataFilter(b,a.dataType)),i=f,f=k.shift())if("*"===f)f=i;else if("*"!==i&&i!==f){if(g=j[i+" "+f]||j["* "+f],!g)for(e in j)if(h=e.split(" "),h[1]===f&&(g=j[i+" "+h[0]]||j["* "+h[0]])){g===!0?g=j[e]:j[e]!==!0&&(f=h[0],k.unshift(h[1]));break}if(g!==!0)if(g&&a["throws"])b=g(b);else try{b=g(b)}catch(l){return{state:"parsererror",error:g?l:"No conversion from "+i+" to "+f}}}return{state:"success",data:b}}n.extend({active:0,lastModified:{},etag:{},ajaxSettings:{url:jb.href,type:"GET",isLocal:pb.test(jb.protocol),global:!0,processData:!0,async:!0,contentType:"application/x-www-form-urlencoded; charset=UTF-8",accepts:{"*":ub,text:"text/plain",html:"text/html",xml:"application/xml, text/xml",json:"application/json, text/javascript"},contents:{xml:/\bxml\b/,html:/\bhtml/,json:/\bjson\b/},responseFields:{xml:"responseXML",text:"responseText",json:"responseJSON"},converters:{"* text":String,"text html":!0,"text json":n.parseJSON,"text xml":n.parseXML},flatOptions:{url:!0,context:!0}},ajaxSetup:function(a,b){return b?yb(yb(a,n.ajaxSettings),b):yb(n.ajaxSettings,a)},ajaxPrefilter:wb(sb),ajaxTransport:wb(tb),ajax:function(b,c){"object"==typeof b&&(c=b,b=void 0),c=c||{};var e,f,g,h,i,j,k,l,m=n.ajaxSetup({},c),o=m.context||m,p=m.context&&(o.nodeType||o.jquery)?n(o):n.event,q=n.Deferred(),r=n.Callbacks("once memory"),s=m.statusCode||{},t={},u={},v=0,w="canceled",x={readyState:0,getResponseHeader:function(a){var b;if(2===v){if(!h){h={};while(b=ob.exec(g))h[b[1].toLowerCase()]=b[2]}b=h[a.toLowerCase()]}return null==b?null:b},getAllResponseHeaders:function(){return 2===v?g:null},setRequestHeader:function(a,b){var c=a.toLowerCase();return v||(a=u[c]=u[c]||a,t[a]=b),this},overrideMimeType:function(a){return v||(m.mimeType=a),this},statusCode:function(a){var b;if(a)if(2>v)for(b in a)s[b]=[s[b],a[b]];else x.always(a[x.status]);return this},abort:function(a){var b=a||w;return e&&e.abort(b),z(0,b),this}};if(q.promise(x).complete=r.add,x.success=x.done,x.error=x.fail,m.url=((b||m.url||jb.href)+"").replace(mb,"").replace(rb,jb.protocol+"//"),m.type=c.method||c.type||m.method||m.type,m.dataTypes=n.trim(m.dataType||"*").toLowerCase().match(G)||[""],null==m.crossDomain){j=d.createElement("a");try{j.href=m.url,j.href=j.href,m.crossDomain=vb.protocol+"//"+vb.host!=j.protocol+"//"+j.host}catch(y){m.crossDomain=!0}}if(m.data&&m.processData&&"string"!=typeof m.data&&(m.data=n.param(m.data,m.traditional)),xb(sb,m,c,x),2===v)return x;k=n.event&&m.global,k&&0===n.active++&&n.event.trigger("ajaxStart"),m.type=m.type.toUpperCase(),m.hasContent=!qb.test(m.type),f=m.url,m.hasContent||(m.data&&(f=m.url+=(lb.test(f)?"&":"?")+m.data,delete m.data),m.cache===!1&&(m.url=nb.test(f)?f.replace(nb,"$1_="+kb++):f+(lb.test(f)?"&":"?")+"_="+kb++)),m.ifModified&&(n.lastModified[f]&&x.setRequestHeader("If-Modified-Since",n.lastModified[f]),n.etag[f]&&x.setRequestHeader("If-None-Match",n.etag[f])),(m.data&&m.hasContent&&m.contentType!==!1||c.contentType)&&x.setRequestHeader("Content-Type",m.contentType),x.setRequestHeader("Accept",m.dataTypes[0]&&m.accepts[m.dataTypes[0]]?m.accepts[m.dataTypes[0]]+("*"!==m.dataTypes[0]?", "+ub+"; q=0.01":""):m.accepts["*"]);for(l in m.headers)x.setRequestHeader(l,m.headers[l]);if(m.beforeSend&&(m.beforeSend.call(o,x,m)===!1||2===v))return x.abort();w="abort";for(l in{success:1,error:1,complete:1})x[l](m[l]);if(e=xb(tb,m,c,x)){if(x.readyState=1,k&&p.trigger("ajaxSend",[x,m]),2===v)return x;m.async&&m.timeout>0&&(i=a.setTimeout(function(){x.abort("timeout")},m.timeout));try{v=1,e.send(t,z)}catch(y){if(!(2>v))throw y;z(-1,y)}}else z(-1,"No Transport");function z(b,c,d,h){var j,l,t,u,w,y=c;2!==v&&(v=2,i&&a.clearTimeout(i),e=void 0,g=h||"",x.readyState=b>0?4:0,j=b>=200&&300>b||304===b,d&&(u=zb(m,x,d)),u=Ab(m,u,x,j),j?(m.ifModified&&(w=x.getResponseHeader("Last-Modified"),w&&(n.lastModified[f]=w),w=x.getResponseHeader("etag"),w&&(n.etag[f]=w)),204===b||"HEAD"===m.type?y="nocontent":304===b?y="notmodified":(y=u.state,l=u.data,t=u.error,j=!t)):(t=y,!b&&y||(y="error",0>b&&(b=0))),x.status=b,x.statusText=(c||y)+"",j?q.resolveWith(o,[l,y,x]):q.rejectWith(o,[x,y,t]),x.statusCode(s),s=void 0,k&&p.trigger(j?"ajaxSuccess":"ajaxError",[x,m,j?l:t]),r.fireWith(o,[x,y]),k&&(p.trigger("ajaxComplete",[x,m]),--n.active||n.event.trigger("ajaxStop")))}return x},getJSON:function(a,b,c){return n.get(a,b,c,"json")},getScript:function(a,b){return n.get(a,void 0,b,"script")}}),n.each(["get","post"],function(a,b){n[b]=function(a,c,d,e){return n.isFunction(c)&&(e=e||d,d=c,c=void 0),n.ajax(n.extend({url:a,type:b,dataType:e,data:c,success:d},n.isPlainObject(a)&&a))}}),n._evalUrl=function(a){return n.ajax({url:a,type:"GET",dataType:"script",async:!1,global:!1,"throws":!0})},n.fn.extend({wrapAll:function(a){var b;return n.isFunction(a)?this.each(function(b){n(this).wrapAll(a.call(this,b))}):(this[0]&&(b=n(a,this[0].ownerDocument).eq(0).clone(!0),this[0].parentNode&&b.insertBefore(this[0]),b.map(function(){var a=this;while(a.firstElementChild)a=a.firstElementChild;return a}).append(this)),this)},wrapInner:function(a){return n.isFunction(a)?this.each(function(b){n(this).wrapInner(a.call(this,b))}):this.each(function(){var b=n(this),c=b.contents();c.length?c.wrapAll(a):b.append(a)})},wrap:function(a){var b=n.isFunction(a);return this.each(function(c){n(this).wrapAll(b?a.call(this,c):a)})},unwrap:function(){return this.parent().each(function(){n.nodeName(this,"body")||n(this).replaceWith(this.childNodes)}).end()}}),n.expr.filters.hidden=function(a){return!n.expr.filters.visible(a)},n.expr.filters.visible=function(a){return a.offsetWidth>0||a.offsetHeight>0||a.getClientRects().length>0};var Bb=/%20/g,Cb=/\[\]$/,Db=/\r?\n/g,Eb=/^(?:submit|button|image|reset|file)$/i,Fb=/^(?:input|select|textarea|keygen)/i;function Gb(a,b,c,d){var e;if(n.isArray(b))n.each(b,function(b,e){c||Cb.test(a)?d(a,e):Gb(a+"["+("object"==typeof e&&null!=e?b:"")+"]",e,c,d)});else if(c||"object"!==n.type(b))d(a,b);else for(e in b)Gb(a+"["+e+"]",b[e],c,d)}n.param=function(a,b){var c,d=[],e=function(a,b){b=n.isFunction(b)?b():null==b?"":b,d[d.length]=encodeURIComponent(a)+"="+encodeURIComponent(b)};if(void 0===b&&(b=n.ajaxSettings&&n.ajaxSettings.traditional),n.isArray(a)||a.jquery&&!n.isPlainObject(a))n.each(a,function(){e(this.name,this.value)});else for(c in a)Gb(c,a[c],b,e);return d.join("&").replace(Bb,"+")},n.fn.extend({serialize:function(){return n.param(this.serializeArray())},serializeArray:function(){return this.map(function(){var a=n.prop(this,"elements");return a?n.makeArray(a):this}).filter(function(){var a=this.type;return this.name&&!n(this).is(":disabled")&&Fb.test(this.nodeName)&&!Eb.test(a)&&(this.checked||!X.test(a))}).map(function(a,b){var c=n(this).val();return null==c?null:n.isArray(c)?n.map(c,function(a){return{name:b.name,value:a.replace(Db,"\r\n")}}):{name:b.name,value:c.replace(Db,"\r\n")}}).get()}}),n.ajaxSettings.xhr=function(){try{return new a.XMLHttpRequest}catch(b){}};var Hb={0:200,1223:204},Ib=n.ajaxSettings.xhr();l.cors=!!Ib&&"withCredentials"in Ib,l.ajax=Ib=!!Ib,n.ajaxTransport(function(b){var c,d;return l.cors||Ib&&!b.crossDomain?{send:function(e,f){var g,h=b.xhr();if(h.open(b.type,b.url,b.async,b.username,b.password),b.xhrFields)for(g in b.xhrFields)h[g]=b.xhrFields[g];b.mimeType&&h.overrideMimeType&&h.overrideMimeType(b.mimeType),b.crossDomain||e["X-Requested-With"]||(e["X-Requested-With"]="XMLHttpRequest");for(g in e)h.setRequestHeader(g,e[g]);c=function(a){return function(){c&&(c=d=h.onload=h.onerror=h.onabort=h.onreadystatechange=null,"abort"===a?h.abort():"error"===a?"number"!=typeof h.status?f(0,"error"):f(h.status,h.statusText):f(Hb[h.status]||h.status,h.statusText,"text"!==(h.responseType||"text")||"string"!=typeof h.responseText?{binary:h.response}:{text:h.responseText},h.getAllResponseHeaders()))}},h.onload=c(),d=h.onerror=c("error"),void 0!==h.onabort?h.onabort=d:h.onreadystatechange=function(){4===h.readyState&&a.setTimeout(function(){c&&d()})},c=c("abort");try{h.send(b.hasContent&&b.data||null)}catch(i){if(c)throw i}},abort:function(){c&&c()}}:void 0}),n.ajaxSetup({accepts:{script:"text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"},contents:{script:/\b(?:java|ecma)script\b/},converters:{"text script":function(a){return n.globalEval(a),a}}}),n.ajaxPrefilter("script",function(a){void 0===a.cache&&(a.cache=!1),a.crossDomain&&(a.type="GET")}),n.ajaxTransport("script",function(a){if(a.crossDomain){var b,c;return{send:function(e,f){b=n("<script>").prop({charset:a.scriptCharset,src:a.url}).on("load error",c=function(a){b.remove(),c=null,a&&f("error"===a.type?404:200,a.type)}),d.head.appendChild(b[0])},abort:function(){c&&c()}}}});var Jb=[],Kb=/(=)\?(?=&|$)|\?\?/;n.ajaxSetup({jsonp:"callback",jsonpCallback:function(){var a=Jb.pop()||n.expando+"_"+kb++;return this[a]=!0,a}}),n.ajaxPrefilter("json jsonp",function(b,c,d){var e,f,g,h=b.jsonp!==!1&&(Kb.test(b.url)?"url":"string"==typeof b.data&&0===(b.contentType||"").indexOf("application/x-www-form-urlencoded")&&Kb.test(b.data)&&"data");return h||"jsonp"===b.dataTypes[0]?(e=b.jsonpCallback=n.isFunction(b.jsonpCallback)?b.jsonpCallback():b.jsonpCallback,h?b[h]=b[h].replace(Kb,"$1"+e):b.jsonp!==!1&&(b.url+=(lb.test(b.url)?"&":"?")+b.jsonp+"="+e),b.converters["script json"]=function(){return g||n.error(e+" was not called"),g[0]},b.dataTypes[0]="json",f=a[e],a[e]=function(){g=arguments},d.always(function(){void 0===f?n(a).removeProp(e):a[e]=f,b[e]&&(b.jsonpCallback=c.jsonpCallback,Jb.push(e)),g&&n.isFunction(f)&&f(g[0]),g=f=void 0}),"script"):void 0}),n.parseHTML=function(a,b,c){if(!a||"string"!=typeof a)return null;"boolean"==typeof b&&(c=b,b=!1),b=b||d;var e=x.exec(a),f=!c&&[];return e?[b.createElement(e[1])]:(e=ca([a],b,f),f&&f.length&&n(f).remove(),n.merge([],e.childNodes))};var Lb=n.fn.load;n.fn.load=function(a,b,c){if("string"!=typeof a&&Lb)return Lb.apply(this,arguments);var d,e,f,g=this,h=a.indexOf(" ");return h>-1&&(d=n.trim(a.slice(h)),a=a.slice(0,h)),n.isFunction(b)?(c=b,b=void 0):b&&"object"==typeof b&&(e="POST"),g.length>0&&n.ajax({url:a,type:e||"GET",dataType:"html",data:b}).done(function(a){f=arguments,g.html(d?n("<div>").append(n.parseHTML(a)).find(d):a)}).always(c&&function(a,b){g.each(function(){c.apply(this,f||[a.responseText,b,a])})}),this},n.each(["ajaxStart","ajaxStop","ajaxComplete","ajaxError","ajaxSuccess","ajaxSend"],function(a,b){n.fn[b]=function(a){return this.on(b,a)}}),n.expr.filters.animated=function(a){return n.grep(n.timers,function(b){return a===b.elem}).length};function Mb(a){return n.isWindow(a)?a:9===a.nodeType&&a.defaultView}n.offset={setOffset:function(a,b,c){var d,e,f,g,h,i,j,k=n.css(a,"position"),l=n(a),m={};"static"===k&&(a.style.position="relative"),h=l.offset(),f=n.css(a,"top"),i=n.css(a,"left"),j=("absolute"===k||"fixed"===k)&&(f+i).indexOf("auto")>-1,j?(d=l.position(),g=d.top,e=d.left):(g=parseFloat(f)||0,e=parseFloat(i)||0),n.isFunction(b)&&(b=b.call(a,c,n.extend({},h))),null!=b.top&&(m.top=b.top-h.top+g),null!=b.left&&(m.left=b.left-h.left+e),"using"in b?b.using.call(a,m):l.css(m)}},n.fn.extend({offset:function(a){if(arguments.length)return void 0===a?this:this.each(function(b){n.offset.setOffset(this,a,b)});var b,c,d=this[0],e={top:0,left:0},f=d&&d.ownerDocument;if(f)return b=f.documentElement,n.contains(b,d)?(e=d.getBoundingClientRect(),c=Mb(f),{top:e.top+c.pageYOffset-b.clientTop,left:e.left+c.pageXOffset-b.clientLeft}):e},position:function(){if(this[0]){var a,b,c=this[0],d={top:0,left:0};return"fixed"===n.css(c,"position")?b=c.getBoundingClientRect():(a=this.offsetParent(),b=this.offset(),n.nodeName(a[0],"html")||(d=a.offset()),d.top+=n.css(a[0],"borderTopWidth",!0),d.left+=n.css(a[0],"borderLeftWidth",!0)),{top:b.top-d.top-n.css(c,"marginTop",!0),left:b.left-d.left-n.css(c,"marginLeft",!0)}}},offsetParent:function(){return this.map(function(){var a=this.offsetParent;while(a&&"static"===n.css(a,"position"))a=a.offsetParent;return a||Ea})}}),n.each({scrollLeft:"pageXOffset",scrollTop:"pageYOffset"},function(a,b){var c="pageYOffset"===b;n.fn[a]=function(d){return K(this,function(a,d,e){var f=Mb(a);return void 0===e?f?f[b]:a[d]:void(f?f.scrollTo(c?f.pageXOffset:e,c?e:f.pageYOffset):a[d]=e)},a,d,arguments.length)}}),n.each(["top","left"],function(a,b){n.cssHooks[b]=Ga(l.pixelPosition,function(a,c){return c?(c=Fa(a,b),Ba.test(c)?n(a).position()[b]+"px":c):void 0})}),n.each({Height:"height",Width:"width"},function(a,b){n.each({padding:"inner"+a,content:b,"":"outer"+a},function(c,d){n.fn[d]=function(d,e){var f=arguments.length&&(c||"boolean"!=typeof d),g=c||(d===!0||e===!0?"margin":"border");return K(this,function(b,c,d){var e;return n.isWindow(b)?b.document.documentElement["client"+a]:9===b.nodeType?(e=b.documentElement,Math.max(b.body["scroll"+a],e["scroll"+a],b.body["offset"+a],e["offset"+a],e["client"+a])):void 0===d?n.css(b,c,g):n.style(b,c,d,g)},b,f?d:void 0,f,null)}})}),n.fn.extend({bind:function(a,b,c){return this.on(a,null,b,c)},unbind:function(a,b){return this.off(a,null,b)},delegate:function(a,b,c,d){return this.on(b,a,c,d)},undelegate:function(a,b,c){return 1===arguments.length?this.off(a,"**"):this.off(b,a||"**",c)},size:function(){return this.length}}),n.fn.andSelf=n.fn.addBack,"function"==typeof define&&define.amd&&define("jquery",[],function(){return n});var Nb=a.jQuery,Ob=a.$;return n.noConflict=function(b){return a.$===n&&(a.$=Ob),b&&a.jQuery===n&&(a.jQuery=Nb),n},b||(a.jQuery=a.$=n),n});





// Attempts to preserve comments that likely contain licensing information,
// even if the comment does not have directives such as `@license` or `/*!`.
//
// Implemented via the [`uglify-save-license`](https://github.com/shinnn/uglify-save-license)
// module, this option preserves a comment if one of the following is true:
//
// 1. The comment is in the *first* line of a file
// 2. A regular expression matches the string of the comment.
//    For example: `MIT`, `@license`, or `Copyright`.
// 3. There is a comment at the *previous* line, and it matches 1, 2, or 3.


/*================ Slate 12 ================*/
/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {

  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function($element) {
    var focusClass = 'js-focus-hidden';

    $element.first()
      .attr('tabIndex', '-1')
      .focus()
      .addClass(focusClass)
      .one('blur', callback);

    function callback() {
      $element.first()
        .removeClass(focusClass)
        .removeAttr('tabindex');
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function() {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function() {
    $('a[href*=#]').on('click', function(evt) {
      this.pageLinkFocus($(evt.currentTarget.hash));
    }.bind(this));
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).on(eventName, function(evt) {
      if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  }
};

/**
 * Cart Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Cart template.
 *
 * @namespace cart
 */

slate.cart = {
  
  /**
   * Browser cookies are required to use the cart. This function checks if
   * cookies are enabled in the browser.
   */
  cookiesEnabled: function() {
    var cookieEnabled = navigator.cookieEnabled;

    if (!cookieEnabled){
      document.cookie = 'testcookie';
      cookieEnabled = (document.cookie.indexOf('testcookie') !== -1);
    }
    return cookieEnabled;
  }
};

/**
 * Utility helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions for dealing with arrays and objects
 *
 * @namespace utils
 */

slate.utils = {

  /**
   * Return an object from an array of objects that matches the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  findInstance: function(array, key, value) {
    for (var i = 0; i < array.length; i++) {
      if (array[i][key] === value) {
        return array[i];
      }
    }
  },

  /**
   * Remove an object from an array of objects by matching the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  removeInstance: function(array, key, value) {
    var i = array.length;
    while(i--) {
      if (array[i][key] === value) {
        array.splice(i, 1);
        break;
      }
    }

    return array;
  },

  /**
   * _.compact from lodash
   * Remove empty/false items from array
   * Source: https://github.com/lodash/lodash/blob/master/compact.js
   *
   * @param {array} array
   */
  compact: function(array) {
    var index = -1;
    var length = array == null ? 0 : array.length;
    var resIndex = 0;
    var result = [];

    while (++index < length) {
      var value = array[index];
      if (value) {
        result[resIndex++] = value;
      }
    }
    return result;
  },

  /**
   * _.defaultTo from lodash
   * Checks `value` to determine whether a default value should be returned in
   * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
   * or `undefined`.
   * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
   *
   * @param {*} value - Value to check
   * @param {*} defaultValue - Default value
   * @returns {*} - Returns the resolved value
   */
  defaultTo: function(value, defaultValue) {
    return (value == null || value !== value) ? defaultValue : value
  }
};

/**
 * Rich Text Editor
 * -----------------------------------------------------------------------------
 * Wrap videos in div to force responsive layout.
 *
 * @namespace rte
 */

slate.rte = {

  wrapTable: function() {
    $('.rte table').wrap('<div class="rte__table-wrapper"></div>');
  },

  iframeReset: function() {
    var $iframeVideo = $('.rte iframe[src*="youtube.com/embed"], .rte iframe[src*="player.vimeo"]');
    var $iframeReset = $iframeVideo.add('.rte iframe#admin_bar_iframe');

    $iframeVideo.each(function() {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="rte__video-wrapper"></div>');
    });

    $iframeReset.each(function() {
      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  }
};

slate.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:section:reorder', this._onReorder.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

slate.Sections.prototype = $.extend({}, slate.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (typeof constructor === 'undefined') {
      return;
    }

    var instance = $.extend(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (!instance) {
      return;
    }

    if (typeof instance.onUnload === 'function') {
      instance.onUnload(evt);
    }

    this.instances = slate.utils.removeInstance(this.instances, 'id', evt.detail.sectionId);
  },

  _onSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onSelect === 'function') {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onDeselect === 'function') {
      instance.onDeselect(evt);
    }
  },

  _onReorder: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onReorder === 'function') {
      instance.onReorder(evt);
    }
  },

  _onBlockSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockSelect === 'function') {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockDeselect === 'function') {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(function(index, container) {
      this._createInstance(container, constructor);
    }.bind(this));
  }
});

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */

slate.Currency = (function() {
  var moneyFormat = '${{amount}}';

  /**
   * Format money values based on your shop currency settings
   * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
   * or 3.00 dollars
   * @param  {String} format - shop money_format setting
   * @return {String} value - formatted value
   */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || moneyFormat);

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = slate.utils.defaultTo(precision, 2);
      thousands = slate.utils.defaultTo(thousands, ',');
      decimal = slate.utils.defaultTo(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? (decimal + parts[1]) : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_space_separator':
        value = formatWithDelimiters(cents, 2, ' ', '.');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, ',', '.');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  };
})();

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

slate.Image = (function() {

  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);

    if (match) {
      return match[1];
    } else {
      return null;
    }
  }

  /**
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === 'master') {
      return this.removeProtocol(src);
    }

    var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

    if (match) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    } else {
      return null;
    }
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  return {
    preload: preload,
    loadImage: loadImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol
  };
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist. Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function() {

  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();

    $(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));
  }

  Variants.prototype = $.extend({}, Variants.prototype, {

    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function() {
      var currentOptions = $.map($(this.singleOptionSelector, this.$container), function(element) {
        var $element = $(element);
        var type = $element.attr('type');
        var currentOption = {};

        if (type === 'radio' || type === 'checkbox') {
          if ($element[0].checked) {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');

            return currentOption;
          } else {
            return false;
          }
        } else {
          currentOption.value = $element.val();
          currentOption.index = $element.data('index');

          return currentOption;
        }
      });

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = slate.utils.compact(currentOptions);

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function() {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;
      var found = false;

      variants.forEach(function(variant) {
        var satisfied = true;

        selectedValues.forEach(function(option) {
          if (satisfied) {
            satisfied = (option.value === variant[option.index]);
          }
        });

        if (satisfied) {
          found = variant;
        }
      });

      return found || null;
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function() {
      var variant = this._getVariantFromOptions();

      this.$container.trigger({
        type: 'variantChange',
        variant: variant
      });

      if (!variant) {
        return;
      }

      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function(variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
        return;
      }

      this.$container.trigger({
        type: 'variantImageChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function(variant) {
      if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
        return;
      }

      this.$container.trigger({
        type: 'variantPriceChange',
        variant: variant
      });
    },

    /**
     * Update history state for product deeplinking
     *
     * @param  {variant} variant - Currently selected variant
     * @return {k}         [description]
     */
    _updateHistoryState: function(variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
      window.history.replaceState({path: newurl}, '', newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param  {variant} variant - Currently selected variant
     */
    _updateMasterSelect: function(variant) {
      $(this.originalSelectorId, this.$container)[0].value = variant.id;
    }
  });

  return Variants;
})();


/*================ Sections ================*/
/**
 * Product Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 *
   * @namespace product
 */

theme.Product = (function() {

  var selectors = {
    addToCart: '[data-add-to-cart]',
    addToCartText: '[data-add-to-cart-text]',
    comparePrice: '[data-compare-price]',
    comparePriceText: '[data-compare-text]',
    originalSelectorId: '[data-product-select]',
    priceWrapper: '[data-price-wrapper]',
    productFeaturedImage: '[data-product-featured-image]',
    productJson: '[data-product-json]',
    productPrice: '[data-product-price]',
    productThumbs: '[data-product-single-thumbnail]',
    singleOptionSelector: '[data-single-option-selector]'
  };

  /**
   * Product section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function Product(container) {
    this.$container = $(container);

    // Stop parsing if we don't have the product json script tag when loading
    // section in the Theme Editor
    if (!$(selectors.productJson, this.$container).html()) {
      return;
    }

    var sectionId = this.$container.attr('data-section-id');
    this.productSingleObject = JSON.parse($(selectors.productJson, this.$container).html());

    var options = {
      $container: this.$container,
      enableHistoryState: this.$container.data('enable-history-state') || false,
      singleOptionSelector: selectors.singleOptionSelector,
      originalSelectorId: selectors.originalSelectorId,
      product: this.productSingleObject
    };

    this.settings = {};
    this.namespace = '.product';
    this.variants = new slate.Variants(options);
    this.$featuredImage = $(selectors.productFeaturedImage, this.$container);

    this.$container.on('variantChange' + this.namespace, this.updateAddToCartState.bind(this));
    this.$container.on('variantPriceChange' + this.namespace, this.updateProductPrices.bind(this));

    if (this.$featuredImage.length > 0) {
      this.settings.imageSize = slate.Image.imageSize(this.$featuredImage.attr('src'));
      slate.Image.preload(this.productSingleObject.images, this.settings.imageSize);

      this.$container.on('variantImageChange' + this.namespace, this.updateProductImage.bind(this));
    }
  }

  Product.prototype = $.extend({}, Product.prototype, {

    /**
     * Updates the DOM state of the add to cart button
     *
     * @param {boolean} enabled - Decides whether cart is enabled or disabled
     * @param {string} text - Updates the text notification content of the cart
     */
    updateAddToCartState: function(evt) {
      var variant = evt.variant;

      if (variant) {
        $(selectors.priceWrapper, this.$container).removeClass('hide');
      } else {
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCartText, this.$container).html(theme.strings.unavailable);
        $(selectors.priceWrapper, this.$container).addClass('hide');
        return;
      }

      if (variant.available) {
        $(selectors.addToCart, this.$container).prop('disabled', false);
        $(selectors.addToCartText, this.$container).html(theme.strings.addToCart);
      } else {
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCartText, this.$container).html(theme.strings.soldOut);
      }
    },

    /**
     * Updates the DOM with specified prices
     *
     * @param {string} productPrice - The current price of the product
     * @param {string} comparePrice - The original price of the product
     */
    updateProductPrices: function(evt) {
      var variant = evt.variant;
      var $comparePrice = $(selectors.comparePrice, this.$container);
      var $compareEls = $comparePrice.add(selectors.comparePriceText, this.$container);

      $(selectors.productPrice, this.$container)
        .html(slate.Currency.formatMoney(variant.price, theme.moneyFormat));

      if (variant.compare_at_price > variant.price) {
        $comparePrice.html(slate.Currency.formatMoney(variant.compare_at_price, theme.moneyFormat));
        $compareEls.removeClass('hide');
      } else {
        $comparePrice.html('');
        $compareEls.addClass('hide');
      }
    },

    /**
     * Updates the DOM with the specified image URL
     *
     * @param {string} src - Image src URL
     */
    updateProductImage: function(evt) {
      var variant = evt.variant;
      var sizedImgUrl = slate.Image.getSizedImageUrl(variant.featured_image.src, this.settings.imageSize);

      this.$featuredImage.attr('src', sizedImgUrl);
    },

    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload: function() {
      this.$container.off(this.namespace);
    }
  });

  return Product;
})();

! function() {
    function t(t, e) {
        return e = {
            exports: {}
        }, t(e, e.exports), e.exports
    }

    function e(t, e) {
        for (var n = -1, i = null == t ? 0 : t.length, r = Array(i); ++n < i;) r[n] = e(t[n], n, t);
        return r
    }

    function n() {
        this.__data__ = [], this.size = 0
    }

    function i(t, e) {
        return t === e || t !== t && e !== e
    }

    function r(t, e) {
        for (var n = t.length; n--;)
            if (i(t[n][0], e)) return n;
        return -1
    }

    function o(t) {
        var e = this.__data__,
            n = r(e, t);
        return !(n < 0) && (n == e.length - 1 ? e.pop() : An.call(e, n, 1), --this.size, !0)
    }

    function s(t) {
        var e = this.__data__,
            n = r(e, t);
        return n < 0 ? void 0 : e[n][1]
    }

    function a(t) {
        return r(this.__data__, t) > -1
    }

    function c(t, e) {
        var n = this.__data__,
            i = r(n, t);
        return i < 0 ? (++this.size, n.push([t, e])) : n[i][1] = e, this
    }

    function u(t) {
        var e = -1,
            n = null == t ? 0 : t.length;
        for (this.clear(); ++e < n;) {
            var i = t[e];
            this.set(i[0], i[1])
        }
    }

    function l() {
        this.__data__ = new u, this.size = 0
    }

    function d(t) {
        var e = this.__data__,
            n = e.delete(t);
        return this.size = e.size, n
    }

    function h(t) {
        return this.__data__.get(t)
    }

    function f(t) {
        return this.__data__.has(t)
    }

    function p(t) {
        var e = In.call(t, Bn),
            n = t[Bn];
        try {
            t[Bn] = void 0;
            var i = !0
        } catch (t) {}
        var r = Fn.call(t);
        return i && (e ? t[Bn] = n : delete t[Bn]), r
    }

    function m(t) {
        return Hn.call(t)
    }

    function g(t) {
        return null == t ? void 0 === t ? qn : Mn : (t = Object(t), Rn && Rn in t ? p(t) : m(t))
    }

    function v(t) {
        var e = typeof t;
        return null != t && ("object" == e || "function" == e)
    }

    function y(t) {
        if (!v(t)) return !1;
        var e = g(t);
        return e == zn || e == Vn || e == Wn || e == Un
    }

    function b(t) {
        return !!Yn && Yn in t
    }

    function _(t) {
        if (null != t) {
            try {
                return Gn.call(t)
            } catch (t) {}
            try {
                return t + ""
            } catch (t) {}
        }
        return ""
    }

    function w(t) {
        return !(!v(t) || b(t)) && (y(t) ? ii : Jn).test(_(t))
    }

    function S(t, e) {
        return null == t ? void 0 : t[e]
    }

    function x(t, e) {
        var n = S(t, e);
        return w(n) ? n : void 0
    }

    function C() {
        this.__data__ = oi ? oi(null) : {}, this.size = 0
    }

    function T(t) {
        var e = this.has(t) && delete this.__data__[t];
        return this.size -= e ? 1 : 0, e
    }

    function k(t) {
        var e = this.__data__;
        if (oi) {
            var n = e[t];
            return n === si ? void 0 : n
        }
        return ci.call(e, t) ? e[t] : void 0
    }

    function E(t) {
        var e = this.__data__;
        return oi ? void 0 !== e[t] : li.call(e, t)
    }

    function A(t, e) {
        var n = this.__data__;
        return this.size += this.has(t) ? 0 : 1, n[t] = oi && void 0 === e ? di : e, this
    }

    function j(t) {
        var e = -1,
            n = null == t ? 0 : t.length;
        for (this.clear(); ++e < n;) {
            var i = t[e];
            this.set(i[0], i[1])
        }
    }

    function P() {
        this.size = 0, this.__data__ = {
            hash: new j,
            map: new(ri || u),
            string: new j
        }
    }

    function D(t) {
        var e = typeof t;
        return "string" == e || "number" == e || "symbol" == e || "boolean" == e ? "__proto__" !== t : null === t
    }

    function N(t, e) {
        var n = t.__data__;
        return D(e) ? n["string" == typeof e ? "string" : "hash"] : n.map
    }

    function O(t) {
        var e = N(this, t).delete(t);
        return this.size -= e ? 1 : 0, e
    }

    function I(t) {
        return N(this, t).get(t)
    }

    function F(t) {
        return N(this, t).has(t)
    }

    function B(t, e) {
        var n = N(this, t),
            i = n.size;
        return n.set(t, e), this.size += n.size == i ? 0 : 1, this
    }

    function L(t) {
        var e = -1,
            n = null == t ? 0 : t.length;
        for (this.clear(); ++e < n;) {
            var i = t[e];
            this.set(i[0], i[1])
        }
    }

    function H(t, e) {
        var n = this.__data__;
        if (n instanceof u) {
            var i = n.__data__;
            if (!ri || i.length < hi - 1) return i.push([t, e]), this.size = ++n.size, this;
            n = this.__data__ = new L(i)
        }
        return n.set(t, e), this.size = n.size, this
    }

    function M(t) {
        var e = this.__data__ = new u(t);
        this.size = e.size
    }

    function q(t, e) {
        for (var n = -1, i = null == t ? 0 : t.length; ++n < i && !1 !== e(t[n], n, t););
        return t
    }

    function R(t, e, n) {
        "__proto__" == e && fi ? fi(t, e, {
            configurable: !0,
            enumerable: !0,
            value: n,
            writable: !0
        }) : t[e] = n
    }

    function W(t, e, n) {
        var r = t[e];
        mi.call(t, e) && i(r, n) && (void 0 !== n || e in t) || R(t, e, n)
    }

    function z(t, e, n, i) {
        var r = !n;
        n || (n = {});
        for (var o = -1, s = e.length; ++o < s;) {
            var a = e[o],
                c = i ? i(n[a], t[a], a, n, t) : void 0;
            void 0 === c && (c = t[a]), r ? R(n, a, c) : W(n, a, c)
        }
        return n
    }

    function V(t, e) {
        for (var n = -1, i = Array(t); ++n < t;) i[n] = e(n);
        return i
    }

    function U(t) {
        return null != t && "object" == typeof t
    }

    function X(t) {
        return U(t) && g(t) == gi
    }

    function Y() {
        return !1
    }

    function Q(t, e) {
        return !!(e = null == e ? Ei : e) && ("number" == typeof t || Ai.test(t)) && t > -1 && t % 1 == 0 && t < e
    }

    function G(t) {
        return "number" == typeof t && t > -1 && t % 1 == 0 && t <= ji
    }

    function K(t) {
        return U(t) && G(t.length) && !!Pi[g(t)]
    }

    function J(t, e) {
        var n = wi(t),
            i = !n && _i(t),
            r = !n && !i && $i(t),
            o = !n && !i && !r && Li(t),
            s = n || i || r || o,
            a = s ? V(t.length, String) : [],
            c = a.length;
        for (var u in t) !e && !Mi.call(t, u) || s && ("length" == u || r && ("offset" == u || "parent" == u) || o && ("buffer" == u || "byteLength" == u || "byteOffset" == u) || Q(u, c)) || a.push(u);
        return a
    }

    function Z(t) {
        var e = t && t.constructor;
        return t === ("function" == typeof e && e.prototype || qi)
    }

    function tt(t, e) {
        return function(n) {
            return t(e(n))
        }
    }

    function et(t) {
        if (!Z(t)) return Ri(t);
        var e = [];
        for (var n in Object(t)) zi.call(t, n) && "constructor" != n && e.push(n);
        return e
    }

    function nt(t) {
        return null != t && G(t.length) && !y(t)
    }

    function it(t) {
        return nt(t) ? J(t) : et(t)
    }

    function rt(t, e) {
        return t && z(e, it(e), t)
    }

    function ot(t) {
        var e = [];
        if (null != t)
            for (var n in Object(t)) e.push(n);
        return e
    }

    function st(t) {
        if (!v(t)) return ot(t);
        var e = Z(t),
            n = [];
        for (var i in t)("constructor" != i || !e && Ui.call(t, i)) && n.push(i);
        return n
    }

    function at(t) {
        return nt(t) ? J(t, !0) : st(t)
    }

    function ct(t, e) {
        return t && z(e, at(e), t)
    }

    function ut(t, e) {
        if (e) return t.slice();
        var n = t.length,
            i = Ki ? Ki(n) : new t.constructor(n);
        return t.copy(i), i
    }

    function lt(t, e) {
        var n = -1,
            i = t.length;
        for (e || (e = Array(i)); ++n < i;) e[n] = t[n];
        return e
    }

    function dt() {
        return []
    }

    function ht(t, e) {
        return z(t, Zi(t), e)
    }

    function ft(t, e) {
        for (var n = -1, i = e.length, r = t.length; ++n < i;) t[r + n] = e[n];
        return t
    }

    function pt(t, e) {
        return z(t, nr(t), e)
    }

    function mt(t, e, n) {
        var i = e(t);
        return wi(t) ? i : ft(i, n(t))
    }

    function gt(t) {
        return mt(t, it, Zi)
    }

    function vt(t) {
        return mt(t, at, nr)
    }

    function yt(t) {
        var e = t.length,
            n = t.constructor(e);
        return e && "string" == typeof t[0] && mr.call(t, "index") && (n.index = t.index, n.input = t.input), n
    }

    function bt(t) {
        var e = new t.constructor(t.byteLength);
        return new gr(e).set(new gr(t)), e
    }

    function _t(t, e) {
        var n = e ? bt(t.buffer) : t.buffer;
        return new t.constructor(n, t.byteOffset, t.byteLength)
    }

    function wt(t, e) {
        return t.set(e[0], e[1]), t
    }

    function St(t, e, n, i) {
        var r = -1,
            o = null == t ? 0 : t.length;
        for (i && o && (n = t[++r]); ++r < o;) n = e(n, t[r], r, t);
        return n
    }

    function xt(t) {
        var e = -1,
            n = Array(t.size);
        return t.forEach(function(t, i) {
            n[++e] = [i, t]
        }), n
    }

    function Ct(t, e, n) {
        return St(e ? n(xt(t), vr) : xt(t), wt, new t.constructor)
    }

    function Tt(t) {
        var e = new t.constructor(t.source, yr.exec(t));
        return e.lastIndex = t.lastIndex, e
    }

    function kt(t, e) {
        return t.add(e), t
    }

    function $t(t) {
        var e = -1,
            n = Array(t.size);
        return t.forEach(function(t) {
            n[++e] = t
        }), n
    }

    function Et(t, e, n) {
        return St(e ? n($t(t), br) : $t(t), kt, new t.constructor)
    }

    function At(t) {
        return wr ? Object(wr.call(t)) : {}
    }

    function jt(t, e) {
        var n = e ? bt(t.buffer) : t.buffer;
        return new t.constructor(n, t.byteOffset, t.length)
    }

    function Pt(t, e, n, i) {
        var r = t.constructor;
        switch (e) {
            case jr:
                return bt(t);
            case Sr:
            case xr:
                return new r(+t);
            case Pr:
                return _t(t, i);
            case Dr:
            case Nr:
            case Or:
            case Ir:
            case Fr:
            case Br:
            case Lr:
            case Hr:
            case Mr:
                return jt(t, i);
            case Cr:
                return Ct(t, i, n);
            case Tr:
            case Er:
                return new r(t);
            case kr:
                return Tt(t);
            case $r:
                return Et(t, i, n);
            case Ar:
                return At(t)
        }
    }

    function Dt(t) {
        return "function" != typeof t.constructor || Z(t) ? {} : Rr(tr(t))
    }

    function Nt(t, e, n, i, r, o) {
        var s, a = e & Wr,
            c = e & zr,
            u = e & Vr;
        if (n && (s = r ? n(t, i, r, o) : n(t)), void 0 !== s) return s;
        if (!v(t)) return t;
        var l = wi(t);
        if (l) {
            if (s = yt(t), !a) return lt(t, s)
        } else {
            var d = fr(t),
                h = d == Xr || d == Yr;
            if ($i(t)) return ut(t, a);
            if (d == Qr || d == Ur || h && !r) {
                if (s = c || h ? {} : Dt(t), !a) return c ? pt(t, ct(s, t)) : ht(t, rt(s, t))
            } else {
                if (!Gr[d]) return r ? t : {};
                s = Pt(t, d, Nt, a)
            }
        }
        o || (o = new M);
        var f = o.get(t);
        if (f) return f;
        o.set(t, s);
        var p = u ? c ? vt : gt : c ? keysIn : it,
            m = l ? void 0 : p(t);
        return q(m || t, function(i, r) {
            m && (r = i, i = t[r]), W(s, r, Nt(i, e, n, r, t, o))
        }), s
    }

    function Ot(t) {
        return "symbol" == typeof t || U(t) && g(t) == Kr
    }

    function It(t, e) {
        if (wi(t)) return !1;
        var n = typeof t;
        return !("number" != n && "symbol" != n && "boolean" != n && null != t && !Ot(t)) || (Zr.test(t) || !Jr.test(t) || null != e && t in Object(e))
    }

    function Ft(t, e) {
        if ("function" != typeof t || null != e && "function" != typeof e) throw new TypeError(to);
        var n = function() {
            var i = arguments,
                r = e ? e.apply(this, i) : i[0],
                o = n.cache;
            if (o.has(r)) return o.get(r);
            var s = t.apply(this, i);
            return n.cache = o.set(r, s) || o, s
        };
        return n.cache = new(Ft.Cache || L), n
    }

    function Bt(t) {
        if ("string" == typeof t) return t;
        if (wi(t)) return e(t, Bt) + "";
        if (Ot(t)) return co ? co.call(t) : "";
        var n = t + "";
        return "0" == n && 1 / t == -so ? "-0" : n
    }

    function Lt(t) {
        return null == t ? "" : Bt(t)
    }

    function Ht(t, e) {
        return wi(t) ? t : It(t, e) ? [t] : oo(Lt(t))
    }

    function Mt(t) {
        var e = null == t ? 0 : t.length;
        return e ? t[e - 1] : void 0
    }

    function qt(t) {
        if ("string" == typeof t || Ot(t)) return t;
        var e = t + "";
        return "0" == e && 1 / t == -uo ? "-0" : e
    }

    function Rt(t, e) {
        e = Ht(e, t);
        for (var n = 0, i = e.length; null != t && n < i;) t = t[qt(e[n++])];
        return n && n == i ? t : void 0
    }

    function Wt(t, e, n) {
        var i = -1,
            r = t.length;
        e < 0 && (e = -e > r ? 0 : r + e), n = n > r ? r : n, n < 0 && (n += r), r = e > n ? 0 : n - e >>> 0, e >>>= 0;
        for (var o = Array(r); ++i < r;) o[i] = t[i + e];
        return o
    }

    function zt(t, e) {
        return e.length < 2 ? t : Rt(t, Wt(e, 0, -1))
    }

    function Vt(t, e) {
        return e = Ht(e, t), null == (t = zt(t, e)) || delete t[qt(Mt(e))]
    }

    function Ut(t) {
        return wi(t) || _i(t) || !!(lo && t && t[lo])
    }

    function Xt(t, e, n, i, r) {
        var o = -1,
            s = t.length;
        for (n || (n = Ut), r || (r = []); ++o < s;) {
            var a = t[o];
            e > 0 && n(a) ? e > 1 ? Xt(a, e - 1, n, i, r) : ft(r, a) : i || (r[r.length] = a)
        }
        return r
    }

    function Yt(t) {
        return (null == t ? 0 : t.length) ? Xt(t, 1) : []
    }

    function Qt(t, e, n) {
        switch (n.length) {
            case 0:
                return t.call(e);
            case 1:
                return t.call(e, n[0]);
            case 2:
                return t.call(e, n[0], n[1]);
            case 3:
                return t.call(e, n[0], n[1], n[2])
        }
        return t.apply(e, n)
    }

    function Gt(t, e, n) {
        return e = ho(void 0 === e ? t.length - 1 : e, 0),
            function() {
                for (var i = arguments, r = -1, o = ho(i.length - e, 0), s = Array(o); ++r < o;) s[r] = i[e + r];
                r = -1;
                for (var a = Array(e + 1); ++r < e;) a[r] = i[r];
                return a[e] = n(s), Qt(t, this, a)
            }
    }

    function Kt(t) {
        return function() {
            return t
        }
    }

    function Jt(t) {
        return t
    }

    function Zt(t) {
        return this.__data__.set(t, bo), this
    }

    function te(t) {
        return this.__data__.has(t)
    }

    function ee(t) {
        var e = -1,
            n = null == t ? 0 : t.length;
        for (this.__data__ = new L; ++e < n;) this.add(t[e])
    }

    function ne(t, e) {
        for (var n = -1, i = null == t ? 0 : t.length; ++n < i;)
            if (e(t[n], n, t)) return !0;
        return !1
    }

    function ie(t, e) {
        return t.has(e)
    }

    function re(t, e, n, i, r, o) {
        var s = n & _o,
            a = t.length,
            c = e.length;
        if (a != c && !(s && c > a)) return !1;
        var u = o.get(t);
        if (u && o.get(e)) return u == e;
        var l = -1,
            d = !0,
            h = n & wo ? new ee : void 0;
        for (o.set(t, e), o.set(e, t); ++l < a;) {
            var f = t[l],
                p = e[l];
            if (i) var m = s ? i(p, f, l, e, t, o) : i(f, p, l, t, e, o);
            if (void 0 !== m) {
                if (m) continue;
                d = !1;
                break
            }
            if (h) {
                if (!ne(e, function(t, e) {
                        if (!ie(h, e) && (f === t || r(f, t, n, i, o))) return h.push(e)
                    })) {
                    d = !1;
                    break
                }
            } else if (f !== p && !r(f, p, n, i, o)) {
                d = !1;
                break
            }
        }
        return o.delete(t), o.delete(e), d
    }

    function oe(t, e, n, r, o, s, a) {
        switch (n) {
            case Oo:
                if (t.byteLength != e.byteLength || t.byteOffset != e.byteOffset) return !1;
                t = t.buffer, e = e.buffer;
            case No:
                return !(t.byteLength != e.byteLength || !s(new gr(t), new gr(e)));
            case Co:
            case To:
            case Eo:
                return i(+t, +e);
            case ko:
                return t.name == e.name && t.message == e.message;
            case Ao:
            case Po:
                return t == e + "";
            case $o:
                var c = xt;
            case jo:
                var u = r & So;
                if (c || (c = $t), t.size != e.size && !u) return !1;
                var l = a.get(t);
                if (l) return l == e;
                r |= xo, a.set(t, e);
                var d = re(c(t), c(e), r, o, s, a);
                return a.delete(t), d;
            case Do:
                if (Fo) return Fo.call(t) == Fo.call(e)
        }
        return !1
    }

    function se(t, e, n, i, r, o) {
        var s = n & Bo,
            a = it(t),
            c = a.length;
        if (c != it(e).length && !s) return !1;
        for (var u = c; u--;) {
            var l = a[u];
            if (!(s ? l in e : Ho.call(e, l))) return !1
        }
        var d = o.get(t);
        if (d && o.get(e)) return d == e;
        var h = !0;
        o.set(t, e), o.set(e, t);
        for (var f = s; ++u < c;) {
            l = a[u];
            var p = t[l],
                m = e[l];
            if (i) var g = s ? i(m, p, l, e, t, o) : i(p, m, l, t, e, o);
            if (!(void 0 === g ? p === m || r(p, m, n, i, o) : g)) {
                h = !1;
                break
            }
            f || (f = "constructor" == l)
        }
        if (h && !f) {
            var v = t.constructor,
                y = e.constructor;
            v != y && "constructor" in t && "constructor" in e && !("function" == typeof v && v instanceof v && "function" == typeof y && y instanceof y) && (h = !1)
        }
        return o.delete(t), o.delete(e), h
    }

    function ae(t, e, n, i, r, o) {
        var s = wi(t),
            a = wi(e),
            c = Ro,
            u = Ro;
        s || (c = fr(t), c = c == qo ? Wo : c), a || (u = fr(e), u = u == qo ? Wo : u);
        var l = c == Wo,
            d = u == Wo,
            h = c == u;
        if (h && $i(t)) {
            if (!$i(e)) return !1;
            s = !0, l = !1
        }
        if (h && !l) return o || (o = new M), s || Li(t) ? re(t, e, n, i, r, o) : oe(t, e, c, n, i, r, o);
        if (!(n & Mo)) {
            var f = l && Vo.call(t, "__wrapped__"),
                p = d && Vo.call(e, "__wrapped__");
            if (f || p) {
                var m = f ? t.value() : t,
                    g = p ? e.value() : e;
                return o || (o = new M), r(m, g, n, i, o)
            }
        }
        return !!h && (o || (o = new M), se(t, e, n, i, r, o))
    }

    function ce(t, e, n, i, r) {
        return t === e || (null == t || null == e || !v(t) && !U(e) ? t !== t && e !== e : ae(t, e, n, i, ce, r))
    }

    function ue(t, e, n, i) {
        var r = n.length,
            o = r,
            s = !i;
        if (null == t) return !o;
        for (t = Object(t); r--;) {
            var a = n[r];
            if (s && a[2] ? a[1] !== t[a[0]] : !(a[0] in t)) return !1
        }
        for (; ++r < o;) {
            a = n[r];
            var c = a[0],
                u = t[c],
                l = a[1];
            if (s && a[2]) {
                if (void 0 === u && !(c in t)) return !1
            } else {
                var d = new M;
                if (i) var h = i(u, l, c, t, e, d);
                if (!(void 0 === h ? ce(l, u, Uo | Xo, i, d) : h)) return !1
            }
        }
        return !0
    }

    function le(t) {
        return t === t && !v(t)
    }

    function de(t) {
        for (var e = it(t), n = e.length; n--;) {
            var i = e[n],
                r = t[i];
            e[n] = [i, r, le(r)]
        }
        return e
    }

    function he(t, e) {
        return function(n) {
            return null != n && (n[t] === e && (void 0 !== e || t in Object(n)))
        }
    }

    function fe(t) {
        var e = de(t);
        return 1 == e.length && e[0][2] ? he(e[0][0], e[0][1]) : function(n) {
            return n === t || ue(n, t, e)
        }
    }

    function pe(t, e, n) {
        var i = null == t ? void 0 : Rt(t, e);
        return void 0 === i ? n : i
    }

    function me(t, e) {
        return null != t && e in Object(t)
    }

    function ge(t, e, n) {
        e = Ht(e, t);
        for (var i = -1, r = e.length, o = !1; ++i < r;) {
            var s = qt(e[i]);
            if (!(o = null != t && n(t, s))) break;
            t = t[s]
        }
        return o || ++i != r ? o : !!(r = null == t ? 0 : t.length) && G(r) && Q(s, r) && (wi(t) || _i(t))
    }

    function ve(t, e) {
        return null != t && ge(t, e, me)
    }

    function ye(t, e) {
        return It(t) && le(e) ? he(qt(t), e) : function(n) {
            var i = pe(n, t);
            return void 0 === i && i === e ? ve(n, t) : ce(e, i, Yo | Qo)
        }
    }

    function be(t) {
        return function(e) {
            return null == e ? void 0 : e[t]
        }
    }

    function _e(t) {
        return function(e) {
            return Rt(e, t)
        }
    }

    function we(t) {
        return It(t) ? be(qt(t)) : _e(t)
    }

    function Se(t) {
        return "function" == typeof t ? t : null == t ? Jt : "object" == typeof t ? wi(t) ? ye(t[0], t[1]) : fe(t) : we(t)
    }

    function xe(t, e, n, i) {
        for (var r = t.length, o = n + (i ? 1 : -1); i ? o-- : ++o < r;)
            if (e(t[o], o, t)) return o;
        return -1
    }

    function Ce(t) {
        if ("number" == typeof t) return t;
        if (Ot(t)) return Go;
        if (v(t)) {
            var e = "function" == typeof t.valueOf ? t.valueOf() : t;
            t = v(e) ? e + "" : e
        }
        if ("string" != typeof t) return 0 === t ? t : +t;
        t = t.replace(Ko, "");
        var n = Zo.test(t);
        return n || ts.test(t) ? es(t.slice(2), n ? 2 : 8) : Jo.test(t) ? Go : +t
    }

    function Te(t) {
        if (!t) return 0 === t ? t : 0;
        if ((t = Ce(t)) === ns || t === -ns) {
            return (t < 0 ? -1 : 1) * is
        }
        return t === t ? t : 0
    }

    function ke(t) {
        var e = Te(t),
            n = e % 1;
        return e === e ? n ? e - n : e : 0
    }

    function $e(t, e, n) {
        var i = null == t ? 0 : t.length;
        if (!i) return -1;
        var r = null == n ? 0 : ke(n);
        return r < 0 && (r = rs(i + r, 0)), xe(t, Se(e, 3), r)
    }

    function Ee() {
        this.registered = {}, this.instances = [], this.extensions = {
            "*": []
        }
    }

    function Ae() {
        this.extensions.forEach(function(t) {
            this.extend(t)
        }.bind(this))
    }

    function je(t, e, n) {
        function i(e) {
            var n = h,
                i = f;
            return h = f = void 0, b = e, m = t.apply(i, n)
        }

        function r(t) {
            return b = t, g = setTimeout(a, e), _ ? i(t) : m
        }

        function o(t) {
            var n = t - y,
                i = t - b,
                r = e - n;
            return w ? hs(r, p - i) : r
        }

        function s(t) {
            var n = t - y,
                i = t - b;
            return void 0 === y || n >= e || n < 0 || w && i >= p
        }

        function a() {
            var t = us();
            if (s(t)) return c(t);
            g = setTimeout(a, o(t))
        }

        function c(t) {
            return g = void 0, S && h ? i(t) : (h = f = void 0, m)
        }

        function u() {
            void 0 !== g && clearTimeout(g), b = 0, h = y = f = g = void 0
        }

        function l() {
            return void 0 === g ? m : c(us())
        }

        function d() {
            var t = us(),
                n = s(t);
            if (h = arguments, f = this, y = t, n) {
                if (void 0 === g) return r(y);
                if (w) return g = setTimeout(a, e), i(y)
            }
            return void 0 === g && (g = setTimeout(a, e)), m
        }
        var h, f, p, m, g, y, b = 0,
            _ = !1,
            w = !1,
            S = !0;
        if ("function" != typeof t) throw new TypeError(ls);
        return e = Ce(e) || 0, v(n) && (_ = !!n.leading, w = "maxWait" in n, p = w ? ds(Ce(n.maxWait) || 0, e) : p, S = "trailing" in n ? !!n.trailing : S), d.cancel = u, d.flush = l, d
    }

    function Pe(t, e, n) {
        var i = !0,
            r = !0;
        if ("function" != typeof t) throw new TypeError(fs);
        return v(n) && (i = "leading" in n ? !!n.leading : i, r = "trailing" in n ? !!n.trailing : r), je(t, e, {
            leading: i,
            maxWait: e,
            trailing: r
        })
    }

    function De(t, e) {
        for (var n = t ? e.length : 0, i = n - 1; n--;) {
            var r = e[n];
            if (n == i || r !== o) {
                var o = r;
                Q(r) ? Ps.call(t, r, 1) : Vt(t, r)
            }
        }
        return t
    }

    function Ne(t, e) {
        var n = [];
        if (!t || !t.length) return n;
        var i = -1,
            r = [],
            o = t.length;
        for (e = Se(e, 3); ++i < o;) {
            var s = t[i];
            e(s, i, t) && (n.push(s), r.push(i))
        }
        return De(t, r), n
    }

    function Oe(t, e) {
        for (var n = -1, i = null == t ? 0 : t.length, r = 0, o = []; ++n < i;) {
            var s = t[n];
            e(s, n, t) && (o[r++] = s)
        }
        return o
    }

    function Ie(t, e) {
        return t && Ds(t, e, it)
    }

    function Fe(t, e) {
        var n = [];
        return Ns(t, function(t, i, r) {
            e(t, i, r) && n.push(t)
        }), n
    }

    function Be(t, e) {
        return (wi(t) ? Oe : Fe)(t, Se(e, 3))
    }

    function Le() {
        this.$document = $n(document), this.namespace = ".section-js-events", document.addEventListener("shopify:section:load", function(t) {
            var e = t.detail.sectionId,
                n = t.target.querySelector('[data-section-id="' + e + '"]'),
                i = n.getAttribute("data-section-type");
            this.load(i, n)
        }.bind(this))
    }

    function He(t) {
        this.container = t.container, this.$container = $n(this.container), this.id = t.id, this.namespace = "." + t.id, this.extensions = t.extensions || [], this.$eventBinder = this.$container, Me.call(this), qe.call(this), Re.call(this)
    }

    function Me() {
        this.extensions.forEach(function(t) {
            this.extend(t)
        }.bind(this))
    }

    function qe() {
        $n(document).on("shopify:section:unload" + this.namespace, We.bind(this)).on("shopify:section:select" + this.namespace, ze.bind(this)).on("shopify:section:deselect" + this.namespace, Ve.bind(this)).on("shopify:block:select" + this.namespace, Ue.bind(this)).on("shopify:block:deselect" + this.namespace, Xe.bind(this))
    }

    function Re() {
        this.on("section_load", this.onLoad.bind(this)), this.on("section_unload", this.onUnload.bind(this)), this.on("section_select", this.onSelect.bind(this)), this.on("section_deselect", this.onDeselect.bind(this)), this.on("block_select", this.onBlockSelect.bind(this)), this.on("block_deselect", this.onBlockDeselect.bind(this))
    }

    function We(t) {
        this.id === t.detail.sectionId && (t.type = "section_unload", this.trigger(t), this.off(this.namespace), Os.off(this.namespace), $n(document).off(this.namespace), $n(window).off(this.namespace), Ne(Os.instances, {
            id: this.id
        }))
    }

    function ze(t) {
        this.id === t.detail.sectionId && (t.type = "section_select", this.trigger(t))
    }

    function Ve(t) {
        this.id === t.detail.sectionId && (t.type = "section_deselect", this.trigger(t))
    }

    function Ue(t) {
        this.id === t.detail.sectionId && (t.type = "block_select", this.trigger(t))
    }

    function Xe(t) {
        this.id === t.detail.sectionId && (t.type = "block_deselect", this.trigger(t))
    }

    function Ye(t) {
        var e = typeof t;
        return null != t && ("object" == e || "function" == e)
    }

    function Qe(t) {
        var e = Xs.call(t, Qs),
            n = t[Qs];
        try {
            t[Qs] = void 0;
            var i = !0
        } catch (t) {}
        var r = Ys.call(t);
        return i && (e ? t[Qs] = n : delete t[Qs]), r
    }

    function Ge(t) {
        return Js.call(t)
    }

    function Ke(t) {
        return null == t ? void 0 === t ? ra : ia : oa && oa in Object(t) ? ea(t) : na(t)
    }

    function Je(t) {
        return null != t && "object" == typeof t
    }

    function Ze(t) {
        return "symbol" == typeof t || ua(t) && ca(t) == la
    }

    function tn(t) {
        if ("number" == typeof t) return t;
        if (fa(t)) return pa;
        if (ha(t)) {
            var e = "function" == typeof t.valueOf ? t.valueOf() : t;
            t = ha(e) ? e + "" : e
        }
        if ("string" != typeof t) return 0 === t ? t : +t;
        t = t.replace(ma, "");
        var n = va.test(t);
        return n || ya.test(t) ? ba(t.slice(2), n ? 2 : 8) : ga.test(t) ? pa : +t
    }

    function en(t) {
        if (!t) return 0 === t ? t : 0;
        if ((t = wa(t)) === Sa || t === -Sa) {
            return (t < 0 ? -1 : 1) * xa
        }
        return t === t ? t : 0
    }

    function nn(t) {
        var e = Ta(t),
            n = e % 1;
        return e === e ? n ? e - n : e : 0
    }

    function rn(t, e, n) {
        return t === t && (void 0 !== n && (t = t <= n ? t : n), void 0 !== e && (t = t >= e ? t : e)), t
    }

    function on(t) {
        return t ? Ea(Aa(t), 0, ja) : 0
    }

    function sn(t, e, n, i) {
        var r = t.length;
        for (n = Da(n), n < 0 && (n = -n > r ? 0 : r + n), i = void 0 === i || i > r ? r : Da(i), i < 0 && (i += r), i = n > i ? 0 : Na(i); n < i;) t[n++] = e;
        return t
    }

    function an(t, e) {
        return t === e || t !== t && e !== e
    }

    function cn(t) {
        if (!Ba(t)) return !1;
        var e = Fa(t);
        return e == Ha || e == Ma || e == La || e == qa
    }

    function un(t) {
        return "number" == typeof t && t > -1 && t % 1 == 0 && t <= Wa
    }

    function ln(t) {
        return null != t && Ua(t.length) && !Va(t)
    }

    function dn(t, e) {
        return !!(e = null == e ? Ya : e) && ("number" == typeof t || Qa.test(t)) && t > -1 && t % 1 == 0 && t < e
    }

    function hn(t, e, n) {
        if (!tc(n)) return !1;
        var i = typeof e;
        return !!("number" == i ? Ja(n) && Za(e, n.length) : "string" == i && e in n) && Ka(n[e], t)
    }

    function fn(t, e, n, i) {
        var r = null == t ? 0 : t.length;
        return r ? (n && "number" != typeof n && ic(t, e, n) && (n = 0, i = r), nc(t, e, n, i)) : []
    }

    function pn(t) {
        !cc && lc.createRange && (cc = lc.createRange(), cc.selectNode(lc.body));
        var e;
        return cc && cc.createContextualFragment ? e = cc.createContextualFragment(t) : (e = lc.createElement("body"), e.innerHTML = t), e.childNodes[0]
    }

    function mn(t, e, n) {
        t[n] !== e[n] && (t[n] = e[n], t[n] ? t.setAttribute(n, "") : t.removeAttribute(n, ""))
    }

    function gn() {}

    function vn(t, e) {
        var n = t.nodeName,
            i = e.nodeName;
        return n === i || !!(e.actualize && n.charCodeAt(0) < 91 && i.charCodeAt(0) > 90) && n === i.toUpperCase()
    }

    function yn(t, e) {
        return e && e !== hc ? lc.createElementNS(e, t) : lc.createElement(t)
    }

    function bn(t, e) {
        if (e.assignAttributes) e.assignAttributes(t);
        else {
            var n, i, r, o, s, a = e.attributes;
            for (n = a.length - 1; n >= 0; --n) i = a[n], r = i.name, o = i.namespaceURI, s = i.value, o ? (r = i.localName || r, t.getAttributeNS(o, r) !== s && t.setAttributeNS(o, r, s)) : t.getAttribute(r) !== s && t.setAttribute(r, s);
            for (a = t.attributes, n = a.length - 1; n >= 0; --n) i = a[n], !1 !== i.specified && (r = i.name, o = i.namespaceURI, o ? (r = i.localName || r, uc(e, o, r) || t.removeAttributeNS(o, r)) : uc(e, null, r) || t.removeAttribute(r))
        }
    }

    function _n(t, e) {
        for (var n = t.firstChild; n;) {
            var i = n.nextSibling;
            e.appendChild(n), n = i
        }
        return e
    }

    function wn(t) {
        return t.id
    }

    function Sn(t, e, n) {
        function i(t) {
            l ? l.push(t) : l = [t]
        }

        function r(t, e) {
            if (t.nodeType === fc)
                for (var n = t.firstChild; n;) {
                    var o = void 0;
                    e && (o = d(n)) ? i(o) : (v(n), n.firstChild && r(n, e)), n = n.nextSibling
                }
        }

        function o(t, e, n) {
            !1 !== g(t) && (e && e.removeChild(t), v(t), r(t, n))
        }

        function s(t) {
            if (t.nodeType === fc)
                for (var e = t.firstChild; e;) {
                    var n = d(e);
                    n && (_[n] = e), s(e), e = e.nextSibling
                }
        }

        function a(t) {
            f(t);
            for (var e = t.firstChild; e;) {
                var n = e.nextSibling,
                    i = d(e);
                if (i) {
                    var r = _[i];
                    r && vn(e, r) && (e.parentNode.replaceChild(r, e), c(r, e))
                }
                a(e), e = n
            }
        }

        function c(n, r, s) {
            var u, l = d(r);
            if (l && delete _[l], !e.isSameNode || !e.isSameNode(t)) {
                if (!s) {
                    if (!1 === p(n, r)) return;
                    if (bn(n, r), m(n), !1 === y(n, r)) return
                }
                if ("TEXTAREA" !== n.nodeName) {
                    var f, g, v, b, w = r.firstChild,
                        S = n.firstChild;
                    t: for (; w;) {
                        for (v = w.nextSibling, f = d(w); S;) {
                            if (g = S.nextSibling, w.isSameNode && w.isSameNode(S)) {
                                w = v, S = g;
                                continue t
                            }
                            u = d(S);
                            var x = S.nodeType,
                                C = void 0;
                            if (x === w.nodeType && (x === fc ? (f ? f !== u && ((b = _[f]) ? S.nextSibling === b ? C = !1 : (n.insertBefore(b, S), u ? i(u) : o(S, n, !0), g = S.nextSibling, S = b) : C = !1) : u && (C = !1), (C = !1 !== C && vn(S, w)) && c(S, w)) : x !== pc && x != mc || (C = !0, S.nodeValue = w.nodeValue)), C) {
                                w = v, S = g;
                                continue t
                            }
                            u ? i(u) : o(S, n, !0), S = g
                        }
                        if (f && (b = _[f]) && vn(b, w)) n.appendChild(b), c(b, w);
                        else {
                            var T = h(w);
                            !1 !== T && (T && (w = T), w.actualize && (w = w.actualize(n.ownerDocument || lc)), n.appendChild(w), a(w))
                        }
                        w = v, S = g
                    }
                    for (; S;) g = S.nextSibling, (u = d(S)) ? i(u) : o(S, n, !0), S = g
                }
                var k = gc[n.nodeName];
                k && k(n, r)
            }
        }
        if (n || (n = {}), "string" == typeof e)
            if ("#document" === t.nodeName || "HTML" === t.nodeName) {
                var u = e;
                e = lc.createElement("html"), e.innerHTML = u
            } else e = pn(e);
        var l, d = n.getNodeKey || wn,
            h = n.onBeforeNodeAdded || gn,
            f = n.onNodeAdded || gn,
            p = n.onBeforeElUpdated || gn,
            m = n.onElUpdated || gn,
            g = n.onBeforeNodeDiscarded || gn,
            v = n.onNodeDiscarded || gn,
            y = n.onBeforeElChildrenUpdated || gn,
            b = !0 === n.childrenOnly,
            _ = {};
        s(t);
        var w = t,
            S = w.nodeType,
            x = e.nodeType;
        if (!b)
            if (S === fc) x === fc ? vn(t, e) || (v(t), w = _n(t, yn(e.nodeName, e.namespaceURI))) : w = e;
            else if (S === pc || S === mc) {
            if (x === S) return w.nodeValue = e.nodeValue, w;
            w = e
        }
        if (w === e) v(t);
        else if (c(w, e, b), l)
            for (var C = 0, T = l.length; C < T; C++) {
                var k = _[l[C]];
                k && o(k, k.parentNode, !1)
            }
        return !b && w !== t && t.parentNode && (w.actualize && (w = w.actualize(t.ownerDocument || lc)), t.parentNode.replaceChild(w, t)), w
    }

    function xn(t, e) {
        return null == t || t !== t ? e : t
    }

    function Cn(t, e) {
        this.$element = $n(t), this.$slides = $n(Lc.slides, this.$element), this.config = $n.extend({}, qc, e), this._setCurrentSlide($n(Lc.activeSlide, this.$element)), this._assignTouchHandlers(), this.bindedOnFocus = this._onFocus.bind(this), this.bindedOnBlur = this._onBlur.bind(this), this.$slides[0].addEventListener("focus", this.bindedOnFocus, !0), this.$slides[0].addEventListener("blur", this.bindedOnBlur, !0)
    }

    function Tn(t) {
        var e;
        switch (t) {
            case "ZERO_RESULTS":
                e = nu.zeroResults;
                break;
            case "OVER_QUERY_LIMIT":
                e = nu.overQueryLimit;
                break;
            case "REQUEST_DENIED":
                e = nu.requestDenied;
                break;
            case "UNKNOWN_ERROR":
                e = nu.geocodeUnknownError;
                break;
            default:
                e = e.geocodeUnknownError
        }
        return e
    }
    var kn = "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self ? self : {},
        $n = t(function(t) {
            ! function(e, n) {
                "use strict";
                "object" == typeof t && "object" == typeof t.exports ? t.exports = e.document ? n(e, !0) : function(t) {
                    if (!t.document) throw new Error("jQuery requires a window with a document");
                    return n(t)
                } : n(e)
            }("undefined" != typeof window ? window : kn, function(t, e) {
                "use strict";

                function n(t, e) {
                    e = e || Z;
                    var n = e.createElement("script");
                    n.text = t, e.head.appendChild(n).parentNode.removeChild(n)
                }

                function i(t) {
                    var e = !!t && "length" in t && t.length,
                        n = dt.type(t);
                    return "function" !== n && !dt.isWindow(t) && ("array" === n || 0 === e || "number" == typeof e && e > 0 && e - 1 in t)
                }

                function r(t, e, n) {
                    if (dt.isFunction(e)) return dt.grep(t, function(t, i) {
                        return !!e.call(t, i, t) !== n
                    });
                    if (e.nodeType) return dt.grep(t, function(t) {
                        return t === e !== n
                    });
                    if ("string" == typeof e) {
                        if (wt.test(e)) return dt.filter(e, t, n);
                        e = dt.filter(e, t)
                    }
                    return dt.grep(t, function(t) {
                        return rt.call(e, t) > -1 !== n && 1 === t.nodeType
                    })
                }

                function o(t, e) {
                    for (;
                        (t = t[e]) && 1 !== t.nodeType;);
                    return t
                }

                function s(t) {
                    var e = {};
                    return dt.each(t.match(kt) || [], function(t, n) {
                        e[n] = !0
                    }), e
                }

                function a(t) {
                    return t
                }

                function c(t) {
                    throw t
                }

                function u(t, e, n) {
                    var i;
                    try {
                        t && dt.isFunction(i = t.promise) ? i.call(t).done(e).fail(n) : t && dt.isFunction(i = t.then) ? i.call(t, e, n) : e.call(void 0, t)
                    } catch (t) {
                        n.call(void 0, t)
                    }
                }

                function l() {
                    Z.removeEventListener("DOMContentLoaded", l), t.removeEventListener("load", l), dt.ready()
                }

                function d() {
                    this.expando = dt.expando + d.uid++
                }

                function h(t, e, n) {
                    var i;
                    if (void 0 === n && 1 === t.nodeType)
                        if (i = "data-" + e.replace(Ot, "-$&").toLowerCase(), "string" == typeof(n = t.getAttribute(i))) {
                            try {
                                n = "true" === n || "false" !== n && ("null" === n ? null : +n + "" === n ? +n : Nt.test(n) ? JSON.parse(n) : n)
                            } catch (t) {}
                            Dt.set(t, e, n)
                        } else n = void 0;
                    return n
                }

                function f(t, e, n, i) {
                    var r, o = 1,
                        s = 20,
                        a = i ? function() {
                            return i.cur()
                        } : function() {
                            return dt.css(t, e, "")
                        },
                        c = a(),
                        u = n && n[3] || (dt.cssNumber[e] ? "" : "px"),
                        l = (dt.cssNumber[e] || "px" !== u && +c) && Ft.exec(dt.css(t, e));
                    if (l && l[3] !== u) {
                        u = u || l[3], n = n || [], l = +c || 1;
                        do {
                            o = o || ".5", l /= o, dt.style(t, e, l + u)
                        } while (o !== (o = a() / c) && 1 !== o && --s)
                    }
                    return n && (l = +l || +c || 0, r = n[1] ? l + (n[1] + 1) * n[2] : +n[2], i && (i.unit = u, i.start = l, i.end = r)), r
                }

                function p(t) {
                    var e, n = t.ownerDocument,
                        i = t.nodeName,
                        r = Mt[i];
                    return r || (e = n.body.appendChild(n.createElement(i)), r = dt.css(e, "display"), e.parentNode.removeChild(e), "none" === r && (r = "block"), Mt[i] = r, r)
                }

                function m(t, e) {
                    for (var n, i, r = [], o = 0, s = t.length; o < s; o++) i = t[o], i.style && (n = i.style.display, e ? ("none" === n && (r[o] = Pt.get(i, "display") || null, r[o] || (i.style.display = "")), "" === i.style.display && Lt(i) && (r[o] = p(i))) : "none" !== n && (r[o] = "none", Pt.set(i, "display", n)));
                    for (o = 0; o < s; o++) null != r[o] && (t[o].style.display = r[o]);
                    return t
                }

                function g(t, e) {
                    var n = void 0 !== t.getElementsByTagName ? t.getElementsByTagName(e || "*") : void 0 !== t.querySelectorAll ? t.querySelectorAll(e || "*") : [];
                    return void 0 === e || e && dt.nodeName(t, e) ? dt.merge([t], n) : n
                }

                function v(t, e) {
                    for (var n = 0, i = t.length; n < i; n++) Pt.set(t[n], "globalEval", !e || Pt.get(e[n], "globalEval"))
                }

                function y(t, e, n, i, r) {
                    for (var o, s, a, c, u, l, d = e.createDocumentFragment(), h = [], f = 0, p = t.length; f < p; f++)
                        if ((o = t[f]) || 0 === o)
                            if ("object" === dt.type(o)) dt.merge(h, o.nodeType ? [o] : o);
                            else if (Vt.test(o)) {
                        for (s = s || d.appendChild(e.createElement("div")), a = (Rt.exec(o) || ["", ""])[1].toLowerCase(), c = zt[a] || zt._default, s.innerHTML = c[1] + dt.htmlPrefilter(o) + c[2], l = c[0]; l--;) s = s.lastChild;
                        dt.merge(h, s.childNodes), s = d.firstChild, s.textContent = ""
                    } else h.push(e.createTextNode(o));
                    for (d.textContent = "", f = 0; o = h[f++];)
                        if (i && dt.inArray(o, i) > -1) r && r.push(o);
                        else if (u = dt.contains(o.ownerDocument, o), s = g(d.appendChild(o), "script"), u && v(s), n)
                        for (l = 0; o = s[l++];) Wt.test(o.type || "") && n.push(o);
                    return d
                }

                function b() {
                    return !0
                }

                function _() {
                    return !1
                }

                function w() {
                    try {
                        return Z.activeElement
                    } catch (t) {}
                }

                function S(t, e, n, i, r, o) {
                    var s, a;
                    if ("object" == typeof e) {
                        "string" != typeof n && (i = i || n, n = void 0);
                        for (a in e) S(t, a, n, i, e[a], o);
                        return t
                    }
                    if (null == i && null == r ? (r = n, i = n = void 0) : null == r && ("string" == typeof n ? (r = i, i = void 0) : (r = i, i = n, n = void 0)), !1 === r) r = _;
                    else if (!r) return t;
                    return 1 === o && (s = r, r = function(t) {
                        return dt().off(t), s.apply(this, arguments)
                    }, r.guid = s.guid || (s.guid = dt.guid++)), t.each(function() {
                        dt.event.add(this, e, r, i, n)
                    })
                }

                function x(t, e) {
                    return dt.nodeName(t, "table") && dt.nodeName(11 !== e.nodeType ? e : e.firstChild, "tr") ? t.getElementsByTagName("tbody")[0] || t : t
                }

                function C(t) {
                    return t.type = (null !== t.getAttribute("type")) + "/" + t.type, t
                }

                function T(t) {
                    var e = Zt.exec(t.type);
                    return e ? t.type = e[1] : t.removeAttribute("type"), t
                }

                function k(t, e) {
                    var n, i, r, o, s, a, c, u;
                    if (1 === e.nodeType) {
                        if (Pt.hasData(t) && (o = Pt.access(t), s = Pt.set(e, o), u = o.events)) {
                            delete s.handle, s.events = {};
                            for (r in u)
                                for (n = 0, i = u[r].length; n < i; n++) dt.event.add(e, r, u[r][n])
                        }
                        Dt.hasData(t) && (a = Dt.access(t), c = dt.extend({}, a), Dt.set(e, c))
                    }
                }

                function $(t, e) {
                    var n = e.nodeName.toLowerCase();
                    "input" === n && qt.test(t.type) ? e.checked = t.checked : "input" !== n && "textarea" !== n || (e.defaultValue = t.defaultValue)
                }

                function E(t, e, i, r) {
                    e = nt.apply([], e);
                    var o, s, a, c, u, l, d = 0,
                        h = t.length,
                        f = h - 1,
                        p = e[0],
                        m = dt.isFunction(p);
                    if (m || h > 1 && "string" == typeof p && !lt.checkClone && Jt.test(p)) return t.each(function(n) {
                        var o = t.eq(n);
                        m && (e[0] = p.call(this, n, o.html())), E(o, e, i, r)
                    });
                    if (h && (o = y(e, t[0].ownerDocument, !1, t, r), s = o.firstChild, 1 === o.childNodes.length && (o = s), s || r)) {
                        for (a = dt.map(g(o, "script"), C), c = a.length; d < h; d++) u = o, d !== f && (u = dt.clone(u, !0, !0), c && dt.merge(a, g(u, "script"))), i.call(t[d], u, d);
                        if (c)
                            for (l = a[a.length - 1].ownerDocument, dt.map(a, T), d = 0; d < c; d++) u = a[d], Wt.test(u.type || "") && !Pt.access(u, "globalEval") && dt.contains(l, u) && (u.src ? dt._evalUrl && dt._evalUrl(u.src) : n(u.textContent.replace(te, ""), l))
                    }
                    return t
                }

                function A(t, e, n) {
                    for (var i, r = e ? dt.filter(e, t) : t, o = 0; null != (i = r[o]); o++) n || 1 !== i.nodeType || dt.cleanData(g(i)), i.parentNode && (n && dt.contains(i.ownerDocument, i) && v(g(i, "script")), i.parentNode.removeChild(i));
                    return t
                }

                function j(t, e, n) {
                    var i, r, o, s, a = t.style;
                    return n = n || ie(t), n && (s = n.getPropertyValue(e) || n[e], "" !== s || dt.contains(t.ownerDocument, t) || (s = dt.style(t, e)), !lt.pixelMarginRight() && ne.test(s) && ee.test(e) && (i = a.width, r = a.minWidth, o = a.maxWidth, a.minWidth = a.maxWidth = a.width = s, s = n.width, a.width = i, a.minWidth = r, a.maxWidth = o)), void 0 !== s ? s + "" : s
                }

                function P(t, e) {
                    return {
                        get: function() {
                            return t() ? void delete this.get : (this.get = e).apply(this, arguments)
                        }
                    }
                }

                function D(t) {
                    if (t in ce) return t;
                    for (var e = t[0].toUpperCase() + t.slice(1), n = ae.length; n--;)
                        if ((t = ae[n] + e) in ce) return t
                }

                function N(t, e, n) {
                    var i = Ft.exec(e);
                    return i ? Math.max(0, i[2] - (n || 0)) + (i[3] || "px") : e
                }

                function O(t, e, n, i, r) {
                    for (var o = n === (i ? "border" : "content") ? 4 : "width" === e ? 1 : 0, s = 0; o < 4; o += 2) "margin" === n && (s += dt.css(t, n + Bt[o], !0, r)), i ? ("content" === n && (s -= dt.css(t, "padding" + Bt[o], !0, r)), "margin" !== n && (s -= dt.css(t, "border" + Bt[o] + "Width", !0, r))) : (s += dt.css(t, "padding" + Bt[o], !0, r), "padding" !== n && (s += dt.css(t, "border" + Bt[o] + "Width", !0, r)));
                    return s
                }

                function I(t, e, n) {
                    var i, r = !0,
                        o = ie(t),
                        s = "border-box" === dt.css(t, "boxSizing", !1, o);
                    if (t.getClientRects().length && (i = t.getBoundingClientRect()[e]), i <= 0 || null == i) {
                        if (i = j(t, e, o), (i < 0 || null == i) && (i = t.style[e]), ne.test(i)) return i;
                        r = s && (lt.boxSizingReliable() || i === t.style[e]), i = parseFloat(i) || 0
                    }
                    return i + O(t, e, n || (s ? "border" : "content"), r, o) + "px"
                }

                function F(t, e, n, i, r) {
                    return new F.prototype.init(t, e, n, i, r)
                }

                function B() {
                    le && (t.requestAnimationFrame(B), dt.fx.tick())
                }

                function L() {
                    return t.setTimeout(function() {
                        ue = void 0
                    }), ue = dt.now()
                }

                function H(t, e) {
                    var n, i = 0,
                        r = {
                            height: t
                        };
                    for (e = e ? 1 : 0; i < 4; i += 2 - e) n = Bt[i], r["margin" + n] = r["padding" + n] = t;
                    return e && (r.opacity = r.width = t), r
                }

                function M(t, e, n) {
                    for (var i, r = (W.tweeners[e] || []).concat(W.tweeners["*"]), o = 0, s = r.length; o < s; o++)
                        if (i = r[o].call(n, e, t)) return i
                }

                function q(t, e, n) {
                    var i, r, o, s, a, c, u, l, d = "width" in e || "height" in e,
                        h = this,
                        f = {},
                        p = t.style,
                        g = t.nodeType && Lt(t),
                        v = Pt.get(t, "fxshow");
                    n.queue || (s = dt._queueHooks(t, "fx"), null == s.unqueued && (s.unqueued = 0, a = s.empty.fire, s.empty.fire = function() {
                        s.unqueued || a()
                    }), s.unqueued++, h.always(function() {
                        h.always(function() {
                            s.unqueued--, dt.queue(t, "fx").length || s.empty.fire()
                        })
                    }));
                    for (i in e)
                        if (r = e[i], de.test(r)) {
                            if (delete e[i], o = o || "toggle" === r, r === (g ? "hide" : "show")) {
                                if ("show" !== r || !v || void 0 === v[i]) continue;
                                g = !0
                            }
                            f[i] = v && v[i] || dt.style(t, i)
                        }
                    if ((c = !dt.isEmptyObject(e)) || !dt.isEmptyObject(f)) {
                        d && 1 === t.nodeType && (n.overflow = [p.overflow, p.overflowX, p.overflowY], u = v && v.display, null == u && (u = Pt.get(t, "display")), l = dt.css(t, "display"), "none" === l && (u ? l = u : (m([t], !0), u = t.style.display || u, l = dt.css(t, "display"), m([t]))), ("inline" === l || "inline-block" === l && null != u) && "none" === dt.css(t, "float") && (c || (h.done(function() {
                            p.display = u
                        }), null == u && (l = p.display, u = "none" === l ? "" : l)), p.display = "inline-block")), n.overflow && (p.overflow = "hidden", h.always(function() {
                            p.overflow = n.overflow[0], p.overflowX = n.overflow[1], p.overflowY = n.overflow[2]
                        })), c = !1;
                        for (i in f) c || (v ? "hidden" in v && (g = v.hidden) : v = Pt.access(t, "fxshow", {
                                display: u
                            }), o && (v.hidden = !g), g && m([t], !0), h.done(function() {
                                g || m([t]), Pt.remove(t, "fxshow");
                                for (i in f) dt.style(t, i, f[i])
                            })), c = M(g ? v[i] : 0, i, h),
                            i in v || (v[i] = c.start, g && (c.end = c.start, c.start = 0))
                    }
                }

                function R(t, e) {
                    var n, i, r, o, s;
                    for (n in t)
                        if (i = dt.camelCase(n), r = e[i], o = t[n], dt.isArray(o) && (r = o[1], o = t[n] = o[0]), n !== i && (t[i] = o, delete t[n]), (s = dt.cssHooks[i]) && "expand" in s) {
                            o = s.expand(o), delete t[i];
                            for (n in o) n in t || (t[n] = o[n], e[n] = r)
                        } else e[i] = r
                }

                function W(t, e, n) {
                    var i, r, o = 0,
                        s = W.prefilters.length,
                        a = dt.Deferred().always(function() {
                            delete c.elem
                        }),
                        c = function() {
                            if (r) return !1;
                            for (var e = ue || L(), n = Math.max(0, u.startTime + u.duration - e), i = n / u.duration || 0, o = 1 - i, s = 0, c = u.tweens.length; s < c; s++) u.tweens[s].run(o);
                            return a.notifyWith(t, [u, o, n]), o < 1 && c ? n : (a.resolveWith(t, [u]), !1)
                        },
                        u = a.promise({
                            elem: t,
                            props: dt.extend({}, e),
                            opts: dt.extend(!0, {
                                specialEasing: {},
                                easing: dt.easing._default
                            }, n),
                            originalProperties: e,
                            originalOptions: n,
                            startTime: ue || L(),
                            duration: n.duration,
                            tweens: [],
                            createTween: function(e, n) {
                                var i = dt.Tween(t, u.opts, e, n, u.opts.specialEasing[e] || u.opts.easing);
                                return u.tweens.push(i), i
                            },
                            stop: function(e) {
                                var n = 0,
                                    i = e ? u.tweens.length : 0;
                                if (r) return this;
                                for (r = !0; n < i; n++) u.tweens[n].run(1);
                                return e ? (a.notifyWith(t, [u, 1, 0]), a.resolveWith(t, [u, e])) : a.rejectWith(t, [u, e]), this
                            }
                        }),
                        l = u.props;
                    for (R(l, u.opts.specialEasing); o < s; o++)
                        if (i = W.prefilters[o].call(u, t, l, u.opts)) return dt.isFunction(i.stop) && (dt._queueHooks(u.elem, u.opts.queue).stop = dt.proxy(i.stop, i)), i;
                    return dt.map(l, M, u), dt.isFunction(u.opts.start) && u.opts.start.call(t, u), dt.fx.timer(dt.extend(c, {
                        elem: t,
                        anim: u,
                        queue: u.opts.queue
                    })), u.progress(u.opts.progress).done(u.opts.done, u.opts.complete).fail(u.opts.fail).always(u.opts.always)
                }

                function z(t) {
                    return t.getAttribute && t.getAttribute("class") || ""
                }

                function V(t, e, n, i) {
                    var r;
                    if (dt.isArray(e)) dt.each(e, function(e, r) {
                        n || Ce.test(t) ? i(t, r) : V(t + "[" + ("object" == typeof r && null != r ? e : "") + "]", r, n, i)
                    });
                    else if (n || "object" !== dt.type(e)) i(t, e);
                    else
                        for (r in e) V(t + "[" + r + "]", e[r], n, i)
                }

                function U(t) {
                    return function(e, n) {
                        "string" != typeof e && (n = e, e = "*");
                        var i, r = 0,
                            o = e.toLowerCase().match(kt) || [];
                        if (dt.isFunction(n))
                            for (; i = o[r++];) "+" === i[0] ? (i = i.slice(1) || "*", (t[i] = t[i] || []).unshift(n)) : (t[i] = t[i] || []).push(n)
                    }
                }

                function X(t, e, n, i) {
                    function r(a) {
                        var c;
                        return o[a] = !0, dt.each(t[a] || [], function(t, a) {
                            var u = a(e, n, i);
                            return "string" != typeof u || s || o[u] ? s ? !(c = u) : void 0 : (e.dataTypes.unshift(u), r(u), !1)
                        }), c
                    }
                    var o = {},
                        s = t === Fe;
                    return r(e.dataTypes[0]) || !o["*"] && r("*")
                }

                function Y(t, e) {
                    var n, i, r = dt.ajaxSettings.flatOptions || {};
                    for (n in e) void 0 !== e[n] && ((r[n] ? t : i || (i = {}))[n] = e[n]);
                    return i && dt.extend(!0, t, i), t
                }

                function Q(t, e, n) {
                    for (var i, r, o, s, a = t.contents, c = t.dataTypes;
                        "*" === c[0];) c.shift(), void 0 === i && (i = t.mimeType || e.getResponseHeader("Content-Type"));
                    if (i)
                        for (r in a)
                            if (a[r] && a[r].test(i)) {
                                c.unshift(r);
                                break
                            }
                    if (c[0] in n) o = c[0];
                    else {
                        for (r in n) {
                            if (!c[0] || t.converters[r + " " + c[0]]) {
                                o = r;
                                break
                            }
                            s || (s = r)
                        }
                        o = o || s
                    }
                    if (o) return o !== c[0] && c.unshift(o), n[o]
                }

                function G(t, e, n, i) {
                    var r, o, s, a, c, u = {},
                        l = t.dataTypes.slice();
                    if (l[1])
                        for (s in t.converters) u[s.toLowerCase()] = t.converters[s];
                    for (o = l.shift(); o;)
                        if (t.responseFields[o] && (n[t.responseFields[o]] = e), !c && i && t.dataFilter && (e = t.dataFilter(e, t.dataType)), c = o, o = l.shift())
                            if ("*" === o) o = c;
                            else if ("*" !== c && c !== o) {
                        if (!(s = u[c + " " + o] || u["* " + o]))
                            for (r in u)
                                if (a = r.split(" "), a[1] === o && (s = u[c + " " + a[0]] || u["* " + a[0]])) {
                                    !0 === s ? s = u[r] : !0 !== u[r] && (o = a[0], l.unshift(a[1]));
                                    break
                                }
                        if (!0 !== s)
                            if (s && t.throws) e = s(e);
                            else try {
                                e = s(e)
                            } catch (t) {
                                return {
                                    state: "parsererror",
                                    error: s ? t : "No conversion from " + c + " to " + o
                                }
                            }
                    }
                    return {
                        state: "success",
                        data: e
                    }
                }

                function K(t) {
                    return dt.isWindow(t) ? t : 9 === t.nodeType && t.defaultView
                }
                var J = [],
                    Z = t.document,
                    tt = Object.getPrototypeOf,
                    et = J.slice,
                    nt = J.concat,
                    it = J.push,
                    rt = J.indexOf,
                    ot = {},
                    st = ot.toString,
                    at = ot.hasOwnProperty,
                    ct = at.toString,
                    ut = ct.call(Object),
                    lt = {},
                    dt = function(t, e) {
                        return new dt.fn.init(t, e)
                    },
                    ht = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g,
                    ft = /^-ms-/,
                    pt = /-([a-z])/g,
                    mt = function(t, e) {
                        return e.toUpperCase()
                    };
                dt.fn = dt.prototype = {
                    jquery: "3.1.0",
                    constructor: dt,
                    length: 0,
                    toArray: function() {
                        return et.call(this)
                    },
                    get: function(t) {
                        return null != t ? t < 0 ? this[t + this.length] : this[t] : et.call(this)
                    },
                    pushStack: function(t) {
                        var e = dt.merge(this.constructor(), t);
                        return e.prevObject = this, e
                    },
                    each: function(t) {
                        return dt.each(this, t)
                    },
                    map: function(t) {
                        return this.pushStack(dt.map(this, function(e, n) {
                            return t.call(e, n, e)
                        }))
                    },
                    slice: function() {
                        return this.pushStack(et.apply(this, arguments))
                    },
                    first: function() {
                        return this.eq(0)
                    },
                    last: function() {
                        return this.eq(-1)
                    },
                    eq: function(t) {
                        var e = this.length,
                            n = +t + (t < 0 ? e : 0);
                        return this.pushStack(n >= 0 && n < e ? [this[n]] : [])
                    },
                    end: function() {
                        return this.prevObject || this.constructor()
                    },
                    push: it,
                    sort: J.sort,
                    splice: J.splice
                }, dt.extend = dt.fn.extend = function() {
                    var t, e, n, i, r, o, s = arguments[0] || {},
                        a = 1,
                        c = arguments.length,
                        u = !1;
                    for ("boolean" == typeof s && (u = s, s = arguments[a] || {}, a++), "object" == typeof s || dt.isFunction(s) || (s = {}), a === c && (s = this, a--); a < c; a++)
                        if (null != (t = arguments[a]))
                            for (e in t) n = s[e], i = t[e], s !== i && (u && i && (dt.isPlainObject(i) || (r = dt.isArray(i))) ? (r ? (r = !1, o = n && dt.isArray(n) ? n : []) : o = n && dt.isPlainObject(n) ? n : {}, s[e] = dt.extend(u, o, i)) : void 0 !== i && (s[e] = i));
                    return s
                }, dt.extend({
                    expando: "jQuery" + ("3.1.0" + Math.random()).replace(/\D/g, ""),
                    isReady: !0,
                    error: function(t) {
                        throw new Error(t)
                    },
                    noop: function() {},
                    isFunction: function(t) {
                        return "function" === dt.type(t)
                    },
                    isArray: Array.isArray,
                    isWindow: function(t) {
                        return null != t && t === t.window
                    },
                    isNumeric: function(t) {
                        var e = dt.type(t);
                        return ("number" === e || "string" === e) && !isNaN(t - parseFloat(t))
                    },
                    isPlainObject: function(t) {
                        var e, n;
                        return !(!t || "[object Object]" !== st.call(t)) && (!(e = tt(t)) || "function" == typeof(n = at.call(e, "constructor") && e.constructor) && ct.call(n) === ut)
                    },
                    isEmptyObject: function(t) {
                        var e;
                        for (e in t) return !1;
                        return !0
                    },
                    type: function(t) {
                        return null == t ? t + "" : "object" == typeof t || "function" == typeof t ? ot[st.call(t)] || "object" : typeof t
                    },
                    globalEval: function(t) {
                        n(t)
                    },
                    camelCase: function(t) {
                        return t.replace(ft, "ms-").replace(pt, mt)
                    },
                    nodeName: function(t, e) {
                        return t.nodeName && t.nodeName.toLowerCase() === e.toLowerCase()
                    },
                    each: function(t, e) {
                        var n, r = 0;
                        if (i(t))
                            for (n = t.length; r < n && !1 !== e.call(t[r], r, t[r]); r++);
                        else
                            for (r in t)
                                if (!1 === e.call(t[r], r, t[r])) break; return t
                    },
                    trim: function(t) {
                        return null == t ? "" : (t + "").replace(ht, "")
                    },
                    makeArray: function(t, e) {
                        var n = e || [];
                        return null != t && (i(Object(t)) ? dt.merge(n, "string" == typeof t ? [t] : t) : it.call(n, t)), n
                    },
                    inArray: function(t, e, n) {
                        return null == e ? -1 : rt.call(e, t, n)
                    },
                    merge: function(t, e) {
                        for (var n = +e.length, i = 0, r = t.length; i < n; i++) t[r++] = e[i];
                        return t.length = r, t
                    },
                    grep: function(t, e, n) {
                        for (var i = [], r = 0, o = t.length, s = !n; r < o; r++) !e(t[r], r) !== s && i.push(t[r]);
                        return i
                    },
                    map: function(t, e, n) {
                        var r, o, s = 0,
                            a = [];
                        if (i(t))
                            for (r = t.length; s < r; s++) null != (o = e(t[s], s, n)) && a.push(o);
                        else
                            for (s in t) null != (o = e(t[s], s, n)) && a.push(o);
                        return nt.apply([], a)
                    },
                    guid: 1,
                    proxy: function(t, e) {
                        var n, i, r;
                        if ("string" == typeof e && (n = t[e], e = t, t = n), dt.isFunction(t)) return i = et.call(arguments, 2), r = function() {
                            return t.apply(e || this, i.concat(et.call(arguments)))
                        }, r.guid = t.guid = t.guid || dt.guid++, r
                    },
                    now: Date.now,
                    support: lt
                }), "function" == typeof Symbol && (dt.fn[Symbol.iterator] = J[Symbol.iterator]), dt.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "), function(t, e) {
                    ot["[object " + e + "]"] = e.toLowerCase()
                });
                var gt = function(t) {
                    function e(t, e, n, i) {
                        var r, o, s, a, c, l, h, f = e && e.ownerDocument,
                            p = e ? e.nodeType : 9;
                        if (n = n || [], "string" != typeof t || !t || 1 !== p && 9 !== p && 11 !== p) return n;
                        if (!i && ((e ? e.ownerDocument || e : H) !== P && j(e), e = e || P, N)) {
                            if (11 !== p && (c = mt.exec(t)))
                                if (r = c[1]) {
                                    if (9 === p) {
                                        if (!(s = e.getElementById(r))) return n;
                                        if (s.id === r) return n.push(s), n
                                    } else if (f && (s = f.getElementById(r)) && B(e, s) && s.id === r) return n.push(s), n
                                } else {
                                    if (c[2]) return G.apply(n, e.getElementsByTagName(t)), n;
                                    if ((r = c[3]) && _.getElementsByClassName && e.getElementsByClassName) return G.apply(n, e.getElementsByClassName(r)), n
                                }
                            if (_.qsa && !z[t + " "] && (!O || !O.test(t))) {
                                if (1 !== p) f = e, h = t;
                                else if ("object" !== e.nodeName.toLowerCase()) {
                                    for ((a = e.getAttribute("id")) ? a = a.replace(bt, _t) : e.setAttribute("id", a = L), l = C(t), o = l.length; o--;) l[o] = "#" + a + " " + d(l[o]);
                                    h = l.join(","), f = gt.test(t) && u(e.parentNode) || e
                                }
                                if (h) try {
                                    return G.apply(n, f.querySelectorAll(h)), n
                                } catch (t) {} finally {
                                    a === L && e.removeAttribute("id")
                                }
                            }
                        }
                        return k(t.replace(ot, "$1"), e, n, i)
                    }

                    function n() {
                        function t(n, i) {
                            return e.push(n + " ") > w.cacheLength && delete t[e.shift()], t[n + " "] = i
                        }
                        var e = [];
                        return t
                    }

                    function i(t) {
                        return t[L] = !0, t
                    }

                    function r(t) {
                        var e = P.createElement("fieldset");
                        try {
                            return !!t(e)
                        } catch (t) {
                            return !1
                        } finally {
                            e.parentNode && e.parentNode.removeChild(e), e = null
                        }
                    }

                    function o(t, e) {
                        for (var n = t.split("|"), i = n.length; i--;) w.attrHandle[n[i]] = e
                    }

                    function s(t, e) {
                        var n = e && t,
                            i = n && 1 === t.nodeType && 1 === e.nodeType && t.sourceIndex - e.sourceIndex;
                        if (i) return i;
                        if (n)
                            for (; n = n.nextSibling;)
                                if (n === e) return -1;
                        return t ? 1 : -1
                    }

                    function a(t) {
                        return function(e) {
                            return "label" in e && e.disabled === t || "form" in e && e.disabled === t || "form" in e && !1 === e.disabled && (e.isDisabled === t || e.isDisabled !== !t && ("label" in e || !St(e)) !== t)
                        }
                    }

                    function c(t) {
                        return i(function(e) {
                            return e = +e, i(function(n, i) {
                                for (var r, o = t([], n.length, e), s = o.length; s--;) n[r = o[s]] && (n[r] = !(i[r] = n[r]))
                            })
                        })
                    }

                    function u(t) {
                        return t && void 0 !== t.getElementsByTagName && t
                    }

                    function l() {}

                    function d(t) {
                        for (var e = 0, n = t.length, i = ""; e < n; e++) i += t[e].value;
                        return i
                    }

                    function h(t, e, n) {
                        var i = e.dir,
                            r = e.next,
                            o = r || i,
                            s = n && "parentNode" === o,
                            a = q++;
                        return e.first ? function(e, n, r) {
                            for (; e = e[i];)
                                if (1 === e.nodeType || s) return t(e, n, r)
                        } : function(e, n, c) {
                            var u, l, d, h = [M, a];
                            if (c) {
                                for (; e = e[i];)
                                    if ((1 === e.nodeType || s) && t(e, n, c)) return !0
                            } else
                                for (; e = e[i];)
                                    if (1 === e.nodeType || s)
                                        if (d = e[L] || (e[L] = {}), l = d[e.uniqueID] || (d[e.uniqueID] = {}), r && r === e.nodeName.toLowerCase()) e = e[i] || e;
                                        else {
                                            if ((u = l[o]) && u[0] === M && u[1] === a) return h[2] = u[2];
                                            if (l[o] = h, h[2] = t(e, n, c)) return !0
                                        }
                        }
                    }

                    function f(t) {
                        return t.length > 1 ? function(e, n, i) {
                            for (var r = t.length; r--;)
                                if (!t[r](e, n, i)) return !1;
                            return !0
                        } : t[0]
                    }

                    function p(t, n, i) {
                        for (var r = 0, o = n.length; r < o; r++) e(t, n[r], i);
                        return i
                    }

                    function m(t, e, n, i, r) {
                        for (var o, s = [], a = 0, c = t.length, u = null != e; a < c; a++)(o = t[a]) && (n && !n(o, i, r) || (s.push(o), u && e.push(a)));
                        return s
                    }

                    function g(t, e, n, r, o, s) {
                        return r && !r[L] && (r = g(r)), o && !o[L] && (o = g(o, s)), i(function(i, s, a, c) {
                            var u, l, d, h = [],
                                f = [],
                                g = s.length,
                                v = i || p(e || "*", a.nodeType ? [a] : a, []),
                                y = !t || !i && e ? v : m(v, h, t, a, c),
                                b = n ? o || (i ? t : g || r) ? [] : s : y;
                            if (n && n(y, b, a, c), r)
                                for (u = m(b, f), r(u, [], a, c), l = u.length; l--;)(d = u[l]) && (b[f[l]] = !(y[f[l]] = d));
                            if (i) {
                                if (o || t) {
                                    if (o) {
                                        for (u = [], l = b.length; l--;)(d = b[l]) && u.push(y[l] = d);
                                        o(null, b = [], u, c)
                                    }
                                    for (l = b.length; l--;)(d = b[l]) && (u = o ? J(i, d) : h[l]) > -1 && (i[u] = !(s[u] = d))
                                }
                            } else b = m(b === s ? b.splice(g, b.length) : b), o ? o(null, s, b, c) : G.apply(s, b)
                        })
                    }

                    function v(t) {
                        for (var e, n, i, r = t.length, o = w.relative[t[0].type], s = o || w.relative[" "], a = o ? 1 : 0, c = h(function(t) {
                                return t === e
                            }, s, !0), u = h(function(t) {
                                return J(e, t) > -1
                            }, s, !0), l = [function(t, n, i) {
                                var r = !o && (i || n !== $) || ((e = n).nodeType ? c(t, n, i) : u(t, n, i));
                                return e = null, r
                            }]; a < r; a++)
                            if (n = w.relative[t[a].type]) l = [h(f(l), n)];
                            else {
                                if (n = w.filter[t[a].type].apply(null, t[a].matches), n[L]) {
                                    for (i = ++a; i < r && !w.relative[t[i].type]; i++);
                                    return g(a > 1 && f(l), a > 1 && d(t.slice(0, a - 1).concat({
                                        value: " " === t[a - 2].type ? "*" : ""
                                    })).replace(ot, "$1"), n, a < i && v(t.slice(a, i)), i < r && v(t = t.slice(i)), i < r && d(t))
                                }
                                l.push(n)
                            }
                        return f(l)
                    }

                    function y(t, n) {
                        var r = n.length > 0,
                            o = t.length > 0,
                            s = function(i, s, a, c, u) {
                                var l, d, h, f = 0,
                                    p = "0",
                                    g = i && [],
                                    v = [],
                                    y = $,
                                    b = i || o && w.find.TAG("*", u),
                                    _ = M += null == y ? 1 : Math.random() || .1,
                                    S = b.length;
                                for (u && ($ = s === P || s || u); p !== S && null != (l = b[p]); p++) {
                                    if (o && l) {
                                        for (d = 0, s || l.ownerDocument === P || (j(l), a = !N); h = t[d++];)
                                            if (h(l, s || P, a)) {
                                                c.push(l);
                                                break
                                            }
                                        u && (M = _)
                                    }
                                    r && ((l = !h && l) && f--, i && g.push(l))
                                }
                                if (f += p, r && p !== f) {
                                    for (d = 0; h = n[d++];) h(g, v, s, a);
                                    if (i) {
                                        if (f > 0)
                                            for (; p--;) g[p] || v[p] || (v[p] = Y.call(c));
                                        v = m(v)
                                    }
                                    G.apply(c, v), u && !i && v.length > 0 && f + n.length > 1 && e.uniqueSort(c)
                                }
                                return u && (M = _, $ = y), g
                            };
                        return r ? i(s) : s
                    }
                    var b, _, w, S, x, C, T, k, $, E, A, j, P, D, N, O, I, F, B, L = "sizzle" + 1 * new Date,
                        H = t.document,
                        M = 0,
                        q = 0,
                        R = n(),
                        W = n(),
                        z = n(),
                        V = function(t, e) {
                            return t === e && (A = !0), 0
                        },
                        U = {}.hasOwnProperty,
                        X = [],
                        Y = X.pop,
                        Q = X.push,
                        G = X.push,
                        K = X.slice,
                        J = function(t, e) {
                            for (var n = 0, i = t.length; n < i; n++)
                                if (t[n] === e) return n;
                            return -1
                        },
                        Z = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",
                        tt = "[\\x20\\t\\r\\n\\f]",
                        et = "(?:\\\\.|[\\w-]|[^\0-\\xa0])+",
                        nt = "\\[" + tt + "*(" + et + ")(?:" + tt + "*([*^$|!~]?=)" + tt + "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + et + "))|)" + tt + "*\\]",
                        it = ":(" + et + ")(?:\\((('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|((?:\\\\.|[^\\\\()[\\]]|" + nt + ")*)|.*)\\)|)",
                        rt = new RegExp(tt + "+", "g"),
                        ot = new RegExp("^" + tt + "+|((?:^|[^\\\\])(?:\\\\.)*)" + tt + "+$", "g"),
                        st = new RegExp("^" + tt + "*," + tt + "*"),
                        at = new RegExp("^" + tt + "*([>+~]|" + tt + ")" + tt + "*"),
                        ct = new RegExp("=" + tt + "*([^\\]'\"]*?)" + tt + "*\\]", "g"),
                        ut = new RegExp(it),
                        lt = new RegExp("^" + et + "$"),
                        dt = {
                            ID: new RegExp("^#(" + et + ")"),
                            CLASS: new RegExp("^\\.(" + et + ")"),
                            TAG: new RegExp("^(" + et + "|[*])"),
                            ATTR: new RegExp("^" + nt),
                            PSEUDO: new RegExp("^" + it),
                            CHILD: new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + tt + "*(even|odd|(([+-]|)(\\d*)n|)" + tt + "*(?:([+-]|)" + tt + "*(\\d+)|))" + tt + "*\\)|)", "i"),
                            bool: new RegExp("^(?:" + Z + ")$", "i"),
                            needsContext: new RegExp("^" + tt + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + tt + "*((?:-\\d)?\\d*)" + tt + "*\\)|)(?=[^-]|$)", "i")
                        },
                        ht = /^(?:input|select|textarea|button)$/i,
                        ft = /^h\d$/i,
                        pt = /^[^{]+\{\s*\[native \w/,
                        mt = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
                        gt = /[+~]/,
                        vt = new RegExp("\\\\([\\da-f]{1,6}" + tt + "?|(" + tt + ")|.)", "ig"),
                        yt = function(t, e, n) {
                            var i = "0x" + e - 65536;
                            return i !== i || n ? e : i < 0 ? String.fromCharCode(i + 65536) : String.fromCharCode(i >> 10 | 55296, 1023 & i | 56320)
                        },
                        bt = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\x80-\uFFFF\w-]/g,
                        _t = function(t, e) {
                            return e ? "\0" === t ? "�" : t.slice(0, -1) + "\\" + t.charCodeAt(t.length - 1).toString(16) + " " : "\\" + t
                        },
                        wt = function() {
                            j()
                        },
                        St = h(function(t) {
                            return !0 === t.disabled
                        }, {
                            dir: "parentNode",
                            next: "legend"
                        });
                    try {
                        G.apply(X = K.call(H.childNodes), H.childNodes), X[H.childNodes.length].nodeType
                    } catch (t) {
                        G = {
                            apply: X.length ? function(t, e) {
                                Q.apply(t, K.call(e))
                            } : function(t, e) {
                                for (var n = t.length, i = 0; t[n++] = e[i++];);
                                t.length = n - 1
                            }
                        }
                    }
                    _ = e.support = {}, x = e.isXML = function(t) {
                        var e = t && (t.ownerDocument || t).documentElement;
                        return !!e && "HTML" !== e.nodeName
                    }, j = e.setDocument = function(t) {
                        var e, n, i = t ? t.ownerDocument || t : H;
                        return i !== P && 9 === i.nodeType && i.documentElement ? (P = i, D = P.documentElement, N = !x(P), H !== P && (n = P.defaultView) && n.top !== n && (n.addEventListener ? n.addEventListener("unload", wt, !1) : n.attachEvent && n.attachEvent("onunload", wt)), _.attributes = r(function(t) {
                            return t.className = "i", !t.getAttribute("className")
                        }), _.getElementsByTagName = r(function(t) {
                            return t.appendChild(P.createComment("")), !t.getElementsByTagName("*").length
                        }), _.getElementsByClassName = pt.test(P.getElementsByClassName), _.getById = r(function(t) {
                            return D.appendChild(t).id = L, !P.getElementsByName || !P.getElementsByName(L).length
                        }), _.getById ? (w.find.ID = function(t, e) {
                            if (void 0 !== e.getElementById && N) {
                                var n = e.getElementById(t);
                                return n ? [n] : []
                            }
                        }, w.filter.ID = function(t) {
                            var e = t.replace(vt, yt);
                            return function(t) {
                                return t.getAttribute("id") === e
                            }
                        }) : (delete w.find.ID, w.filter.ID = function(t) {
                            var e = t.replace(vt, yt);
                            return function(t) {
                                var n = void 0 !== t.getAttributeNode && t.getAttributeNode("id");
                                return n && n.value === e
                            }
                        }), w.find.TAG = _.getElementsByTagName ? function(t, e) {
                            return void 0 !== e.getElementsByTagName ? e.getElementsByTagName(t) : _.qsa ? e.querySelectorAll(t) : void 0
                        } : function(t, e) {
                            var n, i = [],
                                r = 0,
                                o = e.getElementsByTagName(t);
                            if ("*" === t) {
                                for (; n = o[r++];) 1 === n.nodeType && i.push(n);
                                return i
                            }
                            return o
                        }, w.find.CLASS = _.getElementsByClassName && function(t, e) {
                            if (void 0 !== e.getElementsByClassName && N) return e.getElementsByClassName(t)
                        }, I = [], O = [], (_.qsa = pt.test(P.querySelectorAll)) && (r(function(t) {
                            D.appendChild(t).innerHTML = "<a id='" + L + "'></a><select id='" + L + "-\r\\' msallowcapture=''><option selected=''></option></select>", t.querySelectorAll("[msallowcapture^='']").length && O.push("[*^$]=" + tt + "*(?:''|\"\")"), t.querySelectorAll("[selected]").length || O.push("\\[" + tt + "*(?:value|" + Z + ")"), t.querySelectorAll("[id~=" + L + "-]").length || O.push("~="), t.querySelectorAll(":checked").length || O.push(":checked"), t.querySelectorAll("a#" + L + "+*").length || O.push(".#.+[+~]")
                        }), r(function(t) {
                            t.innerHTML = "<a href='' disabled='disabled'></a><select disabled='disabled'><option/></select>";
                            var e = P.createElement("input");
                            e.setAttribute("type", "hidden"), t.appendChild(e).setAttribute("name", "D"), t.querySelectorAll("[name=d]").length && O.push("name" + tt + "*[*^$|!~]?="), 2 !== t.querySelectorAll(":enabled").length && O.push(":enabled", ":disabled"), D.appendChild(t).disabled = !0, 2 !== t.querySelectorAll(":disabled").length && O.push(":enabled", ":disabled"), t.querySelectorAll("*,:x"), O.push(",.*:")
                        })), (_.matchesSelector = pt.test(F = D.matches || D.webkitMatchesSelector || D.mozMatchesSelector || D.oMatchesSelector || D.msMatchesSelector)) && r(function(t) {
                            _.disconnectedMatch = F.call(t, "*"), F.call(t, "[s!='']:x"), I.push("!=", it)
                        }), O = O.length && new RegExp(O.join("|")), I = I.length && new RegExp(I.join("|")), e = pt.test(D.compareDocumentPosition), B = e || pt.test(D.contains) ? function(t, e) {
                            var n = 9 === t.nodeType ? t.documentElement : t,
                                i = e && e.parentNode;
                            return t === i || !(!i || 1 !== i.nodeType || !(n.contains ? n.contains(i) : t.compareDocumentPosition && 16 & t.compareDocumentPosition(i)))
                        } : function(t, e) {
                            if (e)
                                for (; e = e.parentNode;)
                                    if (e === t) return !0;
                            return !1
                        }, V = e ? function(t, e) {
                            if (t === e) return A = !0, 0;
                            var n = !t.compareDocumentPosition - !e.compareDocumentPosition;
                            return n || (n = (t.ownerDocument || t) === (e.ownerDocument || e) ? t.compareDocumentPosition(e) : 1, 1 & n || !_.sortDetached && e.compareDocumentPosition(t) === n ? t === P || t.ownerDocument === H && B(H, t) ? -1 : e === P || e.ownerDocument === H && B(H, e) ? 1 : E ? J(E, t) - J(E, e) : 0 : 4 & n ? -1 : 1)
                        } : function(t, e) {
                            if (t === e) return A = !0, 0;
                            var n, i = 0,
                                r = t.parentNode,
                                o = e.parentNode,
                                a = [t],
                                c = [e];
                            if (!r || !o) return t === P ? -1 : e === P ? 1 : r ? -1 : o ? 1 : E ? J(E, t) - J(E, e) : 0;
                            if (r === o) return s(t, e);
                            for (n = t; n = n.parentNode;) a.unshift(n);
                            for (n = e; n = n.parentNode;) c.unshift(n);
                            for (; a[i] === c[i];) i++;
                            return i ? s(a[i], c[i]) : a[i] === H ? -1 : c[i] === H ? 1 : 0
                        }, P) : P
                    }, e.matches = function(t, n) {
                        return e(t, null, null, n)
                    }, e.matchesSelector = function(t, n) {
                        if ((t.ownerDocument || t) !== P && j(t), n = n.replace(ct, "='$1']"), _.matchesSelector && N && !z[n + " "] && (!I || !I.test(n)) && (!O || !O.test(n))) try {
                            var i = F.call(t, n);
                            if (i || _.disconnectedMatch || t.document && 11 !== t.document.nodeType) return i
                        } catch (t) {}
                        return e(n, P, null, [t]).length > 0
                    }, e.contains = function(t, e) {
                        return (t.ownerDocument || t) !== P && j(t), B(t, e)
                    }, e.attr = function(t, e) {
                        (t.ownerDocument || t) !== P && j(t);
                        var n = w.attrHandle[e.toLowerCase()],
                            i = n && U.call(w.attrHandle, e.toLowerCase()) ? n(t, e, !N) : void 0;
                        return void 0 !== i ? i : _.attributes || !N ? t.getAttribute(e) : (i = t.getAttributeNode(e)) && i.specified ? i.value : null
                    }, e.escape = function(t) {
                        return (t + "").replace(bt, _t)
                    }, e.error = function(t) {
                        throw new Error("Syntax error, unrecognized expression: " + t)
                    }, e.uniqueSort = function(t) {
                        var e, n = [],
                            i = 0,
                            r = 0;
                        if (A = !_.detectDuplicates, E = !_.sortStable && t.slice(0), t.sort(V), A) {
                            for (; e = t[r++];) e === t[r] && (i = n.push(r));
                            for (; i--;) t.splice(n[i], 1)
                        }
                        return E = null, t
                    }, S = e.getText = function(t) {
                        var e, n = "",
                            i = 0,
                            r = t.nodeType;
                        if (r) {
                            if (1 === r || 9 === r || 11 === r) {
                                if ("string" == typeof t.textContent) return t.textContent;
                                for (t = t.firstChild; t; t = t.nextSibling) n += S(t)
                            } else if (3 === r || 4 === r) return t.nodeValue
                        } else
                            for (; e = t[i++];) n += S(e);
                        return n
                    }, w = e.selectors = {
                        cacheLength: 50,
                        createPseudo: i,
                        match: dt,
                        attrHandle: {},
                        find: {},
                        relative: {
                            ">": {
                                dir: "parentNode",
                                first: !0
                            },
                            " ": {
                                dir: "parentNode"
                            },
                            "+": {
                                dir: "previousSibling",
                                first: !0
                            },
                            "~": {
                                dir: "previousSibling"
                            }
                        },
                        preFilter: {
                            ATTR: function(t) {
                                return t[1] = t[1].replace(vt, yt), t[3] = (t[3] || t[4] || t[5] || "").replace(vt, yt), "~=" === t[2] && (t[3] = " " + t[3] + " "), t.slice(0, 4)
                            },
                            CHILD: function(t) {
                                return t[1] = t[1].toLowerCase(), "nth" === t[1].slice(0, 3) ? (t[3] || e.error(t[0]), t[4] = +(t[4] ? t[5] + (t[6] || 1) : 2 * ("even" === t[3] || "odd" === t[3])), t[5] = +(t[7] + t[8] || "odd" === t[3])) : t[3] && e.error(t[0]), t
                            },
                            PSEUDO: function(t) {
                                var e, n = !t[6] && t[2];
                                return dt.CHILD.test(t[0]) ? null : (t[3] ? t[2] = t[4] || t[5] || "" : n && ut.test(n) && (e = C(n, !0)) && (e = n.indexOf(")", n.length - e) - n.length) && (t[0] = t[0].slice(0, e), t[2] = n.slice(0, e)), t.slice(0, 3))
                            }
                        },
                        filter: {
                            TAG: function(t) {
                                var e = t.replace(vt, yt).toLowerCase();
                                return "*" === t ? function() {
                                    return !0
                                } : function(t) {
                                    return t.nodeName && t.nodeName.toLowerCase() === e
                                }
                            },
                            CLASS: function(t) {
                                var e = R[t + " "];
                                return e || (e = new RegExp("(^|" + tt + ")" + t + "(" + tt + "|$)")) && R(t, function(t) {
                                    return e.test("string" == typeof t.className && t.className || void 0 !== t.getAttribute && t.getAttribute("class") || "")
                                })
                            },
                            ATTR: function(t, n, i) {
                                return function(r) {
                                    var o = e.attr(r, t);
                                    return null == o ? "!=" === n : !n || (o += "", "=" === n ? o === i : "!=" === n ? o !== i : "^=" === n ? i && 0 === o.indexOf(i) : "*=" === n ? i && o.indexOf(i) > -1 : "$=" === n ? i && o.slice(-i.length) === i : "~=" === n ? (" " + o.replace(rt, " ") + " ").indexOf(i) > -1 : "|=" === n && (o === i || o.slice(0, i.length + 1) === i + "-"))
                                }
                            },
                            CHILD: function(t, e, n, i, r) {
                                var o = "nth" !== t.slice(0, 3),
                                    s = "last" !== t.slice(-4),
                                    a = "of-type" === e;
                                return 1 === i && 0 === r ? function(t) {
                                    return !!t.parentNode
                                } : function(e, n, c) {
                                    var u, l, d, h, f, p, m = o !== s ? "nextSibling" : "previousSibling",
                                        g = e.parentNode,
                                        v = a && e.nodeName.toLowerCase(),
                                        y = !c && !a,
                                        b = !1;
                                    if (g) {
                                        if (o) {
                                            for (; m;) {
                                                for (h = e; h = h[m];)
                                                    if (a ? h.nodeName.toLowerCase() === v : 1 === h.nodeType) return !1;
                                                p = m = "only" === t && !p && "nextSibling"
                                            }
                                            return !0
                                        }
                                        if (p = [s ? g.firstChild : g.lastChild], s && y) {
                                            for (h = g, d = h[L] || (h[L] = {}), l = d[h.uniqueID] || (d[h.uniqueID] = {}), u = l[t] || [], f = u[0] === M && u[1], b = f && u[2], h = f && g.childNodes[f]; h = ++f && h && h[m] || (b = f = 0) || p.pop();)
                                                if (1 === h.nodeType && ++b && h === e) {
                                                    l[t] = [M, f, b];
                                                    break
                                                }
                                        } else if (y && (h = e, d = h[L] || (h[L] = {}), l = d[h.uniqueID] || (d[h.uniqueID] = {}), u = l[t] || [], f = u[0] === M && u[1], b = f), !1 === b)
                                            for (;
                                                (h = ++f && h && h[m] || (b = f = 0) || p.pop()) && ((a ? h.nodeName.toLowerCase() !== v : 1 !== h.nodeType) || !++b || (y && (d = h[L] || (h[L] = {}), l = d[h.uniqueID] || (d[h.uniqueID] = {}), l[t] = [M, b]), h !== e)););
                                        return (b -= r) === i || b % i == 0 && b / i >= 0
                                    }
                                }
                            },
                            PSEUDO: function(t, n) {
                                var r, o = w.pseudos[t] || w.setFilters[t.toLowerCase()] || e.error("unsupported pseudo: " + t);
                                return o[L] ? o(n) : o.length > 1 ? (r = [t, t, "", n], w.setFilters.hasOwnProperty(t.toLowerCase()) ? i(function(t, e) {
                                    for (var i, r = o(t, n), s = r.length; s--;) i = J(t, r[s]), t[i] = !(e[i] = r[s])
                                }) : function(t) {
                                    return o(t, 0, r)
                                }) : o
                            }
                        },
                        pseudos: {
                            not: i(function(t) {
                                var e = [],
                                    n = [],
                                    r = T(t.replace(ot, "$1"));
                                return r[L] ? i(function(t, e, n, i) {
                                    for (var o, s = r(t, null, i, []), a = t.length; a--;)(o = s[a]) && (t[a] = !(e[a] = o))
                                }) : function(t, i, o) {
                                    return e[0] = t, r(e, null, o, n), e[0] = null, !n.pop()
                                }
                            }),
                            has: i(function(t) {
                                return function(n) {
                                    return e(t, n).length > 0
                                }
                            }),
                            contains: i(function(t) {
                                return t = t.replace(vt, yt),
                                    function(e) {
                                        return (e.textContent || e.innerText || S(e)).indexOf(t) > -1
                                    }
                            }),
                            lang: i(function(t) {
                                return lt.test(t || "") || e.error("unsupported lang: " + t), t = t.replace(vt, yt).toLowerCase(),
                                    function(e) {
                                        var n;
                                        do {
                                            if (n = N ? e.lang : e.getAttribute("xml:lang") || e.getAttribute("lang")) return (n = n.toLowerCase()) === t || 0 === n.indexOf(t + "-")
                                        } while ((e = e.parentNode) && 1 === e.nodeType);
                                        return !1
                                    }
                            }),
                            target: function(e) {
                                var n = t.location && t.location.hash;
                                return n && n.slice(1) === e.id
                            },
                            root: function(t) {
                                return t === D
                            },
                            focus: function(t) {
                                return t === P.activeElement && (!P.hasFocus || P.hasFocus()) && !!(t.type || t.href || ~t.tabIndex)
                            },
                            enabled: a(!1),
                            disabled: a(!0),
                            checked: function(t) {
                                var e = t.nodeName.toLowerCase();
                                return "input" === e && !!t.checked || "option" === e && !!t.selected
                            },
                            selected: function(t) {
                                return t.parentNode && t.parentNode.selectedIndex, !0 === t.selected
                            },
                            empty: function(t) {
                                for (t = t.firstChild; t; t = t.nextSibling)
                                    if (t.nodeType < 6) return !1;
                                return !0
                            },
                            parent: function(t) {
                                return !w.pseudos.empty(t)
                            },
                            header: function(t) {
                                return ft.test(t.nodeName)
                            },
                            input: function(t) {
                                return ht.test(t.nodeName)
                            },
                            button: function(t) {
                                var e = t.nodeName.toLowerCase();
                                return "input" === e && "button" === t.type || "button" === e
                            },
                            text: function(t) {
                                var e;
                                return "input" === t.nodeName.toLowerCase() && "text" === t.type && (null == (e = t.getAttribute("type")) || "text" === e.toLowerCase())
                            },
                            first: c(function() {
                                return [0]
                            }),
                            last: c(function(t, e) {
                                return [e - 1]
                            }),
                            eq: c(function(t, e, n) {
                                return [n < 0 ? n + e : n]
                            }),
                            even: c(function(t, e) {
                                for (var n = 0; n < e; n += 2) t.push(n);
                                return t
                            }),
                            odd: c(function(t, e) {
                                for (var n = 1; n < e; n += 2) t.push(n);
                                return t
                            }),
                            lt: c(function(t, e, n) {
                                for (var i = n < 0 ? n + e : n; --i >= 0;) t.push(i);
                                return t
                            }),
                            gt: c(function(t, e, n) {
                                for (var i = n < 0 ? n + e : n; ++i < e;) t.push(i);
                                return t
                            })
                        }
                    }, w.pseudos.nth = w.pseudos.eq;
                    for (b in {
                            radio: !0,
                            checkbox: !0,
                            file: !0,
                            password: !0,
                            image: !0
                        }) w.pseudos[b] = function(t) {
                        return function(e) {
                            return "input" === e.nodeName.toLowerCase() && e.type === t
                        }
                    }(b);
                    for (b in {
                            submit: !0,
                            reset: !0
                        }) w.pseudos[b] = function(t) {
                        return function(e) {
                            var n = e.nodeName.toLowerCase();
                            return ("input" === n || "button" === n) && e.type === t
                        }
                    }(b);
                    return l.prototype = w.filters = w.pseudos, w.setFilters = new l, C = e.tokenize = function(t, n) {
                        var i, r, o, s, a, c, u, l = W[t + " "];
                        if (l) return n ? 0 : l.slice(0);
                        for (a = t, c = [], u = w.preFilter; a;) {
                            i && !(r = st.exec(a)) || (r && (a = a.slice(r[0].length) || a), c.push(o = [])), i = !1, (r = at.exec(a)) && (i = r.shift(), o.push({
                                value: i,
                                type: r[0].replace(ot, " ")
                            }), a = a.slice(i.length));
                            for (s in w.filter) !(r = dt[s].exec(a)) || u[s] && !(r = u[s](r)) || (i = r.shift(), o.push({
                                value: i,
                                type: s,
                                matches: r
                            }), a = a.slice(i.length));
                            if (!i) break
                        }
                        return n ? a.length : a ? e.error(t) : W(t, c).slice(0)
                    }, T = e.compile = function(t, e) {
                        var n, i = [],
                            r = [],
                            o = z[t + " "];
                        if (!o) {
                            for (e || (e = C(t)), n = e.length; n--;) o = v(e[n]), o[L] ? i.push(o) : r.push(o);
                            o = z(t, y(r, i)), o.selector = t
                        }
                        return o
                    }, k = e.select = function(t, e, n, i) {
                        var r, o, s, a, c, l = "function" == typeof t && t,
                            h = !i && C(t = l.selector || t);
                        if (n = n || [], 1 === h.length) {
                            if (o = h[0] = h[0].slice(0), o.length > 2 && "ID" === (s = o[0]).type && _.getById && 9 === e.nodeType && N && w.relative[o[1].type]) {
                                if (!(e = (w.find.ID(s.matches[0].replace(vt, yt), e) || [])[0])) return n;
                                l && (e = e.parentNode), t = t.slice(o.shift().value.length)
                            }
                            for (r = dt.needsContext.test(t) ? 0 : o.length; r-- && (s = o[r], !w.relative[a = s.type]);)
                                if ((c = w.find[a]) && (i = c(s.matches[0].replace(vt, yt), gt.test(o[0].type) && u(e.parentNode) || e))) {
                                    if (o.splice(r, 1), !(t = i.length && d(o))) return G.apply(n, i), n;
                                    break
                                }
                        }
                        return (l || T(t, h))(i, e, !N, n, !e || gt.test(t) && u(e.parentNode) || e), n
                    }, _.sortStable = L.split("").sort(V).join("") === L, _.detectDuplicates = !!A, j(), _.sortDetached = r(function(t) {
                        return 1 & t.compareDocumentPosition(P.createElement("fieldset"))
                    }), r(function(t) {
                        return t.innerHTML = "<a href='#'></a>", "#" === t.firstChild.getAttribute("href")
                    }) || o("type|href|height|width", function(t, e, n) {
                        if (!n) return t.getAttribute(e, "type" === e.toLowerCase() ? 1 : 2)
                    }), _.attributes && r(function(t) {
                        return t.innerHTML = "<input/>", t.firstChild.setAttribute("value", ""), "" === t.firstChild.getAttribute("value")
                    }) || o("value", function(t, e, n) {
                        if (!n && "input" === t.nodeName.toLowerCase()) return t.defaultValue
                    }), r(function(t) {
                        return null == t.getAttribute("disabled")
                    }) || o(Z, function(t, e, n) {
                        var i;
                        if (!n) return !0 === t[e] ? e.toLowerCase() : (i = t.getAttributeNode(e)) && i.specified ? i.value : null
                    }), e
                }(t);
                dt.find = gt, dt.expr = gt.selectors, dt.expr[":"] = dt.expr.pseudos, dt.uniqueSort = dt.unique = gt.uniqueSort, dt.text = gt.getText, dt.isXMLDoc = gt.isXML, dt.contains = gt.contains, dt.escapeSelector = gt.escape;
                var vt = function(t, e, n) {
                        for (var i = [], r = void 0 !== n;
                            (t = t[e]) && 9 !== t.nodeType;)
                            if (1 === t.nodeType) {
                                if (r && dt(t).is(n)) break;
                                i.push(t)
                            }
                        return i
                    },
                    yt = function(t, e) {
                        for (var n = []; t; t = t.nextSibling) 1 === t.nodeType && t !== e && n.push(t);
                        return n
                    },
                    bt = dt.expr.match.needsContext,
                    _t = /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i,
                    wt = /^.[^:#\[\.,]*$/;
                dt.filter = function(t, e, n) {
                    var i = e[0];
                    return n && (t = ":not(" + t + ")"), 1 === e.length && 1 === i.nodeType ? dt.find.matchesSelector(i, t) ? [i] : [] : dt.find.matches(t, dt.grep(e, function(t) {
                        return 1 === t.nodeType
                    }))
                }, dt.fn.extend({
                    find: function(t) {
                        var e, n, i = this.length,
                            r = this;
                        if ("string" != typeof t) return this.pushStack(dt(t).filter(function() {
                            for (e = 0; e < i; e++)
                                if (dt.contains(r[e], this)) return !0
                        }));
                        for (n = this.pushStack([]), e = 0; e < i; e++) dt.find(t, r[e], n);
                        return i > 1 ? dt.uniqueSort(n) : n
                    },
                    filter: function(t) {
                        return this.pushStack(r(this, t || [], !1))
                    },
                    not: function(t) {
                        return this.pushStack(r(this, t || [], !0))
                    },
                    is: function(t) {
                        return !!r(this, "string" == typeof t && bt.test(t) ? dt(t) : t || [], !1).length
                    }
                });
                var St, xt = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/;
                (dt.fn.init = function(t, e, n) {
                    var i, r;
                    if (!t) return this;
                    if (n = n || St, "string" == typeof t) {
                        if (!(i = "<" === t[0] && ">" === t[t.length - 1] && t.length >= 3 ? [null, t, null] : xt.exec(t)) || !i[1] && e) return !e || e.jquery ? (e || n).find(t) : this.constructor(e).find(t);
                        if (i[1]) {
                            if (e = e instanceof dt ? e[0] : e, dt.merge(this, dt.parseHTML(i[1], e && e.nodeType ? e.ownerDocument || e : Z, !0)), _t.test(i[1]) && dt.isPlainObject(e))
                                for (i in e) dt.isFunction(this[i]) ? this[i](e[i]) : this.attr(i, e[i]);
                            return this
                        }
                        return r = Z.getElementById(i[2]), r && (this[0] = r, this.length = 1), this
                    }
                    return t.nodeType ? (this[0] = t, this.length = 1, this) : dt.isFunction(t) ? void 0 !== n.ready ? n.ready(t) : t(dt) : dt.makeArray(t, this)
                }).prototype = dt.fn, St = dt(Z);
                var Ct = /^(?:parents|prev(?:Until|All))/,
                    Tt = {
                        children: !0,
                        contents: !0,
                        next: !0,
                        prev: !0
                    };
                dt.fn.extend({
                    has: function(t) {
                        var e = dt(t, this),
                            n = e.length;
                        return this.filter(function() {
                            for (var t = 0; t < n; t++)
                                if (dt.contains(this, e[t])) return !0
                        })
                    },
                    closest: function(t, e) {
                        var n, i = 0,
                            r = this.length,
                            o = [],
                            s = "string" != typeof t && dt(t);
                        if (!bt.test(t))
                            for (; i < r; i++)
                                for (n = this[i]; n && n !== e; n = n.parentNode)
                                    if (n.nodeType < 11 && (s ? s.index(n) > -1 : 1 === n.nodeType && dt.find.matchesSelector(n, t))) {
                                        o.push(n);
                                        break
                                    }
                        return this.pushStack(o.length > 1 ? dt.uniqueSort(o) : o)
                    },
                    index: function(t) {
                        return t ? "string" == typeof t ? rt.call(dt(t), this[0]) : rt.call(this, t.jquery ? t[0] : t) : this[0] && this[0].parentNode ? this.first().prevAll().length : -1
                    },
                    add: function(t, e) {
                        return this.pushStack(dt.uniqueSort(dt.merge(this.get(), dt(t, e))))
                    },
                    addBack: function(t) {
                        return this.add(null == t ? this.prevObject : this.prevObject.filter(t))
                    }
                }), dt.each({
                    parent: function(t) {
                        var e = t.parentNode;
                        return e && 11 !== e.nodeType ? e : null
                    },
                    parents: function(t) {
                        return vt(t, "parentNode")
                    },
                    parentsUntil: function(t, e, n) {
                        return vt(t, "parentNode", n)
                    },
                    next: function(t) {
                        return o(t, "nextSibling")
                    },
                    prev: function(t) {
                        return o(t, "previousSibling")
                    },
                    nextAll: function(t) {
                        return vt(t, "nextSibling")
                    },
                    prevAll: function(t) {
                        return vt(t, "previousSibling")
                    },
                    nextUntil: function(t, e, n) {
                        return vt(t, "nextSibling", n)
                    },
                    prevUntil: function(t, e, n) {
                        return vt(t, "previousSibling", n)
                    },
                    siblings: function(t) {
                        return yt((t.parentNode || {}).firstChild, t)
                    },
                    children: function(t) {
                        return yt(t.firstChild)
                    },
                    contents: function(t) {
                        return t.contentDocument || dt.merge([], t.childNodes)
                    }
                }, function(t, e) {
                    dt.fn[t] = function(n, i) {
                        var r = dt.map(this, e, n);
                        return "Until" !== t.slice(-5) && (i = n), i && "string" == typeof i && (r = dt.filter(i, r)), this.length > 1 && (Tt[t] || dt.uniqueSort(r), Ct.test(t) && r.reverse()), this.pushStack(r)
                    }
                });
                var kt = /\S+/g;
                dt.Callbacks = function(t) {
                    t = "string" == typeof t ? s(t) : dt.extend({}, t);
                    var e, n, i, r, o = [],
                        a = [],
                        c = -1,
                        u = function() {
                            for (r = t.once, i = e = !0; a.length; c = -1)
                                for (n = a.shift(); ++c < o.length;) !1 === o[c].apply(n[0], n[1]) && t.stopOnFalse && (c = o.length, n = !1);
                            t.memory || (n = !1), e = !1, r && (o = n ? [] : "")
                        },
                        l = {
                            add: function() {
                                return o && (n && !e && (c = o.length - 1, a.push(n)), function e(n) {
                                    dt.each(n, function(n, i) {
                                        dt.isFunction(i) ? t.unique && l.has(i) || o.push(i) : i && i.length && "string" !== dt.type(i) && e(i)
                                    })
                                }(arguments), n && !e && u()), this
                            },
                            remove: function() {
                                return dt.each(arguments, function(t, e) {
                                    for (var n;
                                        (n = dt.inArray(e, o, n)) > -1;) o.splice(n, 1), n <= c && c--
                                }), this
                            },
                            has: function(t) {
                                return t ? dt.inArray(t, o) > -1 : o.length > 0
                            },
                            empty: function() {
                                return o && (o = []), this
                            },
                            disable: function() {
                                return r = a = [], o = n = "", this
                            },
                            disabled: function() {
                                return !o
                            },
                            lock: function() {
                                return r = a = [], n || e || (o = n = ""), this
                            },
                            locked: function() {
                                return !!r
                            },
                            fireWith: function(t, n) {
                                return r || (n = n || [], n = [t, n.slice ? n.slice() : n], a.push(n), e || u()), this
                            },
                            fire: function() {
                                return l.fireWith(this, arguments), this
                            },
                            fired: function() {
                                return !!i
                            }
                        };
                    return l
                }, dt.extend({
                    Deferred: function(e) {
                        var n = [
                                ["notify", "progress", dt.Callbacks("memory"), dt.Callbacks("memory"), 2],
                                ["resolve", "done", dt.Callbacks("once memory"), dt.Callbacks("once memory"), 0, "resolved"],
                                ["reject", "fail", dt.Callbacks("once memory"), dt.Callbacks("once memory"), 1, "rejected"]
                            ],
                            i = "pending",
                            r = {
                                state: function() {
                                    return i
                                },
                                always: function() {
                                    return o.done(arguments).fail(arguments), this
                                },
                                catch: function(t) {
                                    return r.then(null, t)
                                },
                                pipe: function() {
                                    var t = arguments;
                                    return dt.Deferred(function(e) {
                                        dt.each(n, function(n, i) {
                                            var r = dt.isFunction(t[i[4]]) && t[i[4]];
                                            o[i[1]](function() {
                                                var t = r && r.apply(this, arguments);
                                                t && dt.isFunction(t.promise) ? t.promise().progress(e.notify).done(e.resolve).fail(e.reject) : e[i[0] + "With"](this, r ? [t] : arguments)
                                            })
                                        }), t = null
                                    }).promise()
                                },
                                then: function(e, i, r) {
                                    function o(e, n, i, r) {
                                        return function() {
                                            var u = this,
                                                l = arguments,
                                                d = function() {
                                                    var t, d;
                                                    if (!(e < s)) {
                                                        if ((t = i.apply(u, l)) === n.promise()) throw new TypeError("Thenable self-resolution");
                                                        d = t && ("object" == typeof t || "function" == typeof t) && t.then,
                                                            dt.isFunction(d) ? r ? d.call(t, o(s, n, a, r), o(s, n, c, r)) : (s++, d.call(t, o(s, n, a, r), o(s, n, c, r), o(s, n, a, n.notifyWith))) : (i !== a && (u = void 0, l = [t]), (r || n.resolveWith)(u, l))
                                                    }
                                                },
                                                h = r ? d : function() {
                                                    try {
                                                        d()
                                                    } catch (t) {
                                                        dt.Deferred.exceptionHook && dt.Deferred.exceptionHook(t, h.stackTrace), e + 1 >= s && (i !== c && (u = void 0, l = [t]), n.rejectWith(u, l))
                                                    }
                                                };
                                            e ? h() : (dt.Deferred.getStackHook && (h.stackTrace = dt.Deferred.getStackHook()), t.setTimeout(h))
                                        }
                                    }
                                    var s = 0;
                                    return dt.Deferred(function(t) {
                                        n[0][3].add(o(0, t, dt.isFunction(r) ? r : a, t.notifyWith)), n[1][3].add(o(0, t, dt.isFunction(e) ? e : a)), n[2][3].add(o(0, t, dt.isFunction(i) ? i : c))
                                    }).promise()
                                },
                                promise: function(t) {
                                    return null != t ? dt.extend(t, r) : r
                                }
                            },
                            o = {};
                        return dt.each(n, function(t, e) {
                            var s = e[2],
                                a = e[5];
                            r[e[1]] = s.add, a && s.add(function() {
                                i = a
                            }, n[3 - t][2].disable, n[0][2].lock), s.add(e[3].fire), o[e[0]] = function() {
                                return o[e[0] + "With"](this === o ? void 0 : this, arguments), this
                            }, o[e[0] + "With"] = s.fireWith
                        }), r.promise(o), e && e.call(o, o), o
                    },
                    when: function(t) {
                        var e = arguments.length,
                            n = e,
                            i = Array(n),
                            r = et.call(arguments),
                            o = dt.Deferred(),
                            s = function(t) {
                                return function(n) {
                                    i[t] = this, r[t] = arguments.length > 1 ? et.call(arguments) : n, --e || o.resolveWith(i, r)
                                }
                            };
                        if (e <= 1 && (u(t, o.done(s(n)).resolve, o.reject), "pending" === o.state() || dt.isFunction(r[n] && r[n].then))) return o.then();
                        for (; n--;) u(r[n], s(n), o.reject);
                        return o.promise()
                    }
                });
                var $t = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
                dt.Deferred.exceptionHook = function(e, n) {
                    t.console && t.console.warn && e && $t.test(e.name) && t.console.warn("jQuery.Deferred exception: " + e.message, e.stack, n)
                }, dt.readyException = function(e) {
                    t.setTimeout(function() {
                        throw e
                    })
                };
                var Et = dt.Deferred();
                dt.fn.ready = function(t) {
                    return Et.then(t).catch(function(t) {
                        dt.readyException(t)
                    }), this
                }, dt.extend({
                    isReady: !1,
                    readyWait: 1,
                    holdReady: function(t) {
                        t ? dt.readyWait++ : dt.ready(!0)
                    },
                    ready: function(t) {
                        (!0 === t ? --dt.readyWait : dt.isReady) || (dt.isReady = !0, !0 !== t && --dt.readyWait > 0 || Et.resolveWith(Z, [dt]))
                    }
                }), dt.ready.then = Et.then, "complete" === Z.readyState || "loading" !== Z.readyState && !Z.documentElement.doScroll ? t.setTimeout(dt.ready) : (Z.addEventListener("DOMContentLoaded", l), t.addEventListener("load", l));
                var At = function(t, e, n, i, r, o, s) {
                        var a = 0,
                            c = t.length,
                            u = null == n;
                        if ("object" === dt.type(n)) {
                            r = !0;
                            for (a in n) At(t, e, a, n[a], !0, o, s)
                        } else if (void 0 !== i && (r = !0, dt.isFunction(i) || (s = !0), u && (s ? (e.call(t, i), e = null) : (u = e, e = function(t, e, n) {
                                return u.call(dt(t), n)
                            })), e))
                            for (; a < c; a++) e(t[a], n, s ? i : i.call(t[a], a, e(t[a], n)));
                        return r ? t : u ? e.call(t) : c ? e(t[0], n) : o
                    },
                    jt = function(t) {
                        return 1 === t.nodeType || 9 === t.nodeType || !+t.nodeType
                    };
                d.uid = 1, d.prototype = {
                    cache: function(t) {
                        var e = t[this.expando];
                        return e || (e = {}, jt(t) && (t.nodeType ? t[this.expando] = e : Object.defineProperty(t, this.expando, {
                            value: e,
                            configurable: !0
                        }))), e
                    },
                    set: function(t, e, n) {
                        var i, r = this.cache(t);
                        if ("string" == typeof e) r[dt.camelCase(e)] = n;
                        else
                            for (i in e) r[dt.camelCase(i)] = e[i];
                        return r
                    },
                    get: function(t, e) {
                        return void 0 === e ? this.cache(t) : t[this.expando] && t[this.expando][dt.camelCase(e)]
                    },
                    access: function(t, e, n) {
                        return void 0 === e || e && "string" == typeof e && void 0 === n ? this.get(t, e) : (this.set(t, e, n), void 0 !== n ? n : e)
                    },
                    remove: function(t, e) {
                        var n, i = t[this.expando];
                        if (void 0 !== i) {
                            if (void 0 !== e) {
                                dt.isArray(e) ? e = e.map(dt.camelCase) : (e = dt.camelCase(e), e = e in i ? [e] : e.match(kt) || []), n = e.length;
                                for (; n--;) delete i[e[n]]
                            }(void 0 === e || dt.isEmptyObject(i)) && (t.nodeType ? t[this.expando] = void 0 : delete t[this.expando])
                        }
                    },
                    hasData: function(t) {
                        var e = t[this.expando];
                        return void 0 !== e && !dt.isEmptyObject(e)
                    }
                };
                var Pt = new d,
                    Dt = new d,
                    Nt = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
                    Ot = /[A-Z]/g;
                dt.extend({
                    hasData: function(t) {
                        return Dt.hasData(t) || Pt.hasData(t)
                    },
                    data: function(t, e, n) {
                        return Dt.access(t, e, n)
                    },
                    removeData: function(t, e) {
                        Dt.remove(t, e)
                    },
                    _data: function(t, e, n) {
                        return Pt.access(t, e, n)
                    },
                    _removeData: function(t, e) {
                        Pt.remove(t, e)
                    }
                }), dt.fn.extend({
                    data: function(t, e) {
                        var n, i, r, o = this[0],
                            s = o && o.attributes;
                        if (void 0 === t) {
                            if (this.length && (r = Dt.get(o), 1 === o.nodeType && !Pt.get(o, "hasDataAttrs"))) {
                                for (n = s.length; n--;) s[n] && (i = s[n].name, 0 === i.indexOf("data-") && (i = dt.camelCase(i.slice(5)), h(o, i, r[i])));
                                Pt.set(o, "hasDataAttrs", !0)
                            }
                            return r
                        }
                        return "object" == typeof t ? this.each(function() {
                            Dt.set(this, t)
                        }) : At(this, function(e) {
                            var n;
                            if (o && void 0 === e) {
                                if (void 0 !== (n = Dt.get(o, t))) return n;
                                if (void 0 !== (n = h(o, t))) return n
                            } else this.each(function() {
                                Dt.set(this, t, e)
                            })
                        }, null, e, arguments.length > 1, null, !0)
                    },
                    removeData: function(t) {
                        return this.each(function() {
                            Dt.remove(this, t)
                        })
                    }
                }), dt.extend({
                    queue: function(t, e, n) {
                        var i;
                        if (t) return e = (e || "fx") + "queue", i = Pt.get(t, e), n && (!i || dt.isArray(n) ? i = Pt.access(t, e, dt.makeArray(n)) : i.push(n)), i || []
                    },
                    dequeue: function(t, e) {
                        e = e || "fx";
                        var n = dt.queue(t, e),
                            i = n.length,
                            r = n.shift(),
                            o = dt._queueHooks(t, e),
                            s = function() {
                                dt.dequeue(t, e)
                            };
                        "inprogress" === r && (r = n.shift(), i--), r && ("fx" === e && n.unshift("inprogress"), delete o.stop, r.call(t, s, o)), !i && o && o.empty.fire()
                    },
                    _queueHooks: function(t, e) {
                        var n = e + "queueHooks";
                        return Pt.get(t, n) || Pt.access(t, n, {
                            empty: dt.Callbacks("once memory").add(function() {
                                Pt.remove(t, [e + "queue", n])
                            })
                        })
                    }
                }), dt.fn.extend({
                    queue: function(t, e) {
                        var n = 2;
                        return "string" != typeof t && (e = t, t = "fx", n--), arguments.length < n ? dt.queue(this[0], t) : void 0 === e ? this : this.each(function() {
                            var n = dt.queue(this, t, e);
                            dt._queueHooks(this, t), "fx" === t && "inprogress" !== n[0] && dt.dequeue(this, t)
                        })
                    },
                    dequeue: function(t) {
                        return this.each(function() {
                            dt.dequeue(this, t)
                        })
                    },
                    clearQueue: function(t) {
                        return this.queue(t || "fx", [])
                    },
                    promise: function(t, e) {
                        var n, i = 1,
                            r = dt.Deferred(),
                            o = this,
                            s = this.length,
                            a = function() {
                                --i || r.resolveWith(o, [o])
                            };
                        for ("string" != typeof t && (e = t, t = void 0), t = t || "fx"; s--;)(n = Pt.get(o[s], t + "queueHooks")) && n.empty && (i++, n.empty.add(a));
                        return a(), r.promise(e)
                    }
                });
                var It = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source,
                    Ft = new RegExp("^(?:([+-])=|)(" + It + ")([a-z%]*)$", "i"),
                    Bt = ["Top", "Right", "Bottom", "Left"],
                    Lt = function(t, e) {
                        return t = e || t, "none" === t.style.display || "" === t.style.display && dt.contains(t.ownerDocument, t) && "none" === dt.css(t, "display")
                    },
                    Ht = function(t, e, n, i) {
                        var r, o, s = {};
                        for (o in e) s[o] = t.style[o], t.style[o] = e[o];
                        r = n.apply(t, i || []);
                        for (o in e) t.style[o] = s[o];
                        return r
                    },
                    Mt = {};
                dt.fn.extend({
                    show: function() {
                        return m(this, !0)
                    },
                    hide: function() {
                        return m(this)
                    },
                    toggle: function(t) {
                        return "boolean" == typeof t ? t ? this.show() : this.hide() : this.each(function() {
                            Lt(this) ? dt(this).show() : dt(this).hide()
                        })
                    }
                });
                var qt = /^(?:checkbox|radio)$/i,
                    Rt = /<([a-z][^\/\0>\x20\t\r\n\f]+)/i,
                    Wt = /^$|\/(?:java|ecma)script/i,
                    zt = {
                        option: [1, "<select multiple='multiple'>", "</select>"],
                        thead: [1, "<table>", "</table>"],
                        col: [2, "<table><colgroup>", "</colgroup></table>"],
                        tr: [2, "<table><tbody>", "</tbody></table>"],
                        td: [3, "<table><tbody><tr>", "</tr></tbody></table>"],
                        _default: [0, "", ""]
                    };
                zt.optgroup = zt.option, zt.tbody = zt.tfoot = zt.colgroup = zt.caption = zt.thead, zt.th = zt.td;
                var Vt = /<|&#?\w+;/;
                ! function() {
                    var t = Z.createDocumentFragment(),
                        e = t.appendChild(Z.createElement("div")),
                        n = Z.createElement("input");
                    n.setAttribute("type", "radio"), n.setAttribute("checked", "checked"), n.setAttribute("name", "t"), e.appendChild(n), lt.checkClone = e.cloneNode(!0).cloneNode(!0).lastChild.checked, e.innerHTML = "<textarea>x</textarea>", lt.noCloneChecked = !!e.cloneNode(!0).lastChild.defaultValue
                }();
                var Ut = Z.documentElement,
                    Xt = /^key/,
                    Yt = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
                    Qt = /^([^.]*)(?:\.(.+)|)/;
                dt.event = {
                    global: {},
                    add: function(t, e, n, i, r) {
                        var o, s, a, c, u, l, d, h, f, p, m, g = Pt.get(t);
                        if (g)
                            for (n.handler && (o = n, n = o.handler, r = o.selector), r && dt.find.matchesSelector(Ut, r), n.guid || (n.guid = dt.guid++), (c = g.events) || (c = g.events = {}), (s = g.handle) || (s = g.handle = function(e) {
                                    return void 0 !== dt && dt.event.triggered !== e.type ? dt.event.dispatch.apply(t, arguments) : void 0
                                }), e = (e || "").match(kt) || [""], u = e.length; u--;) a = Qt.exec(e[u]) || [], f = m = a[1], p = (a[2] || "").split(".").sort(), f && (d = dt.event.special[f] || {}, f = (r ? d.delegateType : d.bindType) || f, d = dt.event.special[f] || {}, l = dt.extend({
                                type: f,
                                origType: m,
                                data: i,
                                handler: n,
                                guid: n.guid,
                                selector: r,
                                needsContext: r && dt.expr.match.needsContext.test(r),
                                namespace: p.join(".")
                            }, o), (h = c[f]) || (h = c[f] = [], h.delegateCount = 0, d.setup && !1 !== d.setup.call(t, i, p, s) || t.addEventListener && t.addEventListener(f, s)), d.add && (d.add.call(t, l), l.handler.guid || (l.handler.guid = n.guid)), r ? h.splice(h.delegateCount++, 0, l) : h.push(l), dt.event.global[f] = !0)
                    },
                    remove: function(t, e, n, i, r) {
                        var o, s, a, c, u, l, d, h, f, p, m, g = Pt.hasData(t) && Pt.get(t);
                        if (g && (c = g.events)) {
                            for (e = (e || "").match(kt) || [""], u = e.length; u--;)
                                if (a = Qt.exec(e[u]) || [], f = m = a[1], p = (a[2] || "").split(".").sort(), f) {
                                    for (d = dt.event.special[f] || {}, f = (i ? d.delegateType : d.bindType) || f, h = c[f] || [], a = a[2] && new RegExp("(^|\\.)" + p.join("\\.(?:.*\\.|)") + "(\\.|$)"), s = o = h.length; o--;) l = h[o], !r && m !== l.origType || n && n.guid !== l.guid || a && !a.test(l.namespace) || i && i !== l.selector && ("**" !== i || !l.selector) || (h.splice(o, 1), l.selector && h.delegateCount--, d.remove && d.remove.call(t, l));
                                    s && !h.length && (d.teardown && !1 !== d.teardown.call(t, p, g.handle) || dt.removeEvent(t, f, g.handle), delete c[f])
                                } else
                                    for (f in c) dt.event.remove(t, f + e[u], n, i, !0);
                            dt.isEmptyObject(c) && Pt.remove(t, "handle events")
                        }
                    },
                    dispatch: function(t) {
                        var e, n, i, r, o, s, a = dt.event.fix(t),
                            c = new Array(arguments.length),
                            u = (Pt.get(this, "events") || {})[a.type] || [],
                            l = dt.event.special[a.type] || {};
                        for (c[0] = a, e = 1; e < arguments.length; e++) c[e] = arguments[e];
                        if (a.delegateTarget = this, !l.preDispatch || !1 !== l.preDispatch.call(this, a)) {
                            for (s = dt.event.handlers.call(this, a, u), e = 0;
                                (r = s[e++]) && !a.isPropagationStopped();)
                                for (a.currentTarget = r.elem, n = 0;
                                    (o = r.handlers[n++]) && !a.isImmediatePropagationStopped();) a.rnamespace && !a.rnamespace.test(o.namespace) || (a.handleObj = o, a.data = o.data, void 0 !== (i = ((dt.event.special[o.origType] || {}).handle || o.handler).apply(r.elem, c)) && !1 === (a.result = i) && (a.preventDefault(), a.stopPropagation()));
                            return l.postDispatch && l.postDispatch.call(this, a), a.result
                        }
                    },
                    handlers: function(t, e) {
                        var n, i, r, o, s = [],
                            a = e.delegateCount,
                            c = t.target;
                        if (a && c.nodeType && ("click" !== t.type || isNaN(t.button) || t.button < 1))
                            for (; c !== this; c = c.parentNode || this)
                                if (1 === c.nodeType && (!0 !== c.disabled || "click" !== t.type)) {
                                    for (i = [], n = 0; n < a; n++) o = e[n], r = o.selector + " ", void 0 === i[r] && (i[r] = o.needsContext ? dt(r, this).index(c) > -1 : dt.find(r, this, null, [c]).length), i[r] && i.push(o);
                                    i.length && s.push({
                                        elem: c,
                                        handlers: i
                                    })
                                }
                        return a < e.length && s.push({
                            elem: this,
                            handlers: e.slice(a)
                        }), s
                    },
                    addProp: function(t, e) {
                        Object.defineProperty(dt.Event.prototype, t, {
                            enumerable: !0,
                            configurable: !0,
                            get: dt.isFunction(e) ? function() {
                                if (this.originalEvent) return e(this.originalEvent)
                            } : function() {
                                if (this.originalEvent) return this.originalEvent[t]
                            },
                            set: function(e) {
                                Object.defineProperty(this, t, {
                                    enumerable: !0,
                                    configurable: !0,
                                    writable: !0,
                                    value: e
                                })
                            }
                        })
                    },
                    fix: function(t) {
                        return t[dt.expando] ? t : new dt.Event(t)
                    },
                    special: {
                        load: {
                            noBubble: !0
                        },
                        focus: {
                            trigger: function() {
                                if (this !== w() && this.focus) return this.focus(), !1
                            },
                            delegateType: "focusin"
                        },
                        blur: {
                            trigger: function() {
                                if (this === w() && this.blur) return this.blur(), !1
                            },
                            delegateType: "focusout"
                        },
                        click: {
                            trigger: function() {
                                if ("checkbox" === this.type && this.click && dt.nodeName(this, "input")) return this.click(), !1
                            },
                            _default: function(t) {
                                return dt.nodeName(t.target, "a")
                            }
                        },
                        beforeunload: {
                            postDispatch: function(t) {
                                void 0 !== t.result && t.originalEvent && (t.originalEvent.returnValue = t.result)
                            }
                        }
                    }
                }, dt.removeEvent = function(t, e, n) {
                    t.removeEventListener && t.removeEventListener(e, n)
                }, dt.Event = function(t, e) {
                    if (!(this instanceof dt.Event)) return new dt.Event(t, e);
                    t && t.type ? (this.originalEvent = t, this.type = t.type, this.isDefaultPrevented = t.defaultPrevented || void 0 === t.defaultPrevented && !1 === t.returnValue ? b : _, this.target = t.target && 3 === t.target.nodeType ? t.target.parentNode : t.target, this.currentTarget = t.currentTarget, this.relatedTarget = t.relatedTarget) : this.type = t, e && dt.extend(this, e), this.timeStamp = t && t.timeStamp || dt.now(), this[dt.expando] = !0
                }, dt.Event.prototype = {
                    constructor: dt.Event,
                    isDefaultPrevented: _,
                    isPropagationStopped: _,
                    isImmediatePropagationStopped: _,
                    isSimulated: !1,
                    preventDefault: function() {
                        var t = this.originalEvent;
                        this.isDefaultPrevented = b, t && !this.isSimulated && t.preventDefault()
                    },
                    stopPropagation: function() {
                        var t = this.originalEvent;
                        this.isPropagationStopped = b, t && !this.isSimulated && t.stopPropagation()
                    },
                    stopImmediatePropagation: function() {
                        var t = this.originalEvent;
                        this.isImmediatePropagationStopped = b, t && !this.isSimulated && t.stopImmediatePropagation(), this.stopPropagation()
                    }
                }, dt.each({
                    altKey: !0,
                    bubbles: !0,
                    cancelable: !0,
                    changedTouches: !0,
                    ctrlKey: !0,
                    detail: !0,
                    eventPhase: !0,
                    metaKey: !0,
                    pageX: !0,
                    pageY: !0,
                    shiftKey: !0,
                    view: !0,
                    char: !0,
                    charCode: !0,
                    key: !0,
                    keyCode: !0,
                    button: !0,
                    buttons: !0,
                    clientX: !0,
                    clientY: !0,
                    offsetX: !0,
                    offsetY: !0,
                    pointerId: !0,
                    pointerType: !0,
                    screenX: !0,
                    screenY: !0,
                    targetTouches: !0,
                    toElement: !0,
                    touches: !0,
                    which: function(t) {
                        var e = t.button;
                        return null == t.which && Xt.test(t.type) ? null != t.charCode ? t.charCode : t.keyCode : !t.which && void 0 !== e && Yt.test(t.type) ? 1 & e ? 1 : 2 & e ? 3 : 4 & e ? 2 : 0 : t.which
                    }
                }, dt.event.addProp), dt.each({
                    mouseenter: "mouseover",
                    mouseleave: "mouseout",
                    pointerenter: "pointerover",
                    pointerleave: "pointerout"
                }, function(t, e) {
                    dt.event.special[t] = {
                        delegateType: e,
                        bindType: e,
                        handle: function(t) {
                            var n, i = this,
                                r = t.relatedTarget,
                                o = t.handleObj;
                            return r && (r === i || dt.contains(i, r)) || (t.type = o.origType, n = o.handler.apply(this, arguments), t.type = e), n
                        }
                    }
                }), dt.fn.extend({
                    on: function(t, e, n, i) {
                        return S(this, t, e, n, i)
                    },
                    one: function(t, e, n, i) {
                        return S(this, t, e, n, i, 1)
                    },
                    off: function(t, e, n) {
                        var i, r;
                        if (t && t.preventDefault && t.handleObj) return i = t.handleObj, dt(t.delegateTarget).off(i.namespace ? i.origType + "." + i.namespace : i.origType, i.selector, i.handler), this;
                        if ("object" == typeof t) {
                            for (r in t) this.off(r, e, t[r]);
                            return this
                        }
                        return !1 !== e && "function" != typeof e || (n = e, e = void 0), !1 === n && (n = _), this.each(function() {
                            dt.event.remove(this, t, n, e)
                        })
                    }
                });
                var Gt = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([a-z][^\/\0>\x20\t\r\n\f]*)[^>]*)\/>/gi,
                    Kt = /<script|<style|<link/i,
                    Jt = /checked\s*(?:[^=]|=\s*.checked.)/i,
                    Zt = /^true\/(.*)/,
                    te = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;
                dt.extend({
                    htmlPrefilter: function(t) {
                        return t.replace(Gt, "<$1></$2>")
                    },
                    clone: function(t, e, n) {
                        var i, r, o, s, a = t.cloneNode(!0),
                            c = dt.contains(t.ownerDocument, t);
                        if (!(lt.noCloneChecked || 1 !== t.nodeType && 11 !== t.nodeType || dt.isXMLDoc(t)))
                            for (s = g(a), o = g(t), i = 0, r = o.length; i < r; i++) $(o[i], s[i]);
                        if (e)
                            if (n)
                                for (o = o || g(t), s = s || g(a), i = 0, r = o.length; i < r; i++) k(o[i], s[i]);
                            else k(t, a);
                        return s = g(a, "script"), s.length > 0 && v(s, !c && g(t, "script")), a
                    },
                    cleanData: function(t) {
                        for (var e, n, i, r = dt.event.special, o = 0; void 0 !== (n = t[o]); o++)
                            if (jt(n)) {
                                if (e = n[Pt.expando]) {
                                    if (e.events)
                                        for (i in e.events) r[i] ? dt.event.remove(n, i) : dt.removeEvent(n, i, e.handle);
                                    n[Pt.expando] = void 0
                                }
                                n[Dt.expando] && (n[Dt.expando] = void 0)
                            }
                    }
                }), dt.fn.extend({
                    detach: function(t) {
                        return A(this, t, !0)
                    },
                    remove: function(t) {
                        return A(this, t)
                    },
                    text: function(t) {
                        return At(this, function(t) {
                            return void 0 === t ? dt.text(this) : this.empty().each(function() {
                                1 !== this.nodeType && 11 !== this.nodeType && 9 !== this.nodeType || (this.textContent = t)
                            })
                        }, null, t, arguments.length)
                    },
                    append: function() {
                        return E(this, arguments, function(t) {
                            if (1 === this.nodeType || 11 === this.nodeType || 9 === this.nodeType) {
                                x(this, t).appendChild(t)
                            }
                        })
                    },
                    prepend: function() {
                        return E(this, arguments, function(t) {
                            if (1 === this.nodeType || 11 === this.nodeType || 9 === this.nodeType) {
                                var e = x(this, t);
                                e.insertBefore(t, e.firstChild)
                            }
                        })
                    },
                    before: function() {
                        return E(this, arguments, function(t) {
                            this.parentNode && this.parentNode.insertBefore(t, this)
                        })
                    },
                    after: function() {
                        return E(this, arguments, function(t) {
                            this.parentNode && this.parentNode.insertBefore(t, this.nextSibling)
                        })
                    },
                    empty: function() {
                        for (var t, e = 0; null != (t = this[e]); e++) 1 === t.nodeType && (dt.cleanData(g(t, !1)), t.textContent = "");
                        return this
                    },
                    clone: function(t, e) {
                        return t = null != t && t, e = null == e ? t : e, this.map(function() {
                            return dt.clone(this, t, e)
                        })
                    },
                    html: function(t) {
                        return At(this, function(t) {
                            var e = this[0] || {},
                                n = 0,
                                i = this.length;
                            if (void 0 === t && 1 === e.nodeType) return e.innerHTML;
                            if ("string" == typeof t && !Kt.test(t) && !zt[(Rt.exec(t) || ["", ""])[1].toLowerCase()]) {
                                t = dt.htmlPrefilter(t);
                                try {
                                    for (; n < i; n++) e = this[n] || {}, 1 === e.nodeType && (dt.cleanData(g(e, !1)), e.innerHTML = t);
                                    e = 0
                                } catch (t) {}
                            }
                            e && this.empty().append(t)
                        }, null, t, arguments.length)
                    },
                    replaceWith: function() {
                        var t = [];
                        return E(this, arguments, function(e) {
                            var n = this.parentNode;
                            dt.inArray(this, t) < 0 && (dt.cleanData(g(this)), n && n.replaceChild(e, this))
                        }, t)
                    }
                }), dt.each({
                    appendTo: "append",
                    prependTo: "prepend",
                    insertBefore: "before",
                    insertAfter: "after",
                    replaceAll: "replaceWith"
                }, function(t, e) {
                    dt.fn[t] = function(t) {
                        for (var n, i = [], r = dt(t), o = r.length - 1, s = 0; s <= o; s++) n = s === o ? this : this.clone(!0), dt(r[s])[e](n), it.apply(i, n.get());
                        return this.pushStack(i)
                    }
                });
                var ee = /^margin/,
                    ne = new RegExp("^(" + It + ")(?!px)[a-z%]+$", "i"),
                    ie = function(e) {
                        var n = e.ownerDocument.defaultView;
                        return n && n.opener || (n = t), n.getComputedStyle(e)
                    };
                ! function() {
                    function e() {
                        if (a) {
                            a.style.cssText = "box-sizing:border-box;position:relative;display:block;margin:auto;border:1px;padding:1px;top:1%;width:50%", a.innerHTML = "", Ut.appendChild(s);
                            var e = t.getComputedStyle(a);
                            n = "1%" !== e.top, o = "2px" === e.marginLeft, i = "4px" === e.width, a.style.marginRight = "50%", r = "4px" === e.marginRight, Ut.removeChild(s), a = null
                        }
                    }
                    var n, i, r, o, s = Z.createElement("div"),
                        a = Z.createElement("div");
                    a.style && (a.style.backgroundClip = "content-box", a.cloneNode(!0).style.backgroundClip = "", lt.clearCloneStyle = "content-box" === a.style.backgroundClip, s.style.cssText = "border:0;width:8px;height:0;top:0;left:-9999px;padding:0;margin-top:1px;position:absolute", s.appendChild(a), dt.extend(lt, {
                        pixelPosition: function() {
                            return e(), n
                        },
                        boxSizingReliable: function() {
                            return e(), i
                        },
                        pixelMarginRight: function() {
                            return e(), r
                        },
                        reliableMarginLeft: function() {
                            return e(), o
                        }
                    }))
                }();
                var re = /^(none|table(?!-c[ea]).+)/,
                    oe = {
                        position: "absolute",
                        visibility: "hidden",
                        display: "block"
                    },
                    se = {
                        letterSpacing: "0",
                        fontWeight: "400"
                    },
                    ae = ["Webkit", "Moz", "ms"],
                    ce = Z.createElement("div").style;
                dt.extend({
                    cssHooks: {
                        opacity: {
                            get: function(t, e) {
                                if (e) {
                                    var n = j(t, "opacity");
                                    return "" === n ? "1" : n
                                }
                            }
                        }
                    },
                    cssNumber: {
                        animationIterationCount: !0,
                        columnCount: !0,
                        fillOpacity: !0,
                        flexGrow: !0,
                        flexShrink: !0,
                        fontWeight: !0,
                        lineHeight: !0,
                        opacity: !0,
                        order: !0,
                        orphans: !0,
                        widows: !0,
                        zIndex: !0,
                        zoom: !0
                    },
                    cssProps: {
                        float: "cssFloat"
                    },
                    style: function(t, e, n, i) {
                        if (t && 3 !== t.nodeType && 8 !== t.nodeType && t.style) {
                            var r, o, s, a = dt.camelCase(e),
                                c = t.style;
                            if (e = dt.cssProps[a] || (dt.cssProps[a] = D(a) || a), s = dt.cssHooks[e] || dt.cssHooks[a], void 0 === n) return s && "get" in s && void 0 !== (r = s.get(t, !1, i)) ? r : c[e];
                            o = typeof n, "string" === o && (r = Ft.exec(n)) && r[1] && (n = f(t, e, r), o = "number"), null != n && n === n && ("number" === o && (n += r && r[3] || (dt.cssNumber[a] ? "" : "px")), lt.clearCloneStyle || "" !== n || 0 !== e.indexOf("background") || (c[e] = "inherit"), s && "set" in s && void 0 === (n = s.set(t, n, i)) || (c[e] = n))
                        }
                    },
                    css: function(t, e, n, i) {
                        var r, o, s, a = dt.camelCase(e);
                        return e = dt.cssProps[a] || (dt.cssProps[a] = D(a) || a), s = dt.cssHooks[e] || dt.cssHooks[a], s && "get" in s && (r = s.get(t, !0, n)), void 0 === r && (r = j(t, e, i)), "normal" === r && e in se && (r = se[e]), "" === n || n ? (o = parseFloat(r), !0 === n || isFinite(o) ? o || 0 : r) : r
                    }
                }), dt.each(["height", "width"], function(t, e) {
                    dt.cssHooks[e] = {
                        get: function(t, n, i) {
                            if (n) return !re.test(dt.css(t, "display")) || t.getClientRects().length && t.getBoundingClientRect().width ? I(t, e, i) : Ht(t, oe, function() {
                                return I(t, e, i)
                            })
                        },
                        set: function(t, n, i) {
                            var r, o = i && ie(t),
                                s = i && O(t, e, i, "border-box" === dt.css(t, "boxSizing", !1, o), o);
                            return s && (r = Ft.exec(n)) && "px" !== (r[3] || "px") && (t.style[e] = n, n = dt.css(t, e)), N(t, n, s)
                        }
                    }
                }), dt.cssHooks.marginLeft = P(lt.reliableMarginLeft, function(t, e) {
                    if (e) return (parseFloat(j(t, "marginLeft")) || t.getBoundingClientRect().left - Ht(t, {
                        marginLeft: 0
                    }, function() {
                        return t.getBoundingClientRect().left
                    })) + "px"
                }), dt.each({
                    margin: "",
                    padding: "",
                    border: "Width"
                }, function(t, e) {
                    dt.cssHooks[t + e] = {
                        expand: function(n) {
                            for (var i = 0, r = {}, o = "string" == typeof n ? n.split(" ") : [n]; i < 4; i++) r[t + Bt[i] + e] = o[i] || o[i - 2] || o[0];
                            return r
                        }
                    }, ee.test(t) || (dt.cssHooks[t + e].set = N)
                }), dt.fn.extend({
                    css: function(t, e) {
                        return At(this, function(t, e, n) {
                            var i, r, o = {},
                                s = 0;
                            if (dt.isArray(e)) {
                                for (i = ie(t), r = e.length; s < r; s++) o[e[s]] = dt.css(t, e[s], !1, i);
                                return o
                            }
                            return void 0 !== n ? dt.style(t, e, n) : dt.css(t, e)
                        }, t, e, arguments.length > 1)
                    }
                }), dt.Tween = F, F.prototype = {
                    constructor: F,
                    init: function(t, e, n, i, r, o) {
                        this.elem = t, this.prop = n, this.easing = r || dt.easing._default, this.options = e, this.start = this.now = this.cur(), this.end = i, this.unit = o || (dt.cssNumber[n] ? "" : "px")
                    },
                    cur: function() {
                        var t = F.propHooks[this.prop];
                        return t && t.get ? t.get(this) : F.propHooks._default.get(this)
                    },
                    run: function(t) {
                        var e, n = F.propHooks[this.prop];
                        return this.options.duration ? this.pos = e = dt.easing[this.easing](t, this.options.duration * t, 0, 1, this.options.duration) : this.pos = e = t, this.now = (this.end - this.start) * e + this.start, this.options.step && this.options.step.call(this.elem, this.now, this), n && n.set ? n.set(this) : F.propHooks._default.set(this), this
                    }
                }, F.prototype.init.prototype = F.prototype, F.propHooks = {
                    _default: {
                        get: function(t) {
                            var e;
                            return 1 !== t.elem.nodeType || null != t.elem[t.prop] && null == t.elem.style[t.prop] ? t.elem[t.prop] : (e = dt.css(t.elem, t.prop, ""), e && "auto" !== e ? e : 0)
                        },
                        set: function(t) {
                            dt.fx.step[t.prop] ? dt.fx.step[t.prop](t) : 1 !== t.elem.nodeType || null == t.elem.style[dt.cssProps[t.prop]] && !dt.cssHooks[t.prop] ? t.elem[t.prop] = t.now : dt.style(t.elem, t.prop, t.now + t.unit)
                        }
                    }
                }, F.propHooks.scrollTop = F.propHooks.scrollLeft = {
                    set: function(t) {
                        t.elem.nodeType && t.elem.parentNode && (t.elem[t.prop] = t.now)
                    }
                }, dt.easing = {
                    linear: function(t) {
                        return t
                    },
                    swing: function(t) {
                        return .5 - Math.cos(t * Math.PI) / 2
                    },
                    _default: "swing"
                }, dt.fx = F.prototype.init, dt.fx.step = {};
                var ue, le, de = /^(?:toggle|show|hide)$/,
                    he = /queueHooks$/;
                dt.Animation = dt.extend(W, {
                        tweeners: {
                            "*": [function(t, e) {
                                var n = this.createTween(t, e);
                                return f(n.elem, t, Ft.exec(e), n), n
                            }]
                        },
                        tweener: function(t, e) {
                            dt.isFunction(t) ? (e = t, t = ["*"]) : t = t.match(kt);
                            for (var n, i = 0, r = t.length; i < r; i++) n = t[i], W.tweeners[n] = W.tweeners[n] || [], W.tweeners[n].unshift(e)
                        },
                        prefilters: [q],
                        prefilter: function(t, e) {
                            e ? W.prefilters.unshift(t) : W.prefilters.push(t)
                        }
                    }), dt.speed = function(t, e, n) {
                        var i = t && "object" == typeof t ? dt.extend({}, t) : {
                            complete: n || !n && e || dt.isFunction(t) && t,
                            duration: t,
                            easing: n && e || e && !dt.isFunction(e) && e
                        };
                        return dt.fx.off || Z.hidden ? i.duration = 0 : i.duration = "number" == typeof i.duration ? i.duration : i.duration in dt.fx.speeds ? dt.fx.speeds[i.duration] : dt.fx.speeds._default, null != i.queue && !0 !== i.queue || (i.queue = "fx"), i.old = i.complete, i.complete = function() {
                            dt.isFunction(i.old) && i.old.call(this), i.queue && dt.dequeue(this, i.queue)
                        }, i
                    }, dt.fn.extend({
                        fadeTo: function(t, e, n, i) {
                            return this.filter(Lt).css("opacity", 0).show().end().animate({
                                opacity: e
                            }, t, n, i)
                        },
                        animate: function(t, e, n, i) {
                            var r = dt.isEmptyObject(t),
                                o = dt.speed(e, n, i),
                                s = function() {
                                    var e = W(this, dt.extend({}, t), o);
                                    (r || Pt.get(this, "finish")) && e.stop(!0)
                                };
                            return s.finish = s, r || !1 === o.queue ? this.each(s) : this.queue(o.queue, s)
                        },
                        stop: function(t, e, n) {
                            var i = function(t) {
                                var e = t.stop;
                                delete t.stop, e(n)
                            };
                            return "string" != typeof t && (n = e, e = t, t = void 0), e && !1 !== t && this.queue(t || "fx", []), this.each(function() {
                                var e = !0,
                                    r = null != t && t + "queueHooks",
                                    o = dt.timers,
                                    s = Pt.get(this);
                                if (r) s[r] && s[r].stop && i(s[r]);
                                else
                                    for (r in s) s[r] && s[r].stop && he.test(r) && i(s[r]);
                                for (r = o.length; r--;) o[r].elem !== this || null != t && o[r].queue !== t || (o[r].anim.stop(n), e = !1, o.splice(r, 1));
                                !e && n || dt.dequeue(this, t)
                            })
                        },
                        finish: function(t) {
                            return !1 !== t && (t = t || "fx"), this.each(function() {
                                var e, n = Pt.get(this),
                                    i = n[t + "queue"],
                                    r = n[t + "queueHooks"],
                                    o = dt.timers,
                                    s = i ? i.length : 0;
                                for (n.finish = !0, dt.queue(this, t, []), r && r.stop && r.stop.call(this, !0), e = o.length; e--;) o[e].elem === this && o[e].queue === t && (o[e].anim.stop(!0), o.splice(e, 1));
                                for (e = 0; e < s; e++) i[e] && i[e].finish && i[e].finish.call(this);
                                delete n.finish
                            })
                        }
                    }), dt.each(["toggle", "show", "hide"], function(t, e) {
                        var n = dt.fn[e];
                        dt.fn[e] = function(t, i, r) {
                            return null == t || "boolean" == typeof t ? n.apply(this, arguments) : this.animate(H(e, !0), t, i, r)
                        }
                    }), dt.each({
                        slideDown: H("show"),
                        slideUp: H("hide"),
                        slideToggle: H("toggle"),
                        fadeIn: {
                            opacity: "show"
                        },
                        fadeOut: {
                            opacity: "hide"
                        },
                        fadeToggle: {
                            opacity: "toggle"
                        }
                    }, function(t, e) {
                        dt.fn[t] = function(t, n, i) {
                            return this.animate(e, t, n, i)
                        }
                    }), dt.timers = [], dt.fx.tick = function() {
                        var t, e = 0,
                            n = dt.timers;
                        for (ue = dt.now(); e < n.length; e++)(t = n[e])() || n[e] !== t || n.splice(e--, 1);
                        n.length || dt.fx.stop(), ue = void 0
                    }, dt.fx.timer = function(t) {
                        dt.timers.push(t), t() ? dt.fx.start() : dt.timers.pop()
                    }, dt.fx.interval = 13, dt.fx.start = function() {
                        le || (le = t.requestAnimationFrame ? t.requestAnimationFrame(B) : t.setInterval(dt.fx.tick, dt.fx.interval))
                    }, dt.fx.stop = function() {
                        t.cancelAnimationFrame ? t.cancelAnimationFrame(le) : t.clearInterval(le), le = null
                    }, dt.fx.speeds = {
                        slow: 600,
                        fast: 200,
                        _default: 400
                    }, dt.fn.delay = function(e, n) {
                        return e = dt.fx ? dt.fx.speeds[e] || e : e, n = n || "fx", this.queue(n, function(n, i) {
                            var r = t.setTimeout(n, e);
                            i.stop = function() {
                                t.clearTimeout(r)
                            }
                        })
                    },
                    function() {
                        var t = Z.createElement("input"),
                            e = Z.createElement("select"),
                            n = e.appendChild(Z.createElement("option"));
                        t.type = "checkbox", lt.checkOn = "" !== t.value, lt.optSelected = n.selected, t = Z.createElement("input"), t.value = "t", t.type = "radio", lt.radioValue = "t" === t.value
                    }();
                var fe, pe = dt.expr.attrHandle;
                dt.fn.extend({
                    attr: function(t, e) {
                        return At(this, dt.attr, t, e, arguments.length > 1)
                    },
                    removeAttr: function(t) {
                        return this.each(function() {
                            dt.removeAttr(this, t)
                        })
                    }
                }), dt.extend({
                    attr: function(t, e, n) {
                        var i, r, o = t.nodeType;
                        if (3 !== o && 8 !== o && 2 !== o) return void 0 === t.getAttribute ? dt.prop(t, e, n) : (1 === o && dt.isXMLDoc(t) || (r = dt.attrHooks[e.toLowerCase()] || (dt.expr.match.bool.test(e) ? fe : void 0)), void 0 !== n ? null === n ? void dt.removeAttr(t, e) : r && "set" in r && void 0 !== (i = r.set(t, n, e)) ? i : (t.setAttribute(e, n + ""), n) : r && "get" in r && null !== (i = r.get(t, e)) ? i : (i = dt.find.attr(t, e), null == i ? void 0 : i))
                    },
                    attrHooks: {
                        type: {
                            set: function(t, e) {
                                if (!lt.radioValue && "radio" === e && dt.nodeName(t, "input")) {
                                    var n = t.value;
                                    return t.setAttribute("type", e), n && (t.value = n), e
                                }
                            }
                        }
                    },
                    removeAttr: function(t, e) {
                        var n, i = 0,
                            r = e && e.match(kt);
                        if (r && 1 === t.nodeType)
                            for (; n = r[i++];) t.removeAttribute(n)
                    }
                }), fe = {
                    set: function(t, e, n) {
                        return !1 === e ? dt.removeAttr(t, n) : t.setAttribute(n, n), n
                    }
                }, dt.each(dt.expr.match.bool.source.match(/\w+/g), function(t, e) {
                    var n = pe[e] || dt.find.attr;
                    pe[e] = function(t, e, i) {
                        var r, o, s = e.toLowerCase();
                        return i || (o = pe[s], pe[s] = r, r = null != n(t, e, i) ? s : null, pe[s] = o), r
                    }
                });
                var me = /^(?:input|select|textarea|button)$/i,
                    ge = /^(?:a|area)$/i;
                dt.fn.extend({
                    prop: function(t, e) {
                        return At(this, dt.prop, t, e, arguments.length > 1)
                    },
                    removeProp: function(t) {
                        return this.each(function() {
                            delete this[dt.propFix[t] || t]
                        })
                    }
                }), dt.extend({
                    prop: function(t, e, n) {
                        var i, r, o = t.nodeType;
                        if (3 !== o && 8 !== o && 2 !== o) return 1 === o && dt.isXMLDoc(t) || (e = dt.propFix[e] || e, r = dt.propHooks[e]), void 0 !== n ? r && "set" in r && void 0 !== (i = r.set(t, n, e)) ? i : t[e] = n : r && "get" in r && null !== (i = r.get(t, e)) ? i : t[e]
                    },
                    propHooks: {
                        tabIndex: {
                            get: function(t) {
                                var e = dt.find.attr(t, "tabindex");
                                return e ? parseInt(e, 10) : me.test(t.nodeName) || ge.test(t.nodeName) && t.href ? 0 : -1
                            }
                        }
                    },
                    propFix: {
                        for: "htmlFor",
                        class: "className"
                    }
                }), lt.optSelected || (dt.propHooks.selected = {
                    get: function(t) {
                        var e = t.parentNode;
                        return e && e.parentNode && e.parentNode.selectedIndex, null
                    },
                    set: function(t) {
                        var e = t.parentNode;
                        e && (e.selectedIndex, e.parentNode && e.parentNode.selectedIndex)
                    }
                }), dt.each(["tabIndex", "readOnly", "maxLength", "cellSpacing", "cellPadding", "rowSpan", "colSpan", "useMap", "frameBorder", "contentEditable"], function() {
                    dt.propFix[this.toLowerCase()] = this
                });
                var ve = /[\t\r\n\f]/g;
                dt.fn.extend({
                    addClass: function(t) {
                        var e, n, i, r, o, s, a, c = 0;
                        if (dt.isFunction(t)) return this.each(function(e) {
                            dt(this).addClass(t.call(this, e, z(this)))
                        });
                        if ("string" == typeof t && t)
                            for (e = t.match(kt) || []; n = this[c++];)
                                if (r = z(n), i = 1 === n.nodeType && (" " + r + " ").replace(ve, " ")) {
                                    for (s = 0; o = e[s++];) i.indexOf(" " + o + " ") < 0 && (i += o + " ");
                                    a = dt.trim(i), r !== a && n.setAttribute("class", a)
                                }
                        return this
                    },
                    removeClass: function(t) {
                        var e, n, i, r, o, s, a, c = 0;
                        if (dt.isFunction(t)) return this.each(function(e) {
                            dt(this).removeClass(t.call(this, e, z(this)))
                        });
                        if (!arguments.length) return this.attr("class", "");
                        if ("string" == typeof t && t)
                            for (e = t.match(kt) || []; n = this[c++];)
                                if (r = z(n), i = 1 === n.nodeType && (" " + r + " ").replace(ve, " ")) {
                                    for (s = 0; o = e[s++];)
                                        for (; i.indexOf(" " + o + " ") > -1;) i = i.replace(" " + o + " ", " ");
                                    a = dt.trim(i), r !== a && n.setAttribute("class", a)
                                }
                        return this
                    },
                    toggleClass: function(t, e) {
                        var n = typeof t;
                        return "boolean" == typeof e && "string" === n ? e ? this.addClass(t) : this.removeClass(t) : dt.isFunction(t) ? this.each(function(n) {
                            dt(this).toggleClass(t.call(this, n, z(this), e), e)
                        }) : this.each(function() {
                            var e, i, r, o;
                            if ("string" === n)
                                for (i = 0, r = dt(this), o = t.match(kt) || []; e = o[i++];) r.hasClass(e) ? r.removeClass(e) : r.addClass(e);
                            else void 0 !== t && "boolean" !== n || (e = z(this), e && Pt.set(this, "__className__", e), this.setAttribute && this.setAttribute("class", e || !1 === t ? "" : Pt.get(this, "__className__") || ""))
                        })
                    },
                    hasClass: function(t) {
                        var e, n, i = 0;
                        for (e = " " + t + " "; n = this[i++];)
                            if (1 === n.nodeType && (" " + z(n) + " ").replace(ve, " ").indexOf(e) > -1) return !0;
                        return !1
                    }
                });
                var ye = /\r/g,
                    be = /[\x20\t\r\n\f]+/g;
                dt.fn.extend({
                    val: function(t) {
                        var e, n, i, r = this[0]; {
                            if (arguments.length) return i = dt.isFunction(t), this.each(function(n) {
                                var r;
                                1 === this.nodeType && (r = i ? t.call(this, n, dt(this).val()) : t, null == r ? r = "" : "number" == typeof r ? r += "" : dt.isArray(r) && (r = dt.map(r, function(t) {
                                    return null == t ? "" : t + ""
                                })), (e = dt.valHooks[this.type] || dt.valHooks[this.nodeName.toLowerCase()]) && "set" in e && void 0 !== e.set(this, r, "value") || (this.value = r))
                            });
                            if (r) return (e = dt.valHooks[r.type] || dt.valHooks[r.nodeName.toLowerCase()]) && "get" in e && void 0 !== (n = e.get(r, "value")) ? n : (n = r.value, "string" == typeof n ? n.replace(ye, "") : null == n ? "" : n)
                        }
                    }
                }), dt.extend({
                    valHooks: {
                        option: {
                            get: function(t) {
                                var e = dt.find.attr(t, "value");
                                return null != e ? e : dt.trim(dt.text(t)).replace(be, " ")
                            }
                        },
                        select: {
                            get: function(t) {
                                for (var e, n, i = t.options, r = t.selectedIndex, o = "select-one" === t.type, s = o ? null : [], a = o ? r + 1 : i.length, c = r < 0 ? a : o ? r : 0; c < a; c++)
                                    if (n = i[c], (n.selected || c === r) && !n.disabled && (!n.parentNode.disabled || !dt.nodeName(n.parentNode, "optgroup"))) {
                                        if (e = dt(n).val(), o) return e;
                                        s.push(e)
                                    }
                                return s
                            },
                            set: function(t, e) {
                                for (var n, i, r = t.options, o = dt.makeArray(e), s = r.length; s--;) i = r[s], (i.selected = dt.inArray(dt.valHooks.option.get(i), o) > -1) && (n = !0);
                                return n || (t.selectedIndex = -1), o
                            }
                        }
                    }
                }), dt.each(["radio", "checkbox"], function() {
                    dt.valHooks[this] = {
                        set: function(t, e) {
                            if (dt.isArray(e)) return t.checked = dt.inArray(dt(t).val(), e) > -1
                        }
                    }, lt.checkOn || (dt.valHooks[this].get = function(t) {
                        return null === t.getAttribute("value") ? "on" : t.value
                    })
                });
                var _e = /^(?:focusinfocus|focusoutblur)$/;
                dt.extend(dt.event, {
                    trigger: function(e, n, i, r) {
                        var o, s, a, c, u, l, d, h = [i || Z],
                            f = at.call(e, "type") ? e.type : e,
                            p = at.call(e, "namespace") ? e.namespace.split(".") : [];
                        if (s = a = i = i || Z, 3 !== i.nodeType && 8 !== i.nodeType && !_e.test(f + dt.event.triggered) && (f.indexOf(".") > -1 && (p = f.split("."), f = p.shift(), p.sort()), u = f.indexOf(":") < 0 && "on" + f, e = e[dt.expando] ? e : new dt.Event(f, "object" == typeof e && e), e.isTrigger = r ? 2 : 3, e.namespace = p.join("."), e.rnamespace = e.namespace ? new RegExp("(^|\\.)" + p.join("\\.(?:.*\\.|)") + "(\\.|$)") : null, e.result = void 0, e.target || (e.target = i), n = null == n ? [e] : dt.makeArray(n, [e]), d = dt.event.special[f] || {}, r || !d.trigger || !1 !== d.trigger.apply(i, n))) {
                            if (!r && !d.noBubble && !dt.isWindow(i)) {
                                for (c = d.delegateType || f, _e.test(c + f) || (s = s.parentNode); s; s = s.parentNode) h.push(s), a = s;
                                a === (i.ownerDocument || Z) && h.push(a.defaultView || a.parentWindow || t)
                            }
                            for (o = 0;
                                (s = h[o++]) && !e.isPropagationStopped();) e.type = o > 1 ? c : d.bindType || f, l = (Pt.get(s, "events") || {})[e.type] && Pt.get(s, "handle"), l && l.apply(s, n), (l = u && s[u]) && l.apply && jt(s) && (e.result = l.apply(s, n), !1 === e.result && e.preventDefault());
                            return e.type = f, r || e.isDefaultPrevented() || d._default && !1 !== d._default.apply(h.pop(), n) || !jt(i) || u && dt.isFunction(i[f]) && !dt.isWindow(i) && (a = i[u], a && (i[u] = null), dt.event.triggered = f, i[f](), dt.event.triggered = void 0, a && (i[u] = a)), e.result
                        }
                    },
                    simulate: function(t, e, n) {
                        var i = dt.extend(new dt.Event, n, {
                            type: t,
                            isSimulated: !0
                        });
                        dt.event.trigger(i, null, e)
                    }
                }), dt.fn.extend({
                    trigger: function(t, e) {
                        return this.each(function() {
                            dt.event.trigger(t, e, this)
                        })
                    },
                    triggerHandler: function(t, e) {
                        var n = this[0];
                        if (n) return dt.event.trigger(t, e, n, !0)
                    }
                }), dt.each("blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(" "), function(t, e) {
                    dt.fn[e] = function(t, n) {
                        return arguments.length > 0 ? this.on(e, null, t, n) : this.trigger(e)
                    }
                }), dt.fn.extend({
                    hover: function(t, e) {
                        return this.mouseenter(t).mouseleave(e || t)
                    }
                }), lt.focusin = "onfocusin" in t, lt.focusin || dt.each({
                    focus: "focusin",
                    blur: "focusout"
                }, function(t, e) {
                    var n = function(t) {
                        dt.event.simulate(e, t.target, dt.event.fix(t))
                    };
                    dt.event.special[e] = {
                        setup: function() {
                            var i = this.ownerDocument || this,
                                r = Pt.access(i, e);
                            r || i.addEventListener(t, n, !0), Pt.access(i, e, (r || 0) + 1)
                        },
                        teardown: function() {
                            var i = this.ownerDocument || this,
                                r = Pt.access(i, e) - 1;
                            r ? Pt.access(i, e, r) : (i.removeEventListener(t, n, !0), Pt.remove(i, e))
                        }
                    }
                });
                var we = t.location,
                    Se = dt.now(),
                    xe = /\?/;
                dt.parseXML = function(e) {
                    var n;
                    if (!e || "string" != typeof e) return null;
                    try {
                        n = (new t.DOMParser).parseFromString(e, "text/xml")
                    } catch (t) {
                        n = void 0
                    }
                    return n && !n.getElementsByTagName("parsererror").length || dt.error("Invalid XML: " + e), n
                };
                var Ce = /\[\]$/,
                    Te = /\r?\n/g,
                    ke = /^(?:submit|button|image|reset|file)$/i,
                    $e = /^(?:input|select|textarea|keygen)/i;
                dt.param = function(t, e) {
                    var n, i = [],
                        r = function(t, e) {
                            var n = dt.isFunction(e) ? e() : e;
                            i[i.length] = encodeURIComponent(t) + "=" + encodeURIComponent(null == n ? "" : n)
                        };
                    if (dt.isArray(t) || t.jquery && !dt.isPlainObject(t)) dt.each(t, function() {
                        r(this.name, this.value)
                    });
                    else
                        for (n in t) V(n, t[n], e, r);
                    return i.join("&")
                }, dt.fn.extend({
                    serialize: function() {
                        return dt.param(this.serializeArray())
                    },
                    serializeArray: function() {
                        return this.map(function() {
                            var t = dt.prop(this, "elements");
                            return t ? dt.makeArray(t) : this
                        }).filter(function() {
                            var t = this.type;
                            return this.name && !dt(this).is(":disabled") && $e.test(this.nodeName) && !ke.test(t) && (this.checked || !qt.test(t))
                        }).map(function(t, e) {
                            var n = dt(this).val();
                            return null == n ? null : dt.isArray(n) ? dt.map(n, function(t) {
                                return {
                                    name: e.name,
                                    value: t.replace(Te, "\r\n")
                                }
                            }) : {
                                name: e.name,
                                value: n.replace(Te, "\r\n")
                            }
                        }).get()
                    }
                });
                var Ee = /%20/g,
                    Ae = /#.*$/,
                    je = /([?&])_=[^&]*/,
                    Pe = /^(.*?):[ \t]*([^\r\n]*)$/gm,
                    De = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
                    Ne = /^(?:GET|HEAD)$/,
                    Oe = /^\/\//,
                    Ie = {},
                    Fe = {},
                    Be = "*/".concat("*"),
                    Le = Z.createElement("a");
                Le.href = we.href, dt.extend({
                    active: 0,
                    lastModified: {},
                    etag: {},
                    ajaxSettings: {
                        url: we.href,
                        type: "GET",
                        isLocal: De.test(we.protocol),
                        global: !0,
                        processData: !0,
                        async: !0,
                        contentType: "application/x-www-form-urlencoded; charset=UTF-8",
                        accepts: {
                            "*": Be,
                            text: "text/plain",
                            html: "text/html",
                            xml: "application/xml, text/xml",
                            json: "application/json, text/javascript"
                        },
                        contents: {
                            xml: /\bxml\b/,
                            html: /\bhtml/,
                            json: /\bjson\b/
                        },
                        responseFields: {
                            xml: "responseXML",
                            text: "responseText",
                            json: "responseJSON"
                        },
                        converters: {
                            "* text": String,
                            "text html": !0,
                            "text json": JSON.parse,
                            "text xml": dt.parseXML
                        },
                        flatOptions: {
                            url: !0,
                            context: !0
                        }
                    },
                    ajaxSetup: function(t, e) {
                        return e ? Y(Y(t, dt.ajaxSettings), e) : Y(dt.ajaxSettings, t)
                    },
                    ajaxPrefilter: U(Ie),
                    ajaxTransport: U(Fe),
                    ajax: function(e, n) {
                        function i(e, n, i, a) {
                            var u, h, f, _, w, S = n;
                            l || (l = !0, c && t.clearTimeout(c), r = void 0, s = a || "", x.readyState = e > 0 ? 4 : 0, u = e >= 200 && e < 300 || 304 === e, i && (_ = Q(p, x, i)), _ = G(p, _, x, u), u ? (p.ifModified && (w = x.getResponseHeader("Last-Modified"), w && (dt.lastModified[o] = w), (w = x.getResponseHeader("etag")) && (dt.etag[o] = w)), 204 === e || "HEAD" === p.type ? S = "nocontent" : 304 === e ? S = "notmodified" : (S = _.state, h = _.data, f = _.error, u = !f)) : (f = S, !e && S || (S = "error", e < 0 && (e = 0))), x.status = e, x.statusText = (n || S) + "", u ? v.resolveWith(m, [h, S, x]) : v.rejectWith(m, [x, S, f]), x.statusCode(b), b = void 0, d && g.trigger(u ? "ajaxSuccess" : "ajaxError", [x, p, u ? h : f]), y.fireWith(m, [x, S]), d && (g.trigger("ajaxComplete", [x, p]), --dt.active || dt.event.trigger("ajaxStop")))
                        }
                        "object" == typeof e && (n = e, e = void 0), n = n || {};
                        var r, o, s, a, c, u, l, d, h, f, p = dt.ajaxSetup({}, n),
                            m = p.context || p,
                            g = p.context && (m.nodeType || m.jquery) ? dt(m) : dt.event,
                            v = dt.Deferred(),
                            y = dt.Callbacks("once memory"),
                            b = p.statusCode || {},
                            _ = {},
                            w = {},
                            S = "canceled",
                            x = {
                                readyState: 0,
                                getResponseHeader: function(t) {
                                    var e;
                                    if (l) {
                                        if (!a)
                                            for (a = {}; e = Pe.exec(s);) a[e[1].toLowerCase()] = e[2];
                                        e = a[t.toLowerCase()]
                                    }
                                    return null == e ? null : e
                                },
                                getAllResponseHeaders: function() {
                                    return l ? s : null
                                },
                                setRequestHeader: function(t, e) {
                                    return null == l && (t = w[t.toLowerCase()] = w[t.toLowerCase()] || t, _[t] = e), this
                                },
                                overrideMimeType: function(t) {
                                    return null == l && (p.mimeType = t), this
                                },
                                statusCode: function(t) {
                                    var e;
                                    if (t)
                                        if (l) x.always(t[x.status]);
                                        else
                                            for (e in t) b[e] = [b[e], t[e]];
                                    return this
                                },
                                abort: function(t) {
                                    var e = t || S;
                                    return r && r.abort(e), i(0, e), this
                                }
                            };
                        if (v.promise(x), p.url = ((e || p.url || we.href) + "").replace(Oe, we.protocol + "//"), p.type = n.method || n.type || p.method || p.type, p.dataTypes = (p.dataType || "*").toLowerCase().match(kt) || [""], null == p.crossDomain) {
                            u = Z.createElement("a");
                            try {
                                u.href = p.url, u.href = u.href, p.crossDomain = Le.protocol + "//" + Le.host != u.protocol + "//" + u.host
                            } catch (t) {
                                p.crossDomain = !0
                            }
                        }
                        if (p.data && p.processData && "string" != typeof p.data && (p.data = dt.param(p.data, p.traditional)), X(Ie, p, n, x), l) return x;
                        d = dt.event && p.global, d && 0 == dt.active++ && dt.event.trigger("ajaxStart"), p.type = p.type.toUpperCase(), p.hasContent = !Ne.test(p.type), o = p.url.replace(Ae, ""), p.hasContent ? p.data && p.processData && 0 === (p.contentType || "").indexOf("application/x-www-form-urlencoded") && (p.data = p.data.replace(Ee, "+")) : (f = p.url.slice(o.length), p.data && (o += (xe.test(o) ? "&" : "?") + p.data, delete p.data), !1 === p.cache && (o = o.replace(je, ""), f = (xe.test(o) ? "&" : "?") + "_=" + Se++ +f), p.url = o + f), p.ifModified && (dt.lastModified[o] && x.setRequestHeader("If-Modified-Since", dt.lastModified[o]), dt.etag[o] && x.setRequestHeader("If-None-Match", dt.etag[o])), (p.data && p.hasContent && !1 !== p.contentType || n.contentType) && x.setRequestHeader("Content-Type", p.contentType), x.setRequestHeader("Accept", p.dataTypes[0] && p.accepts[p.dataTypes[0]] ? p.accepts[p.dataTypes[0]] + ("*" !== p.dataTypes[0] ? ", " + Be + "; q=0.01" : "") : p.accepts["*"]);
                        for (h in p.headers) x.setRequestHeader(h, p.headers[h]);
                        if (p.beforeSend && (!1 === p.beforeSend.call(m, x, p) || l)) return x.abort();
                        if (S = "abort", y.add(p.complete), x.done(p.success), x.fail(p.error), r = X(Fe, p, n, x)) {
                            if (x.readyState = 1, d && g.trigger("ajaxSend", [x, p]), l) return x;
                            p.async && p.timeout > 0 && (c = t.setTimeout(function() {
                                x.abort("timeout")
                            }, p.timeout));
                            try {
                                l = !1, r.send(_, i)
                            } catch (t) {
                                if (l) throw t;
                                i(-1, t)
                            }
                        } else i(-1, "No Transport");
                        return x
                    },
                    getJSON: function(t, e, n) {
                        return dt.get(t, e, n, "json")
                    },
                    getScript: function(t, e) {
                        return dt.get(t, void 0, e, "script")
                    }
                }), dt.each(["get", "post"], function(t, e) {
                    dt[e] = function(t, n, i, r) {
                        return dt.isFunction(n) && (r = r || i, i = n, n = void 0), dt.ajax(dt.extend({
                            url: t,
                            type: e,
                            dataType: r,
                            data: n,
                            success: i
                        }, dt.isPlainObject(t) && t))
                    }
                }), dt._evalUrl = function(t) {
                    return dt.ajax({
                        url: t,
                        type: "GET",
                        dataType: "script",
                        cache: !0,
                        async: !1,
                        global: !1,
                        throws: !0
                    })
                }, dt.fn.extend({
                    wrapAll: function(t) {
                        var e;
                        return this[0] && (dt.isFunction(t) && (t = t.call(this[0])), e = dt(t, this[0].ownerDocument).eq(0).clone(!0), this[0].parentNode && e.insertBefore(this[0]), e.map(function() {
                            for (var t = this; t.firstElementChild;) t = t.firstElementChild;
                            return t
                        }).append(this)), this
                    },
                    wrapInner: function(t) {
                        return dt.isFunction(t) ? this.each(function(e) {
                            dt(this).wrapInner(t.call(this, e))
                        }) : this.each(function() {
                            var e = dt(this),
                                n = e.contents();
                            n.length ? n.wrapAll(t) : e.append(t)
                        })
                    },
                    wrap: function(t) {
                        var e = dt.isFunction(t);
                        return this.each(function(n) {
                            dt(this).wrapAll(e ? t.call(this, n) : t)
                        })
                    },
                    unwrap: function(t) {
                        return this.parent(t).not("body").each(function() {
                            dt(this).replaceWith(this.childNodes)
                        }), this
                    }
                }), dt.expr.pseudos.hidden = function(t) {
                    return !dt.expr.pseudos.visible(t)
                }, dt.expr.pseudos.visible = function(t) {
                    return !!(t.offsetWidth || t.offsetHeight || t.getClientRects().length)
                }, dt.ajaxSettings.xhr = function() {
                    try {
                        return new t.XMLHttpRequest
                    } catch (t) {}
                };
                var He = {
                        0: 200,
                        1223: 204
                    },
                    Me = dt.ajaxSettings.xhr();
                lt.cors = !!Me && "withCredentials" in Me, lt.ajax = Me = !!Me, dt.ajaxTransport(function(e) {
                    var n, i;
                    if (lt.cors || Me && !e.crossDomain) return {
                        send: function(r, o) {
                            var s, a = e.xhr();
                            if (a.open(e.type, e.url, e.async, e.username, e.password), e.xhrFields)
                                for (s in e.xhrFields) a[s] = e.xhrFields[s];
                            e.mimeType && a.overrideMimeType && a.overrideMimeType(e.mimeType), e.crossDomain || r["X-Requested-With"] || (r["X-Requested-With"] = "XMLHttpRequest");
                            for (s in r) a.setRequestHeader(s, r[s]);
                            n = function(t) {
                                return function() {
                                    n && (n = i = a.onload = a.onerror = a.onabort = a.onreadystatechange = null, "abort" === t ? a.abort() : "error" === t ? "number" != typeof a.status ? o(0, "error") : o(a.status, a.statusText) : o(He[a.status] || a.status, a.statusText, "text" !== (a.responseType || "text") || "string" != typeof a.responseText ? {
                                        binary: a.response
                                    } : {
                                        text: a.responseText
                                    }, a.getAllResponseHeaders()))
                                }
                            }, a.onload = n(), i = a.onerror = n("error"), void 0 !== a.onabort ? a.onabort = i : a.onreadystatechange = function() {
                                4 === a.readyState && t.setTimeout(function() {
                                    n && i()
                                })
                            }, n = n("abort");
                            try {
                                a.send(e.hasContent && e.data || null)
                            } catch (t) {
                                if (n) throw t
                            }
                        },
                        abort: function() {
                            n && n()
                        }
                    }
                }), dt.ajaxPrefilter(function(t) {
                    t.crossDomain && (t.contents.script = !1)
                }), dt.ajaxSetup({
                    accepts: {
                        script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"
                    },
                    contents: {
                        script: /\b(?:java|ecma)script\b/
                    },
                    converters: {
                        "text script": function(t) {
                            return dt.globalEval(t), t
                        }
                    }
                }), dt.ajaxPrefilter("script", function(t) {
                    void 0 === t.cache && (t.cache = !1), t.crossDomain && (t.type = "GET")
                }), dt.ajaxTransport("script", function(t) {
                    if (t.crossDomain) {
                        var e, n;
                        return {
                            send: function(i, r) {
                                e = dt("<script>").prop({
                                    charset: t.scriptCharset,
                                    src: t.url
                                }).on("load error", n = function(t) {
                                    e.remove(), n = null, t && r("error" === t.type ? 404 : 200, t.type)
                                }), Z.head.appendChild(e[0])
                            },
                            abort: function() {
                                n && n()
                            }
                        }
                    }
                });
                var qe = [],
                    Re = /(=)\?(?=&|$)|\?\?/;
                dt.ajaxSetup({
                    jsonp: "callback",
                    jsonpCallback: function() {
                        var t = qe.pop() || dt.expando + "_" + Se++;
                        return this[t] = !0, t
                    }
                }), dt.ajaxPrefilter("json jsonp", function(e, n, i) {
                    var r, o, s, a = !1 !== e.jsonp && (Re.test(e.url) ? "url" : "string" == typeof e.data && 0 === (e.contentType || "").indexOf("application/x-www-form-urlencoded") && Re.test(e.data) && "data");
                    if (a || "jsonp" === e.dataTypes[0]) return r = e.jsonpCallback = dt.isFunction(e.jsonpCallback) ? e.jsonpCallback() : e.jsonpCallback, a ? e[a] = e[a].replace(Re, "$1" + r) : !1 !== e.jsonp && (e.url += (xe.test(e.url) ? "&" : "?") + e.jsonp + "=" + r), e.converters["script json"] = function() {
                        return s || dt.error(r + " was not called"), s[0]
                    }, e.dataTypes[0] = "json", o = t[r], t[r] = function() {
                        s = arguments
                    }, i.always(function() {
                        void 0 === o ? dt(t).removeProp(r) : t[r] = o, e[r] && (e.jsonpCallback = n.jsonpCallback, qe.push(r)), s && dt.isFunction(o) && o(s[0]), s = o = void 0
                    }), "script"
                }), lt.createHTMLDocument = function() {
                    var t = Z.implementation.createHTMLDocument("").body;
                    return t.innerHTML = "<form></form><form></form>", 2 === t.childNodes.length
                }(), dt.parseHTML = function(t, e, n) {
                    if ("string" != typeof t) return [];
                    "boolean" == typeof e && (n = e, e = !1);
                    var i, r, o;
                    return e || (lt.createHTMLDocument ? (e = Z.implementation.createHTMLDocument(""), i = e.createElement("base"), i.href = Z.location.href, e.head.appendChild(i)) : e = Z), r = _t.exec(t), o = !n && [], r ? [e.createElement(r[1])] : (r = y([t], e, o), o && o.length && dt(o).remove(), dt.merge([], r.childNodes))
                }, dt.fn.load = function(t, e, n) {
                    var i, r, o, s = this,
                        a = t.indexOf(" ");
                    return a > -1 && (i = dt.trim(t.slice(a)), t = t.slice(0, a)), dt.isFunction(e) ? (n = e, e = void 0) : e && "object" == typeof e && (r = "POST"), s.length > 0 && dt.ajax({
                        url: t,
                        type: r || "GET",
                        dataType: "html",
                        data: e
                    }).done(function(t) {
                        o = arguments, s.html(i ? dt("<div>").append(dt.parseHTML(t)).find(i) : t)
                    }).always(n && function(t, e) {
                        s.each(function() {
                            n.apply(this, o || [t.responseText, e, t])
                        })
                    }), this
                }, dt.each(["ajaxStart", "ajaxStop", "ajaxComplete", "ajaxError", "ajaxSuccess", "ajaxSend"], function(t, e) {
                    dt.fn[e] = function(t) {
                        return this.on(e, t)
                    }
                }), dt.expr.pseudos.animated = function(t) {
                    return dt.grep(dt.timers, function(e) {
                        return t === e.elem
                    }).length
                }, dt.offset = {
                    setOffset: function(t, e, n) {
                        var i, r, o, s, a, c, u, l = dt.css(t, "position"),
                            d = dt(t),
                            h = {};
                        "static" === l && (t.style.position = "relative"), a = d.offset(), o = dt.css(t, "top"), c = dt.css(t, "left"), u = ("absolute" === l || "fixed" === l) && (o + c).indexOf("auto") > -1, u ? (i = d.position(), s = i.top, r = i.left) : (s = parseFloat(o) || 0, r = parseFloat(c) || 0), dt.isFunction(e) && (e = e.call(t, n, dt.extend({}, a))), null != e.top && (h.top = e.top - a.top + s), null != e.left && (h.left = e.left - a.left + r), "using" in e ? e.using.call(t, h) : d.css(h)
                    }
                }, dt.fn.extend({
                    offset: function(t) {
                        if (arguments.length) return void 0 === t ? this : this.each(function(e) {
                            dt.offset.setOffset(this, t, e)
                        });
                        var e, n, i, r, o = this[0];
                        if (o) return o.getClientRects().length ? (i = o.getBoundingClientRect(), i.width || i.height ? (r = o.ownerDocument, n = K(r), e = r.documentElement, {
                            top: i.top + n.pageYOffset - e.clientTop,
                            left: i.left + n.pageXOffset - e.clientLeft
                        }) : i) : {
                            top: 0,
                            left: 0
                        }
                    },
                    position: function() {
                        if (this[0]) {
                            var t, e, n = this[0],
                                i = {
                                    top: 0,
                                    left: 0
                                };
                            return "fixed" === dt.css(n, "position") ? e = n.getBoundingClientRect() : (t = this.offsetParent(), e = this.offset(), dt.nodeName(t[0], "html") || (i = t.offset()), i = {
                                top: i.top + dt.css(t[0], "borderTopWidth", !0),
                                left: i.left + dt.css(t[0], "borderLeftWidth", !0)
                            }), {
                                top: e.top - i.top - dt.css(n, "marginTop", !0),
                                left: e.left - i.left - dt.css(n, "marginLeft", !0)
                            }
                        }
                    },
                    offsetParent: function() {
                        return this.map(function() {
                            for (var t = this.offsetParent; t && "static" === dt.css(t, "position");) t = t.offsetParent;
                            return t || Ut
                        })
                    }
                }), dt.each({
                    scrollLeft: "pageXOffset",
                    scrollTop: "pageYOffset"
                }, function(t, e) {
                    var n = "pageYOffset" === e;
                    dt.fn[t] = function(i) {
                        return At(this, function(t, i, r) {
                            var o = K(t);
                            if (void 0 === r) return o ? o[e] : t[i];
                            o ? o.scrollTo(n ? o.pageXOffset : r, n ? r : o.pageYOffset) : t[i] = r
                        }, t, i, arguments.length)
                    }
                }), dt.each(["top", "left"], function(t, e) {
                    dt.cssHooks[e] = P(lt.pixelPosition, function(t, n) {
                        if (n) return n = j(t, e), ne.test(n) ? dt(t).position()[e] + "px" : n
                    })
                }), dt.each({
                    Height: "height",
                    Width: "width"
                }, function(t, e) {
                    dt.each({
                        padding: "inner" + t,
                        content: e,
                        "": "outer" + t
                    }, function(n, i) {
                        dt.fn[i] = function(r, o) {
                            var s = arguments.length && (n || "boolean" != typeof r),
                                a = n || (!0 === r || !0 === o ? "margin" : "border");
                            return At(this, function(e, n, r) {
                                var o;
                                return dt.isWindow(e) ? 0 === i.indexOf("outer") ? e["inner" + t] : e.document.documentElement["client" + t] : 9 === e.nodeType ? (o = e.documentElement, Math.max(e.body["scroll" + t], o["scroll" + t], e.body["offset" + t], o["offset" + t], o["client" + t])) : void 0 === r ? dt.css(e, n, a) : dt.style(e, n, r, a)
                            }, e, s ? r : void 0, s)
                        }
                    })
                }), dt.fn.extend({
                    bind: function(t, e, n) {
                        return this.on(t, null, e, n)
                    },
                    unbind: function(t, e) {
                        return this.off(t, null, e)
                    },
                    delegate: function(t, e, n, i) {
                        return this.on(e, t, n, i)
                    },
                    undelegate: function(t, e, n) {
                        return 1 === arguments.length ? this.off(t, "**") : this.off(e, t || "**", n)
                    }
                }), dt.parseJSON = JSON.parse, "function" == typeof define && define.amd && define("jquery", [], function() {
                    return dt
                });
                var We = t.jQuery,
                    ze = t.$;
                return dt.noConflict = function(e) {
                    return t.$ === dt && (t.$ = ze), e && t.jQuery === dt && (t.jQuery = We), dt
                }, e || (t.jQuery = t.$ = dt), dt
            })
        }),
        En = Array.prototype,
        An = En.splice;
    u.prototype.clear = n, u.prototype.delete = o, u.prototype.get = s, u.prototype.has = a, u.prototype.set = c;
    var jn = "object" == typeof global && global && global.Object === Object && global,
        Pn = "object" == typeof self && self && self.Object === Object && self,
        Dn = jn || Pn || Function("return this")(),
        Nn = Dn.Symbol,
        On = Object.prototype,
        In = On.hasOwnProperty,
        Fn = On.toString,
        Bn = Nn ? Nn.toStringTag : void 0,
        Ln = Object.prototype,
        Hn = Ln.toString,
        Mn = "[object Null]",
        qn = "[object Undefined]",
        Rn = Nn ? Nn.toStringTag : void 0,
        Wn = "[object AsyncFunction]",
        zn = "[object Function]",
        Vn = "[object GeneratorFunction]",
        Un = "[object Proxy]",
        Xn = Dn["__core-js_shared__"],
        Yn = function() {
            var t = /[^.]+$/.exec(Xn && Xn.keys && Xn.keys.IE_PROTO || "");
            return t ? "Symbol(src)_1." + t : ""
        }(),
        Qn = Function.prototype,
        Gn = Qn.toString,
        Kn = /[\\^$.*+?()[\]{}|]/g,
        Jn = /^\[object .+?Constructor\]$/,
        Zn = Function.prototype,
        ti = Object.prototype,
        ei = Zn.toString,
        ni = ti.hasOwnProperty,
        ii = RegExp("^" + ei.call(ni).replace(Kn, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"),
        ri = x(Dn, "Map"),
        oi = x(Object, "create"),
        si = "__lodash_hash_undefined__",
        ai = Object.prototype,
        ci = ai.hasOwnProperty,
        ui = Object.prototype,
        li = ui.hasOwnProperty,
        di = "__lodash_hash_undefined__";
    j.prototype.clear = C, j.prototype.delete = T, j.prototype.get = k, j.prototype.has = E, j.prototype.set = A, L.prototype.clear = P, L.prototype.delete = O, L.prototype.get = I, L.prototype.has = F, L.prototype.set = B;
    var hi = 200;
    M.prototype.clear = l, M.prototype.delete = d, M.prototype.get = h, M.prototype.has = f, M.prototype.set = H;
    var fi = function() {
            try {
                var t = x(Object, "defineProperty");
                return t({}, "", {}), t
            } catch (t) {}
        }(),
        pi = Object.prototype,
        mi = pi.hasOwnProperty,
        gi = "[object Arguments]",
        vi = Object.prototype,
        yi = vi.hasOwnProperty,
        bi = vi.propertyIsEnumerable,
        _i = X(function() {
            return arguments
        }()) ? X : function(t) {
            return U(t) && yi.call(t, "callee") && !bi.call(t, "callee")
        },
        wi = Array.isArray,
        Si = "object" == typeof exports && exports && !exports.nodeType && exports,
        xi = Si && "object" == typeof module && module && !module.nodeType && module,
        Ci = xi && xi.exports === Si,
        Ti = Ci ? Dn.Buffer : void 0,
        ki = Ti ? Ti.isBuffer : void 0,
        $i = ki || Y,
        Ei = 9007199254740991,
        Ai = /^(?:0|[1-9]\d*)$/,
        ji = 9007199254740991,
        Pi = {};
    Pi["[object Float32Array]"] = Pi["[object Float64Array]"] = Pi["[object Int8Array]"] = Pi["[object Int16Array]"] = Pi["[object Int32Array]"] = Pi["[object Uint8Array]"] = Pi["[object Uint8ClampedArray]"] = Pi["[object Uint16Array]"] = Pi["[object Uint32Array]"] = !0, Pi["[object Arguments]"] = Pi["[object Array]"] = Pi["[object ArrayBuffer]"] = Pi["[object Boolean]"] = Pi["[object DataView]"] = Pi["[object Date]"] = Pi["[object Error]"] = Pi["[object Function]"] = Pi["[object Map]"] = Pi["[object Number]"] = Pi["[object Object]"] = Pi["[object RegExp]"] = Pi["[object Set]"] = Pi["[object String]"] = Pi["[object WeakMap]"] = !1;
    var Di = "object" == typeof exports && exports && !exports.nodeType && exports,
        Ni = Di && "object" == typeof module && module && !module.nodeType && module,
        Oi = Ni && Ni.exports === Di,
        Ii = Oi && jn.process,
        Fi = function() {
            try {
                return Ii && Ii.binding && Ii.binding("util")
            } catch (t) {}
        }(),
        Bi = Fi && Fi.isTypedArray,
        Li = Bi ? function(t) {
            return function(e) {
                return t(e)
            }
        }(Bi) : K,
        Hi = Object.prototype,
        Mi = Hi.hasOwnProperty,
        qi = Object.prototype,
        Ri = tt(Object.keys, Object),
        Wi = Object.prototype,
        zi = Wi.hasOwnProperty,
        Vi = Object.prototype,
        Ui = Vi.hasOwnProperty,
        Xi = "object" == typeof exports && exports && !exports.nodeType && exports,
        Yi = Xi && "object" == typeof module && module && !module.nodeType && module,
        Qi = Yi && Yi.exports === Xi,
        Gi = Qi ? Dn.Buffer : void 0,
        Ki = Gi ? Gi.allocUnsafe : void 0,
        Ji = Object.getOwnPropertySymbols,
        Zi = Ji ? tt(Ji, Object) : dt,
        tr = tt(Object.getPrototypeOf, Object),
        er = Object.getOwnPropertySymbols,
        nr = er ? function(t) {
            for (var e = []; t;) ft(e, Zi(t)), t = tr(t);
            return e
        } : dt,
        ir = x(Dn, "DataView"),
        rr = x(Dn, "Promise"),
        or = x(Dn, "Set"),
        sr = x(Dn, "WeakMap"),
        ar = _(ir),
        cr = _(ri),
        ur = _(rr),
        lr = _(or),
        dr = _(sr),
        hr = g;
    (ir && "[object DataView]" != hr(new ir(new ArrayBuffer(1))) || ri && "[object Map]" != hr(new ri) || rr && "[object Promise]" != hr(rr.resolve()) || or && "[object Set]" != hr(new or) || sr && "[object WeakMap]" != hr(new sr)) && (hr = function(t) {
        var e = g(t),
            n = "[object Object]" == e ? t.constructor : void 0,
            i = n ? _(n) : "";
        if (i) switch (i) {
            case ar:
                return "[object DataView]";
            case cr:
                return "[object Map]";
            case ur:
                return "[object Promise]";
            case lr:
                return "[object Set]";
            case dr:
                return "[object WeakMap]"
        }
        return e
    });
    var fr = hr,
        pr = Object.prototype,
        mr = pr.hasOwnProperty,
        gr = Dn.Uint8Array,
        vr = 1,
        yr = /\w*$/,
        br = 1,
        _r = Nn ? Nn.prototype : void 0,
        wr = _r ? _r.valueOf : void 0,
        Sr = "[object Boolean]",
        xr = "[object Date]",
        Cr = "[object Map]",
        Tr = "[object Number]",
        kr = "[object RegExp]",
        $r = "[object Set]",
        Er = "[object String]",
        Ar = "[object Symbol]",
        jr = "[object ArrayBuffer]",
        Pr = "[object DataView]",
        Dr = "[object Float32Array]",
        Nr = "[object Float64Array]",
        Or = "[object Int8Array]",
        Ir = "[object Int16Array]",
        Fr = "[object Int32Array]",
        Br = "[object Uint8Array]",
        Lr = "[object Uint8ClampedArray]",
        Hr = "[object Uint16Array]",
        Mr = "[object Uint32Array]",
        qr = Object.create,
        Rr = function() {
            function t() {}
            return function(e) {
                if (!v(e)) return {};
                if (qr) return qr(e);
                t.prototype = e;
                var n = new t;
                return t.prototype = void 0, n
            }
        }(),
        Wr = 1,
        zr = 2,
        Vr = 4,
        Ur = "[object Arguments]",
        Xr = "[object Function]",
        Yr = "[object GeneratorFunction]",
        Qr = "[object Object]",
        Gr = {};
    Gr[Ur] = Gr["[object Array]"] = Gr["[object ArrayBuffer]"] = Gr["[object DataView]"] = Gr["[object Boolean]"] = Gr["[object Date]"] = Gr["[object Float32Array]"] = Gr["[object Float64Array]"] = Gr["[object Int8Array]"] = Gr["[object Int16Array]"] = Gr["[object Int32Array]"] = Gr["[object Map]"] = Gr["[object Number]"] = Gr[Qr] = Gr["[object RegExp]"] = Gr["[object Set]"] = Gr["[object String]"] = Gr["[object Symbol]"] = Gr["[object Uint8Array]"] = Gr["[object Uint8ClampedArray]"] = Gr["[object Uint16Array]"] = Gr["[object Uint32Array]"] = !0, Gr["[object Error]"] = Gr[Xr] = Gr["[object WeakMap]"] = !1;
    var Kr = "[object Symbol]",
        Jr = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
        Zr = /^\w*$/,
        to = "Expected a function";
    Ft.Cache = L;
    var eo = 500,
        no = /^\./,
        io = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g,
        ro = /\\(\\)?/g,
        oo = function(t) {
            var e = Ft(t, function(t) {
                    return n.size === eo && n.clear(), t
                }),
                n = e.cache;
            return e
        }(function(t) {
            var e = [];
            return no.test(t) && e.push(""), t.replace(io, function(t, n, i, r) {
                e.push(i ? r.replace(ro, "$1") : n || t)
            }), e
        }),
        so = 1 / 0,
        ao = Nn ? Nn.prototype : void 0,
        co = ao ? ao.toString : void 0,
        uo = 1 / 0,
        lo = Nn ? Nn.isConcatSpreadable : void 0,
        ho = Math.max,
        fo = fi ? function(t, e) {
            return fi(t, "toString", {
                configurable: !0,
                enumerable: !1,
                value: Kt(e),
                writable: !0
            })
        } : Jt,
        po = 800,
        mo = 16,
        go = Date.now,
        vo = function(t) {
            var e = 0,
                n = 0;
            return function() {
                var i = go(),
                    r = mo - (i - n);
                if (n = i, r > 0) {
                    if (++e >= po) return arguments[0]
                } else e = 0;
                return t.apply(void 0, arguments)
            }
        }(fo),
        yo = function(t) {
            return vo(Gt(t, void 0, Yt), t + "")
        }(function(t, n) {
            var i = {};
            if (null == t) return i;
            var r = !1;
            n = e(n, function(e) {
                return e = Ht(e, t), r || (r = e.length > 1), e
            }), z(t, vt(t), i), r && (i = Nt(i, 7));
            for (var o = n.length; o--;) Vt(i, n[o]);
            return i
        }),
        bo = "__lodash_hash_undefined__";
    ee.prototype.add = ee.prototype.push = Zt, ee.prototype.has = te;
    var _o = 1,
        wo = 2,
        So = 1,
        xo = 2,
        Co = "[object Boolean]",
        To = "[object Date]",
        ko = "[object Error]",
        $o = "[object Map]",
        Eo = "[object Number]",
        Ao = "[object RegExp]",
        jo = "[object Set]",
        Po = "[object String]",
        Do = "[object Symbol]",
        No = "[object ArrayBuffer]",
        Oo = "[object DataView]",
        Io = Nn ? Nn.prototype : void 0,
        Fo = Io ? Io.valueOf : void 0,
        Bo = 1,
        Lo = Object.prototype,
        Ho = Lo.hasOwnProperty,
        Mo = 1,
        qo = "[object Arguments]",
        Ro = "[object Array]",
        Wo = "[object Object]",
        zo = Object.prototype,
        Vo = zo.hasOwnProperty,
        Uo = 1,
        Xo = 2,
        Yo = 1,
        Qo = 2,
        Go = NaN,
        Ko = /^\s+|\s+$/g,
        Jo = /^[-+]0x[0-9a-f]+$/i,
        Zo = /^0b[01]+$/i,
        ts = /^0o[0-7]+$/i,
        es = parseInt,
        ns = 1 / 0,
        is = 1.7976931348623157e308,
        rs = Math.max,
        os = function(t) {
            return function(e, n, i) {
                var r = Object(e);
                if (!nt(e)) {
                    var o = Se(n, 3);
                    e = it(e), n = function(t) {
                        return o(r[t], t, r)
                    }
                }
                var s = t(e, n, i);
                return s > -1 ? r[o ? e[s] : s] : void 0
            }
        }($e);
    Ee.prototype = {
        register: function(t, e, n) {
            function i(e, n) {
                this.name = t.toLowerCase(), this.container = e, this.$container = $n(e), this.extensions = n, Ae.call(this)
            }
            i.classname = e, i.constructor = i, i.prototype = Object.create(Ae.prototype), $n.extend(i.prototype, n), this.registered[t] = i
        },
        extend: function(t, e) {
            "*" === t ? (t = Object.keys(this.registered), t.push("*")) : "string" == typeof t && (t = [t]), t.forEach(function(t) {
                this.extensions[t] = this.extensions[t] || [], this.extensions[t].push(e), void 0 !== this.registered[t] && "*" !== t && this.instances.forEach(function(n) {
                    n.name === t && n.extend(e)
                })
            }.bind(this))
        },
        load: function(t) {
            "*" === t ? t = Object.keys(this.registered) : "string" == typeof t && (t = [t]), t.forEach(this._loadTemplate.bind(this))
        },
        _loadTemplate: function(t) {
            var e, n, i = this.registered[t],
                r = os(this.instances, {
                    name: t
                });
            void 0 === i || r || (e = "*" === i.classname ? document.body : document.querySelector("body." + i.classname)) && (n = this.extensions["*"].concat(this.extensions[t] || []), r = new i(e, n), $n.isFunction(r.onLoad) && r.onLoad(e), this.instances.push(r))
        }
    }, Ae.prototype = {
        extend: function(t) {
            var e = t.init;
            this.extensions.push(t), $n.isFunction(e) && (t = yo(t, "init")), $n.extend(this, t), e.apply(this)
        }
    };
    var ss = new Ee,
        as = {
            disableScroll: "disable-scroll"
        },
        cs = {
            pointerEventToXY: function(t) {
                var e;
                return e = t.originalEvent.touches ? t.originalEvent.touches[0] || t.originalEvent.changedTouches[0] : t, {
                    x: e.pageX,
                    y: e.pageY
                }
            },
            promiseRepeatSeries: function(t, e) {
                return e--, t().then(function() {
                    if (e) return this.promiseRepeatSeries(t, e)
                }.bind(this))
            },
            mapPromiseSeries: function(t, e, n) {
                function i(t, i) {
                    return $n.Deferred(function(r) {
                        setTimeout(function() {
                            r.resolve(e(t, i))
                        }, n)
                    })
                }
                var r = $n.Deferred().resolve();
                return $n.each(t, function(t, o) {
                    r = r.then(function() {
                        return "number" == typeof n ? i(t, o) : e(t, o)
                    })
                }), r
            },
            promiseAnimationEnd: function(t) {
                var e = "animationend webkitAnimationEnd oAnimationEnd",
                    n = ["animation-duration", "-moz-animation-duration", "-webkit-animation-duration", "-o-animation-duration"],
                    i = 0,
                    r = $n.Deferred().resolve();
                return $n.each(n, function(e, n) {
                    i || (i = parseFloat(t.css(n)))
                }), i > 0 && (r = $n.Deferred(function(n) {
                    t.on(e, function(i) {
                        i.target === t[0] && (t.off(e), n.resolve())
                    })
                })), r
            },
            promiseTransitionEnd: function(t) {
                var e = "webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend",
                    n = ["transition-duration", "-moz-transition-duration", "-webkit-transition-duration", "-o-transition-duration"],
                    i = 0,
                    r = $n.Deferred().resolve();
                return $n.each(n, function(e, n) {
                    i || (i = parseFloat(t.css(n)))
                }), i > 0 && (r = $n.Deferred(function(n) {
                    t.on(e, function(i) {
                        i.target === t[0] && (t.off(e), n.resolve())
                    })
                })), r
            },
            isLocalStorageSupported: function() {
                var t = "localStorageTest";
                try {
                    return localStorage.setItem(t, t), localStorage.removeItem(t), !0
                } catch (t) {
                    return !1
                }
            },
            isSessionStorageSupported: function() {
                var t = "sessionStorageTest";
                try {
                    return sessionStorage.setItem(t, t), sessionStorage.removeItem(t), !0
                } catch (t) {
                    return !1
                }
            },
            disableTabbingOfChildren: function(t) {
                $n(t).each(function(t, e) {
                    $n("a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, *[tabindex], *[contenteditable]", e).attr("tabindex", "-1")
                })
            },
            enableTabbingOfChildren: function(t) {
                $n(t).each(function(t, e) {
                    $n("a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, *[tabindex], *[contenteditable]", e).removeAttr("tabindex")
                })
            },
            isiOSSafari: function() {
                var t = window.navigator.userAgent,
                    e = Boolean(t.match(/iPad/i)) || Boolean(t.match(/iPhone/i)),
                    n = Boolean(t.match(/WebKit/i));
                return e && n && !t.match(/CriOS/i)
            },
            disableScrollBody: function() {
                document.body.scrollHeight - window.innerHeight != 0 && $n("html").addClass(as.disableScroll)
            },
            enableScrollBody: function() {
                $n("html").removeClass(as.disableScroll)
            },
            updateUrlParameter: function(t, e, n) {
                var i = new RegExp("([?&])" + e + "=.*?(&|$)", "i"),
                    r = -1 === t.indexOf("?") ? "?" : "&";
                return t.match(i) ? t.replace(i, "$1" + e + "=" + n + "$2") : t + r + e + "=" + n
            },
            cookiesEnabled: function() {
                var t = navigator.cookieEnabled;
                return t || (document.cookie = "testcookie", t = -1 !== document.cookie.indexOf("testcookie")), t
            },
            onFirst: function(t, e) {
                this.on(t, e), this.each(function() {
                    var e = $n._data(this, "events")[t.split(".")[0]],
                        n = e.pop();
                    e.splice(0, 0, n)
                })
            },
            promiseStylesheet: function() {
                return void 0 === this.stylesheetPromise && (this.stylesheetPromise = $n.Deferred(function(t) {
                    var e = document.querySelector('link[href="' + theme.stylesheet + '"]');
                    e.loaded && t.resolve(), onloadCSS(e, function() {
                        t.resolve()
                    })
                })), this.stylesheetPromise
            },
            isMobile: function() {
                function t() {
                    return e = $n(window).outerWidth() < theme.mediaQuerySmall
                }
                var e = !1;
                return this.isMobile = function() {
                    return e
                }, $n.fn.onFirst = this.onFirst, $n(window).onFirst("resize", t), t()
            },
            isTablet: function() {
                function t() {
                    var t = $n(window).outerWidth();
                    return e = t > theme.mediaQuerySmall && t < theme.mediaQueryMedium
                }
                var e = !1;
                return this.isTablet = function() {
                    return e
                }, $n.fn.onFirst = this.onFirst, $n(window).onFirst("resize", t), t()
            },
            isInOrAboveViewport: function(t) {
                var e = t.getBoundingClientRect();
                return e.top + 50 >= 0 && e.top + 50 <= window.innerHeight || e.bottom + 50 >= 0 && e.bottom + 50 <= window.innerHeight || e.top + 50 < 0 && e.bottom + 50 > window.innerHeight || e.bottom < 0
            }
        },
        us = function() {
            return Dn.Date.now()
        },
        ls = "Expected a function",
        ds = Math.max,
        hs = Math.min,
        fs = "Expected a function",
        ps = {
            elementsToAnimate: "[data-animate]"
        },
        ms = {
            animated: "has-animated",
            animationsDisabled: "animations--disabled"
        };
    ss.register("Page animations", "*", {
        onLoad: function() {
            this.animationNamespace = ".animations", this.$elementsToAnimate = $n(ps.elementsToAnimate, this.$container), 0 !== this.$elementsToAnimate.length && ($n(window).on("scroll" + this.animationNamespace, Pe(this._animateElementsInViewport.bind(this), 200)), $n(window).on("resize" + this.animationNamespace, Pe(this._animateElementsInViewport.bind(this), 200)), Shopify && Shopify.designMode && ($n(document).on("shopify:section:load shopify:section:select", this._onSectionSelect.bind(this)), $n(document).on("shopify:section:unload shopify:section:deselect", this._onSectionDeselect.bind(this))), cs.promiseStylesheet().then(this._animateElementsInViewport.bind(this)))
        },
        _animateElementsInViewport: function() {
            this.$elementsToAnimate = this.$elementsToAnimate.map(function(t, e) {
                return cs.isInOrAboveViewport(e) ? (requestAnimationFrame(function() {
                    $n(e).addClass(ms.animated), $n(e).trigger("animate_element", [e])
                }), null) : e
            }), 0 === this.$elementsToAnimate.length && $n(window).off(this.animationNamespace)
        },
        _onSectionSelect: function() {
            $n(document.body).addClass(ms.animationsDisabled)
        },
        _onSectionDeselect: function(t) {
            $n(document.body).removeClass(ms.animationsDisabled), $n(t.target).find(ps.elementsToAnimate).addClass(ms.animated)
        }
    });
    var gs = {
            socialSharing: ".social-sharing",
            socialSharingToggle: ".social-sharing__toggle",
            linkList: ".social-sharing__item-list"
        },
        vs = {
            socialSharingAction: "social-sharing--active"
        },
        ys = {
            init: function() {
                this.$elements = $n(gs.socialSharing, this.$container), this.clicked = !1, $n(gs.socialSharingToggle, this.$container).on("click", this._onClick.bind(this)).one("click", function() {
                    this.clicked = !0
                }), this.$container.on("section_unload", this.destroySocialSharing.bind(this))
            },
            showSocialSharing: function() {
                $n(gs.socialSharing, this.$container).addClass(vs.socialSharingAction), $n(gs.socialSharingToggle, this.$container).attr("aria-expanded", !0), $n(gs.linkList, this.$container).attr("aria-hidden", !1), cs.enableTabbingOfChildren($n(gs.linkList, this.$container))
            },
            hideSocialSharing: function() {
                $n(gs.socialSharing, this.$container).removeClass(vs.socialSharingAction), $n(gs.socialSharingToggle, this.$container).attr("aria-expanded", !1), $n(gs.linkList, this.$container).attr("aria-hidden", !0), cs.disableTabbingOfChildren($n(gs.linkList, this.$container))
            },
            destroySocialSharing: function() {
                $n(gs.socialSharingToggle, this.$container).off()
            },
            _onClick: function(t) {
                "true" === $n(t.currentTarget).attr("aria-expanded") ? this.hideSocialSharing() : this.showSocialSharing()
            }
        },
        bs = {
            articleContentWrapper: ".article__wrapper",
            articleShareDesktop: ".article__share-desktop",
            articleShareMobile: ".article__share-mobile",
            articleShareDesktopWrapper: ".article__share-desktop-wrapper",
            socialSharing: ".social-sharing"
        },
        _s = {
            shareFixed: "article__share-desktop--fixed",
            shareBottom: "article__share-desktop--bottom"
        },
        ws = {
            shareExpandedHeight: 350
        };
    ss.register("Article Template", "template-article", {
        onLoad: function() {
            this.extend(ys), $n(window).on("scroll", this.setSharePosition.bind(this)).on("resize", this.updateMeasurements.bind(this)), cs.promiseStylesheet().then(function() {
                this.updateMeasurements()
            }.bind(this))
        },
        setSharePosition: function() {
            if (!cs.isMobile() && !cs.isTablet()) {
                var t = $n(window).scrollTop();
                requestAnimationFrame(function() {
                    t > this.fixedTop ? t > this.fixedBottom ? $n(bs.articleShareDesktop).removeClass(_s.shareFixed).addClass(_s.shareBottom) : $n(bs.articleShareDesktop).addClass(_s.shareFixed).removeClass(_s.shareBottom) : $n(bs.articleShareDesktop).removeClass(_s.shareFixed).removeClass(_s.shareBottom), this.clicked || (t > this.fixedBottom - ws.shareExpandedHeight ? this.showSocialSharing() : this.hideSocialSharing())
                }.bind(this))
            }
        },
        updateMeasurements: function() {
            this.fixedTop = $n(bs.articleContentWrapper).offset().top, this.fixedBottom = this.fixedTop + $n(bs.articleContentWrapper).height() - $n(bs.articleShareDesktopWrapper).height(), this.windowHeight = $n(window).outerHeight(), this.setSharePosition()
        }
    });
    var Ss = {
            addressCountrySelect: ".address-country-selector",
            newToggle: ".address-new-toggle",
            newAddressContainer: ".new-address",
            editToggle: ".address-edit-toggle",
            editAddressContainer: "#EditAddress_",
            deleteAddress: ".address-delete",
            currentAddresses: ".current-addresses",
            currentAddress: "#CurrentAddress_",
            currentAddressesItem: ".current-addresses__item"
        },
        xs = {
            customerAddresses: "template-customers-addresses",
            newAddressHide: "new-address--hidden",
            editAddressShow: "edit-address--show"
        };
    ss.register("Customer Addresses Template", "template-customers-addresses", {
        onLoad: function(t) {
            var e = this.$sideScroller = $n(t),
                n = $n(theme.countryOptionTags).filter("option"),
                i = $n(Ss.addressCountrySelect, e);
            n.each(function() {
                this.value = this.text
            }), i.each(function(t, i) {
                var r = this._populateCountrySelect(i, n),
                    o = this._fetchCurrentProvinces(r),
                    s = $n(r.attr("data-province-select"), e),
                    a = s.data("default");
                this._populateProvinceSelect(s, o, a)
            }.bind(this)), $n(Ss.newToggle).on("click", this._onNewAddressClick.bind(this)), $n(Ss.editToggle).on("click", this._onEditAddressClick.bind(this)), $n(Ss.deleteAddress).on("click", this._onDeleteAddressClick.bind(this))
        },
        _populateCountrySelect: function(t, e) {
            var n = $n(t),
                i = n.data("default") || $n(e[0]).val();
            return n.html(e.clone()).val(i).on("change", this._onCountrySelectChange.bind(this))
        },
        _populateProvinceSelect: function(t, e, n) {
            var i = t.parent(),
                r = e.map(this._createProvinceOption),
                o = n || $n(r[0]).val();
            return r.length ? i.show() : i.hide(), t.html(r).val(o)
        },
        _createProvinceOption: function(t) {
            return $n("<option>").attr({
                value: t[1]
            }).text(t[1])
        },
        _fetchCurrentProvinces: function(t) {
            return t.find(":selected").data("provinces") || []
        },
        _onCountrySelectChange: function(t) {
            var e = $n(t.target),
                n = this._fetchCurrentProvinces(e),
                i = $n(e.data("province-select"));
            this._populateProvinceSelect(i, n)
        },
        _onNewAddressClick: function() {
            $n(Ss.newAddressContainer, this.$sideScroller).toggleClass(xs.newAddressHide)
        },
        _onEditAddressClick: function(t) {
            var e = $n(t.target).data("form-id");
            $n(Ss.editAddressContainer + e, this.$sideScroller).toggleClass(xs.editAddressShow)
        },
        _onDeleteAddressClick: function(t) {
            var e = $n(t.target),
                n = e.data("form-id"),
                i = e.data("confirm-message"),
                r = $n(Ss.currentAddress + n, this.$sideScroller);
            confirm(i) && ($n.post("/account/addresses/" + n, {
                _method: "delete"
            }), r.remove(), $n(Ss.currentAddressesItem).length || ($n(Ss.currentAddresses, this.$sideScroller).remove(), $n(Ss.newAddressContainer, this.$sideScroller).removeClass(xs.newAddressHide)))
        }
    });
    var Cs = {
        recoverPasswordForm: "#RecoverPassword",
        hideRecoverPasswordLink: "#HideRecoverPasswordLink"
    };
    ss.register("Customer Login Template", "template-customers-login", {
        onLoad: function(t) {
            var e = this.$sideScroller = $n(t);
            this.checkUrlHash(), this.resetPasswordSuccess(), $n(Cs.recoverPasswordForm, e).on("click", this.onShowHidePasswordForm.bind(this)), $n(Cs.hideRecoverPasswordLink, e).on("click", this.onShowHidePasswordForm.bind(this))
        },
        onShowHidePasswordForm: function(t) {
            t.preventDefault(), this.toggleRecoverPasswordForm()
        },
        checkUrlHash: function() {
            "#recover" === window.location.hash && this.toggleRecoverPasswordForm()
        },
        toggleRecoverPasswordForm: function() {
            $n("#RecoverPasswordForm").toggleClass("hide"), $n("#CustomerLoginForm").toggleClass("hide")
        },
        resetPasswordSuccess: function() {
            $n(".reset-password-success").length && $n("#ResetSuccess").removeClass("hide")
        }
    });
    var Ts = {
            pageLinkFocus: function(t) {
                function e() {
                    t.first().removeClass(n).removeAttr("tabindex")
                }
                var n = "js-focus-hidden";
                t.first().attr("tabIndex", "-1").focus().addClass(n).one("blur", e)
            },
            forceFocus: function(t) {
                t.focus(), t.is(document.activeElement) || t.attr("tabindex", "0").focus().one("blur", function() {
                    t.removeAttr("tabindex")
                })
            },
            focusHash: function() {
                var t = window.location.hash;
                t && document.getElementById(t.slice(1)) && this.pageLinkFocus($n(t))
            },
            bindInPageLinks: function() {
                $n("a[href*=#]").on("click", function(t) {
                    this.pageLinkFocus($n(t.currentTarget.hash))
                }.bind(this))
            },
            trapFocus: function(t) {
                var e = t.namespace ? "focusin." + t.namespace : "focusin";
                t.$elementToFocus || (t.$elementToFocus = t.$container), t.$container.attr("tabindex", "-1"), t.$elementToFocus.focus(), $n(document).on(e, function(e) {
                    t.$container[0] === e.target || t.$container.has(e.target).length || t.$container.focus()
                })
            },
            removeTrapFocus: function(t) {
                var e = t.namespace ? "focusin." + t.namespace : "focusin";
                t.$container && t.$container.length && t.$container.removeAttr("tabindex"), $n(document).off(e)
            }
        },
        ks = {
            wrapTable: function() {
                $n(".rte table").wrap('<div class="rte__table-wrapper"></div>')
            },
            iframeReset: function() {
                var t = $n('.rte iframe[src*="youtube.com/embed"], .rte iframe[src*="player.vimeo"]'),
                    e = t.add(".rte iframe#admin_bar_iframe");
                t.each(function() {
                    $n(this).wrap('<div class="video-wrapper"></div>')
                }), e.each(function() {
                    this.src = this.src
                })
            }
        };
    ss.register("Page Helpers", "*", {
        onLoad: function() {
            this.pageLinkFocus(), this.rteFixes(), this.disableOutlineOnClick(), this.checkIfMobileOS()
        },
        pageLinkFocus: function() {
            Ts.pageLinkFocus($(window.location.hash)), $(".in-page-link").on("click", function(t) {
                Ts.pageLinkFocus($(t.currentTarget.hash))
            })
        },
        rteFixes: function() {
            ks.wrapTable(), ks.iframeReset()
        },
        disableOutlineOnClick: function() {
            var t = {
                outlineDisabled: "outline-disabled"
            };
            $("html").addClass(t.outlineDisabled), $(document).on("keyup", function() {
                $("html").removeClass(t.outlineDisabled)
            }), $(document).on("click", function(e) {
                $("html").toggleClass(t.outlineDisabled, !$(e.target).is("input, textarea, select"))
            })
        },
        checkIfMobileOS: function() {
            var t = navigator.userAgent.toLowerCase(),
                e = /ipad|iphone|ipod/.test(t) && !window.MSStream,
                n = /android/.test(t);
            (e || n) && $("html").addClass("is-mobile-os")
        }
    });
    var $s = {
        qrCode: "#QrCode",
        printButton: "#PrintGiftCard",
        giftCardCode: ".giftcard__code"
    };
    ss.register("Giftcard Template", "template-giftcard", {
            onLoad: function() {
                var t = $n($s.qrCode);
                new QRCode(t[0], {
                    text: t.attr("data-identifier"),
                    width: 120,
                    height: 120
                }), $n($s.printButton).on("click", function() {
                    window.print()
                }), $n($s.giftCardCode).on("click", {
                    element: "GiftCardDigits"
                }, this.selectText)
            },
            selectText: function(t) {
                var e = "",
                    n = document.getElementById(t.data.element);
                if (document.body.createTextRange) e = document.body.createTextRange(), e.moveToElementText(n), e.select();
                else if (window.getSelection) {
                    var i = window.getSelection();
                    e = document.createRange(), e.selectNodeContents(n), i.removeAllRanges(), i.addRange(e)
                }
            }
        }),
        function(t) {
            t.fn.prepareTransition = function() {
                return this.each(function() {
                    var e = t(this);
                    e.one("TransitionEnd webkitTransitionEnd transitionend oTransitionEnd", function() {
                        e.removeClass("is-transitioning")
                    });
                    var n = ["transition-duration", "-moz-transition-duration", "-webkit-transition-duration", "-o-transition-duration"],
                        i = 0;
                    t.each(n, function(t, n) {
                        i || (i = parseFloat(e.css(n)))
                    }), 0 != i && (e.addClass("is-transitioning"), e[0].offsetWidth)
                })
            }
        }($n);
    var Es = {
            passwordModal: ".password-modal",
            modalOpenButton: ".password__open-modal",
            modalCloseButton: ".password-modal__close",
            modalInput: ".password-modal__input"
        },
        As = {
            passwordModalOpen: "password-modal--open",
            disableScroll: "disable-scroll"
        };
    ss.register("Password Template", "password-template", {
        onLoad: function(t) {
            var e = this.$container = $n(t);
            $n(Es.modalOpenButton, e).on("click", this.showPasswordModal.bind(this)), $n(Es.modalCloseButton, e).on("click", this.hidePasswordModal.bind(this)), $n(".errors", e).length && this.showPasswordModal()
        },
        showPasswordModal: function() {
            var t = this.$container,
                e = $n(Es.passwordModal, t);
            Ts.trapFocus({
                $container: e,
                namespace: "passwordModal",
                $elementToFocus: $n(Es.modalCloseButton, t)
            }), e.prepareTransition().addClass(As.passwordModalOpen), $n(Es.modalOpenButton, t).attr("aria-expanded", !0), $n(Es.modalInput, t).focus(), $n(document.documentElement).addClass(As.disableScroll), $n(document).on("keyup", this.closeOnEscape.bind(this))
        },
        hidePasswordModal: function() {
            var t = this.$container,
                e = $n(Es.passwordModal, t);
            Ts.removeTrapFocus({
                namespace: "passwordModal"
            }), e.prepareTransition().removeClass(As.passwordModalOpen), $n(document.documentElement).removeClass(As.disableScroll), $n(Es.modalOpenButton, t).attr("aria-expanded", !1).focus(), $n(document).off("keyup", this.closeOnEscape.bind(this))
        },
        closeOnEscape: function(t) {
            27 === t.keyCode && this.hidePasswordModal()
        }
    });
    var js = Array.prototype,
        Ps = js.splice,
        Ds = function(t) {
            return function(e, n, i) {
                for (var r = -1, o = Object(e), s = i(e), a = s.length; a--;) {
                    var c = s[t ? a : ++r];
                    if (!1 === n(o[c], c, o)) break
                }
                return e
            }
        }(),
        Ns = function(t, e) {
            return function(n, i) {
                if (null == n) return n;
                if (!nt(n)) return t(n, i);
                for (var r = n.length, o = e ? r : -1, s = Object(n);
                    (e ? o-- : ++o < r) && !1 !== i(s[o], o, s););
                return n
            }
        }(Ie);
    $n.extend(Le.prototype, {
        registered: {},
        instances: [],
        extensions: {
            "*": []
        },
        register: function(t, e) {
            function n(e) {
                this.type = t, He.call(this, e)
            }
            n.constructor = this.registered[t], n.prototype = Object.create(He.prototype), $n.extend(n.prototype, e), this.registered[t] = n
        },
        load: function(t, e) {
            t = this._normalizeTypeParam(t), e = this._normalizeContainersParam(e), t.forEach(function(t) {
                var n = this.registered[t],
                    i = e;
                void 0 !== n && (void 0 === i && (i = document.querySelectorAll('[data-section-type="' + t + '"]')), i = Array.prototype.slice.call(i), i.forEach(function(e) {
                    if (!this._instanceExists(e)) {
                        var i = this.extensions["*"].concat(this.extensions[t] || []),
                            r = new n({
                                container: e,
                                extensions: i,
                                id: e.getAttribute("data-section-id")
                            });
                        r.trigger("section_load"), this.instances.push(r)
                    }
                }.bind(this)))
            }.bind(this))
        },
        extend: function(t, e) {
            t = this._normalizeTypeParam(t), t.forEach(function(t) {
                this.extensions[t] = this.extensions[t] || [], this.extensions[t].push(e), void 0 !== this.registered[t] && this.instances.forEach(function(n) {
                    n.type === t && n.extend(e)
                })
            }.bind(this))
        },
        isInstance: function(t) {
            return "object" == typeof os(this.instances, {
                type: t
            })
        },
        getInstances: function(t) {
            return $n.Deferred(function(e) {
                var n = Be(this.instances, {
                    type: t
                });
                0 === n.length ? e.reject() : e.resolve(n)
            }.bind(this))
        },
        on: function() {
            var t = Array.prototype.slice.call(arguments);
            t[0] = t[0].concat(this.namespace), this.$document.on.apply(this.$document, t)
        },
        off: function() {
            var t = Array.prototype.slice.call(arguments);
            t[0] = t[0].concat(this.namespace), this.$document.off.apply(this.$document, arguments)
        },
        trigger: function() {
            var t = arguments;
            this.instances.forEach(function(e) {
                e.trigger.apply(e, t)
            })
        },
        _sectionTrigger: function() {
            this.$document.trigger.apply(this.$document, arguments)
        },
        _normalizeTypeParam: function(t) {
            return "*" === t ? t = Object.keys(this.registered) : "string" == typeof t && (t = [t]), t = t.map(function(t) {
                return t.toLowerCase()
            })
        },
        _normalizeContainersParam: function(t) {
            return Array.isArray(t) || "object" != typeof t || (t = [t]), t
        },
        _instanceExists: function(t) {
            return void 0 !== os(this.instances, {
                id: t.getAttribute("data-section-id")
            })
        }
    });
    var Os = new Le;
    He.prototype = {
        onLoad: function() {},
        onUnload: function() {},
        onSelect: function() {},
        onDeselect: function() {},
        onBlockSelect: function() {},
        onBlockDeselect: function() {},
        on: function() {
            var t = Array.prototype.slice.call(arguments);
            t[0] = t[0].concat(this.namespace), this.$eventBinder.on.apply(this.$eventBinder, t), this.$eventBinder = this.$container
        },
        one: function() {
            var t = Array.prototype.slice.call(arguments);
            t[0] = t[0].concat(this.namespace), this.$eventBinder.one.apply(this.$eventBinder, t), this.$eventBinder = this.$container
        },
        off: function() {
            var t = Array.prototype.slice.call(arguments);
            t[0] = t[0] || "", t[0] = t[0].concat(this.namespace), this.$eventBinder.off.apply(this.$eventBinder, arguments), this.$eventBinder = this.$container
        },
        trigger: function() {
            var t = Array.prototype.slice.call(arguments);
            t[1] = t[1] || [], t[1].splice(0, 0, this), this.$eventBinder.trigger.apply(this.$eventBinder, t), this.$eventBinder = this.$container
        },
        extend: function(t) {
            var e = t.init;
            this.extensions.push(t), $n.extend(this, yo(t, "init")), $n.isFunction(e) && e.apply(this)
        }
    }, He.prototype.document = function() {
        var t = $n(document),
            e = this;
        return {
            on: function() {
                e.$eventBinder = t, e.on.apply(e, arguments)
            },
            off: function() {
                e.$eventBinder = t, e.off.apply(e, arguments)
            },
            trigger: function() {
                e.$eventBinder = t, e.trigger.apply(e, arguments)
            }
        }
    }, He.prototype.window = function() {
        var t = $n(window),
            e = this;
        return {
            on: function() {
                e.$eventBinder = t, e.on.apply(e, arguments)
            },
            off: function() {
                e.$eventBinder = t, e.off.apply(e, arguments)
            },
            trigger: function() {
                e.$eventBinder = t, e.trigger.apply(e, arguments)
            }
        }
    };
    var Is = Ye,
        Fs = "object" == typeof kn && kn && kn.Object === Object && kn,
        Bs = Fs,
        Ls = Bs,
        Hs = "object" == typeof self && self && self.Object === Object && self,
        Ms = Ls || Hs || Function("return this")(),
        qs = Ms,
        Rs = qs,
        Ws = Rs.Symbol,
        zs = Ws,
        Vs = zs,
        Us = Object.prototype,
        Xs = Us.hasOwnProperty,
        Ys = Us.toString,
        Qs = Vs ? Vs.toStringTag : void 0,
        Gs = Qe,
        Ks = Object.prototype,
        Js = Ks.toString,
        Zs = Ge,
        ta = zs,
        ea = Gs,
        na = Zs,
        ia = "[object Null]",
        ra = "[object Undefined]",
        oa = ta ? ta.toStringTag : void 0,
        sa = Ke,
        aa = Je,
        ca = sa,
        ua = aa,
        la = "[object Symbol]",
        da = Ze,
        ha = Is,
        fa = da,
        pa = NaN,
        ma = /^\s+|\s+$/g,
        ga = /^[-+]0x[0-9a-f]+$/i,
        va = /^0b[01]+$/i,
        ya = /^0o[0-7]+$/i,
        ba = parseInt,
        _a = tn,
        wa = _a,
        Sa = 1 / 0,
        xa = 1.7976931348623157e308,
        Ca = en,
        Ta = Ca,
        ka = nn,
        $a = rn,
        Ea = $a,
        Aa = ka,
        ja = 4294967295,
        Pa = on,
        Da = ka,
        Na = Pa,
        Oa = sn,
        Ia = an,
        Fa = sa,
        Ba = Is,
        La = "[object AsyncFunction]",
        Ha = "[object Function]",
        Ma = "[object GeneratorFunction]",
        qa = "[object Proxy]",
        Ra = cn,
        Wa = 9007199254740991,
        za = un,
        Va = Ra,
        Ua = za,
        Xa = ln,
        Ya = 9007199254740991,
        Qa = /^(?:0|[1-9]\d*)$/,
        Ga = dn,
        Ka = Ia,
        Ja = Xa,
        Za = Ga,
        tc = Is,
        ec = hn,
        nc = Oa,
        ic = ec,
        rc = fn,
        oc = {
            cardListSubLoaded: "card-list__sub-actions--loaded",
            cardReveal: "card--reveal"
        },
        sc = {
            cardList: ".card-list",
            cardListColumn: ".card-list__column",
            cardListSub: ".card-list__sub-actions",
            card: ".card",
            cardWrapper: ".card__wrapper"
        },
        ac = {
            init: function() {
                this.$cardList = $n(sc.cardList, this.$container), this.$emptyColumn = $n(sc.cardListColumn, this.$container).clone().empty(), this.$cards = $n(sc.card, this.$container), this.desktopColumnCount = this.$cardList.data("desktop-columns") || 2, this.mobileColumnCount = this.$cardList.data("mobile-columns") || 1, this.cardLoadPromises = [], this.window().on("resize", this._onResize.bind(this)), this.on("keydown", sc.cardWrapper, this._onCardTabDown.bind(this)), this.on("keyup", this._onCardTabUp.bind(this)), cs.promiseStylesheet().then(function() {
                    this.cardsLoaded = this._loadCards(), $n("html").removeClass("site-footer--hidden"), $n(sc.cardListSub, this.$container).prepareTransition().addClass(oc.cardListSubLoaded)
                }.bind(this))
            },
            _onResize: function() {
                this.$columns = this._replaceColumns()
            },
            _onCardTabDown: function(t) {
                if (9 === t.keyCode) {
                    var e = $n(t.target).data("tabindex");
                    this.tabFromList = !0, t.shiftKey ? e > 1 && (t.preventDefault(), $n("[data-tabindex=" + (e - 1) + "]").focus()) : e === this.$cards.length ? $n(sc.cardWrapper, this.$container).last().focus() : (t.preventDefault(), $n("[data-tabindex=" + (e + 1) + "]").focus())
                }
            },
            _onCardTabUp: function(t) {
                if (9 === t.keyCode) {
                    var e = this.tabFromList || !1;
                    this.tabFromList = !1, t.shiftKey && !e && $n(sc.cardWrapper, this.$container).last().is(t.target) && $n("[data-tabindex=" + this.$cards.length + "]").focus()
                }
            },
            _loadCards: function() {
                return this.trigger("cards_load_start"), this.$columns = this._addColumns(), this._promiseAllCardsReveal().always(function() {
                    this.trigger("cards_load_done")
                }.bind(this))
            },
            _addColumns: function() {
                for (var t, e = cs.isMobile() ? this.mobileColumnCount : this.desktopColumnCount, n = 1; n < e; n++) this.$cardList.append(this.$emptyColumn.clone());
                return t = $n(sc.cardListColumn, this.$container), t.heights = rc(Array(e), 0), t
            },
            _replaceColumns: function() {
                var t = cs.isMobile() ? this.mobileColumnCount : this.desktopColumnCount,
                    e = this.$emptyColumn.clone();
                e.heights = rc(Array(t), 0);
                for (var n = 1; n < t; n++) e.push(this.$emptyColumn.clone()[0]);
                return $n.each(this.$cards, function(t, n) {
                    this._positionCard($n(n), t, e)
                }.bind(this)), this.$cardList.html(e), e
            },
            _promiseAllCardsReveal: function() {
                var t = $n.Deferred().resolve();
                return this.$cards.each(function(e, n) {
                    this._positionCard($n(n), e, this.$columns);
                    var i = this._promiseRevealReady(n);
                    t = t.then(function() {
                        return i
                    }).then(this._revealCard.bind(this, n)).then(function() {
                        return $n.Deferred(function(t) {
                            setTimeout(t.resolve, 80)
                        })
                    })
                }.bind(this)), t
            },
            _revealCard: function(t) {
                var e = $n(t);
                this.trigger("card_loaded", [e[0]]), requestAnimationFrame(e.addClass.bind(e, oc.cardReveal))
            },
            _promiseRevealReady: function(t) {
                return $n.Deferred(function(e) {
                    function n(r, o) {
                        o === t && (i.off("animate_element", n), e.resolve())
                    }
                    var i = $n(t);
                    requestAnimationFrame(function() {
                        if (cs.isInOrAboveViewport(t)) return e.resolve()
                    }), i.on("animate_element", n)
                })
            },
            _positionCard: function(t, e, n) {
                for (var i = t.outerHeight(!0), r = n.heights.indexOf(Math.min.apply(Math, n.heights)), o = 0; o < n.heights.length; o++)
                    if (n.heights[r] > n.heights[o] - 150) {
                        r = o;
                        break
                    }
                n.eq(r).append(t), n.heights[r] += i, t.find("a").attr("data-tabindex", e + 1)
            }
        };
    Os.register("blog-template", {
        onLoad: function() {
            this.extend(ac)
        }
    });
    var cc, uc, lc = "undefined" != typeof document && document,
        dc = lc ? lc.body || lc.createElement("div") : {},
        hc = "http://www.w3.org/1999/xhtml",
        fc = 1,
        pc = 3,
        mc = 8;
    uc = dc.hasAttributeNS ? function(t, e, n) {
        return t.hasAttributeNS(e, n)
    } : dc.hasAttribute ? function(t, e, n) {
        return t.hasAttribute(n)
    } : function(t, e, n) {
        return !!t.getAttributeNode(n)
    };
    var gc = {
            OPTION: function(t, e) {
                mn(t, e, "selected")
            },
            INPUT: function(t, e) {
                mn(t, e, "checked"), mn(t, e, "disabled"), t.value !== e.value && (t.value = e.value), uc(e, null, "value") || t.removeAttribute("value")
            },
            TEXTAREA: function(t, e) {
                var n = e.value;
                t.value !== n && (t.value = n), t.firstChild && (t.firstChild.nodeValue = n)
            }
        },
        vc = Sn,
        yc = {
            isUpdating: !1,
            getCart: function() {
                return $n.getJSON("/cart.js")
            },
            on: function(t, e) {
                $n(this).on(t, e)
            },
            trigger: function(t, e) {
                $n(this).triggerHandler(t, e)
            },
            updateNote: function(t) {
                return this._promiseChange({
                    url: "/cart/update.js",
                    dataType: "json",
                    data: {
                        note: t || ""
                    }
                })
            },
            addItem: function(t, e) {
                return this._promiseChange({
                    url: "/cart/add.js",
                    dataType: "json",
                    data: {
                        id: t,
                        quantity: void 0 === e ? 1 : e
                    }
                })
            },
            addItemFromForm: function(t) {
                return this._promiseChange({
                    url: "/cart/add.js",
                    dataType: "json",
                    data: t
                })
            },
            removeItem: function(t) {
                return this._promiseChange({
                    url: "/cart/change.js",
                    dataType: "json",
                    data: {
                        id: t,
                        quantity: 0
                    }
                })
            },
            changeItem: function(t, e) {
                var n = parseInt(e, 10),
                    i = {
                        url: "/cart/change.js",
                        dataType: "json",
                        data: {
                            id: t,
                            quantity: e
                        }
                    };
                return this._promiseChange(i).then(function(e) {
                    var i = os(e.items, {
                        key: t
                    });
                    return "object" == typeof i && i.quantity !== n && this.trigger("quantity", i), e
                }.bind(this))
            },
            saveLocalState: function(t) {
                return cs.isLocalStorageSupported() && (localStorage.shopify_cart_state = JSON.stringify(t)), t
            },
            getLocalState: function() {
                if (cs.isLocalStorageSupported()) return JSON.parse(localStorage.shopify_cart_state || "")
            },
            _promiseChange: function(t) {
                var e = $n.ajax(t);
                return this.isUpdating = !0, navigator && !theme.isOnline && (e = $n.Deferred().reject()), e.then(function(t) {
                    return void 0 === t.token ? this.getCart() : t
                }.bind(this)).then(this.saveLocalState).then(this._triggerChangeEvent.bind(this)).catch(this._triggerErrorEvent.bind(this)).always(function() {
                    this.isUpdating = !1
                }.bind(this))
            },
            _triggerChangeEvent: function(t) {
                return this.trigger("change", t), t
            },
            _triggerErrorEvent: function(t) {
                throw this.trigger("error", t), t
            }
        },
        bc = {
            formatMoney: function(t, e) {
                function n(t, e, n, i) {
                    if (e = xn(e, 2), n = xn(n, ","), i = xn(i, "."), isNaN(t) || null == t) return 0;
                    t = (t / 100).toFixed(e);
                    var r = t.split(".");
                    return r[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + n) + (r[1] ? i + r[1] : "")
                }
                "string" == typeof t && (t = t.replace(".", ""));
                var i = "",
                    r = /\{\{\s*(\w+)\s*\}\}/,
                    o = e || "${{amount}}";
                switch (o.match(r)[1]) {
                    case "amount":
                        i = n(t, 2);
                        break;
                    case "amount_no_decimals":
                        i = n(t, 0);
                        break;
                    case "amount_with_comma_separator":
                        i = n(t, 2, ".", ",");
                        break;
                    case "amount_no_decimals_with_comma_separator":
                        i = n(t, 0, ".", ",");
                        break;
                    case "amount_no_decimals_with_space_separator":
                        i = n(t, 0, " ")
                }
                return o.replace(r, i)
            }
        },
        _c = {
            preload: function(t, e) {
                "string" == typeof t && (t = [t]);
                for (var n = 0; n < t.length; n++) {
                    var i = t[n];
                    this.loadImage(this.getSizedImageUrl(i, e))
                }
            },
            loadImage: function(t) {
                (new Image).src = t
            },
            switchImage: function(t, e, n) {
                var i = this.imageSize(e.src),
                    r = this.getSizedImageUrl(t.src, i);
                n ? n(r, t, e) : e.src = r
            },
            imageSize: function(t) {
                t = t || "";
                var e = t.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);
                return null !== e ? e[1] : null
            },
            getSizedImageUrl: function(t, e) {
                if (null == e) return t;
                if ("master" === e) return this.removeProtocol(t);
                var n = t.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);
                if (null != n) {
                    var i = t.split(n[0]),
                        r = n[0];
                    return this.removeProtocol(i[0] + "_" + e + r)
                }
                return null
            },
            removeProtocol: function(t) {
                return t.replace(/http(s)?:/, "")
            }
        },
        wc = {
            itemId: "data-cart-item-id"
        },
        Sc = {
            ajaxCart: ".cart-drawer",
            itemList: "[data-cart-item-list]",
            item: "[data-cart-item]",
            itemId: "[data-cart-item-id]",
            itemHref: "[data-cart-item-href]",
            itemImage: "[data-cart-item-image]",
            itemBackgroundImage: "[data-cart-item-background-image]",
            itemTitle: "[data-cart-item-title]",
            itemVariantTitle: "[data-cart-item-variant-title]",
            itemPropertyList: "[data-cart-item-property-list]",
            itemProperty: "[data-cart-item-property]",
            itemDiscountList: "[data-cart-item-discount-list]",
            itemDiscount: "[data-cart-item-discount]",
            itemLabelQuantity: "[data-cart-item-label-quantity]",
            itemInputQuantity: "[data-cart-item-input-quantity]",
            itemDelete: "[data-cart-item-delete]",
            itemPrice: "[data-cart-item-price]",
            itemMessage: "[data-item-message]",
            itemOriginalPrice: "[data-cart-item-original-price]",
            itemLinePrice: "[data-cart-item-line-price]",
            cartNoteContainer: "[data-cart-note-container]",
            cartNoteInput: "[data-cart-note]",
            cartMessage: "[data-cart-message]",
            cartTotalDiscountContainer: "[data-cart-total-discount-container]",
            cartTotalDiscount: "[data-cart-total-discount]",
            cartSubtotal: "[data-cart-subtotal]",
            cartSubmit: "[data-cart-submit]"
        },
        xc = {
            cartTemplate: "ajax-cart__template",
            cartItemRemove: "ajax-cart__item--remove",
            cartError: "ajax-cart--error",
            visuallyHidden: "visually-hidden",
            cartDiscountActive: "ajax-cart__discount-container--active",
            btnLoaderActive: "btn--loader-active"
        },
        Cc = {
            init: function() {
                this.$ajaxCart = $n(Sc.ajaxCart, this.$container), this.$itemTemplate = $n(Sc.item, this.$container).first().clone(), this.$propertyTemplate = $n(Sc.itemProperty, this.$container).first().clone(), this.$discountTemplate = $n(Sc.itemDiscount, this.$container).first().clone(), yc.on("quantity", this._onQuantityError.bind(this)), yc.on("change", function(t, e) {
                    this.update(e)
                }.bind(this)), this.on("change keyup input", Sc.itemInputQuantity, je(this._onItemQuantityChange.bind(this), 500)), this.on("focus", Sc.itemInputQuantity, this._highlightText), this.on("click", Sc.itemDelete, this._onItemDelete.bind(this)), this.on("change", Sc.cartNoteInput, this._onNoteChange.bind(this)), this.on("submit", this._onSubmit.bind(this)), this.window().on("storage", this._onStorageStateChange.bind(this))
            },
            refresh: function() {
                yc.getCart().then(this.update.bind(this))
            },
            update: function(t) {
                this.trigger("cart_update_start", [t]);
                var e = this._createCart(t);
                vc(this.$container[0], e[0]), this.trigger("cart_update_done", [t])
            },
            _onError: function(t) {
                this.trigger("cart_error", [t]), this.$container.addClass(xc.cartError), $n(Sc.item, this.$container).removeClass(xc.cartItemRemove), $n(Sc.cartMessage, this.$container).text(theme.strings.cartError)
            },
            _onQuantityError: function(t, e) {
                this.trigger("cart_item_quantity_error", [e]), this.$container.addClass(xc.cartError);
                var n = theme.strings.cartQuantityError.replace("[quantity]", e.quantity).replace("[title]", e.title);
                $n(Sc.itemMessage, $n("[" + wc.itemId + '="' + e.key + '"]')).html(n), $n(Sc.cartMessage, this.$container).html(n)
            },
            _createCart: function(t) {
                var e = this.$container.clone();
                return e.removeClass(xc.cartError), $n(Sc.cartMessage, e).text(""), $n(Sc.item, e).not(Sc.cartNoteContainer).remove(), $n(Sc.itemList, e).prepend(this._createItemList(t)), $n(Sc.cartNoteInput, e).val(t.note), $n(Sc.cartTotalDiscountContainer, e).toggleClass(xc.cartDiscountActive, 0 !== t.total_discount), $n(Sc.cartTotalDiscount, e).html(bc.formatMoney(t.total_discount, theme.moneyFormat)), $n(Sc.cartSubtotal, e).html(bc.formatMoney(t.total_price, theme.moneyFormat)), $n(Sc.cartSubmit, e).attr("disabled", 0 === t.items.length), e
            },
            _createItemList: function(t) {
                return $n.map(t.items, function(t) {
                    var e = this.$itemTemplate.clone().removeClass(xc.cartTemplate),
                        n = this._createPropertyList(t),
                        i = this._createDiscountList(t);
                    return e.find(Sc.itemId).addBack(Sc.itemId).attr(wc.itemId, t.key), $n(Sc.itemHref, e).attr("href", t.url), $n(Sc.itemImage, e).attr("src", t.image ? _c.getSizedImageUrl(t.image, "medium") : "").toggleClass("hide", "string" != typeof t.image), $n(Sc.itemBackgroundImage, e).css("background-image", t.image ? "url(" + _c.getSizedImageUrl(t.image, "medium") + ")" : "none"), $n(Sc.itemTitle, e).text(t.product_title), $n(Sc.itemVariantTitle, e).text(t.variant_title), $n(Sc.itemPrice, e).html(bc.formatMoney(t.discounted_price, theme.moneyFormat)), $n(Sc.itemOriginalPrice, e).html(t.discounted_price === t.price ? "" : bc.formatMoney(t.original_price, theme.moneyFormat)), $n(Sc.itemLinePrice, e).html(bc.formatMoney(t.line_price, theme.moneyFormat)), $n(Sc.itemLabelQuantity, e).attr("for", "quantity_" + t.key), $n(Sc.itemInputQuantity, e).attr("name", "updates[" + t.key + "]").attr("id", "quantity_" + t.key).val(t.quantity), $n(Sc.itemPropertyList, e).html(n), $n(Sc.itemDiscountList, e).html(i), e[0]
                }.bind(this))
            },
            _createPropertyList: function(t) {
                return $n.map(t.properties, function(t, e) {
                    var n = this.$propertyTemplate.clone().removeClass(xc.cartTemplate);
                    return -1 === t.indexOf("/uploads/") ? n.text(e + ": " + t).toggleClass(xc.visuallyHidden, "" === t) : n.html(e + ': <a href="' + t + '">' + t.split("/").pop() + "</a>"), n[0]
                }.bind(this))
            },
            _createDiscountList: function(t) {
                return $n.map(t.discounts, function(t) {
                    var e = this.$discountTemplate.clone().removeClass(xc.cartTemplate);
                    return e.text(t.title), e[0]
                }.bind(this))
            },
            _onStorageStateChange: function(t) {
                if ("shopify_cart_state" === t.key) {
                    var e = yc.getLocalState();
                    this.trigger("cart_storage_state_change", [e]), this.update(yc.getLocalState())
                }
            },
            _onItemQuantityChange: function(t) {
                var e = $n(t.target),
                    n = e.closest(Sc.item).attr(wc.itemId),
                    i = e.val();
                this.trigger("cart_item_quantity_change", [n, i]), yc.changeItem(n, i).catch(this._onError.bind(this))
            },
            _onItemDelete: function(t) {
                t.preventDefault();
                var e = $n(t.target),
                    n = $n(Sc.item, this.$container),
                    i = e.closest(Sc.item),
                    r = $n(Sc.cartNoteContainer, this.$container),
                    o = i.attr(wc.itemId);
                this.trigger("cart_item_remove", [o]), 2 === n.length && n.last().is(r) && (r.addClass(xc.cartItemRemove), cs.promiseTransitionEnd($n(Sc.itemList, this.$container)).then(function() {
                    r.removeClass(xc.cartItemRemove)
                })), i.addClass(xc.cartItemRemove), cs.promiseAnimationEnd(i).then(function() {
                    yc.removeItem(o).catch(this._onError.bind(this))
                }.bind(this))
            },
            _onNoteChange: function(t) {
                var e = $n(t.target).val();
                this.trigger("cart_note_change", [e]), yc.updateNote(e).catch(this._onError.bind(this))
            },
            _onSubmit: function(t) {
                yc.isUpdating ? t.preventDefault() : ($n(Sc.cartSubmit, this.$container).addClass(xc.btnLoaderActive), this.trigger("cart_submit"))
            },
            _highlightText: function(t) {
                $n(t.target).select()
            }
        },
        Tc = {
            drawerActive: "drawer--active",
            disableScroll: "disable-scroll"
        },
        kc = {
            drawerPush: "[data-drawer-push]",
            drawerCover: ".drawer-cover",
            mainContent: ".main-content",
            siteHeader: ".site-header"
        },
        $c = {
            init: function() {
                this.$toggleButton = null, this.draggingAction = null, this.namespaceTouch = ".onTouchStart", this.namespaceOpen = ".onOpen", this.document().on("resize", this._onWindowResize.bind(this))
            },
            drawerOpen: function(t) {
                this.trigger("drawer_open_start"), Ts.trapFocus({
                    $container: this.$container,
                    namespace: "drawer"
                }), t && t.currentTarget && (this.$toggleButton = $n(t.target).attr("aria-expanded", !0)), cs.disableScrollBody(), $n("body").addClass(Tc.drawerActive), this.trigger("drawer_open_transitioning"), cs.promiseTransitionEnd(this.$container).then(function() {
                    cs.enableTabbingOfChildren(this.$container), this.$container.attr("aria-hidden", !1), this.document().on("click touchend" + this.namespaceOpen, kc.drawerCover, this.drawerClose.bind(this)), this.document().on("keyup" + this.namespaceOpen, this._closeOnEscape.bind(this)), this.document().on("touchstart" + this.namespaceOpen, this._onTouchStart.bind(this)), this.trigger("drawer_open_done")
                }.bind(this))
            },
            drawerClose: function() {
                this.trigger("drawer_close_start"), Ts.removeTrapFocus({
                    namespace: "drawer"
                }), this.$toggleButton && this.$toggleButton.length && (this.$toggleButton.focus().attr("aria-expanded", !1), this.$toggleButton = null), cs.enableScrollBody(), cs.disableTabbingOfChildren(this.$container), this.$container.attr("aria-hidden", !0), this.document().off(this.namespaceOpen), $n("body").removeClass(Tc.drawerActive), this.trigger("drawer_close_transitioning"), cs.promiseTransitionEnd(this.$container).then(function() {
                    this.trigger("drawer_close_done")
                }.bind(this))
            },
            _onWindowResize: function() {
                this.sliderWidth = 0
            },
            _onTouchStart: function(t) {
                this.startPosition = cs.pointerEventToXY(t), this.$elementsToPush = this.$elementsToPush || $n(kc.drawerPush), this.sliderWidth = this.sliderWidth || this.$container.width(), this.isDragging = !1, this.document().on("touchmove" + this.namespaceTouch, this._onTouchMove.bind(this)), this.document().on("touchend" + this.namespaceTouch, this._onTouchEnd.bind(this))
            },
            _onTouchMove: function(t) {
                var e, n, i, r;
                this.isDragging = !0, this.currentPosition = cs.pointerEventToXY(t), this.trigger("drawer_dragging", [this.currentPosition]), e = this.currentPosition.x - this.startPosition.x, n = this.currentPosition.y - this.startPosition.y, i = Math.atan2(e, n) / (Math.PI / 180), this.translated = e > 0 ? e : 0, Math.abs(i) > 65 && Math.abs(i) < 115 && null === this.draggingAction ? this.draggingAction = "slide" : (Math.abs(i) < 65 || Math.abs(i) > 115) && null === this.draggingAction && (this.draggingAction = "scroll"), "slide" === this.draggingAction && (t.preventDefault(), r = {
                    transform: "translateX(-" + (this.sliderWidth - this.translated) + "px)",
                    transition: "none"
                }, this.$elementsToPush.css(r))
            },
            _onTouchEnd: function() {
                var t;
                this.wasDragging = this.isDragging, this.isDragging = !1, this.wasDragging && (t = this.translated / this.sliderWidth, t > .25 && "slide" === this.draggingAction ? (this.drawerClose("ease-out"), this.trigger("drawer_dragging_success")) : this.trigger("drawer_dragging_fail"), this.$elementsToPush.removeAttr("style")), this.draggingAction = null, this.document().off(this.namespaceTouch)
            },
            _closeOnEscape: function(t) {
                27 === t.keyCode && this.drawerClose()
            }
        },
        Ec = {
            drawer: ".drawer",
            cartHeader: ".cart-drawer__header",
            cartTitle: ".cart-drawer__header-title",
            cartContent: ".cart-drawer__content",
            cartToggle: ".ajax-cart__toggle",
            cartCloseButton: ".cart-drawer__close-button",
            siteHeader: ".site-header"
        },
        Ac = {
            cartTemplate: "template-cart",
            cartEmpty: "cart-drawer--empty",
            cartNoCookies: "cart-drawer--no-cookies"
        };
    Os.register("cart-drawer", {
        onLoad: function() {
            if (!$n(document.body).hasClass(Ac.cartTemplate)) {
                if (this.extend($c), this._setDrawerHeaderHeight(), this.on("drawer_close_done", this._onDrawerClose.bind(this)), this.document().on("click", Ec.cartToggle, this._openCartDrawer.bind(this)), !cs.cookiesEnabled()) return void this.$container.addClass(Ac.cartNoCookies);
                this.extend(Cc), yc.on("change", function(t, e) {
                    this.$ajaxCart.toggleClass(Ac.cartEmpty, 0 === e.items.length)
                }.bind(this))
            }
        },
        onSelect: function() {
            this._openCartDrawer()
        },
        onDeselect: function() {
            this._closeCartDrawer()
        },
        _onDrawerClose: function() {
            Os.getInstances("header-section").then(function(t) {
                t[0].scrollHandler = !0
            })
        },
        _setDrawerHeaderHeight: function() {
            var t = $n(Ec.cartHeader, this.$container),
                e = $n(Ec.siteHeader).outerHeight();
            t.css("height", e)
        },
        _openCartDrawer: function(t) {
            t.preventDefault(), Os.getInstances("header-section").then(function(t) {
                return t[0].scrollHandler = !1, t[0].hideNavigation()
            }).then(function() {
                this.drawerOpen(t), $n(Ec.cartContent, this.$container).scrollTop(0), Ts.forceFocus($n(Ec.cartTitle, this.$container)), this.$container.on("click", Ec.cartCloseButton, this._closeCartDrawer.bind(this))
            }.bind(this))
        },
        _closeCartDrawer: function() {
            this.drawerClose()
        }
    });
    var jc = {
        showClass: "cart-item__update--show",
        showEditClass: "cart-item__edit--active",
        cartEmpty: "cart--empty",
        cartNoCookies: "cart--no-cookies"
    };
    Os.register("cart-template", {
        onLoad: function() {
            var t = $n(this.container);
            if (!cs.cookiesEnabled()) return void t.addClass(jc.cartNoCookies);
            this.extend(Cc), yc.on("change", function(e, n) {
                t.toggleClass(jc.cartEmpty, 0 === n.items.length)
            })
        }
    });
    var Pc = {
        filterBy: "#FilterBy",
        sortBy: "#SortBy",
        collectionImage: ".section-header-image"
    };
    Os.register("collection-template", {
        onLoad: function() {
            var t = this.$container = $n(this.container),
                e = $n(Pc.filterBy, t),
                n = $n(Pc.sortBy, t);
            this.defaultSort = this.getDefaultSortValue(), this.extend(ac), e.on("change", this.onFilterChange.bind(this)), n.on("change", this.onSortChange.bind(this))
        },
        onSortChange: function() {
            var t = "";
            this.sort = this.getSortValue(), this.sort !== this.defaultSort && (t = ["sort_by=" + this.sort]), document.location.search = t.length ? "?" + t : ""
        },
        onFilterChange: function() {
            this.filter = this.getFilterValue(), document.location.href = this.filter + document.location.search
        },
        getSortValue: function() {
            return $n(Pc.sortBy).val() || this.defaultSort
        },
        getDefaultSortValue: function() {
            return $n(Pc.sortBy, this.$container).val() || "title-ascending"
        },
        getFilterValue: function() {
            return $n(Pc.filterBy, this.$container).val() || "collections/all"
        }
    }), Os.register("featured-blog", {
        onLoad: function() {
            this.extend(ac)
        }
    });
    var Dc = {
            validate: function(t) {
                if ("object" != typeof t || "number" != typeof t.id) throw Error("Please pass a valid Product object to the Product Controller");
                return $.extend({}, t)
            },
            getVariant: function(t, e) {
                var n;
                return "string" == typeof e || "number" == typeof e ? n = this._getVariantFromId(t, e) : "object" == typeof e && "number" == typeof e.id ? n = this._getVariantFromId(t, e.id) : wi(e) && (n = "object" == typeof e[0] ? this._getVariantFromOptionCollection(t, e) : this._getVariantFromOptionArray(t, e)), n
            },
            optionArrayFromOptionCollection: function(t, e) {
                var n = [];
                return e.forEach(function(e) {
                    var i;
                    if ("string" != typeof e.name) throw Error("Invalid value type passed for name of option " + i + ". Value should be string.");
                    if (-1 === (i = $e(t.options, function(t) {
                            return t.toLowerCase() === e.name.toLowerCase()
                        }))) throw Error("Invalid option name, " + e.name);
                    n[i] = e.value
                }), n
            },
            _getVariantFromId: function(t, e) {
                return os(t.variants, {
                    id: e
                })
            },
            _getVariantFromOptionCollection: function(t, e, n) {
                var i = this.optionArrayFromOptionCollection(t, e);
                return this._getVariantFromOptionArray(t, i, n)
            },
            _getVariantFromOptionArray: function(t, e) {
                return os(t.variants, function(t) {
                    return e.every(function(e, n) {
                        return t.options[n] === e
                    })
                })
            }
        },
        Nc = {
            productPriceSale: "product__price--sale",
            productNotificationSuccess: "product__notification--success",
            productNotificationError: "product__notification--error",
            buttonTransition: "btn--to-secondary-transitioned",
            ajaxCartToggle: "ajax-cart__toggle",
            hide: "hide",
            lazyPreload: "lazypreload"
        },
        Oc = {
            productForm: ".product-form",
            selectorWrapper: ".product-form__item",
            ajaxCartToggle: ".ajax-cart__toggle",
            productJSON: "[data-product-json]",
            optionInputs: "[data-option-input]",
            masterSelect: "[data-master-select]",
            variantImage: "[data-variant-image]",
            variantImageToggleHide: "[data-variant-image-toggle-hide]",
            variantImageSrc: "[data-variant-image-src]",
            productPrice: "[data-product-price]",
            regularPrice: "[data-regular-price]",
            compareAtPrice: "[data-compare-price]",
            submitButton: "[data-cart-submit]",
            submitButtonPrimaryText: "[data-cart-primary-submit-text]",
            submitButtonSecondaryText: "[data-cart-secondary-submit-text]",
            notification: "[data-cart-notification]"
        },
        Ic = {
            init: function() {
                var t = $n(Oc.productJSON, this.container);
                0 !== t.length && (this.product = JSON.parse(t.html()), this.variant = Dc.getVariant(this.product, this.$container.data("variant-id")), this._formatVariantSelectors(), this.on("submit", Oc.productForm, this._addItemToCart.bind(this)), this.one("focus", Oc.optionInputs, this._preloadVariantImages.bind(this)), this.on("change.variantController", Oc.optionInputs, this.update.bind(this)), this.document().on("click", Oc.ajaxCartToggle, this._resetAddToCartButton.bind(this)), this.window().on("online", this._updateOnlineStatus), this.window().on("offline", this._updateOfflineStatus))
            },
            update: function() {
                var t = $n(Oc.optionInputs, this.$container),
                    e = t.serializeArray(),
                    n = Dc.getVariant(this.product, e);
                void 0 === n ? (this.trigger("variant_change_undefined", [this.product, e]), n = $n.extend({}, this.variant), n.isUndefined = !0, n.available = !1, n.options = Dc.optionArrayFromOptionCollection(this.product, e)) : this.trigger("variant_change_successful", [this.product, n]), this.variant = n, vc(this.$container[0], this._updatedContainer(this.variant)), this.trigger("variant_change", [this.product, n])
            },
            _preloadVariantImages: function() {
                $n(Oc.variantImage, this.$container).addClass(Nc.lazyPreload)
            },
            _formatVariantSelectors: function() {
                cs.promiseStylesheet().then(function() {
                    $n(Oc.selectorWrapper, this.$container).each(function() {
                        var t = $n(this),
                            e = t.find("label");
                        t.find("select, input").css({
                            "padding-left": e.outerWidth(),
                            opacity: 1
                        })
                    })
                }.bind(this))
            },
            _updatedContainer: function(t) {
                var e = this.$container.clone();
                return $n(Oc.masterSelect, e).val(t.id), this._updateInputValues(t, e), this._updateProductPrices(t, e), this._updateVariantImage(t, e), this._toggleVariantImageHide(t, e), this._updateCartButtonState(t, e), e[0]
            },
            _updateInputValues: function(t, e) {
                $n(Oc.optionInputs, e).each(function(e) {
                    $n(this).val(t.options[e])
                })
            },
            _updateCartButtonState: function(t, e) {
                var n;
                n = t.isUndefined ? theme.strings.unavailable : t.available ? theme.strings.addToCart : theme.strings.soldOut, this._resetAddToCartButton(), $n(Oc.submitButton, e).prop("disabled", !t.available), $n(Oc.submitButtonPrimaryText, e).text(n)
            },
            _updateProductPrices: function(t, e) {
                var n = t.price,
                    i = t.compare_at_price;
                $n(Oc.regularPrice, e).html(bc.formatMoney(n, theme.moneyFormat)), $n(Oc.compareAtPrice, e).html(bc.formatMoney(i, theme.moneyFormat)), $n(Oc.productPrice, e).toggleClass(Nc.productPriceSale, i > n)
            },
            _updateVariantImage: function(t, e) {
                var n = t.featured_image && t.featured_image.src || this.product.featured_image,
                    i = $n(Oc.variantImageSrc, e),
                    r = _c.imageSize(i.attr("src")),
                    o = _c.getSizedImageUrl(n, r);
                i.attr("src", o)
            },
            _toggleVariantImageHide: function(t, e) {
                if (t.featured_image || this.product.featured_image) {
                    var n = t.featured_image || this.product.featured_image.id,
                        i = n && n.id;
                    $n(Oc.variantImageToggleHide, e).filter('[data-id="' + i + '"]').removeClass(Nc.hide).siblings().addClass(Nc.hide)
                }
            },
            _addItemToCart: function(t) {
                if (Os.isInstance("cart-drawer")) {
                    t.preventDefault();
                    var e = $n(Oc.submitButton, this.$container),
                        n = $n(Oc.productForm, this.$container).serialize();
                    e.hasClass(Nc.ajaxCartToggle) || yc.addItemFromForm(n).then(this._transitionAddToCartButton.bind(this, n)).catch(this._onAddItemFail.bind(this)).always(function() {
                        this.trigger("variant_add_to_cart", [this.product, this.variant, n])
                    }.bind(this))
                }
            },
            _onAddItemFail: function(t) {
                var e = $n(Oc.notification, this.$container),
                    n = t && t.responseText;
                return n = n ? JSON.parse(n).description : theme.strings.cartError, e.addClass(Nc.productNotificationError).removeClass(Nc.productNotificationSuccess).html(n).attr("role", "alert"), this.trigger("variant_add_to_cart_fail", [this.product, this.variant, n]), cs.promiseTransitionEnd(e)
            },
            _transitionAddToCartButton: function(t) {
                var e = $n(Oc.notification, this.$container),
                    n = $n(Oc.submitButton, this.$container),
                    i = $n(Oc.submitButtonPrimaryText, n),
                    r = $n(Oc.submitButtonSecondaryText, n);
                return n.addClass([Nc.buttonTransition, Nc.ajaxCartToggle].join(" ")), i.attr("aria-hidden", !0), r.attr("aria-hidden", !1), e.removeClass(Nc.productNotificationError).addClass(Nc.productNotificationSuccess).text(theme.strings.addItemSuccess).attr("role", "alert"), this.trigger("variant_add_to_cart_successful", [this.product, this.variant, t]), cs.promiseTransitionEnd(e)
            },
            _resetAddToCartButton: function() {
                var t = $n(Oc.notification, this.$container),
                    e = $n(Oc.submitButton, this.$container),
                    n = $n(Oc.submitButtonPrimaryText, e),
                    i = $n(Oc.submitButtonSecondaryText, e);
                e.removeClass([Nc.buttonTransition, Nc.ajaxCartToggle].join(" ")), n.attr("aria-hidden", !1), i.attr("aria-hidden", !0), t.removeClass(Nc.productNotificationError).removeClass(Nc.productNotificationSuccess).text("").attr("role", "")
            },
            _updateOnlineStatus: function() {
                theme.isOnline = !0
            },
            _updateOfflineStatus: function() {
                theme.isOnline = !1
            }
        },
        Fc = {
            socialSharing: ".social-sharing",
            detailsButton: ".product__more-details"
        };
    Os.register("featured-product", {
        onLoad: function() {
            this.extend(ys), this.extend(Ic), this.on("variant_change", this._updateProductLink.bind(this))
        },
        _updateProductLink: function(t, e, n, i) {
            var r = $n(Fc.detailsButton, this.$container),
                o = cs.updateUrlParameter(r.attr("href"), "variant", i.id);
            r.attr("href", o)
        }
    });
    var Bc = t(function(t) {
            ! function(e, n, i, r) {
                "use strict";

                function o(t, e, n) {
                    return setTimeout(l(t, n), e)
                }

                function s(t, e, n) {
                    return !!Array.isArray(t) && (a(t, n[e], n), !0)
                }

                function a(t, e, n) {
                    var i;
                    if (t)
                        if (t.forEach) t.forEach(e, n);
                        else if (t.length !== r)
                        for (i = 0; i < t.length;) e.call(n, t[i], i, t), i++;
                    else
                        for (i in t) t.hasOwnProperty(i) && e.call(n, t[i], i, t)
                }

                function c(t, n, i) {
                    var r = "DEPRECATED METHOD: " + n + "\n" + i + " AT \n";
                    return function() {
                        var n = new Error("get-stack-trace"),
                            i = n && n.stack ? n.stack.replace(/^[^\(]+?[\n$]/gm, "").replace(/^\s+at\s+/gm, "").replace(/^Object.<anonymous>\s*\(/gm, "{anonymous}()@") : "Unknown Stack Trace",
                            o = e.console && (e.console.warn || e.console.log);
                        return o && o.call(e.console, r, i), t.apply(this, arguments)
                    }
                }

                function u(t, e, n) {
                    var i, r = e.prototype;
                    i = t.prototype = Object.create(r), i.constructor = t, i._super = r, n && dt(i, n)
                }

                function l(t, e) {
                    return function() {
                        return t.apply(e, arguments)
                    }
                }

                function d(t, e) {
                    return typeof t == pt ? t.apply(e ? e[0] || r : r, e) : t
                }

                function h(t, e) {
                    return t === r ? e : t
                }

                function f(t, e, n) {
                    a(v(e), function(e) {
                        t.addEventListener(e, n, !1)
                    })
                }

                function p(t, e, n) {
                    a(v(e), function(e) {
                        t.removeEventListener(e, n, !1)
                    })
                }

                function m(t, e) {
                    for (; t;) {
                        if (t == e) return !0;
                        t = t.parentNode
                    }
                    return !1
                }

                function g(t, e) {
                    return t.indexOf(e) > -1
                }

                function v(t) {
                    return t.trim().split(/\s+/g)
                }

                function y(t, e, n) {
                    if (t.indexOf && !n) return t.indexOf(e);
                    for (var i = 0; i < t.length;) {
                        if (n && t[i][n] == e || !n && t[i] === e) return i;
                        i++
                    }
                    return -1
                }

                function b(t) {
                    return Array.prototype.slice.call(t, 0)
                }

                function _(t, e, n) {
                    for (var i = [], r = [], o = 0; o < t.length;) {
                        var s = e ? t[o][e] : t[o];
                        y(r, s) < 0 && i.push(t[o]), r[o] = s, o++
                    }
                    return n && (i = e ? i.sort(function(t, n) {
                        return t[e] > n[e]
                    }) : i.sort()), i
                }

                function w(t, e) {
                    for (var n, i, o = e[0].toUpperCase() + e.slice(1), s = 0; s < ht.length;) {
                        if (n = ht[s], (i = n ? n + o : e) in t) return i;
                        s++
                    }
                    return r
                }

                function S() {
                    return _t++
                }

                function x(t) {
                    var n = t.ownerDocument || t;
                    return n.defaultView || n.parentWindow || e
                }

                function C(t, e) {
                    var n = this;
                    this.manager = t, this.callback = e, this.element = t.element, this.target = t.options.inputTarget, this.domHandler = function(e) {
                        d(t.options.enable, [t]) && n.handler(e)
                    }, this.init()
                }

                function T(t) {
                    var e = t.options.inputClass;
                    return new(e || (xt ? H : Ct ? R : St ? z : L))(t, k)
                }

                function k(t, e, n) {
                    var i = n.pointers.length,
                        r = n.changedPointers.length,
                        o = e & kt && i - r == 0,
                        s = e & (Et | At) && i - r == 0;
                    n.isFirst = !!o, n.isFinal = !!s, o && (t.session = {}), n.eventType = e, $(t, n), t.emit("hammer.input", n), t.recognize(n), t.session.prevInput = n
                }

                function $(t, e) {
                    var n = t.session,
                        i = e.pointers,
                        r = i.length;
                    n.firstInput || (n.firstInput = j(e)), r > 1 && !n.firstMultiple ? n.firstMultiple = j(e) : 1 === r && (n.firstMultiple = !1);
                    var o = n.firstInput,
                        s = n.firstMultiple,
                        a = s ? s.center : o.center,
                        c = e.center = P(i);
                    e.timeStamp = vt(), e.deltaTime = e.timeStamp - o.timeStamp, e.angle = I(a, c), e.distance = O(a, c), E(n, e), e.offsetDirection = N(e.deltaX, e.deltaY);
                    var u = D(e.deltaTime, e.deltaX, e.deltaY);
                    e.overallVelocityX = u.x, e.overallVelocityY = u.y, e.overallVelocity = gt(u.x) > gt(u.y) ? u.x : u.y, e.scale = s ? B(s.pointers, i) : 1, e.rotation = s ? F(s.pointers, i) : 0, e.maxPointers = n.prevInput ? e.pointers.length > n.prevInput.maxPointers ? e.pointers.length : n.prevInput.maxPointers : e.pointers.length, A(n, e);
                    var l = t.element;
                    m(e.srcEvent.target, l) && (l = e.srcEvent.target), e.target = l
                }

                function E(t, e) {
                    var n = e.center,
                        i = t.offsetDelta || {},
                        r = t.prevDelta || {},
                        o = t.prevInput || {};
                    e.eventType !== kt && o.eventType !== Et || (r = t.prevDelta = {
                        x: o.deltaX || 0,
                        y: o.deltaY || 0
                    }, i = t.offsetDelta = {
                        x: n.x,
                        y: n.y
                    }), e.deltaX = r.x + (n.x - i.x), e.deltaY = r.y + (n.y - i.y)
                }

                function A(t, e) {
                    var n, i, o, s, a = t.lastInterval || e,
                        c = e.timeStamp - a.timeStamp;
                    if (e.eventType != At && (c > Tt || a.velocity === r)) {
                        var u = e.deltaX - a.deltaX,
                            l = e.deltaY - a.deltaY,
                            d = D(c, u, l);
                        i = d.x, o = d.y, n = gt(d.x) > gt(d.y) ? d.x : d.y, s = N(u, l), t.lastInterval = e
                    } else n = a.velocity, i = a.velocityX, o = a.velocityY, s = a.direction;
                    e.velocity = n, e.velocityX = i, e.velocityY = o, e.direction = s
                }

                function j(t) {
                    for (var e = [], n = 0; n < t.pointers.length;) e[n] = {
                        clientX: mt(t.pointers[n].clientX),
                        clientY: mt(t.pointers[n].clientY)
                    }, n++;
                    return {
                        timeStamp: vt(),
                        pointers: e,
                        center: P(e),
                        deltaX: t.deltaX,
                        deltaY: t.deltaY
                    }
                }

                function P(t) {
                    var e = t.length;
                    if (1 === e) return {
                        x: mt(t[0].clientX),
                        y: mt(t[0].clientY)
                    };
                    for (var n = 0, i = 0, r = 0; r < e;) n += t[r].clientX, i += t[r].clientY, r++;
                    return {
                        x: mt(n / e),
                        y: mt(i / e)
                    }
                }

                function D(t, e, n) {
                    return {
                        x: e / t || 0,
                        y: n / t || 0
                    }
                }

                function N(t, e) {
                    return t === e ? jt : gt(t) >= gt(e) ? t < 0 ? Pt : Dt : e < 0 ? Nt : Ot
                }

                function O(t, e, n) {
                    n || (n = Lt);
                    var i = e[n[0]] - t[n[0]],
                        r = e[n[1]] - t[n[1]];
                    return Math.sqrt(i * i + r * r)
                }

                function I(t, e, n) {
                    n || (n = Lt);
                    var i = e[n[0]] - t[n[0]],
                        r = e[n[1]] - t[n[1]];
                    return 180 * Math.atan2(r, i) / Math.PI
                }

                function F(t, e) {
                    return I(e[1], e[0], Ht) + I(t[1], t[0], Ht)
                }

                function B(t, e) {
                    return O(e[0], e[1], Ht) / O(t[0], t[1], Ht)
                }

                function L() {
                    this.evEl = qt, this.evWin = Rt, this.pressed = !1, C.apply(this, arguments)
                }

                function H() {
                    this.evEl = Vt, this.evWin = Ut, C.apply(this, arguments), this.store = this.manager.session.pointerEvents = []
                }

                function M() {
                    this.evTarget = Yt, this.evWin = Qt, this.started = !1, C.apply(this, arguments)
                }

                function q(t, e) {
                    var n = b(t.touches),
                        i = b(t.changedTouches);
                    return e & (Et | At) && (n = _(n.concat(i), "identifier", !0)), [n, i]
                }

                function R() {
                    this.evTarget = Kt, this.targetIds = {}, C.apply(this, arguments)
                }

                function W(t, e) {
                    var n = b(t.touches),
                        i = this.targetIds;
                    if (e & (kt | $t) && 1 === n.length) return i[n[0].identifier] = !0, [n, n];
                    var r, o, s = b(t.changedTouches),
                        a = [],
                        c = this.target;
                    if (o = n.filter(function(t) {
                            return m(t.target, c)
                        }), e === kt)
                        for (r = 0; r < o.length;) i[o[r].identifier] = !0, r++;
                    for (r = 0; r < s.length;) i[s[r].identifier] && a.push(s[r]), e & (Et | At) && delete i[s[r].identifier], r++;
                    return a.length ? [_(o.concat(a), "identifier", !0), a] : void 0
                }

                function z() {
                    C.apply(this, arguments);
                    var t = l(this.handler, this);
                    this.touch = new R(this.manager, t), this.mouse = new L(this.manager, t), this.primaryTouch = null, this.lastTouches = []
                }

                function V(t, e) {
                    t & kt ? (this.primaryTouch = e.changedPointers[0].identifier, U.call(this, e)) : t & (Et | At) && U.call(this, e)
                }

                function U(t) {
                    var e = t.changedPointers[0];
                    if (e.identifier === this.primaryTouch) {
                        var n = {
                            x: e.clientX,
                            y: e.clientY
                        };
                        this.lastTouches.push(n);
                        var i = this.lastTouches,
                            r = function() {
                                var t = i.indexOf(n);
                                t > -1 && i.splice(t, 1)
                            };
                        setTimeout(r, Jt)
                    }
                }

                function X(t) {
                    for (var e = t.srcEvent.clientX, n = t.srcEvent.clientY, i = 0; i < this.lastTouches.length; i++) {
                        var r = this.lastTouches[i],
                            o = Math.abs(e - r.x),
                            s = Math.abs(n - r.y);
                        if (o <= Zt && s <= Zt) return !0
                    }
                    return !1
                }

                function Y(t, e) {
                    this.manager = t, this.set(e)
                }

                function Q(t) {
                    if (g(t, re)) return re;
                    var e = g(t, oe),
                        n = g(t, se);
                    return e && n ? re : e || n ? e ? oe : se : g(t, ie) ? ie : ne
                }

                function G(t) {
                    this.options = dt({}, this.defaults, t || {}), this.id = S(), this.manager = null, this.options.enable = h(this.options.enable, !0), this.state = ce, this.simultaneous = {}, this.requireFail = []
                }

                function K(t) {
                    return t & fe ? "cancel" : t & de ? "end" : t & le ? "move" : t & ue ? "start" : ""
                }

                function J(t) {
                    return t == Ot ? "down" : t == Nt ? "up" : t == Pt ? "left" : t == Dt ? "right" : ""
                }

                function Z(t, e) {
                    var n = e.manager;
                    return n ? n.get(t) : t
                }

                function tt() {
                    G.apply(this, arguments)
                }

                function et() {
                    tt.apply(this, arguments), this.pX = null, this.pY = null
                }

                function nt() {
                    tt.apply(this, arguments)
                }

                function it() {
                    G.apply(this, arguments), this._timer = null, this._input = null
                }

                function rt() {
                    tt.apply(this, arguments)
                }

                function ot() {
                    tt.apply(this, arguments)
                }

                function st() {
                    G.apply(this, arguments), this.pTime = !1, this.pCenter = !1, this._timer = null, this._input = null, this.count = 0
                }

                function at(t, e) {
                    return e = e || {}, e.recognizers = h(e.recognizers, at.defaults.preset), new ct(t, e)
                }

                function ct(t, e) {
                    this.options = dt({}, at.defaults, e || {}), this.options.inputTarget = this.options.inputTarget || t, this.handlers = {}, this.session = {}, this.recognizers = [], this.oldCssProps = {}, this.element = t, this.input = T(this), this.touchAction = new Y(this, this.options.touchAction), ut(this, !0), a(this.options.recognizers, function(t) {
                        var e = this.add(new t[0](t[1]));
                        t[2] && e.recognizeWith(t[2]), t[3] && e.requireFailure(t[3])
                    }, this)
                }

                function ut(t, e) {
                    var n = t.element;
                    if (n.style) {
                        var i;
                        a(t.options.cssProps, function(r, o) {
                            i = w(n.style, o), e ? (t.oldCssProps[i] = n.style[i], n.style[i] = r) : n.style[i] = t.oldCssProps[i] || ""
                        }), e || (t.oldCssProps = {})
                    }
                }

                function lt(t, e) {
                    var i = n.createEvent("Event");
                    i.initEvent(t, !0, !0), i.gesture = e, e.target.dispatchEvent(i)
                }
                var dt, ht = ["", "webkit", "Moz", "MS", "ms", "o"],
                    ft = n.createElement("div"),
                    pt = "function",
                    mt = Math.round,
                    gt = Math.abs,
                    vt = Date.now;
                dt = "function" != typeof Object.assign ? function(t) {
                    if (t === r || null === t) throw new TypeError("Cannot convert undefined or null to object");
                    for (var e = Object(t), n = 1; n < arguments.length; n++) {
                        var i = arguments[n];
                        if (i !== r && null !== i)
                            for (var o in i) i.hasOwnProperty(o) && (e[o] = i[o])
                    }
                    return e
                } : Object.assign;
                var yt = c(function(t, e, n) {
                        for (var i = Object.keys(e), o = 0; o < i.length;)(!n || n && t[i[o]] === r) && (t[i[o]] = e[i[o]]), o++;
                        return t
                    }, "extend", "Use `assign`."),
                    bt = c(function(t, e) {
                        return yt(t, e, !0)
                    }, "merge", "Use `assign`."),
                    _t = 1,
                    wt = /mobile|tablet|ip(ad|hone|od)|android/i,
                    St = "ontouchstart" in e,
                    xt = w(e, "PointerEvent") !== r,
                    Ct = St && wt.test(navigator.userAgent),
                    Tt = 25,
                    kt = 1,
                    $t = 2,
                    Et = 4,
                    At = 8,
                    jt = 1,
                    Pt = 2,
                    Dt = 4,
                    Nt = 8,
                    Ot = 16,
                    It = Pt | Dt,
                    Ft = Nt | Ot,
                    Bt = It | Ft,
                    Lt = ["x", "y"],
                    Ht = ["clientX", "clientY"];
                C.prototype = {
                    handler: function() {},
                    init: function() {
                        this.evEl && f(this.element, this.evEl, this.domHandler), this.evTarget && f(this.target, this.evTarget, this.domHandler), this.evWin && f(x(this.element), this.evWin, this.domHandler)
                    },
                    destroy: function() {
                        this.evEl && p(this.element, this.evEl, this.domHandler), this.evTarget && p(this.target, this.evTarget, this.domHandler), this.evWin && p(x(this.element), this.evWin, this.domHandler)
                    }
                };
                var Mt = {
                        mousedown: kt,
                        mousemove: $t,
                        mouseup: Et
                    },
                    qt = "mousedown",
                    Rt = "mousemove mouseup";
                u(L, C, {
                    handler: function(t) {
                        var e = Mt[t.type];
                        e & kt && 0 === t.button && (this.pressed = !0), e & $t && 1 !== t.which && (e = Et), this.pressed && (e & Et && (this.pressed = !1), this.callback(this.manager, e, {
                            pointers: [t],
                            changedPointers: [t],
                            pointerType: "mouse",
                            srcEvent: t
                        }))
                    }
                });
                var Wt = {
                        pointerdown: kt,
                        pointermove: $t,
                        pointerup: Et,
                        pointercancel: At,
                        pointerout: At
                    },
                    zt = {
                        2: "touch",
                        3: "pen",
                        4: "mouse",
                        5: "kinect"
                    },
                    Vt = "pointerdown",
                    Ut = "pointermove pointerup pointercancel";
                e.MSPointerEvent && !e.PointerEvent && (Vt = "MSPointerDown", Ut = "MSPointerMove MSPointerUp MSPointerCancel"), u(H, C, {
                    handler: function(t) {
                        var e = this.store,
                            n = !1,
                            i = t.type.toLowerCase().replace("ms", ""),
                            r = Wt[i],
                            o = zt[t.pointerType] || t.pointerType,
                            s = "touch" == o,
                            a = y(e, t.pointerId, "pointerId");
                        r & kt && (0 === t.button || s) ? a < 0 && (e.push(t), a = e.length - 1) : r & (Et | At) && (n = !0), a < 0 || (e[a] = t, this.callback(this.manager, r, {
                            pointers: e,
                            changedPointers: [t],
                            pointerType: o,
                            srcEvent: t
                        }), n && e.splice(a, 1))
                    }
                });
                var Xt = {
                        touchstart: kt,
                        touchmove: $t,
                        touchend: Et,
                        touchcancel: At
                    },
                    Yt = "touchstart",
                    Qt = "touchstart touchmove touchend touchcancel";
                u(M, C, {
                    handler: function(t) {
                        var e = Xt[t.type];
                        if (e === kt && (this.started = !0), this.started) {
                            var n = q.call(this, t, e);
                            e & (Et | At) && n[0].length - n[1].length == 0 && (this.started = !1), this.callback(this.manager, e, {
                                pointers: n[0],
                                changedPointers: n[1],
                                pointerType: "touch",
                                srcEvent: t
                            })
                        }
                    }
                });
                var Gt = {
                        touchstart: kt,
                        touchmove: $t,
                        touchend: Et,
                        touchcancel: At
                    },
                    Kt = "touchstart touchmove touchend touchcancel";
                u(R, C, {
                    handler: function(t) {
                        var e = Gt[t.type],
                            n = W.call(this, t, e);
                        n && this.callback(this.manager, e, {
                            pointers: n[0],
                            changedPointers: n[1],
                            pointerType: "touch",
                            srcEvent: t
                        })
                    }
                });
                var Jt = 2500,
                    Zt = 25;
                u(z, C, {
                    handler: function(t, e, n) {
                        var i = "touch" == n.pointerType,
                            r = "mouse" == n.pointerType;
                        if (!(r && n.sourceCapabilities && n.sourceCapabilities.firesTouchEvents)) {
                            if (i) V.call(this, e, n);
                            else if (r && X.call(this, n)) return;
                            this.callback(t, e, n)
                        }
                    },
                    destroy: function() {
                        this.touch.destroy(), this.mouse.destroy()
                    }
                });
                var te = w(ft.style, "touchAction"),
                    ee = te !== r,
                    ne = "auto",
                    ie = "manipulation",
                    re = "none",
                    oe = "pan-x",
                    se = "pan-y",
                    ae = function() {
                        if (!ee) return !1;
                        var t = {},
                            n = e.CSS && e.CSS.supports;
                        return ["auto", "manipulation", "pan-y", "pan-x", "pan-x pan-y", "none"].forEach(function(i) {
                            t[i] = !n || e.CSS.supports("touch-action", i)
                        }), t
                    }();
                Y.prototype = {
                    set: function(t) {
                        "compute" == t && (t = this.compute()), ee && this.manager.element.style && ae[t] && (this.manager.element.style[te] = t), this.actions = t.toLowerCase().trim()
                    },
                    update: function() {
                        this.set(this.manager.options.touchAction)
                    },
                    compute: function() {
                        var t = [];
                        return a(this.manager.recognizers, function(e) {
                            d(e.options.enable, [e]) && (t = t.concat(e.getTouchAction()))
                        }), Q(t.join(" "))
                    },
                    preventDefaults: function(t) {
                        var e = t.srcEvent,
                            n = t.offsetDirection;
                        if (this.manager.session.prevented) return void e.preventDefault();
                        var i = this.actions,
                            r = g(i, re) && !ae[re],
                            o = g(i, se) && !ae[se],
                            s = g(i, oe) && !ae[oe];
                        if (r) {
                            var a = 1 === t.pointers.length,
                                c = t.distance < 2,
                                u = t.deltaTime < 250;
                            if (a && c && u) return
                        }
                        return s && o ? void 0 : r || o && n & It || s && n & Ft ? this.preventSrc(e) : void 0
                    },
                    preventSrc: function(t) {
                        this.manager.session.prevented = !0, t.preventDefault()
                    }
                };
                var ce = 1,
                    ue = 2,
                    le = 4,
                    de = 8,
                    he = de,
                    fe = 16;
                G.prototype = {
                    defaults: {},
                    set: function(t) {
                        return dt(this.options, t), this.manager && this.manager.touchAction.update(), this
                    },
                    recognizeWith: function(t) {
                        if (s(t, "recognizeWith", this)) return this;
                        var e = this.simultaneous;
                        return t = Z(t, this), e[t.id] || (e[t.id] = t, t.recognizeWith(this)), this
                    },
                    dropRecognizeWith: function(t) {
                        return s(t, "dropRecognizeWith", this) ? this : (t = Z(t, this), delete this.simultaneous[t.id], this)
                    },
                    requireFailure: function(t) {
                        if (s(t, "requireFailure", this)) return this;
                        var e = this.requireFail;
                        return t = Z(t, this), -1 === y(e, t) && (e.push(t), t.requireFailure(this)), this
                    },
                    dropRequireFailure: function(t) {
                        if (s(t, "dropRequireFailure", this)) return this;
                        t = Z(t, this);
                        var e = y(this.requireFail, t);
                        return e > -1 && this.requireFail.splice(e, 1), this
                    },
                    hasRequireFailures: function() {
                        return this.requireFail.length > 0
                    },
                    canRecognizeWith: function(t) {
                        return !!this.simultaneous[t.id]
                    },
                    emit: function(t) {
                        function e(e) {
                            n.manager.emit(e, t)
                        }
                        var n = this,
                            i = this.state;
                        i < de && e(n.options.event + K(i)), e(n.options.event), t.additionalEvent && e(t.additionalEvent), i >= de && e(n.options.event + K(i))
                    },
                    tryEmit: function(t) {
                        if (this.canEmit()) return this.emit(t);
                        this.state = 32
                    },
                    canEmit: function() {
                        for (var t = 0; t < this.requireFail.length;) {
                            if (!(this.requireFail[t].state & (32 | ce))) return !1;
                            t++
                        }
                        return !0
                    },
                    recognize: function(t) {
                        var e = dt({}, t);
                        if (!d(this.options.enable, [this, e])) return this.reset(), void(this.state = 32);
                        this.state & (he | fe | 32) && (this.state = ce), this.state = this.process(e), this.state & (ue | le | de | fe) && this.tryEmit(e)
                    },
                    process: function(t) {},
                    getTouchAction: function() {},
                    reset: function() {}
                }, u(tt, G, {
                    defaults: {
                        pointers: 1
                    },
                    attrTest: function(t) {
                        var e = this.options.pointers;
                        return 0 === e || t.pointers.length === e
                    },
                    process: function(t) {
                        var e = this.state,
                            n = t.eventType,
                            i = e & (ue | le),
                            r = this.attrTest(t);
                        return i && (n & At || !r) ? e | fe : i || r ? n & Et ? e | de : e & ue ? e | le : ue : 32
                    }
                }), u(et, tt, {
                    defaults: {
                        event: "pan",
                        threshold: 10,
                        pointers: 1,
                        direction: Bt
                    },
                    getTouchAction: function() {
                        var t = this.options.direction,
                            e = [];
                        return t & It && e.push(se), t & Ft && e.push(oe), e
                    },
                    directionTest: function(t) {
                        var e = this.options,
                            n = !0,
                            i = t.distance,
                            r = t.direction,
                            o = t.deltaX,
                            s = t.deltaY;
                        return r & e.direction || (e.direction & It ? (r = 0 === o ? jt : o < 0 ? Pt : Dt, n = o != this.pX, i = Math.abs(t.deltaX)) : (r = 0 === s ? jt : s < 0 ? Nt : Ot, n = s != this.pY, i = Math.abs(t.deltaY))), t.direction = r, n && i > e.threshold && r & e.direction
                    },
                    attrTest: function(t) {
                        return tt.prototype.attrTest.call(this, t) && (this.state & ue || !(this.state & ue) && this.directionTest(t))
                    },
                    emit: function(t) {
                        this.pX = t.deltaX, this.pY = t.deltaY;
                        var e = J(t.direction);
                        e && (t.additionalEvent = this.options.event + e), this._super.emit.call(this, t)
                    }
                }), u(nt, tt, {
                    defaults: {
                        event: "pinch",
                        threshold: 0,
                        pointers: 2
                    },
                    getTouchAction: function() {
                        return [re]
                    },
                    attrTest: function(t) {
                        return this._super.attrTest.call(this, t) && (Math.abs(t.scale - 1) > this.options.threshold || this.state & ue)
                    },
                    emit: function(t) {
                        if (1 !== t.scale) {
                            var e = t.scale < 1 ? "in" : "out";
                            t.additionalEvent = this.options.event + e
                        }
                        this._super.emit.call(this, t)
                    }
                }), u(it, G, {
                    defaults: {
                        event: "press",
                        pointers: 1,
                        time: 251,
                        threshold: 9
                    },
                    getTouchAction: function() {
                        return [ne]
                    },
                    process: function(t) {
                        var e = this.options,
                            n = t.pointers.length === e.pointers,
                            i = t.distance < e.threshold,
                            r = t.deltaTime > e.time;
                        if (this._input = t, !i || !n || t.eventType & (Et | At) && !r) this.reset();
                        else if (t.eventType & kt) this.reset(), this._timer = o(function() {
                            this.state = he, this.tryEmit()
                        }, e.time, this);
                        else if (t.eventType & Et) return he;
                        return 32
                    },
                    reset: function() {
                        clearTimeout(this._timer)
                    },
                    emit: function(t) {
                        this.state === he && (t && t.eventType & Et ? this.manager.emit(this.options.event + "up", t) : (this._input.timeStamp = vt(), this.manager.emit(this.options.event, this._input)))
                    }
                }), u(rt, tt, {
                    defaults: {
                        event: "rotate",
                        threshold: 0,
                        pointers: 2
                    },
                    getTouchAction: function() {
                        return [re]
                    },
                    attrTest: function(t) {
                        return this._super.attrTest.call(this, t) && (Math.abs(t.rotation) > this.options.threshold || this.state & ue)
                    }
                }), u(ot, tt, {
                    defaults: {
                        event: "swipe",
                        threshold: 10,
                        velocity: .3,
                        direction: It | Ft,
                        pointers: 1
                    },
                    getTouchAction: function() {
                        return et.prototype.getTouchAction.call(this)
                    },
                    attrTest: function(t) {
                        var e, n = this.options.direction;
                        return n & (It | Ft) ? e = t.overallVelocity : n & It ? e = t.overallVelocityX : n & Ft && (e = t.overallVelocityY), this._super.attrTest.call(this, t) && n & t.offsetDirection && t.distance > this.options.threshold && t.maxPointers == this.options.pointers && gt(e) > this.options.velocity && t.eventType & Et
                    },
                    emit: function(t) {
                        var e = J(t.offsetDirection);
                        e && this.manager.emit(this.options.event + e, t), this.manager.emit(this.options.event, t)
                    }
                }), u(st, G, {
                    defaults: {
                        event: "tap",
                        pointers: 1,
                        taps: 1,
                        interval: 300,
                        time: 250,
                        threshold: 9,
                        posThreshold: 10
                    },
                    getTouchAction: function() {
                        return [ie]
                    },
                    process: function(t) {
                        var e = this.options,
                            n = t.pointers.length === e.pointers,
                            i = t.distance < e.threshold,
                            r = t.deltaTime < e.time;
                        if (this.reset(), t.eventType & kt && 0 === this.count) return this.failTimeout();
                        if (i && r && n) {
                            if (t.eventType != Et) return this.failTimeout();
                            var s = !this.pTime || t.timeStamp - this.pTime < e.interval,
                                a = !this.pCenter || O(this.pCenter, t.center) < e.posThreshold;
                            this.pTime = t.timeStamp, this.pCenter = t.center, a && s ? this.count += 1 : this.count = 1, this._input = t;
                            if (0 === this.count % e.taps) return this.hasRequireFailures() ? (this._timer = o(function() {
                                this.state = he, this.tryEmit()
                            }, e.interval, this), ue) : he
                        }
                        return 32
                    },
                    failTimeout: function() {
                        return this._timer = o(function() {
                            this.state = 32
                        }, this.options.interval, this), 32
                    },
                    reset: function() {
                        clearTimeout(this._timer)
                    },
                    emit: function() {
                        this.state == he && (this._input.tapCount = this.count, this.manager.emit(this.options.event, this._input))
                    }
                }), at.VERSION = "2.0.7", at.defaults = {
                    domEvents: !1,
                    touchAction: "compute",
                    enable: !0,
                    inputTarget: null,
                    inputClass: null,
                    preset: [
                        [rt, {
                            enable: !1
                        }],
                        [nt, {
                                enable: !1
                            },
                            ["rotate"]
                        ],
                        [ot, {
                            direction: It
                        }],
                        [et, {
                                direction: It
                            },
                            ["swipe"]
                        ],
                        [st],
                        [st, {
                                event: "doubletap",
                                taps: 2
                            },
                            ["tap"]
                        ],
                        [it]
                    ],
                    cssProps: {
                        userSelect: "none",
                        touchSelect: "none",
                        touchCallout: "none",
                        contentZooming: "none",
                        userDrag: "none",
                        tapHighlightColor: "rgba(0,0,0,0)"
                    }
                };
                ct.prototype = {
                    set: function(t) {
                        return dt(this.options, t), t.touchAction && this.touchAction.update(), t.inputTarget && (this.input.destroy(), this.input.target = t.inputTarget, this.input.init()), this
                    },
                    stop: function(t) {
                        this.session.stopped = t ? 2 : 1
                    },
                    recognize: function(t) {
                        var e = this.session;
                        if (!e.stopped) {
                            this.touchAction.preventDefaults(t);
                            var n, i = this.recognizers,
                                r = e.curRecognizer;
                            (!r || r && r.state & he) && (r = e.curRecognizer = null);
                            for (var o = 0; o < i.length;) n = i[o], 2 === e.stopped || r && n != r && !n.canRecognizeWith(r) ? n.reset() : n.recognize(t), !r && n.state & (ue | le | de) && (r = e.curRecognizer = n), o++
                        }
                    },
                    get: function(t) {
                        if (t instanceof G) return t;
                        for (var e = this.recognizers, n = 0; n < e.length; n++)
                            if (e[n].options.event == t) return e[n];
                        return null
                    },
                    add: function(t) {
                        if (s(t, "add", this)) return this;
                        var e = this.get(t.options.event);
                        return e && this.remove(e), this.recognizers.push(t), t.manager = this, this.touchAction.update(), t
                    },
                    remove: function(t) {
                        if (s(t, "remove", this)) return this;
                        if (t = this.get(t)) {
                            var e = this.recognizers,
                                n = y(e, t); - 1 !== n && (e.splice(n, 1), this.touchAction.update())
                        }
                        return this
                    },
                    on: function(t, e) {
                        if (t !== r && e !== r) {
                            var n = this.handlers;
                            return a(v(t), function(t) {
                                n[t] = n[t] || [], n[t].push(e)
                            }), this
                        }
                    },
                    off: function(t, e) {
                        if (t !== r) {
                            var n = this.handlers;
                            return a(v(t), function(t) {
                                e ? n[t] && n[t].splice(y(n[t], e), 1) : delete n[t]
                            }), this
                        }
                    },
                    emit: function(t, e) {
                        this.options.domEvents && lt(t, e);
                        var n = this.handlers[t] && this.handlers[t].slice();
                        if (n && n.length) {
                            e.type = t, e.preventDefault = function() {
                                e.srcEvent.preventDefault()
                            };
                            for (var i = 0; i < n.length;) n[i](e), i++
                        }
                    },
                    destroy: function() {
                        this.element && ut(this, !1), this.handlers = {}, this.session = {}, this.input.destroy(), this.element = null
                    }
                }, dt(at, {
                    INPUT_START: kt,
                    INPUT_MOVE: $t,
                    INPUT_END: Et,
                    INPUT_CANCEL: At,
                    STATE_POSSIBLE: ce,
                    STATE_BEGAN: ue,
                    STATE_CHANGED: le,
                    STATE_ENDED: de,
                    STATE_RECOGNIZED: he,
                    STATE_CANCELLED: fe,
                    STATE_FAILED: 32,
                    DIRECTION_NONE: jt,
                    DIRECTION_LEFT: Pt,
                    DIRECTION_RIGHT: Dt,
                    DIRECTION_UP: Nt,
                    DIRECTION_DOWN: Ot,
                    DIRECTION_HORIZONTAL: It,
                    DIRECTION_VERTICAL: Ft,
                    DIRECTION_ALL: Bt,
                    Manager: ct,
                    Input: C,
                    TouchAction: Y,
                    TouchInput: R,
                    MouseInput: L,
                    PointerEventInput: H,
                    TouchMouseInput: z,
                    SingleTouchInput: M,
                    Recognizer: G,
                    AttrRecognizer: tt,
                    Tap: st,
                    Pan: et,
                    Swipe: ot,
                    Pinch: nt,
                    Rotate: rt,
                    Press: it,
                    on: f,
                    off: p,
                    each: a,
                    merge: bt,
                    extend: yt,
                    assign: dt,
                    inherit: u,
                    bindFn: l,
                    prefixed: w
                }), (void 0 !== e ? e : "undefined" != typeof self ? self : {}).Hammer = at, "function" == typeof define && define.amd ? define(function() {
                    return at
                }) : void 0 !== t && t.exports ? t.exports = at : e.Hammer = at
            }(window, document)
        }),
        Lc = {
            slides: ".slider__slide",
            activeSlide: ".slider__slide--active"
        },
        Hc = {
            activeSlide: "slider__slide--active",
            previousSlide: "slider__slide--previous",
            nextSlide: "slider__slide--next",
            transitioningSlide: "slider__slide--transitioning",
            draggingSlide: "slider__slide--dragging"
        },
        Mc = {
            nextSlide: "nextslide",
            prevSlide: "prevslide",
            transitionStart: "slidetransitionstart",
            transitionEnd: "slidetransitionend"
        },
        qc = {
            moveThreshold: 25
        };
    Cn.prototype = $n.extend({}, Cn.prototype, {
        destroy: function() {
            return this.$element.off("touchstart mousedown"), this.$slides[0].removeEventListener("focus", this.bindedOnFocus, !0), this.$slides[0].removeEventListener("blur", this.bindedOnBlur, !0), null
        },
        nextSlide: function() {
            return this._triggerEvent([Mc.nextSlide, Mc.transitionStart]), this._promiseNextSlide().then(function() {
                this._triggerEvent(Mc.transitionEnd)
            }.bind(this))
        },
        previousSlide: function() {
            return this._triggerEvent([Mc.prevSlide, Mc.transitionStart]), this._promisePrevSlide().then(function() {
                this._triggerEvent(Mc.transitionEnd)
            }.bind(this))
        },
        setSlide: function(t, e) {
            var n = this.slidePromiseChain || $n.Deferred().resolve(),
                i = this.$currentSlide.index(),
                r = this.$slides.length,
                o = $n.Deferred().resolve();
            return this.slidePromiseChain = n.then(function() {
                return t < r && t !== i && (e ? t > i ? o = cs.promiseRepeatSeries(this.nextSlide.bind(this), t - i) : t < i && (o = cs.promiseRepeatSeries(this.previousSlide.bind(this), i - t)) : o = this._promiseSlide(this.$slides.eq(t))), o
            }.bind(this)), this.slidePromiseChain
        },
        _promiseNextSlide: function() {
            return requestAnimationFrame(function() {
                this.$nextSlide.addClass(Hc.nextSlide), requestAnimationFrame(function() {
                    this.$slides.removeAttr("style"), this.$nextSlide.removeClass(Hc.nextSlide).addClass(Hc.activeSlide).addClass(Hc.transitioningSlide), this.$currentSlide.removeClass(Hc.activeSlide).addClass(Hc.previousSlide).addClass(Hc.transitioningSlide)
                }.bind(this))
            }.bind(this)), this._promiseSlideTransitionEnd().then(function() {
                this._setCurrentSlide(this.$nextSlide)
            }.bind(this))
        },
        _promisePrevSlide: function() {
            return requestAnimationFrame(function() {
                this.$previousSlide.addClass(Hc.previousSlide), requestAnimationFrame(function() {
                    this.$slides.removeAttr("style"), this.$previousSlide.removeClass(Hc.previousSlide).addClass(Hc.activeSlide).addClass(Hc.transitioningSlide), this.$currentSlide.removeClass(Hc.activeSlide).addClass(Hc.nextSlide).addClass(Hc.transitioningSlide)
                }.bind(this))
            }.bind(this)), this._promiseSlideTransitionEnd().then(function() {
                this._setCurrentSlide(this.$previousSlide)
            }.bind(this))
        },
        _promiseSlide: function(t) {
            return this._setCurrentSlide(t), t.addClass(Hc.activeSlide).siblings().removeClass(Hc.activeSlide), $n.Deferred(function(t) {
                requestAnimationFrame(function() {
                    this._triggerEvent(Mc.transitionEnd), t.resolve()
                }.bind(this))
            }.bind(this))
        },
        _promiseCancelSlide: function() {
            return requestAnimationFrame(function() {
                this.$slides.removeAttr("style").addClass(Hc.transitioningSlide)
            }.bind(this)), this._promiseSlideTransitionEnd()
        },
        _promiseSlideTransitionEnd: function() {
            return $n.Deferred(function(t) {
                this.$currentSlide.one("transitionend", function() {
                    this.$slides.removeClass([Hc.transitioningSlide, Hc.nextSlide, Hc.previousSlide].join(" ")), t.resolve()
                }.bind(this))
            }.bind(this))
        },
        _setCurrentSlide: function(t) {
            this.$currentSlide = t, this.$nextSlide = this._nextSlideIndex(t, this.$slides), this.$previousSlide = this._prevSlideIndex(t, this.$slides)
        },
        _assignTouchHandlers: function() {
            this.bindedTouchStart = this._onTouchStart.bind(this), this.bindedTouchMove = this._onTouchMove.bind(this), this.bindedTouchEnd = this._onTouchEnd.bind(this), this.$element.one("touchstart", this.bindedTouchStart).one("mousedown", this.bindedTouchStart)
        },
        _onTouchStart: function(t) {
            this.windowWidth = $n(window).innerWidth(), this.startPosition = cs.pointerEventToXY(t), this.isDragging = !1, this.$element.on("touchmove mousemove", this.bindedTouchMove).on("touchend mouseup", this.bindedTouchEnd)
        },
        _onTouchMove: function(t) {
            this.currentPosition = cs.pointerEventToXY(t), this.percentMoved = (this.currentPosition.x - this.startPosition.x) / this.windowWidth * 100, this.isDragging || (this.isDragging = !0), this.percentMoved > 0 ? (this.$previousSlide.addClass(Hc.previousSlide), this.$nextSlide.removeClass(Hc.nextSlide), this.$previousSlide.css({
                transform: "translateX(" + (this.percentMoved - 100) + "%)"
            })) : (this.$previousSlide.removeClass(Hc.previousSlide), this.$nextSlide.addClass(Hc.nextSlide), this.$nextSlide.css({
                transform: "translateX(" + (100 + this.percentMoved) + "%)"
            })), this.$currentSlide.addClass(Hc.draggingSlide).css({
                transform: "translateX(" + this.percentMoved + "%)"
            })
        },
        _onTouchEnd: function() {
            var t = this.config.moveThreshold,
                e = $n.Deferred().resolve();
            this.$element.off(), this.isDragging && (this.isDragging = !1, this.$currentSlide.removeClass(Hc.draggingSlide), e = this.percentMoved > t ? this.previousSlide() : this.percentMoved < -t ? this.nextSlide() : this._promiseCancelSlide()), e.then(function() {
                this.$element.one("touchstart", this.bindedTouchStart).one("mousedown", this.bindedTouchStart)
            }.bind(this))
        },
        _onFocus: function() {
            this.$element.one("keyup", this._onKeyup.bind(this))
        },
        _onBlur: function() {
            this.$element.off("keyup")
        },
        _onKeyup: function(t) {
            var e = $n.Deferred().resolve(),
                n = !1;
            switch (t.keyCode) {
                case 37:
                    e = this.previousSlide(), n = $n.contains(this.$element[0], document.activeElement);
                    break;
                case 39:
                    e = this.nextSlide(), n = $n.contains(this.$element[0], document.activeElement)
            }
            e.then(function() {
                n && this.$element.focus(), this.$element.one("keyup", this._onKeyup.bind(this))
            }.bind(this))
        },
        _triggerEvent: function(t) {
            "string" == typeof t && (t = [t]), t.forEach(function(t) {
                this.$element.trigger(t, {
                    $previousSlide: this.$previousSlide,
                    $currentSlide: this.$currentSlide,
                    $nextSlide: this.$nextSlide
                })
            }.bind(this))
        },
        _nextSlideIndex: function(t, e) {
            var n = t.index(),
                i = e.length,
                r = n + 1;
            return n + 1 === i && (r = 0), e.eq(r)
        },
        _prevSlideIndex: function(t, e) {
            var n = t.index(),
                i = e.length,
                r = n - 1;
            return n - 1 == -1 && (r = i - 1), e.eq(r)
        }
    });
    var Rc = {
            coverTopBackground: ".reveal-slider__cover-background--top",
            coverBottomBackground: ".reveal-slider__cover-background--bottom",
            coverContent: ".reveal-slider__cover-content",
            slideNavButtons: ".reveal-slider__nav-button",
            slidePreviousButton: ".reveal-slider__previous-button",
            slideNextButton: ".reveal-slider__next-button",
            closeCoverButton: ".reveal-slider__close",
            slider: ".slider"
        },
        Wc = {
            navButtonActive: "active",
            coverOpen: "open"
        },
        zc = {
            initRevealSlider: function() {
                this.trigger("reveal_slider_init_start"), this.revealSlider = !0, this.coverIsOpen = !1, this.revealSliderNamespace = ".revealSlider", this.mediaQuerySmall = theme.mediaQuerySmall, this.slider = new Cn($n(Rc.slider, this.$container)), this.hammertime = new Bc(this.$container[0]), this.on("click", Rc.slideNavButtons, this._onClickNavButton.bind(this)), this.on("click", Rc.slidePreviousButton, this.slider.previousSlide.bind(this.slider)), this.on("click", Rc.slideNextButton, this.slider.nextSlide.bind(this.slider)), this.on("click", Rc.closeCoverButton, this.closeCover.bind(this)), this.on("click", Rc.coverContent, this.openCover.bind(this)), this.on("nextslide prevslide", this._changeBackgroundColor.bind(this)), this.on("slidetransitionend", this._onSlideTransitionEnd.bind(this)), this.document().on("touchstart" + this.revealSliderNamespace, this._onTouchStart.bind(this)), this.document().on("touchend" + this.revealSliderNamespace, this._onTouchEnd.bind(this)), this.hammertime.on("pinchout pinchin", this._onPinch.bind(this)).on("pinchend pinchcancel", this._onPinchEnd.bind(this)), this.trigger("reveal_slider_init_done")
            },
            destroyRevealSlider: function() {
                this.revealSlider = !1, this.slider = this.slider.destroy(), this.document().off(this.revealSliderNamespace), this.off(), this.trigger("reveal_slider_destroy")
            },
            openCover: function() {
                this.$container.addClass(Wc.coverOpen), this.coverIsOpen = !0, this.trigger("reveal_slider_open_cover")
            },
            closeCover: function() {
                this.$container.removeClass(Wc.coverOpen), this.coverIsOpen = !1, this.trigger("reveal_slider_close_cover")
            },
            _changeBackgroundColor: function(t, e) {
                var n;
                n = "nextslide" === t.type ? e.$nextSlide.data("background-color") : e.$previousSlide.data("background-color"), $n(Rc.slider, this.$container).css({
                    backgroundColor: n
                })
            },
            _onSlideTransitionEnd: function(t, e) {
                var n = e.$currentSlide.index();
                $n(Rc.slideNavButtons, this.$container).eq(n).addClass(Wc.navButtonActive).siblings().removeClass(Wc.navButtonActive)
            },
            _onClickNavButton: function(t) {
                var e = $n(t.target),
                    n = e.index();
                this.slider.setSlide(e.index()), this.trigger("reveal_slider_set_slide", [n])
            },
            _onTouchStart: function(t) {
                t.originalEvent.touches.length <= 1 || (this.enablePinch = !0, this.hammertime.get("pinch").set({
                    enable: this.enablePinch
                }))
            },
            _onTouchEnd: function() {
                this.enablePinch && (this.enablePinch = !1, this.hammertime.get("pinch").set({
                    enable: this.enablePinch
                }))
            },
            _onPinch: function(t) {
                this.$coverTopBackground = this.$coverTopBackground || $n(Rc.coverTopBackground, this.$container), this.$coverBottomBackground = this.$coverBottomBackground || $n(Rc.coverBottomBackground, this.$container), this.$coverTitle = this.$coverTitle || $n(Rc.coverContent, this.$container), "pinchin" === t.type && !this.coverIsOpen || "pinchout" === t.type && this.coverIsOpen || (this.distance = this.coverIsOpen ? 70 * t.scale : 25 * (t.scale - 1), this.distance < 0 && (this.distance = 0), this.$coverBottomBackground.css({
                    transform: "translateY(" + this.distance + "%)"
                }), this.$coverTopBackground.css({
                    transform: "translateY(-" + this.distance + "%)"
                }), this.$coverTitle.css({
                    opacity: 1 - this.distance / 30
                }))
            },
            _onPinchEnd: function(t) {
                t.scale > 2 ? (this.$container.addClass(Wc.coverOpen), this.coverIsOpen = !0) : (this.$container.removeClass(Wc.coverOpen), this.coverIsOpen = !1), requestAnimationFrame(function() {
                    this.$coverTopBackground.removeAttr("style"), this.$coverBottomBackground.removeAttr("style"), this.$coverTitle.removeAttr("style")
                }.bind(this))
            }
        },
        Vc = {
            coverContent: ".side-scroller__cover-content",
            slidesContainer: ".side-scroller__slides-container",
            coverBackground: ".side-scroller__cover-background",
            slides: ".side-scroller__slide"
        },
        Uc = {
            coverFixed: "side-scroller--fixed",
            coverBottom: "side-scroller--fixed-bottom"
        },
        Xc = {
            initSideScroller: function() {
                this.trigger("side_scroller_init_start"), this.$slides = $n(Vc.slides, this.$container), this.$slidesContainer = $n(Vc.slidesContainer, this.$container), this.sideScroller = !0, this.sideScrollerNamespace = ".sideScroller", this.coverPosition = "top", this.window().on("scroll" + this.sideScrollerNamespace, this._onScroll.bind(this)), this.window().on("resize" + this.sideScrollerNamespace, this._updateCoverPositionValues.bind(this)), this.window().on("resize" + this.sideScrollerNamespace, this._onScroll.bind(this)), this.document().on("drawer_open_start" + this.sideScrollerNamespace, this._handleFixedSideImage.bind(this)), this.document().on("drawer_close_done" + this.sideScrollerNamespace, this._resetFixedSideImage.bind(this)), cs.promiseStylesheet().then(function() {
                    this._updateCoverPositionValues(), this._onScroll(), this.trigger("side_scroller_init_done")
                }.bind(this))
            },
            destroySideScroller: function() {
                this.sideScroller = !1, this.window().off(this.sideScrollerNamespace), this.document().off(this.sideScrollerNamespace), this.trigger("side_scroller_destroy")
            },
            _handleFixedSideImage: function() {
                if ("fixed" === this.coverPosition) {
                    var t = $n(Vc.coverContent, this.$container),
                        e = t.outerHeight(),
                        n = $n(window).scrollTop(),
                        i = n - this.featuresOffset.top;
                    $n(Vc.coverBackground, this.$container).css({
                        transform: "translateY(" + i + "px)",
                        position: "absolute"
                    }), $n(Vc.coverContent, this.$container).css({
                        transform: "translate(-50%, " + (i - e / 2) + "px)",
                        position: "absolute"
                    })
                }
            },
            _resetFixedSideImage: function() {
                "fixed" === this.coverPosition && $n(Vc.coverBackground, this.$container).add(Vc.coverContent, this.$container).css({
                    transform: "",
                    position: ""
                })
            },
            _onScroll: function() {
                var t = $n(window).scrollTop();
                t > this.featuresOffset.top && t + this.windowHeight <= this.featuresOffset.top + this.featuresHeight ? (requestAnimationFrame(this._setCoverPosition.bind(this, "fixed")), requestAnimationFrame(this._updateBackgroundColor.bind(this, t))) : t + this.windowHeight > this.featuresOffset.top + this.featuresHeight ? requestAnimationFrame(this._setCoverPosition.bind(this, "bottom")) : requestAnimationFrame(this._setCoverPosition.bind(this, "top"))
            },
            _setCoverPosition: function(t) {
                if (this.coverPosition !== t) switch (t) {
                    case "top":
                        this.$container.removeClass([Uc.coverBottom, Uc.coverFixed].join(" ")), this.trigger("side_scroller_position_top");
                        break;
                    case "fixed":
                        this.$container.removeClass(Uc.coverBottom).addClass(Uc.coverFixed), this.trigger("side_scroller_position_fixed");
                        break;
                    case "bottom":
                        this.$container.removeClass(Uc.coverFixed).addClass(Uc.coverBottom), this.trigger("side_scroller_position_bottom")
                }
                this.coverPosition = t
            },
            _updateBackgroundColor: function(t) {
                var e = Math.floor((t - this.featuresOffset.top + this.windowHeight / 2) / this.slideHeight);
                this.currentBackgroundIndex = this.currentBackgroundIndex || 0, e !== this.currentBackgroundIndex && (this.currentBackgroundIndex = e, this.$slidesContainer.css({
                    backgroundColor: this.$slides.eq(e).data("background-color")
                }))
            },
            _updateCoverPositionValues: function() {
                this.slideHeight = this.$slides.first().height(), this.featuresOffset = this.$container.offset(), this.featuresHeight = this.$container.height(), this.windowHeight = $n(window).innerHeight(), this.windowWidth = $n(window).innerWidth()
            }
        };
    Os.register("featured-slider", {
        onLoad: function() {
            this.coverIsOpen = !1, this.extend(zc), this.extend(Xc), this._toggleViewState(), $n(window).on("resize", je(this._toggleViewState.bind(this)))
        },
        onUnload: function() {
            this._destroyDesktopState(), this._destroyMobileState()
        },
        onDeselect: function() {
            this.mobileViewEnabled && this.closeCover()
        },
        onBlockSelect: function(t) {
            this.mobileViewEnabled ? (this.openCover(), this.slider.setSlide($n(t.target).index())) : $n("html, body").animate({
                scrollTop: $n(t.target).offset().top
            }, 400)
        },
        onBlockDeselect: function() {
            this.mobileViewEnabled && this.revealSlider.closeCover()
        },
        _toggleViewState: function() {
            var t, e, n = $n(window).innerWidth();
            void 0 === this.mobileViewEnabled ? (t = n < theme.mediaQuerySmall, e = n >= theme.mediaQuerySmall) : (t = n < theme.mediaQuerySmall && !this.mobileViewEnabled, e = n >= theme.mediaQuerySmall && this.mobileViewEnabled), t && (this.mobileViewEnabled = !0, this._destroyDesktopState(), this._enableMobileState()), e && (this.mobileViewEnabled = !1, this._destroyMobileState(), this._enableDesktopState())
        },
        _enableDesktopState: function() {
            this.initSideScroller()
        },
        _destroyDesktopState: function() {
            void 0 !== this.sideScroller && this.destroySideScroller()
        },
        _enableMobileState: function() {
            this.initRevealSlider()
        },
        _destroyMobileState: function() {
            this.revealSlider && this.destroyRevealSlider()
        }
    });
    var Yc = {
            footerParallax: "site-footer--parallax"
        },
        Qc = {
            contentForLayout: ".content-for-layout",
            footerCover: ".site-footer__drawer-cover "
        };
    Os.register("footer", {
        onLoad: function() {
            this.container.hasAttribute("data-footer-parallax") && (this.window().on("resize", this._setParallax.bind(this)), this.document().on("drawer_open_start", this._handleDrawerOpenState.bind(this)), this.document().on("drawer_close_done", this._resetDrawerOpenState.bind(this)), $n(document.body).addClass(Yc.footerParallax), cs.promiseStylesheet().then(this._setParallax.bind(this)))
        },
        onUnload: function() {
            $n(document.body).removeClass(Yc.footerParallax), $n(Qc.contentForLayout).css("margin-bottom", "")
        },
        _setParallax: function() {
            this.height = this.$container.innerHeight(), $n(Qc.contentForLayout).css("margin-bottom", this.height)
        },
        _handleDrawerOpenState: function() {
            if (document.body.scrollHeight - window.innerHeight == 0) this.$container.css("margin-bottom", document.body.clientHeight - document.body.scrollHeight);
            else {
                var t = document.body.scrollHeight - window.innerHeight - window.scrollY,
                    e = t - this.height;
                this.$container.css("margin-bottom", e), $n(Qc.footerCover).css("height", t).show()
            }
        },
        _resetDrawerOpenState: function() {
            this.$container.css("margin-bottom", ""), $n(Qc.footerCover).hide()
        }
    });
    var Gc = {
            skipLink: ".skip-link",
            navigation: ".navigation",
            navAnimateElements: ".navigation__entrance-animation",
            cartBubble: ".site-header__cart-bubble",
            siteHeader: ".site-header",
            siteHeaderWrapper: ".site-header__wrapper",
            siteHeaderLogo: ".site-header__logo",
            siteHeaderCart: ".site-header__cart",
            navigationButton: ".site-header__navigation",
            navigationExpandSublinks: ".navigation__expand-sublinks",
            navigationSublinks: ".navigation__sublinks",
            navigationHasSublinks: ".navigation__has-sublinks",
            announcementBar: ".announcement-bar",
            announcementBarClose: ".announcement-bar__close"
        },
        Kc = {
            themeEditor: "theme-editor",
            headerFixed: "site-header--fixed",
            headerHomepage: "site-header--homepage",
            cartBubbleVisible: "site-header__cart-bubble--visible",
            bubblePulse: "bubble-pulse",
            drawerActive: "drawer--active",
            navigationOpen: "navigation-open",
            navigationOpenEditor: "navigation-open--editor",
            navigationTransitioning: "navigation--is-transitioning",
            navigationHasSublinksCollapsed: "navigation__has-sublinks--collapsed",
            navigationEntranceActive: "navigation__entrance-animation--active",
            siteHeaderWrapperTransitioning: "site-header__wrapper--transitioning",
            announcementBarVisible: "announcement-bar--visible"
        },
        Jc = !0,
        Zc = !1,
        tu = !1;
    Os.register("header-section", {
        onLoad: function() {
            var t = this.$container = $n(this.container);
            this.scrollTop = 0, this.isFixed = !1, this.headerHeight = 0, this.promiseChain = $n.Deferred().resolve(), $n(Gc.navigationButton).one("click", this._toggleNavigationDisplay.bind(this)).one("click", this._setSublinksMaxHeight.bind(this)), $n(Gc.navigationExpandSublinks, t).on("click", this._toggleNavigationSublinks), $n(Gc.announcementBarClose, t).on("click", this._closeAnnouncementBar.bind(this)), /*$n(document).on("scroll" + this.namespace, Pe(this._toggleHeaderPosition.bind(this), 200)),*/ $n(window).on("resize" + this.namespace, this._adjustNavigationPadding.bind(this)), yc.on("change", this._toggleCartBubble.bind(this)), cs.promiseStylesheet().then(function() {
                this._setupAnnouncementBar()
            }.bind(this))
        },
        onSelect: function() {
            this._adjustNavigationPadding(), tu || (Zc = !0, this.showNavigation())
        },
        onDeselect: function() {
            Zc = !1, setTimeout(function() {
                Zc || (tu = !1, Zc = !1, this.hideNavigation())
            }.bind(this), 100)
        },
        _setupAnnouncementBar: function() {
            var t = $n(Gc.announcementBar, this.$container);
            if (t.length && (!cs.isSessionStorageSupported() || !sessionStorage.getItem("announcement-bar-hidden"))) {
                var e = $n(Gc.siteHeaderWrapper);
                requestAnimationFrame(function() {
                    t.addClass(Kc.announcementBarVisible), e.css("margin-top", "-" + t.outerHeight() + "px"), requestAnimationFrame(function() {
                        e.addClass(Kc.siteHeaderWrapperTransitioning).css("margin-top", "")
                    })
                })
            }
        },
        _closeAnnouncementBar: function(t) {
            if (t.preventDefault(), !Shopify.designMode) {
                var e = $n(Gc.announcementBar),
                    n = $n(Gc.siteHeaderWrapper);
                n.css("margin-top", "-" + e.outerHeight() + "px"), $n(Gc.announcementBarClose).attr("aria-expanded", !1), cs.isSessionStorageSupported() && sessionStorage.setItem("announcement-bar-hidden", !0), cs.promiseTransitionEnd(n).then(function() {
                    e.remove(), n.removeClass(Kc.siteHeaderWrapperTransitioning).css("margin-top", "")
                })
            }
        },
        /*
        _toggleHeaderPosition: function() {
            if (Jc && !this.headerAnimating) {
                var t = $n(document).scrollTop();
                this.headerHeight = this.headerHeight || this.$container.outerHeight(), t <= 0 ? requestAnimationFrame(this._promiseHeaderReset.bind(this)) : t < this.scrollTop && t > 0 && !this.isFixed && !this.isAnimating ? requestAnimationFrame(this._promiseHeaderSlideIn.bind(this)) : t > this.scrollTop && t > this.headerHeight && this.isFixed && !this.isAnimating && requestAnimationFrame(this._promiseHeaderSlideOut.bind(this)), this.scrollTop = t, this._doubleCheckPosition()
            }
        },
        _doubleCheckPosition: function() {
            void 0 === this.doubleCheckDebounced && (this.doubleCheckDebounced = je(function() {
                this.scrollTop = $n(document).scrollTop(), this.scrollTop <= 0 && this._promiseHeaderReset()
            }.bind(this), 500)), this.doubleCheckDebounced()
        },
        _promiseHeaderReset: function() {
            this.promiseChain = this.promiseChain.then(function() {
                this.$container.removeClass(Kc.headerFixed), $n("body").css("padding-top", "")
            }.bind(this))
        },
        */
        /* 1976
        _promiseHeaderSlideIn: function() {
            return this.isFixed = !0, this.headerAnimating = !0, $n(Gc.siteHeaderWrapper).css("transform", "translateY(-100%)"), requestAnimationFrame(function() {
                this.$container.addClass(Kc.headerFixed), this.$container.hasClass(Kc.headerHomepage) || $n("body").css("padding-top", this.headerHeight), requestAnimationFrame(function() {
                    $n(Gc.siteHeaderWrapper).css({
                        transform: "translateY(0%)",
                        transition: "transform 0.25s ease-out"
                    })
                })
            }.bind(this)), cs.promiseTransitionEnd($n(Gc.siteHeaderWrapper)).then(function() {
                this.headerAnimating = !1, $n(Gc.siteHeaderWrapper).attr("style", "")
            }.bind(this))
        },
        */
        _promiseHeaderSlideOut: function() {
            return this.isFixed = !1, this.headerAnimating = !0, $n(Gc.siteHeaderWrapper).css({
                transform: "translateY(-100%)",
                transition: "transform 0.25s ease-out"
            }), cs.promiseTransitionEnd($n(Gc.siteHeaderWrapper)).then(function() {
                this.headerAnimating = !1, $n(Gc.siteHeaderWrapper).attr("style", ""), $n("body").css("padding-top", ""), this.$container.removeClass(Kc.headerFixed)
            }.bind(this))
        },
        _toggleCartBubble: function(t, e) {
            var n = $n(Gc.cartBubble, this.$container);
            n.toggleClass(Kc.cartBubbleVisible, 0 !== e.items.length), $n("body").hasClass(Kc.drawerActive) || (n.addClass(Kc.bubblePulse), cs.promiseAnimationEnd(n).then(function() {
                n.removeClass(Kc.bubblePulse)
            }))
        },
        showNavigation: function() {
            return $n(document.body).hasClass(Kc.navigationOpen) || (Jc = !1, this._adjustNavigationPadding(), cs.enableTabbingOfChildren(Gc.navigation), $n(Gc.navigation).attr("aria-hidden", !1), $n(Gc.siteHeaderLogo).attr("tabindex", "-1"), $n(Gc.siteHeaderCart).attr("tabindex", "-1"), $n(Gc.skipLink).attr("tabindex", "-1"), this.promiseChain = this.promiseChain.then(this._promiseNavTransition.bind(this, !0)).then(this._promiseNavItemsTransition.bind(this, $n(Gc.navAnimateElements, this.$container).toArray(), !0)).then(function() {
                $n(document).on("keyup" + this.namespace, this._closeOnEscape.bind(this)), $n(Gc.navigationButton).attr("aria-expanded", !0).off().one("click", this._toggleNavigationDisplay.bind(this))
            }.bind(this))), this.promiseChain.then(function() {
                Shopify.designMode && $n(document.body).addClass(Kc.navigationOpenEditor)
            })
        },
        hideNavigation: function() {
            if ($n(document.body).hasClass(Kc.navigationOpen)) {
                var t = $n(Gc.navAnimateElements, this.$container);
                cs.disableTabbingOfChildren(Gc.navigation), $n(Gc.navigation).attr("aria-hidden", !0), $n(Gc.siteHeaderLogo).attr("tabindex", ""), $n(Gc.siteHeaderCart).attr("tabindex", ""), $n(Gc.skipLink).attr("tabindex", ""), Shopify.designMode && ($n(document.body).removeClass(Kc.navigationOpenEditor), t.addClass(Kc.navigationEntranceActive)), this.promiseChain = this.promiseChain.then(this._promiseNavItemsTransition.bind(this, t.toArray().reverse(), !1)).then(this._promiseNavTransition.bind(this, !1)).then(function() {
                    Jc = !0, $n(document).off("keyup" + this.namespace), $n(Gc.navigationButton).off().one("click", this._toggleNavigationDisplay.bind(this)).attr("aria-expanded", !1).focus()
                }.bind(this))
            }
            return this.promiseChain
        },
        _toggleNavigationDisplay: function() {
            tu = !0, $n(document.body).hasClass(Kc.navigationOpen) ? this.hideNavigation() : this.showNavigation()
        },
        _adjustNavigationPadding: function() {
            this.headerHeight = $n(Gc.siteHeader).height(), $n(Gc.navigation, this.$container).css("padding-top", this.headerHeight + "px")
        },
        _promiseNavTransition: function(t) {
            return $n(document.body).addClass(Kc.navigationTransitioning).toggleClass(Kc.navigationOpen, t), $n(window).scrollTop(this.scrollTop), cs.promiseTransitionEnd($n(Gc.navigation, this.$container)).then(function() {
                $n(document.body).removeClass(Kc.navigationTransitioning)
            })
        },
        _promiseNavItemsTransition: function(t, e) {
            return cs.mapPromiseSeries(t, function(t, n) {
                var i = $n(n);
                return i.toggleClass(Kc.navigationEntranceActive, e), cs.promiseTransitionEnd(i)
            })
        },
        _closeOnEscape: function(t) {
            27 === t.keyCode && this.hideNavigation()
        },
        _toggleNavigationSublinks: function() {
            var t = $n(this),
                e = t.parent(),
                n = "true" === t.attr("aria-expanded");
            e.toggleClass(Kc.navigationHasSublinksCollapsed), e.siblings(Gc.navigationHasSublinks).addClass(Kc.navigationHasSublinksCollapsed).children(Gc.navigationExpandSublinks).attr("aria-expanded", !1), t.attr("aria-expanded", !n)
        },
        _setSublinksMaxHeight: function() {
            $n(Gc.navigationSublinks, this.$container).each(function() {
                var t = $n(this),
                    e = t.parent(),
                    n = t.outerHeight();
                e.css("max-height", n)
            })
        }
    }), Os.register("list-collections-template", {
        onLoad: function() {
            this.extend(ac)
        }
    });
    var eu, nu = {
            zeroResults: theme.strings.map && theme.strings.map.zeroResults,
            overQueryLimit: theme.strings.map && theme.strings.map.overQueryLimit,
            authError: theme.strings.map && theme.strings.map.authError,
            requestDenied: theme.strings.map && theme.strings.map.addressError,
            geocodeUnknownError: theme.strings.map && theme.strings.map.addressError,
            missingKey: theme.strings.map && theme.strings.map.addressError,
            apiLoadError: theme.strings.map && theme.strings.map.addressError
        },
        iu = {
            promiseAPI: function() {
                var t = theme.googleMapsKey || "";
                return void 0 === eu && (eu = $n.getScript("https://maps.googleapis.com/maps/api/js?key=" + t)), window.gm_authFailure = function() {
                    throw Error(nu.authError)
                }, eu.then(function() {
                    return $n.Deferred(function(t) {
                        window.google && window.google.maps || t.reject(nu.apiLoadError), t.resolve(window.google)
                    })
                })
            },
            promiseGeocode: function(t) {
                return this.promiseAPI().then(function(e) {
                    return $n.Deferred(function(n) {
                        (new e.maps.Geocoder).geocode({
                            address: t
                        }, function(t, i) {
                            i !== e.maps.GeocoderStatus.OK && n.reject(i), n.resolve(t)
                        })
                    })
                }).catch(function(t) {
                    return $n.Deferred().reject(Tn(t))
                })
            },
            promiseMap: function(t) {
                return $n.when(this.promiseAPI(), this.promiseGeocode(t.address)).then(function(e, n) {
                    var i = n[0].geometry.location,
                        r = $n.extend({}, {
                            zoom: 14,
                            center: i,
                            disableDefaultUI: !0
                        }, t),
                        o = new e.maps.Map(t.container, r);
                    return o.centerMarker = new e.maps.Marker({
                        map: o,
                        position: o.getCenter()
                    }), e.maps.event.addDomListener(window, "resize", je(function() {
                        e.maps.event.trigger(o, "resize"), o.setCenter(i)
                    }, 250)), o
                })
            }
        },
        ru = {
            map: ".map-section__container",
            mapError: ".map-section__error-message"
        },
        ou = {
            mapError: "map-section--load-error"
        };
    Os.register("map", {
        onLoad: function() {
            this.$container = $n(this.container), this.$map = $n(ru.map, this.$container);
            var t = {
                container: this.$map[0],
                address: this.$map.data("address-setting")
            };
            iu.promiseMap(t).then(function(t) {
                this.map = t
            }.bind(this)).catch(function(t) {
                this.$container.addClass(ou.mapError), $n(ru.mapError, this.$container).text(t)
            }.bind(this))
        }
    });
    var su = {
            emailField: "#EmailField",
            submitButton: ".btn--newsletter__submit",
            newsletterMessage: ".newsletter__message"
        },
        au = {
            blankError: theme.strings.newsletter && theme.strings.newsletter.blankError,
            invalidError: theme.strings.newsletter && theme.strings.newsletter.invalidError
        };
    Os.register("newsletter", {
        onLoad: function() {
            this.$container = $n(this.container), this.$container.on("click", su.submitButton, this._checkEmail.bind(this))
        },
        _checkEmail: function() {
            var t, e = su.emailField + this.$container.data("section-id"),
                n = $n(e, this.$container),
                i = $n(su.newsletterMessage, this.$container),
                r = n[0].value,
                o = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            if ("" == r) var t = au.blankError;
            else if (!o.test(r)) var t = au.invalidError;
            if (void 0 !== t) return i.html('<p class="errors">' + t + "</p>"), !1;
            i.html("")
        }
    });
    var cu = {
            lazypreload: "lazypreload",
            showProductSlideshow: "product-slideshow--show",
            productSlideshowSelectActive: "product-slideshow__slide-select--active"
        },
        uu = {
            slider: ".slider",
            productSlideshow: ".product-slideshow",
            productSlideshowOpen: ".product-slideshow__open",
            productSlideshowSlide: "[data-product-slideshow-slide]",
            productSlideshowImage: "[data-product-slideshow-image]",
            productSlideshowNext: "[data-product-slideshow-next]",
            productSlideshowSelect: "[data-product-slideshow-select]",
            productSlideshowPrevious: "[data-product-slideshow-previous]",
            productSlideshowClose: "[data-product-slideshow-close]"
        },
        lu = {
            init: function() {
                this.$productSlideshow = $n(uu.productSlideshow, this.$container), 0 !== this.$productSlideshow.length && ($n(uu.productSlideshowOpen).on("click", this._onImageClick.bind(this)), this.$productSlideshow.appendTo(document.body), this.slideCount = $n(uu.productSlideshowSlide, this.$productSlideshow).length, this.slideCount > 1 && (this.slider = new Cn($n(uu.slider, this.$productSlideshow))))
            },
            showSlideshow: function() {
                return this.trigger("product_slideshow_show"), this.$slideshowOpenFocus = $n(document.activeElement), $n(uu.productSlideshowImage, this.$productSlideshow).addClass(cu.lazypreload), Os.getInstances("header-section").then(function(t) {
                    t[0].scrollHandler = !1, this._assignEventHandlers(), Ts.trapFocus({
                        $container: this.$productSlideshow,
                        namespace: "product-slideshow"
                    }), this.$productSlideshow.addClass(cu.showProductSlideshow).attr("aria-hidden", !1), cs.disableScrollBody(), cs.enableTabbingOfChildren(this.$productSlideshow)
                }.bind(this))
            },
            hideSlideshow: function() {
                return this.trigger("product_slideshow_hide"), Os.getInstances("header-section").then(function(t) {
                    t[0].scrollHandler = !0, this._removeEventHandlers(), Ts.removeTrapFocus({
                        namespace: "product-slideshow"
                    }), cs.enableScrollBody(), cs.disableTabbingOfChildren(this.$productSlideshow), this.$productSlideshow.removeClass(cu.showProductSlideshow).attr("aria-hidden", !0), this.$slideshowOpenFocus.focus()
                }.bind(this))
            },
            setSlide: function(t) {
                if (!(this.slideCount <= 1)) {
                    var e = this._getSlideIndex(t);
                    return this.trigger("product_slideshow_set_slide", [e]), this.slider.setSlide(e)
                }
            },
            _onImageClick: function(t) {
                t.preventDefault();
                var e = $n(t.currentTarget).data("id");
                "number" == typeof e && (this.setSlide(e), this.showSlideshow())
            },
            _assignEventHandlers: function() {
                $n(document).one("keyup.product-slideshow", this._onKeyup.bind(this)), this.$productSlideshow.on("slidetransitionend", this._setSlideIndicator.bind(this)).on("click", uu.productSlideshowSelect, this._setSlide.bind(this)).one("click", uu.productSlideshowClose, this.hideSlideshow.bind(this)).one("click", uu.productSlideshowNext, this._nextSlide.bind(this)).one("click", uu.productSlideshowPrevious, this._previousSlide.bind(this))
            },
            _removeEventHandlers: function() {
                this.$productSlideshow.off(), $n(document).off(".product-slideshow")
            },
            _getSlideIndex: function(t) {
                return $n(uu.productSlideshowSlide, this.$productSlideshow).filter('[data-id="' + t + '"]').index()
            },
            _setSlide: function(t) {
                var e = $n(t.target),
                    n = e.index();
                this.trigger("product_slideshow_set_slide", [n]), this.slider.setSlide(n, !0)
            },
            _nextSlide: function() {
                return this.trigger("product_slideshow_next"), this.trigger("product_slideshow_set_slide", [this.slider.$nextSlide.index()]), this.slider.nextSlide().then(function() {
                    this.$productSlideshow.one("click", uu.productSlideshowNext, this._nextSlide.bind(this))
                }.bind(this))
            },
            _previousSlide: function() {
                return this.trigger("product_slideshow_previous"), this.trigger("product_slideshow_set_slide", [this.slider.$previousSlide.index()]), this.slider.previousSlide().then(function() {
                    this.$productSlideshow.one("click", uu.productSlideshowPrevious, this._previousSlide.bind(this))
                }.bind(this))
            },
            _setSlideIndicator: function(t, e) {
                var n = e.$currentSlide.index();
                $n(uu.productSlideshowSelect, this.$productSlideshow).eq(n).addClass(cu.productSlideshowSelectActive).siblings().removeClass(cu.productSlideshowSelectActive)
            },
            _onKeyup: function(t) {
                var e = $n.Deferred().resolve();
                switch (t.keyCode) {
                    case 37:
                        e = this.slider.previousSlide();
                        break;
                    case 39:
                        e = this.slider.nextSlide();
                        break;
                    case 27:
                        this.hideSlideshow(), e = $n.Deferred().reject()
                }
                e.then(function() {
                    $n(document).one("keyup", this._onKeyup.bind(this))
                }.bind(this))
            }
        },
        du = {
            productFormWrapper: ".product__form-wrapper",
            productDescription: ".product__description"
        },
        hu = {
            productFormFixed: "product__form-wrapper--fixed",
            productFormBottom: "product__form-wrapper--bottom"
        };
    Os.register("product-template", {
        onLoad: function() {
            this.coverPosition = "top", this.extend(lu), this.extend(ys), this.extend(Ic), this.window().on("scroll", this._setFormPosition.bind(this)), this.window().on("resize", this._updateMeasurements.bind(this)), this.on("variant_add_to_cart", this._updateMeasurements.bind(this)), this.on("variant_change", this._updateHistoryState.bind(this)), this.document().on("drawer_open_start", this._handleFixedSideImage.bind(this)), this.document().on("drawer_close_done", this._resetFixedSideImage.bind(this)), cs.promiseStylesheet().then(function() {
                this._updateMeasurements()
            }.bind(this))
        },
        _handleFixedSideImage: function() {
            if ("fixed" === this.coverPosition) {
                var t = $(window).scrollTop(),
                    e = t - this.fixedTop + 160 + 28;
                $(du.productFormWrapper, this.$container).css({
                    transform: "translateY(" + e + "px)",
                    position: "absolute"
                })
            }
        },
        _resetFixedSideImage: function() {
            "fixed" === this.coverPosition && $(du.productFormWrapper, this.$container).css({
                transform: "",
                position: ""
            })
        },
        _updateHistoryState: function(t, e, n, i) {
            if (history.replaceState) {
                var r = window.location.protocol + "//" + window.location.host + window.location.pathname + "?variant=" + i.id;
                window.history.replaceState({
                    path: r
                }, "", r)
            }
        },
        _setFormPosition: function() {
            if (!cs.isMobile() && this.enableSticky) {
                var t = $(window).scrollTop();
                requestAnimationFrame(function() {
                    t > this.fixedTop ? t > this.fixedBottom ? (this.coverPosition = "bottom", $(du.productFormWrapper).css("width", this.formWidth).removeClass(hu.productFormFixed).addClass(hu.productFormBottom)) : (this.coverPosition = "fixed", $(du.productFormWrapper).css("width", this.formWidth).addClass(hu.productFormFixed).removeClass(hu.productFormBottom)) : (this.coverPosition = "top", $(du.productFormWrapper).css("width", "").removeClass(hu.productFormFixed).removeClass(hu.productFormBottom))
                }.bind(this))
            }
        },
        _updateMeasurements: function() {
            var t = $(du.productFormWrapper),
                e = $(du.productDescription).outerHeight(!0),
                n = t.height();
            this.enableSticky = e > n, this.enableSticky && (this.fixedTop = t.parent().offset().top - 80, this.fixedBottom = this.fixedTop + e - n, this.formWidth = t.parent().width(), this._setFormPosition())
        }
    });
    var fu = {
            slider: ".quotes-slider",
            slide: ".quotes-slide"
        },
        pu = {
            visible: "quotes-slide--visible"
        };
    Os.register("quotes-section", {
        onLoad: function() {
            this.$container = $n(this.container), this.$slider = $n(fu.slider, this.$container), this.totalSlides = this.$slider.data("count"), this.speed = this.$slider.data("speed"), this.currentSlide = 0, this.$slider.find(fu.slide).length > 1 && this._startSlider()
        },
        _startSlider: function() {
            this.interval = setInterval(function() {
                this.currentSlide + 1 >= this.totalSlides ? this.currentSlide = 0 : this.currentSlide++, this._showSlide(fu.slide + "--" + this.currentSlide)
            }.bind(this), this.speed)
        },
        _showSlide: function(t) {
            this.$slider.find(fu.slide).removeClass(pu.visible).end().find(t).addClass(pu.visible)
        },
        onBlockSelect: function(t) {
            clearInterval(this.interval);
            var e = this.$container.find(fu.slide + "--" + t.detail.blockId);
            this._showSlide(e)
        },
        onBlockDeselect: function() {
            this._startSlider()
        }
    }), Os.register("search-template", {
        onLoad: function() {
            this.extend(ac)
        }
    });
    var mu, gu, vu = {
            promiseAPI: function() {
                if (!mu) {
                    var t = document.createElement("script");
                    t.src = "https://www.youtube.com/iframe_api";
                    var e = document.getElementsByTagName("script")[0];
                    e.parentNode.insertBefore(t, e), mu = $n.Deferred(function(t) {
                        window.onYouTubeIframeAPIReady = t.resolve, setTimeout(function() {
                            t.reject("Request for YouTube API timed out after 30 seconds.")
                        }, 3e4)
                    })
                }
                return mu
            },
            promisePlayer: function(t, e) {
                return this.promiseAPI().then(function() {
                    return $n.Deferred(function(n) {
                        void 0 === window.YT && n.reject("We're sorry, something went wrong. The YouTube API has not loaded correctly.");
                        var i = new YT.Player(t, e);
                        i.addEventListener("onReady", function() {
                            n.resolve(i)
                        }), setTimeout(function() {
                            n.reject("Request for YouTube player has timed out after 30 seconds.")
                        }, 3e4)
                    })
                })
            }
        },
        yu = {
            promiseAPI: function() {
                return gu || (gu = $n.Deferred(function(t) {
                    var e = document.createElement("script");
                    e.src = "https://player.vimeo.com/api/player.js", e.onload = e.onreadystatechange = function() {
                        this.readyState && "complete" !== this.readyState || t.resolve()
                    };
                    var n = document.getElementsByTagName("script")[0];
                    n.parentNode.insertBefore(e, n), setTimeout(function() {
                        t.reject("Request for Vimeo API timed out after 30 seconds.")
                    }, 3e4)
                })), gu
            },
            promisePlayer: function(t, e) {
                return this.promiseAPI().then(function() {
                    return $n.Deferred(function(n) {
                        void 0 === window.Vimeo && n.reject("We're sorry, something went wrong. The Vimeo API has not loaded correctly.");
                        var i = new window.Vimeo.Player(t, e);
                        setTimeout(function() {
                            n.reject("Request for Vimeo player has timed out after 30 seconds.")
                        }, 3e4), i.ready().then(function() {
                            n.resolve(i)
                        })
                    })
                })
            }
        },
        bu = {
            buttons: ".slideshow__buttons",
            button: ".slideshow__button",
            label: ".slideshow__button-label",
            cta: ".slideshow__button-cta--desktop",
            slide: ".slideshow__slide",
            slideshow: ".slideshow",
            video: ".slideshow__video"
        },
        _u = {
            buttonActive: "slideshow__button--active",
            linkActive: "slideshow__button--link",
            slideActive: "slideshow__slide--active",
            slideActiveTransitioning: "slideshow__slide--transitioning",
            videoLoaded: "slideshow__video--loaded"
        },
        wu = {
            easeIntensity: 10
        },
        Su = {
            initDesktopSlideshow: function() {
                this.trigger("slideshow_desktop_init_start"), this.$slide = $n(bu.slide, this.$container), this.$buttons = $n(bu.buttons, this.$container), this.$button = $n(bu.button, this.$container), this.desktopSlideshow = !0, this.isAnimating = !1, this.currentDesktopSlide = 0, this.totalSlides = this.$buttons.data("count"), this.players = [], this.desktopSlideshowNamespace = ".desktopSlideshow", this.on("mouseover" + this.desktopSlideshowNamespace, this._onHoverSlideshow.bind(this)), this.on("mousemove" + this.desktopSlideshowNamespace, this._mouseMoveButtons.bind(this)), this.on("mouseleave" + this.desktopSlideshowNamespace, this._resetButtonsPosition.bind(this)), this.on("click" + this.desktopSlideshowNamespace, bu.label, this._onClickButton.bind(this)), this.on("keydown" + this.desktopSlideshowNamespace, this._addKeyBindings.bind(this)), this.window().on("resize" + this.desktopSlideshowNamespace, this._setButtonWrapperValues.bind(this)), cs.promiseStylesheet().then(function() {
                    this._setButtonWrapperValues(), this._setSlideDesktop(0), this.trigger("slideshow_desktop_init_done")
                }.bind(this))
            },
            destroyDesktopSlideshow: function() {
                this.trigger("slideshow_desktop_destroy"), this.desktopSlideshow = !1,
                    this.off(this.desktopSlideshowNamespace), this.window().off(this.desktopSlideshowNamespace), this._setButtonsTranslateX(0);
                for (var t in this.players) {
                    if (!this.players.hasOwnProperty(t)) return;
                    var e = this.players[t];
                    "function" == typeof e.destroy ? e.destroy() : "function" == typeof e.unload && e.unload()
                }
                this.players = []
            },
            _onHoverSlideshow: function() {
                this._animateButtonFrame()
            },
            _mouseMoveButtons: function(t) {
                this.totalSlides <= 3 || (this.mousePosition = t.pageX - this.centerOfButtonsWrapper, this.isAnimating || (this.isAnimating = !0, this._animateButtonFrame()))
            },
            _resetButtonsPosition: function() {
                this.mousePosition = 0
            },
            _onClickButton: function(t) {
                var e = $n(t.target).parent(),
                    n = e.index();
                this._setButtonStatus(n), this._setSlideDesktop(n)
            },
            _setButtonStatus: function(t) {
                var e = this.$button.eq(t);
                this.$button.removeClass(_u.buttonActive).find(bu.label).attr("aria-expanded", !1), e.addClass(_u.buttonActive).find(bu.label).attr("aria-expanded", !0).focus(), this.$button.find(bu.cta).attr("tabindex", "-1"), e.hasClass(_u.linkActive) && e.find(bu.cta).attr("tabindex", "0")
            },
            _animateButtonFrame: function() {
                var t = this.mousePosition - this.xPosition,
                    e = this.buttonsInnerWidth / this.buttonsWrapperWidth - 1;
                if (Math.abs(t) < 1) return void(this.isAnimating = !1);
                this.xPosition += t / wu.easeIntensity, this._setButtonsTranslateX(-this.xPosition * e), requestAnimationFrame(this._animateButtonFrame.bind(this))
            },
            _setButtonsTranslateX: function(t) {
                this.$buttons.css({
                    transform: "translate3d(" + t + "px, 0, 0)"
                })
            },
            _addKeyBindings: function(t) {
                37 === t.which ? this._previousSlideDesktop() : 39 === t.which && this._nextSlideDesktop()
            },
            _previousSlideDesktop: function() {
                0 !== this.currentDesktopSlide && this._setSlideDesktop(this.currentDesktopSlide - 1)
            },
            _nextSlideDesktop: function() {
                this.currentDesktopSlide !== this.totalSlides - 1 && this._setSlideDesktop(this.currentDesktopSlide + 1)
            },
            _setSlideDesktop: function(t) {
                var e = this.$slide.eq(this.currentDesktopSlide),
                    n = this.$slide.eq(t),
                    i = n.find(bu.video);
                i.length && this._loadVideo(i, n), this.currentDesktopSlide !== t && (n.addClass(_u.slideActive).attr("aria-hidden", !1), e.addClass(_u.slideActiveTransitioning), cs.promiseTransitionEnd(n).then(function() {
                    e.removeClass(_u.slideActive).removeClass(_u.slideActiveTransitioning).attr("aria-hidden", !0)
                }), this._setButtonStatus(t), this.currentDesktopSlide = t, this.trigger("slideshow_set_slide", [t]), this.currentDesktopSlide - 1 >= 0 && this.trigger("slideshow_previous_slide", [t - 1]), this.currentDesktopSlide + 1 < this.totalSlides && this.trigger("slideshow_next_slide", [t + 1]))
            },
            _loadVideo: function(t, e) {
                return this.$video = t, this.trigger("slideshow_video_load", [t[0]]), this._promiseVideo().then(function() {
                    e.addClass(_u.videoLoaded), this.trigger("slideshow_video_loaded", [t[0]])
                }.bind(this))
            },
            _promiseVideo: function() {
                var t, e = this.$video.attr("data-video-type");
                return "youtube" === e ? (t = this._loadYoutubePlayer(), this.$video.attr("tabindex", "-1")) : "vimeo" === e && (t = this._loadVimeoPlayer(), this.$video.find("iframe").attr("tabindex", "-1")), t
            },
            _loadYoutubePlayer: function() {
                var t = this.$video.attr("data-video-id");
                return vu.promisePlayer(this.$video[0], {
                    videoId: t,
                    ratio: 16 / 9,
                    playerVars: {
                        iv_load_policy: 3,
                        modestbranding: 1,
                        autoplay: 0,
                        controls: 0,
                        showinfo: 0,
                        wmode: "opaque",
                        branding: 0,
                        autohide: 0,
                        rel: 0
                    },
                    events: {
                        onStateChange: function(e) {
                            0 === e.data && this.players[t].seekTo(0)
                        }.bind(this)
                    }
                }).then(function(e) {
                    return this.players[t] = e, e.playVideo().mute(), $n.Deferred(function(t) {
                        e.addEventListener("onStateChange", function(e) {
                            1 === e.data && t.resolve()
                        })
                    })
                }.bind(this))
            },
            _loadVimeoPlayer: function() {
                var t = this.$video.attr("data-video-id");
                return yu.promisePlayer(this.$video[0], {
                    id: t,
                    loop: !0,
                    playbar: !1
                }).then(function(e) {
                    return this.players[t] = e, e.play(), e.setVolume(0), $n.Deferred(function(t) {
                        e.on("timeupdate", function(n) {
                            n.percent <= 0 || (e.off("timeupdate"), t.resolve())
                        })
                    })
                }.bind(this))
            },
            _setButtonWrapperValues: function() {
                this.mousePosition = 0, this.xPosition = 0, this.buttonsWrapperWidth = this.$container.outerWidth(), this.buttonsInnerWidth = this.$button.first().width() * this.totalSlides, this.centerOfButtonsWrapper = this.buttonsWrapperWidth / 2, this._setButtonsTranslateX(0)
            }
        },
        xu = {
            button: ".slideshow__button",
            buttons: ".slideshow__buttons",
            cta: ".slideshow__button-cta--mobile",
            label: ".slideshow__button-label",
            nextButton: ".slideshow__button--next",
            previousButton: ".slideshow__button--previous",
            slide: ".slideshow__slide",
            slideshow: ".slideshow",
            slideNavButtons: ".slideshow__nav-dot"
        },
        Cu = {
            buttonActive: "slideshow__button--active",
            dotActive: "slideshow__nav-dot--active",
            linkActive: "slideshow__button--link",
            slideActive: "slideshow__slide--active",
            slideActiveTransitioning: "slideshow__slide--transitioning"
        },
        Tu = {
            initMobileSlideshow: function() {
                this.trigger("slideshow_mobile_init_start"), this.$buttons = $n(xu.buttons, this.$container), this.$button = $n(xu.button, this.$container), this.mobileSlideshow = !0, this.currentMobileSlide = 0, this.totalSlides = this.$buttons.data("count"), this.xPosition = 0, this.mobileSlideshowNamespace = ".mobileSlideshow", this.on("click" + this.mobileSlideshowNamespace, xu.slideNavButtons, this._onClickNavDot.bind(this)), this.on("click" + this.mobileSlideshowNamespace, xu.previousButton, this._previousSlideMobile.bind(this)), this.on("click" + this.mobileSlideshowNamespace, xu.nextButton, this._nextSlideMobile.bind(this)), this.totalSlides > 1 && (this.hammertime = new Bc(this.$container[0]), this.hammertime.on("swipeleft", this._nextSlideMobile.bind(this)).on("swiperight", this._previousSlideMobile.bind(this))), this._setA11ySettings(0), this.$button.first().addClass(Cu.buttonActive), cs.promiseStylesheet().then(function() {
                    this._setSlideMobile(0), this.trigger("slideshow_mobile_init_done")
                }.bind(this))
            },
            destroyMobileSlideshow: function() {
                this.trigger("slideshow_mobile_destroy"), this.mobileSlideshow = !1, this.$container.off(this.mobileSlideshowNamespace), this.totalSlides > 1 && this.hammertime.destroy()
            },
            _onClickNavDot: function(t) {
                var e = $n(t.target),
                    n = e.index();
                this._setSlideMobile(n)
            },
            _previousSlideMobile: function() {
                0 !== this.currentMobileSlide && this._setSlideMobile(this.currentMobileSlide - 1)
            },
            _nextSlideMobile: function() {
                this.currentMobileSlide !== this.totalSlides - 1 && this._setSlideMobile(this.currentMobileSlide + 1)
            },
            _setSlideMobile: function(t) {
                this.currentMobileSlide !== t && (this.xPosition = 50 * t, this.$buttons.css({
                    transform: "translate3d(-" + this.xPosition + "%, 0, 0)"
                }), this._setActiveStates(t), this._setA11ySettings(t), this.currentMobileSlide = t, this.trigger("slideshow_set_slide", [t]), this.currentMobileSlide - 1 >= 0 && this.trigger("slideshow_previous_slide", [t - 1]), this.currentMobileSlide + 1 < this.totalSlides && this.trigger("slideshow_next_slide", [t + 1]))
            },
            _setActiveStates: function(t) {
                this.$slide = this.$slide || $n(xu.slide, this.$container), this.$button = this.$button || $n(xu.button, this.$container), this.$dot = this.$dot || $n(xu.slideNavButtons, this.$container);
                var e = this.$slide.eq(this.currentMobileSlide),
                    n = this.$slide.eq(t);
                n.addClass(Cu.slideActive).attr("aria-hidden", !1), e.addClass(Cu.slideActiveTransitioning), cs.promiseTransitionEnd(n).then(function() {
                    e.removeClass(Cu.slideActive).removeClass(Cu.slideActiveTransitioning).attr("aria-hidden", !0)
                }), this.$button.removeClass(Cu.buttonActive), this.$button.eq(t).addClass(Cu.buttonActive), this.$dot.removeClass(Cu.dotActive), this.$dot.eq(t).addClass(Cu.dotActive)
            },
            _setA11ySettings: function(t) {
                var e = this.$button.eq(t);
                this.$label = this.$label || this.$button.find(xu.label), this.$cta = this.$cta || this.$button.find(xu.cta), this.$label.attr("tabindex", "-1"), this.$cta.attr("tabindex", "-1"), e.hasClass(Cu.linkActive) && this.$cta.eq(t).attr("tabindex", "0")
            }
        },
        ku = {
            button: ".slideshow__button",
            slide: ".slideshow__slide"
        },
        $u = {
            buttonActive: "slideshow__button--active",
            slideActive: "slideshow__slide--active"
        };
    Os.register("slideshow-section", {
        onLoad: function() {
            this.extend(Su), this.extend(Tu), this._toggleViewState(), this.window().on("resize", this._toggleViewState.bind(this))
        },
        onUnload: function() {
            this._destroyDesktopState(), this._destroyMobileState()
        },
        onBlockSelect: function(t) {
            cs.promiseStylesheet().then(function() {
                var e = $n(t.target).index();
                this.mobileViewEnabled ? this._setSlideMobile(e) : this._setSlideDesktop(e)
            }.bind(this))
        },
        _toggleViewState: function() {
            var t, e, n = $n(window).innerWidth();
            void 0 === this.mobileViewEnabled ? (t = n < theme.mediaQuerySmall, e = n >= theme.mediaQuerySmall) : (t = n < theme.mediaQuerySmall && !this.mobileViewEnabled, e = n >= theme.mediaQuerySmall && this.mobileViewEnabled), t && (this.mobileViewEnabled = !0, this._destroyDesktopState(), this._enableMobileState()), e && (this.mobileViewEnabled = !1, this._destroyMobileState(), this._enableDesktopState())
        },
        _enableDesktopState: function() {
            this.initDesktopSlideshow()
            this.initMobileSlideshow() //1976
        },
        _destroyDesktopState: function() {
            this.desktopSlideshow && (this.destroyDesktopSlideshow(), this._resetSlideshowValues())
        },
        _enableMobileState: function() {
            this.initMobileSlideshow()
        },
        _destroyMobileState: function() {
            //this.mobileSlideshow && (this.destroyMobileSlideshow(), this._resetSlideshowValues()) //1976
        },
        _resetSlideshowValues: function() {
            $n(ku.slide).removeClass($u.slideActive).first().addClass($u.slideActive), $n(ku.button).removeClass($u.buttonActive).first().addClass($u.buttonActive)
        }
    });
    var Eu = {
            loadPlayerButton: ".video-section__load-player-button",
            closePlayerButton: ".video-section__player-close",
            playerContainer: ".video-section__player",
            cover: ".video-section__cover",
            errorMessage: ".video-section__error",
            bodyOverlay: ".video-section__body-overlay"
        },
        Au = {
            playerLoading: "video-section--loading",
            playerLoaded: "video-section--loaded",
            playerError: "video-section--error",
            animateButton: "animated pulse"
        };
    Os.register("video-section", {
        onLoad: function() {
            this.$container = $n(this.container), this.$container.on("click", Eu.loadPlayerButton, this._loadPlayer.bind(this)).on("click", Eu.closePlayerButton, this._closePlayer.bind(this)).on("click", Eu.bodyOverlay, this._closePlayer.bind(this))
        },
        _loadPlayer: function() {
            var t, e = this.$container,
                n = $n(Eu.loadPlayerButton, e),
                i = $n(Eu.playerContainer, e),
                r = this.$container.attr("data-video-type");
            return n.addClass(Au.animateButton), this._scrollToPlayer(e), "youtube" === r ? t = this._loadYoutubePlayer(i[0]) : "vimeo" === r && (t = this._loadVimeoPlayer(i[0])), t.then(this._onPlayerLoadReady.bind(this)).catch(this._onPlayerLoadError.bind(this)).always(function() {
                n.removeClass(Au.animateButton)
            })
        },
        _scrollToPlayer: function(t) {
            var e = t.offset().top,
                n = ($n(window).height() - t.height()) / 2;
            $n("html, body").animate({
                scrollTop: e - n
            }, 400)
        },
        _loadYoutubePlayer: function(t) {
            return vu.promisePlayer(t, {
                videoId: this.$container.attr("data-video-id"),
                ratio: 16 / 9,
                playerVars: {
                    modestbranding: 1,
                    autoplay: 1,
                    showinfo: 0,
                    rel: 0
                }
            }).then(function(t) {
                this.player = t
            }.bind(this))
        },
        _loadVimeoPlayer: function(t) {
            return yu.promisePlayer(t, {
                id: this.$container.attr("data-video-id")
            }).then(function(t) {
                this.player = t, this.player.play()
            }.bind(this))
        },
        _onPlayerLoadReady: function() {
            $n(Eu.closePlayerButton, this.$container).show().focus(), $n(Eu.cover, this.$container).prepareTransition().addClass(Au.playerLoaded), this.$container.addClass(Au.playerLoaded), this._setScrollPositionValues(), $n(document).one("keyup" + this.namespace, this._closeOnEscape.bind(this)).on("scroll" + this.namespace, this._onScroll.bind(this)), $n(window).on("resize" + this.namespace, this._setScrollPositionValues.bind(this))
        },
        _onPlayerLoadError: function(t) {
            this.$container.addClass(Au.playerError), $n(Eu.errorMessage, this.$container).text(t)
        },
        _closeOnEscape: function(t) {
            27 === t.keyCode && (this._closePlayer(), $n(Eu.loadPlayerButton, this.$container).focus())
        },
        _onScroll: function() {
            var t = $n(window).scrollTop();
            (t > this.videoTop + .25 * this.videoHeight || t + this.windowHeight < this.videoBottom - .25 * this.videoHeight) && requestAnimationFrame(this._closePlayer.bind(this))
        },
        _setScrollPositionValues: function() {
            this.videoHeight = this.$container.outerHeight(!0), this.videoTop = this.$container.offset().top, this.videoBottom = this.videoTop + this.videoHeight, this.windowHeight = $n(window).innerHeight()
        },
        _closePlayer: function() {
            $n(Eu.cover, this.$container).prepareTransition().removeClass(Au.playerLoaded), this.$container.removeClass(Au.playerLoaded), $n(Eu.closePlayerButton, this.$container).hide(), "function" == typeof this.player.destroy ? this.player.destroy() : "function" == typeof this.player.unload && this.player.unload(), $n(document).off(this.namespace), $n(window).off(this.namespace)
        }
    }), window.$ = window.jQuery = $n, window.theme.templates = ss, window.theme.sections = Os, $n(document).ready(function() {
        ss.load("*"), Os.load("*")
    })
}();

/*================ Templates ================*/
/**
 * Customer Addresses Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Customer Addresses
 * template.
 *
 * @namespace customerAddresses
 */

theme.customerAddresses = (function() {
  var $newAddressForm = $('#AddressNewForm');

  if (!$newAddressForm.length) {
    return;
  }

  // Initialize observers on address selectors, defined in shopify_common.js
  if (Shopify) {
    new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
      hideElement: 'AddressProvinceContainerNew'
    });
  }

  // Initialize each edit form's country/province selector
  $('.address-country-option').each(function() {
    var formId = $(this).data('form-id');
    var countrySelector = 'AddressCountry_' + formId;
    var provinceSelector = 'AddressProvince_' + formId;
    var containerSelector = 'AddressProvinceContainer_' + formId;

    new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
      hideElement: containerSelector
    });
  });

  // Toggle new/edit address forms
  $('.address-new-toggle').on('click', function() {
    $newAddressForm.toggleClass('hide');
  });

  $('.address-edit-toggle').on('click', function() {
    var formId = $(this).data('form-id');
    $('#EditAddress_' + formId).toggleClass('hide');
  });

  $('.address-delete').on('click', function() {
    var $el = $(this);
    var formId = $el.data('form-id');
    var confirmMessage = $el.data('confirm-message');
    if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
      Shopify.postLink('/account/addresses/' + formId, {parameters: {_method: 'delete'}});
    }
  });
})();

/**
 * Password Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Password template.
 *
 * @namespace password
 */

theme.customerLogin = (function() {
  var config = {
    recoverPasswordForm: '#RecoverPassword',
    hideRecoverPasswordLink: '#HideRecoverPasswordLink'
  };

  if (!$(config.recoverPasswordForm).length) {
    return;
  }

  checkUrlHash();
  resetPasswordSuccess();

  $(config.recoverPasswordForm).on('click', onShowHidePasswordForm);
  $(config.hideRecoverPasswordLink).on('click', onShowHidePasswordForm);

  function onShowHidePasswordForm(evt) {
    evt.preventDefault();
    toggleRecoverPasswordForm();
  }

  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === '#recover') {
      toggleRecoverPasswordForm();
    }
  }

  /**
   *  Show/Hide recover password form
   */
  function toggleRecoverPasswordForm() {
    $('#RecoverPasswordForm').toggleClass('hide');
    $('#CustomerLoginForm').toggleClass('hide');
  }

  /**
   *  Show reset password success message
   */
  function resetPasswordSuccess() {
    var $formState = $('.reset-password-success');

    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return;
    }

    // show success message
    $('#ResetSuccess').removeClass('hide');
  }
})();

/*! Select2 4.0.3 | https://github.com/select2/select2/blob/master/LICENSE.md */!function(a){"function"==typeof define&&define.amd?define(["jquery"],a):"object"==typeof module&&module.exports?module.exports=function(b,c){return void 0===c&&(c="undefined"!=typeof window?require("jquery"):require("jquery")(b)),a(c),c}:a(jQuery)}(function(a){var b=function(){if(a&&a.fn&&a.fn.select2&&a.fn.select2.amd)var b=a.fn.select2.amd;var b;return function(){if(!b||!b.requirejs){b?c=b:b={};var a,c,d;!function(b){function e(a,b){return u.call(a,b)}function f(a,b){var c,d,e,f,g,h,i,j,k,l,m,n=b&&b.split("/"),o=s.map,p=o&&o["*"]||{};if(a&&"."===a.charAt(0))if(b){for(a=a.split("/"),g=a.length-1,s.nodeIdCompat&&w.test(a[g])&&(a[g]=a[g].replace(w,"")),a=n.slice(0,n.length-1).concat(a),k=0;k<a.length;k+=1)if(m=a[k],"."===m)a.splice(k,1),k-=1;else if(".."===m){if(1===k&&(".."===a[2]||".."===a[0]))break;k>0&&(a.splice(k-1,2),k-=2)}a=a.join("/")}else 0===a.indexOf("./")&&(a=a.substring(2));if((n||p)&&o){for(c=a.split("/"),k=c.length;k>0;k-=1){if(d=c.slice(0,k).join("/"),n)for(l=n.length;l>0;l-=1)if(e=o[n.slice(0,l).join("/")],e&&(e=e[d])){f=e,h=k;break}if(f)break;!i&&p&&p[d]&&(i=p[d],j=k)}!f&&i&&(f=i,h=j),f&&(c.splice(0,h,f),a=c.join("/"))}return a}function g(a,c){return function(){var d=v.call(arguments,0);return"string"!=typeof d[0]&&1===d.length&&d.push(null),n.apply(b,d.concat([a,c]))}}function h(a){return function(b){return f(b,a)}}function i(a){return function(b){q[a]=b}}function j(a){if(e(r,a)){var c=r[a];delete r[a],t[a]=!0,m.apply(b,c)}if(!e(q,a)&&!e(t,a))throw new Error("No "+a);return q[a]}function k(a){var b,c=a?a.indexOf("!"):-1;return c>-1&&(b=a.substring(0,c),a=a.substring(c+1,a.length)),[b,a]}function l(a){return function(){return s&&s.config&&s.config[a]||{}}}var m,n,o,p,q={},r={},s={},t={},u=Object.prototype.hasOwnProperty,v=[].slice,w=/\.js$/;o=function(a,b){var c,d=k(a),e=d[0];return a=d[1],e&&(e=f(e,b),c=j(e)),e?a=c&&c.normalize?c.normalize(a,h(b)):f(a,b):(a=f(a,b),d=k(a),e=d[0],a=d[1],e&&(c=j(e))),{f:e?e+"!"+a:a,n:a,pr:e,p:c}},p={require:function(a){return g(a)},exports:function(a){var b=q[a];return"undefined"!=typeof b?b:q[a]={}},module:function(a){return{id:a,uri:"",exports:q[a],config:l(a)}}},m=function(a,c,d,f){var h,k,l,m,n,s,u=[],v=typeof d;if(f=f||a,"undefined"===v||"function"===v){for(c=!c.length&&d.length?["require","exports","module"]:c,n=0;n<c.length;n+=1)if(m=o(c[n],f),k=m.f,"require"===k)u[n]=p.require(a);else if("exports"===k)u[n]=p.exports(a),s=!0;else if("module"===k)h=u[n]=p.module(a);else if(e(q,k)||e(r,k)||e(t,k))u[n]=j(k);else{if(!m.p)throw new Error(a+" missing "+k);m.p.load(m.n,g(f,!0),i(k),{}),u[n]=q[k]}l=d?d.apply(q[a],u):void 0,a&&(h&&h.exports!==b&&h.exports!==q[a]?q[a]=h.exports:l===b&&s||(q[a]=l))}else a&&(q[a]=d)},a=c=n=function(a,c,d,e,f){if("string"==typeof a)return p[a]?p[a](c):j(o(a,c).f);if(!a.splice){if(s=a,s.deps&&n(s.deps,s.callback),!c)return;c.splice?(a=c,c=d,d=null):a=b}return c=c||function(){},"function"==typeof d&&(d=e,e=f),e?m(b,a,c,d):setTimeout(function(){m(b,a,c,d)},4),n},n.config=function(a){return n(a)},a._defined=q,d=function(a,b,c){if("string"!=typeof a)throw new Error("See almond README: incorrect module build, no module name");b.splice||(c=b,b=[]),e(q,a)||e(r,a)||(r[a]=[a,b,c])},d.amd={jQuery:!0}}(),b.requirejs=a,b.require=c,b.define=d}}(),b.define("almond",function(){}),b.define("jquery",[],function(){var b=a||$;return null==b&&console&&console.error&&console.error("Select2: An instance of jQuery or a jQuery-compatible library was not found. Make sure that you are including jQuery before Select2 on your web page."),b}),b.define("select2/utils",["jquery"],function(a){function b(a){var b=a.prototype,c=[];for(var d in b){var e=b[d];"function"==typeof e&&"constructor"!==d&&c.push(d)}return c}var c={};c.Extend=function(a,b){function c(){this.constructor=a}var d={}.hasOwnProperty;for(var e in b)d.call(b,e)&&(a[e]=b[e]);return c.prototype=b.prototype,a.prototype=new c,a.__super__=b.prototype,a},c.Decorate=function(a,c){function d(){var b=Array.prototype.unshift,d=c.prototype.constructor.length,e=a.prototype.constructor;d>0&&(b.call(arguments,a.prototype.constructor),e=c.prototype.constructor),e.apply(this,arguments)}function e(){this.constructor=d}var f=b(c),g=b(a);c.displayName=a.displayName,d.prototype=new e;for(var h=0;h<g.length;h++){var i=g[h];d.prototype[i]=a.prototype[i]}for(var j=(function(a){var b=function(){};a in d.prototype&&(b=d.prototype[a]);var e=c.prototype[a];return function(){var a=Array.prototype.unshift;return a.call(arguments,b),e.apply(this,arguments)}}),k=0;k<f.length;k++){var l=f[k];d.prototype[l]=j(l)}return d};var d=function(){this.listeners={}};return d.prototype.on=function(a,b){this.listeners=this.listeners||{},a in this.listeners?this.listeners[a].push(b):this.listeners[a]=[b]},d.prototype.trigger=function(a){var b=Array.prototype.slice,c=b.call(arguments,1);this.listeners=this.listeners||{},null==c&&(c=[]),0===c.length&&c.push({}),c[0]._type=a,a in this.listeners&&this.invoke(this.listeners[a],b.call(arguments,1)),"*"in this.listeners&&this.invoke(this.listeners["*"],arguments)},d.prototype.invoke=function(a,b){for(var c=0,d=a.length;d>c;c++)a[c].apply(this,b)},c.Observable=d,c.generateChars=function(a){for(var b="",c=0;a>c;c++){var d=Math.floor(36*Math.random());b+=d.toString(36)}return b},c.bind=function(a,b){return function(){a.apply(b,arguments)}},c._convertData=function(a){for(var b in a){var c=b.split("-"),d=a;if(1!==c.length){for(var e=0;e<c.length;e++){var f=c[e];f=f.substring(0,1).toLowerCase()+f.substring(1),f in d||(d[f]={}),e==c.length-1&&(d[f]=a[b]),d=d[f]}delete a[b]}}return a},c.hasScroll=function(b,c){var d=a(c),e=c.style.overflowX,f=c.style.overflowY;return e!==f||"hidden"!==f&&"visible"!==f?"scroll"===e||"scroll"===f?!0:d.innerHeight()<c.scrollHeight||d.innerWidth()<c.scrollWidth:!1},c.escapeMarkup=function(a){var b={"\\":"&#92;","&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;","'":"&#39;","/":"&#47;"};return"string"!=typeof a?a:String(a).replace(/[&<>"'\/\\]/g,function(a){return b[a]})},c.appendMany=function(b,c){if("1.7"===a.fn.jquery.substr(0,3)){var d=a();a.map(c,function(a){d=d.add(a)}),c=d}b.append(c)},c}),b.define("select2/results",["jquery","./utils"],function(a,b){function c(a,b,d){this.$element=a,this.data=d,this.options=b,c.__super__.constructor.call(this)}return b.Extend(c,b.Observable),c.prototype.render=function(){var b=a('<ul class="select2-results__options" role="tree"></ul>');return this.options.get("multiple")&&b.attr("aria-multiselectable","true"),this.$results=b,b},c.prototype.clear=function(){this.$results.empty()},c.prototype.displayMessage=function(b){var c=this.options.get("escapeMarkup");this.clear(),this.hideLoading();var d=a('<li role="treeitem" aria-live="assertive" class="select2-results__option"></li>'),e=this.options.get("translations").get(b.message);d.append(c(e(b.args))),d[0].className+=" select2-results__message",this.$results.append(d)},c.prototype.hideMessages=function(){this.$results.find(".select2-results__message").remove()},c.prototype.append=function(a){this.hideLoading();var b=[];if(null==a.results||0===a.results.length)return void(0===this.$results.children().length&&this.trigger("results:message",{message:"noResults"}));a.results=this.sort(a.results);for(var c=0;c<a.results.length;c++){var d=a.results[c],e=this.option(d);b.push(e)}this.$results.append(b)},c.prototype.position=function(a,b){var c=b.find(".select2-results");c.append(a)},c.prototype.sort=function(a){var b=this.options.get("sorter");return b(a)},c.prototype.highlightFirstItem=function(){var a=this.$results.find(".select2-results__option[aria-selected]"),b=a.filter("[aria-selected=true]");b.length>0?b.first().trigger("mouseenter"):a.first().trigger("mouseenter"),this.ensureHighlightVisible()},c.prototype.setClasses=function(){var b=this;this.data.current(function(c){var d=a.map(c,function(a){return a.id.toString()}),e=b.$results.find(".select2-results__option[aria-selected]");e.each(function(){var b=a(this),c=a.data(this,"data"),e=""+c.id;null!=c.element&&c.element.selected||null==c.element&&a.inArray(e,d)>-1?b.attr("aria-selected","true"):b.attr("aria-selected","false")})})},c.prototype.showLoading=function(a){this.hideLoading();var b=this.options.get("translations").get("searching"),c={disabled:!0,loading:!0,text:b(a)},d=this.option(c);d.className+=" loading-results",this.$results.prepend(d)},c.prototype.hideLoading=function(){this.$results.find(".loading-results").remove()},c.prototype.option=function(b){var c=document.createElement("li");c.className="select2-results__option";var d={role:"treeitem","aria-selected":"false"};b.disabled&&(delete d["aria-selected"],d["aria-disabled"]="true"),null==b.id&&delete d["aria-selected"],null!=b._resultId&&(c.id=b._resultId),b.title&&(c.title=b.title),b.children&&(d.role="group",d["aria-label"]=b.text,delete d["aria-selected"]);for(var e in d){var f=d[e];c.setAttribute(e,f)}if(b.children){var g=a(c),h=document.createElement("strong");h.className="select2-results__group";a(h);this.template(b,h);for(var i=[],j=0;j<b.children.length;j++){var k=b.children[j],l=this.option(k);i.push(l)}var m=a("<ul></ul>",{"class":"select2-results__options select2-results__options--nested"});m.append(i),g.append(h),g.append(m)}else this.template(b,c);return a.data(c,"data",b),c},c.prototype.bind=function(b,c){var d=this,e=b.id+"-results";this.$results.attr("id",e),b.on("results:all",function(a){d.clear(),d.append(a.data),b.isOpen()&&(d.setClasses(),d.highlightFirstItem())}),b.on("results:append",function(a){d.append(a.data),b.isOpen()&&d.setClasses()}),b.on("query",function(a){d.hideMessages(),d.showLoading(a)}),b.on("select",function(){b.isOpen()&&(d.setClasses(),d.highlightFirstItem())}),b.on("unselect",function(){b.isOpen()&&(d.setClasses(),d.highlightFirstItem())}),b.on("open",function(){d.$results.attr("aria-expanded","true"),d.$results.attr("aria-hidden","false"),d.setClasses(),d.ensureHighlightVisible()}),b.on("close",function(){d.$results.attr("aria-expanded","false"),d.$results.attr("aria-hidden","true"),d.$results.removeAttr("aria-activedescendant")}),b.on("results:toggle",function(){var a=d.getHighlightedResults();0!==a.length&&a.trigger("mouseup")}),b.on("results:select",function(){var a=d.getHighlightedResults();if(0!==a.length){var b=a.data("data");"true"==a.attr("aria-selected")?d.trigger("close",{}):d.trigger("select",{data:b})}}),b.on("results:previous",function(){var a=d.getHighlightedResults(),b=d.$results.find("[aria-selected]"),c=b.index(a);if(0!==c){var e=c-1;0===a.length&&(e=0);var f=b.eq(e);f.trigger("mouseenter");var g=d.$results.offset().top,h=f.offset().top,i=d.$results.scrollTop()+(h-g);0===e?d.$results.scrollTop(0):0>h-g&&d.$results.scrollTop(i)}}),b.on("results:next",function(){var a=d.getHighlightedResults(),b=d.$results.find("[aria-selected]"),c=b.index(a),e=c+1;if(!(e>=b.length)){var f=b.eq(e);f.trigger("mouseenter");var g=d.$results.offset().top+d.$results.outerHeight(!1),h=f.offset().top+f.outerHeight(!1),i=d.$results.scrollTop()+h-g;0===e?d.$results.scrollTop(0):h>g&&d.$results.scrollTop(i)}}),b.on("results:focus",function(a){a.element.addClass("select2-results__option--highlighted")}),b.on("results:message",function(a){d.displayMessage(a)}),a.fn.mousewheel&&this.$results.on("mousewheel",function(a){var b=d.$results.scrollTop(),c=d.$results.get(0).scrollHeight-b+a.deltaY,e=a.deltaY>0&&b-a.deltaY<=0,f=a.deltaY<0&&c<=d.$results.height();e?(d.$results.scrollTop(0),a.preventDefault(),a.stopPropagation()):f&&(d.$results.scrollTop(d.$results.get(0).scrollHeight-d.$results.height()),a.preventDefault(),a.stopPropagation())}),this.$results.on("mouseup",".select2-results__option[aria-selected]",function(b){var c=a(this),e=c.data("data");return"true"===c.attr("aria-selected")?void(d.options.get("multiple")?d.trigger("unselect",{originalEvent:b,data:e}):d.trigger("close",{})):void d.trigger("select",{originalEvent:b,data:e})}),this.$results.on("mouseenter",".select2-results__option[aria-selected]",function(b){var c=a(this).data("data");d.getHighlightedResults().removeClass("select2-results__option--highlighted"),d.trigger("results:focus",{data:c,element:a(this)})})},c.prototype.getHighlightedResults=function(){var a=this.$results.find(".select2-results__option--highlighted");return a},c.prototype.destroy=function(){this.$results.remove()},c.prototype.ensureHighlightVisible=function(){var a=this.getHighlightedResults();if(0!==a.length){var b=this.$results.find("[aria-selected]"),c=b.index(a),d=this.$results.offset().top,e=a.offset().top,f=this.$results.scrollTop()+(e-d),g=e-d;f-=2*a.outerHeight(!1),2>=c?this.$results.scrollTop(0):(g>this.$results.outerHeight()||0>g)&&this.$results.scrollTop(f)}},c.prototype.template=function(b,c){var d=this.options.get("templateResult"),e=this.options.get("escapeMarkup"),f=d(b,c);null==f?c.style.display="none":"string"==typeof f?c.innerHTML=e(f):a(c).append(f)},c}),b.define("select2/keys",[],function(){var a={BACKSPACE:8,TAB:9,ENTER:13,SHIFT:16,CTRL:17,ALT:18,ESC:27,SPACE:32,PAGE_UP:33,PAGE_DOWN:34,END:35,HOME:36,LEFT:37,UP:38,RIGHT:39,DOWN:40,DELETE:46};return a}),b.define("select2/selection/base",["jquery","../utils","../keys"],function(a,b,c){function d(a,b){this.$element=a,this.options=b,d.__super__.constructor.call(this)}return b.Extend(d,b.Observable),d.prototype.render=function(){var b=a('<span class="select2-selection" role="combobox"  aria-haspopup="true" aria-expanded="false"></span>');return this._tabindex=0,null!=this.$element.data("old-tabindex")?this._tabindex=this.$element.data("old-tabindex"):null!=this.$element.attr("tabindex")&&(this._tabindex=this.$element.attr("tabindex")),b.attr("title",this.$element.attr("title")),b.attr("tabindex",this._tabindex),this.$selection=b,b},d.prototype.bind=function(a,b){var d=this,e=(a.id+"-container",a.id+"-results");this.container=a,this.$selection.on("focus",function(a){d.trigger("focus",a)}),this.$selection.on("blur",function(a){d._handleBlur(a)}),this.$selection.on("keydown",function(a){d.trigger("keypress",a),a.which===c.SPACE&&a.preventDefault()}),a.on("results:focus",function(a){d.$selection.attr("aria-activedescendant",a.data._resultId)}),a.on("selection:update",function(a){d.update(a.data)}),a.on("open",function(){d.$selection.attr("aria-expanded","true"),d.$selection.attr("aria-owns",e),d._attachCloseHandler(a)}),a.on("close",function(){d.$selection.attr("aria-expanded","false"),d.$selection.removeAttr("aria-activedescendant"),d.$selection.removeAttr("aria-owns"),d.$selection.focus(),d._detachCloseHandler(a)}),a.on("enable",function(){d.$selection.attr("tabindex",d._tabindex)}),a.on("disable",function(){d.$selection.attr("tabindex","-1")})},d.prototype._handleBlur=function(b){var c=this;window.setTimeout(function(){document.activeElement==c.$selection[0]||a.contains(c.$selection[0],document.activeElement)||c.trigger("blur",b)},1)},d.prototype._attachCloseHandler=function(b){a(document.body).on("mousedown.select2."+b.id,function(b){var c=a(b.target),d=c.closest(".select2"),e=a(".select2.select2-container--open");e.each(function(){var b=a(this);if(this!=d[0]){var c=b.data("element");c.select2("close")}})})},d.prototype._detachCloseHandler=function(b){a(document.body).off("mousedown.select2."+b.id)},d.prototype.position=function(a,b){var c=b.find(".selection");c.append(a)},d.prototype.destroy=function(){this._detachCloseHandler(this.container)},d.prototype.update=function(a){throw new Error("The `update` method must be defined in child classes.")},d}),b.define("select2/selection/single",["jquery","./base","../utils","../keys"],function(a,b,c,d){function e(){e.__super__.constructor.apply(this,arguments)}return c.Extend(e,b),e.prototype.render=function(){var a=e.__super__.render.call(this);return a.addClass("select2-selection--single"),a.html('<span class="select2-selection__rendered"></span><span class="select2-selection__arrow" role="presentation"><b role="presentation"></b></span>'),a},e.prototype.bind=function(a,b){var c=this;e.__super__.bind.apply(this,arguments);var d=a.id+"-container";this.$selection.find(".select2-selection__rendered").attr("id",d),this.$selection.attr("aria-labelledby",d),this.$selection.on("mousedown",function(a){1===a.which&&c.trigger("toggle",{originalEvent:a})}),this.$selection.on("focus",function(a){}),this.$selection.on("blur",function(a){}),a.on("focus",function(b){a.isOpen()||c.$selection.focus()}),a.on("selection:update",function(a){c.update(a.data)})},e.prototype.clear=function(){this.$selection.find(".select2-selection__rendered").empty()},e.prototype.display=function(a,b){var c=this.options.get("templateSelection"),d=this.options.get("escapeMarkup");return d(c(a,b))},e.prototype.selectionContainer=function(){return a("<span></span>")},e.prototype.update=function(a){if(0===a.length)return void this.clear();var b=a[0],c=this.$selection.find(".select2-selection__rendered"),d=this.display(b,c);c.empty().append(d),c.prop("title",b.title||b.text)},e}),b.define("select2/selection/multiple",["jquery","./base","../utils"],function(a,b,c){function d(a,b){d.__super__.constructor.apply(this,arguments)}return c.Extend(d,b),d.prototype.render=function(){var a=d.__super__.render.call(this);return a.addClass("select2-selection--multiple"),a.html('<ul class="select2-selection__rendered"></ul>'),a},d.prototype.bind=function(b,c){var e=this;d.__super__.bind.apply(this,arguments),this.$selection.on("click",function(a){e.trigger("toggle",{originalEvent:a})}),this.$selection.on("click",".select2-selection__choice__remove",function(b){if(!e.options.get("disabled")){var c=a(this),d=c.parent(),f=d.data("data");e.trigger("unselect",{originalEvent:b,data:f})}})},d.prototype.clear=function(){this.$selection.find(".select2-selection__rendered").empty()},d.prototype.display=function(a,b){var c=this.options.get("templateSelection"),d=this.options.get("escapeMarkup");return d(c(a,b))},d.prototype.selectionContainer=function(){var b=a('<li class="select2-selection__choice"><span class="select2-selection__choice__remove" role="presentation">&times;</span></li>');return b},d.prototype.update=function(a){if(this.clear(),0!==a.length){for(var b=[],d=0;d<a.length;d++){var e=a[d],f=this.selectionContainer(),g=this.display(e,f);f.append(g),f.prop("title",e.title||e.text),f.data("data",e),b.push(f)}var h=this.$selection.find(".select2-selection__rendered");c.appendMany(h,b)}},d}),b.define("select2/selection/placeholder",["../utils"],function(a){function b(a,b,c){this.placeholder=this.normalizePlaceholder(c.get("placeholder")),a.call(this,b,c)}return b.prototype.normalizePlaceholder=function(a,b){return"string"==typeof b&&(b={id:"",text:b}),b},b.prototype.createPlaceholder=function(a,b){var c=this.selectionContainer();return c.html(this.display(b)),c.addClass("select2-selection__placeholder").removeClass("select2-selection__choice"),c},b.prototype.update=function(a,b){var c=1==b.length&&b[0].id!=this.placeholder.id,d=b.length>1;if(d||c)return a.call(this,b);this.clear();var e=this.createPlaceholder(this.placeholder);this.$selection.find(".select2-selection__rendered").append(e)},b}),b.define("select2/selection/allowClear",["jquery","../keys"],function(a,b){function c(){}return c.prototype.bind=function(a,b,c){var d=this;a.call(this,b,c),null==this.placeholder&&this.options.get("debug")&&window.console&&console.error&&console.error("Select2: The `allowClear` option should be used in combination with the `placeholder` option."),this.$selection.on("mousedown",".select2-selection__clear",function(a){d._handleClear(a)}),b.on("keypress",function(a){d._handleKeyboardClear(a,b)})},c.prototype._handleClear=function(a,b){if(!this.options.get("disabled")){var c=this.$selection.find(".select2-selection__clear");if(0!==c.length){b.stopPropagation();for(var d=c.data("data"),e=0;e<d.length;e++){var f={data:d[e]};if(this.trigger("unselect",f),f.prevented)return}this.$element.val(this.placeholder.id).trigger("change"),this.trigger("toggle",{})}}},c.prototype._handleKeyboardClear=function(a,c,d){d.isOpen()||(c.which==b.DELETE||c.which==b.BACKSPACE)&&this._handleClear(c)},c.prototype.update=function(b,c){if(b.call(this,c),!(this.$selection.find(".select2-selection__placeholder").length>0||0===c.length)){var d=a('<span class="select2-selection__clear">&times;</span>');d.data("data",c),this.$selection.find(".select2-selection__rendered").prepend(d)}},c}),b.define("select2/selection/search",["jquery","../utils","../keys"],function(a,b,c){function d(a,b,c){a.call(this,b,c)}return d.prototype.render=function(b){var c=a('<li class="select2-search select2-search--inline"><input class="select2-search__field" type="search" tabindex="-1" autocomplete="off" autocorrect="off" autocapitalize="off" spellcheck="false" role="textbox" aria-autocomplete="list" /></li>');this.$searchContainer=c,this.$search=c.find("input");var d=b.call(this);return this._transferTabIndex(),d},d.prototype.bind=function(a,b,d){var e=this;a.call(this,b,d),b.on("open",function(){e.$search.trigger("focus")}),b.on("close",function(){e.$search.val(""),e.$search.removeAttr("aria-activedescendant"),e.$search.trigger("focus")}),b.on("enable",function(){e.$search.prop("disabled",!1),e._transferTabIndex()}),b.on("disable",function(){e.$search.prop("disabled",!0)}),b.on("focus",function(a){e.$search.trigger("focus")}),b.on("results:focus",function(a){e.$search.attr("aria-activedescendant",a.id)}),this.$selection.on("focusin",".select2-search--inline",function(a){e.trigger("focus",a)}),this.$selection.on("focusout",".select2-search--inline",function(a){e._handleBlur(a)}),this.$selection.on("keydown",".select2-search--inline",function(a){a.stopPropagation(),e.trigger("keypress",a),e._keyUpPrevented=a.isDefaultPrevented();var b=a.which;if(b===c.BACKSPACE&&""===e.$search.val()){var d=e.$searchContainer.prev(".select2-selection__choice");if(d.length>0){var f=d.data("data");e.searchRemoveChoice(f),a.preventDefault()}}});var f=document.documentMode,g=f&&11>=f;this.$selection.on("input.searchcheck",".select2-search--inline",function(a){return g?void e.$selection.off("input.search input.searchcheck"):void e.$selection.off("keyup.search")}),this.$selection.on("keyup.search input.search",".select2-search--inline",function(a){if(g&&"input"===a.type)return void e.$selection.off("input.search input.searchcheck");var b=a.which;b!=c.SHIFT&&b!=c.CTRL&&b!=c.ALT&&b!=c.TAB&&e.handleSearch(a)})},d.prototype._transferTabIndex=function(a){this.$search.attr("tabindex",this.$selection.attr("tabindex")),this.$selection.attr("tabindex","-1")},d.prototype.createPlaceholder=function(a,b){this.$search.attr("placeholder",b.text)},d.prototype.update=function(a,b){var c=this.$search[0]==document.activeElement;this.$search.attr("placeholder",""),a.call(this,b),this.$selection.find(".select2-selection__rendered").append(this.$searchContainer),this.resizeSearch(),c&&this.$search.focus()},d.prototype.handleSearch=function(){if(this.resizeSearch(),!this._keyUpPrevented){var a=this.$search.val();this.trigger("query",{term:a})}this._keyUpPrevented=!1},d.prototype.searchRemoveChoice=function(a,b){this.trigger("unselect",{data:b}),this.$search.val(b.text),this.handleSearch()},d.prototype.resizeSearch=function(){this.$search.css("width","25px");var a="";if(""!==this.$search.attr("placeholder"))a=this.$selection.find(".select2-selection__rendered").innerWidth();else{var b=this.$search.val().length+1;a=.75*b+"em"}this.$search.css("width",a)},d}),b.define("select2/selection/eventRelay",["jquery"],function(a){function b(){}return b.prototype.bind=function(b,c,d){var e=this,f=["open","opening","close","closing","select","selecting","unselect","unselecting"],g=["opening","closing","selecting","unselecting"];b.call(this,c,d),c.on("*",function(b,c){if(-1!==a.inArray(b,f)){c=c||{};var d=a.Event("select2:"+b,{params:c});e.$element.trigger(d),-1!==a.inArray(b,g)&&(c.prevented=d.isDefaultPrevented())}})},b}),b.define("select2/translation",["jquery","require"],function(a,b){function c(a){this.dict=a||{}}return c.prototype.all=function(){return this.dict},c.prototype.get=function(a){return this.dict[a]},c.prototype.extend=function(b){this.dict=a.extend({},b.all(),this.dict)},c._cache={},c.loadPath=function(a){if(!(a in c._cache)){var d=b(a);c._cache[a]=d}return new c(c._cache[a])},c}),b.define("select2/diacritics",[],function(){var a={"Ⓐ":"A","Ａ":"A","À":"A","Á":"A","Â":"A","Ầ":"A","Ấ":"A","Ẫ":"A","Ẩ":"A","Ã":"A","Ā":"A","Ă":"A","Ằ":"A","Ắ":"A","Ẵ":"A","Ẳ":"A","Ȧ":"A","Ǡ":"A","Ä":"A","Ǟ":"A","Ả":"A","Å":"A","Ǻ":"A","Ǎ":"A","Ȁ":"A","Ȃ":"A","Ạ":"A","Ậ":"A","Ặ":"A","Ḁ":"A","Ą":"A","Ⱥ":"A","Ɐ":"A","Ꜳ":"AA","Æ":"AE","Ǽ":"AE","Ǣ":"AE","Ꜵ":"AO","Ꜷ":"AU","Ꜹ":"AV","Ꜻ":"AV","Ꜽ":"AY","Ⓑ":"B","Ｂ":"B","Ḃ":"B","Ḅ":"B","Ḇ":"B","Ƀ":"B","Ƃ":"B","Ɓ":"B","Ⓒ":"C","Ｃ":"C","Ć":"C","Ĉ":"C","Ċ":"C","Č":"C","Ç":"C","Ḉ":"C","Ƈ":"C","Ȼ":"C","Ꜿ":"C","Ⓓ":"D","Ｄ":"D","Ḋ":"D","Ď":"D","Ḍ":"D","Ḑ":"D","Ḓ":"D","Ḏ":"D","Đ":"D","Ƌ":"D","Ɗ":"D","Ɖ":"D","Ꝺ":"D","Ǳ":"DZ","Ǆ":"DZ","ǲ":"Dz","ǅ":"Dz","Ⓔ":"E","Ｅ":"E","È":"E","É":"E","Ê":"E","Ề":"E","Ế":"E","Ễ":"E","Ể":"E","Ẽ":"E","Ē":"E","Ḕ":"E","Ḗ":"E","Ĕ":"E","Ė":"E","Ë":"E","Ẻ":"E","Ě":"E","Ȅ":"E","Ȇ":"E","Ẹ":"E","Ệ":"E","Ȩ":"E","Ḝ":"E","Ę":"E","Ḙ":"E","Ḛ":"E","Ɛ":"E","Ǝ":"E","Ⓕ":"F","Ｆ":"F","Ḟ":"F","Ƒ":"F","Ꝼ":"F","Ⓖ":"G","Ｇ":"G","Ǵ":"G","Ĝ":"G","Ḡ":"G","Ğ":"G","Ġ":"G","Ǧ":"G","Ģ":"G","Ǥ":"G","Ɠ":"G","Ꞡ":"G","Ᵹ":"G","Ꝿ":"G","Ⓗ":"H","Ｈ":"H","Ĥ":"H","Ḣ":"H","Ḧ":"H","Ȟ":"H","Ḥ":"H","Ḩ":"H","Ḫ":"H","Ħ":"H","Ⱨ":"H","Ⱶ":"H","Ɥ":"H","Ⓘ":"I","Ｉ":"I","Ì":"I","Í":"I","Î":"I","Ĩ":"I","Ī":"I","Ĭ":"I","İ":"I","Ï":"I","Ḯ":"I","Ỉ":"I","Ǐ":"I","Ȉ":"I","Ȋ":"I","Ị":"I","Į":"I","Ḭ":"I","Ɨ":"I","Ⓙ":"J","Ｊ":"J","Ĵ":"J","Ɉ":"J","Ⓚ":"K","Ｋ":"K","Ḱ":"K","Ǩ":"K","Ḳ":"K","Ķ":"K","Ḵ":"K","Ƙ":"K","Ⱪ":"K","Ꝁ":"K","Ꝃ":"K","Ꝅ":"K","Ꞣ":"K","Ⓛ":"L","Ｌ":"L","Ŀ":"L","Ĺ":"L","Ľ":"L","Ḷ":"L","Ḹ":"L","Ļ":"L","Ḽ":"L","Ḻ":"L","Ł":"L","Ƚ":"L","Ɫ":"L","Ⱡ":"L","Ꝉ":"L","Ꝇ":"L","Ꞁ":"L","Ǉ":"LJ","ǈ":"Lj","Ⓜ":"M","Ｍ":"M","Ḿ":"M","Ṁ":"M","Ṃ":"M","Ɱ":"M","Ɯ":"M","Ⓝ":"N","Ｎ":"N","Ǹ":"N","Ń":"N","Ñ":"N","Ṅ":"N","Ň":"N","Ṇ":"N","Ņ":"N","Ṋ":"N","Ṉ":"N","Ƞ":"N","Ɲ":"N","Ꞑ":"N","Ꞥ":"N","Ǌ":"NJ","ǋ":"Nj","Ⓞ":"O","Ｏ":"O","Ò":"O","Ó":"O","Ô":"O","Ồ":"O","Ố":"O","Ỗ":"O","Ổ":"O","Õ":"O","Ṍ":"O","Ȭ":"O","Ṏ":"O","Ō":"O","Ṑ":"O","Ṓ":"O","Ŏ":"O","Ȯ":"O","Ȱ":"O","Ö":"O","Ȫ":"O","Ỏ":"O","Ő":"O","Ǒ":"O","Ȍ":"O","Ȏ":"O","Ơ":"O","Ờ":"O","Ớ":"O","Ỡ":"O","Ở":"O","Ợ":"O","Ọ":"O","Ộ":"O","Ǫ":"O","Ǭ":"O","Ø":"O","Ǿ":"O","Ɔ":"O","Ɵ":"O","Ꝋ":"O","Ꝍ":"O","Ƣ":"OI","Ꝏ":"OO","Ȣ":"OU","Ⓟ":"P","Ｐ":"P","Ṕ":"P","Ṗ":"P","Ƥ":"P","Ᵽ":"P","Ꝑ":"P","Ꝓ":"P","Ꝕ":"P","Ⓠ":"Q","Ｑ":"Q","Ꝗ":"Q","Ꝙ":"Q","Ɋ":"Q","Ⓡ":"R","Ｒ":"R","Ŕ":"R","Ṙ":"R","Ř":"R","Ȑ":"R","Ȓ":"R","Ṛ":"R","Ṝ":"R","Ŗ":"R","Ṟ":"R","Ɍ":"R","Ɽ":"R","Ꝛ":"R","Ꞧ":"R","Ꞃ":"R","Ⓢ":"S","Ｓ":"S","ẞ":"S","Ś":"S","Ṥ":"S","Ŝ":"S","Ṡ":"S","Š":"S","Ṧ":"S","Ṣ":"S","Ṩ":"S","Ș":"S","Ş":"S","Ȿ":"S","Ꞩ":"S","Ꞅ":"S","Ⓣ":"T","Ｔ":"T","Ṫ":"T","Ť":"T","Ṭ":"T","Ț":"T","Ţ":"T","Ṱ":"T","Ṯ":"T","Ŧ":"T","Ƭ":"T","Ʈ":"T","Ⱦ":"T","Ꞇ":"T","Ꜩ":"TZ","Ⓤ":"U","Ｕ":"U","Ù":"U","Ú":"U","Û":"U","Ũ":"U","Ṹ":"U","Ū":"U","Ṻ":"U","Ŭ":"U","Ü":"U","Ǜ":"U","Ǘ":"U","Ǖ":"U","Ǚ":"U","Ủ":"U","Ů":"U","Ű":"U","Ǔ":"U","Ȕ":"U","Ȗ":"U","Ư":"U","Ừ":"U","Ứ":"U","Ữ":"U","Ử":"U","Ự":"U","Ụ":"U","Ṳ":"U","Ų":"U","Ṷ":"U","Ṵ":"U","Ʉ":"U","Ⓥ":"V","Ｖ":"V","Ṽ":"V","Ṿ":"V","Ʋ":"V","Ꝟ":"V","Ʌ":"V","Ꝡ":"VY","Ⓦ":"W","Ｗ":"W","Ẁ":"W","Ẃ":"W","Ŵ":"W","Ẇ":"W","Ẅ":"W","Ẉ":"W","Ⱳ":"W","Ⓧ":"X","Ｘ":"X","Ẋ":"X","Ẍ":"X","Ⓨ":"Y","Ｙ":"Y","Ỳ":"Y","Ý":"Y","Ŷ":"Y","Ỹ":"Y","Ȳ":"Y","Ẏ":"Y","Ÿ":"Y","Ỷ":"Y","Ỵ":"Y","Ƴ":"Y","Ɏ":"Y","Ỿ":"Y","Ⓩ":"Z","Ｚ":"Z","Ź":"Z","Ẑ":"Z","Ż":"Z","Ž":"Z","Ẓ":"Z","Ẕ":"Z","Ƶ":"Z","Ȥ":"Z","Ɀ":"Z","Ⱬ":"Z","Ꝣ":"Z","ⓐ":"a","ａ":"a","ẚ":"a","à":"a","á":"a","â":"a","ầ":"a","ấ":"a","ẫ":"a","ẩ":"a","ã":"a","ā":"a","ă":"a","ằ":"a","ắ":"a","ẵ":"a","ẳ":"a","ȧ":"a","ǡ":"a","ä":"a","ǟ":"a","ả":"a","å":"a","ǻ":"a","ǎ":"a","ȁ":"a","ȃ":"a","ạ":"a","ậ":"a","ặ":"a","ḁ":"a","ą":"a","ⱥ":"a","ɐ":"a","ꜳ":"aa","æ":"ae","ǽ":"ae","ǣ":"ae","ꜵ":"ao","ꜷ":"au","ꜹ":"av","ꜻ":"av","ꜽ":"ay","ⓑ":"b","ｂ":"b","ḃ":"b","ḅ":"b","ḇ":"b","ƀ":"b","ƃ":"b","ɓ":"b","ⓒ":"c","ｃ":"c","ć":"c","ĉ":"c","ċ":"c","č":"c","ç":"c","ḉ":"c","ƈ":"c","ȼ":"c","ꜿ":"c","ↄ":"c","ⓓ":"d","ｄ":"d","ḋ":"d","ď":"d","ḍ":"d","ḑ":"d","ḓ":"d","ḏ":"d","đ":"d","ƌ":"d","ɖ":"d","ɗ":"d","ꝺ":"d","ǳ":"dz","ǆ":"dz","ⓔ":"e","ｅ":"e","è":"e","é":"e","ê":"e","ề":"e","ế":"e","ễ":"e","ể":"e","ẽ":"e","ē":"e","ḕ":"e","ḗ":"e","ĕ":"e","ė":"e","ë":"e","ẻ":"e","ě":"e","ȅ":"e","ȇ":"e","ẹ":"e","ệ":"e","ȩ":"e","ḝ":"e","ę":"e","ḙ":"e","ḛ":"e","ɇ":"e","ɛ":"e","ǝ":"e","ⓕ":"f","ｆ":"f","ḟ":"f","ƒ":"f","ꝼ":"f","ⓖ":"g","ｇ":"g","ǵ":"g","ĝ":"g","ḡ":"g","ğ":"g","ġ":"g","ǧ":"g","ģ":"g","ǥ":"g","ɠ":"g","ꞡ":"g","ᵹ":"g","ꝿ":"g","ⓗ":"h","ｈ":"h","ĥ":"h","ḣ":"h","ḧ":"h","ȟ":"h","ḥ":"h","ḩ":"h","ḫ":"h","ẖ":"h","ħ":"h","ⱨ":"h","ⱶ":"h","ɥ":"h","ƕ":"hv","ⓘ":"i","ｉ":"i","ì":"i","í":"i","î":"i","ĩ":"i","ī":"i","ĭ":"i","ï":"i","ḯ":"i","ỉ":"i","ǐ":"i","ȉ":"i","ȋ":"i","ị":"i","į":"i","ḭ":"i","ɨ":"i","ı":"i","ⓙ":"j","ｊ":"j","ĵ":"j","ǰ":"j","ɉ":"j","ⓚ":"k","ｋ":"k","ḱ":"k","ǩ":"k","ḳ":"k","ķ":"k","ḵ":"k","ƙ":"k","ⱪ":"k","ꝁ":"k","ꝃ":"k","ꝅ":"k","ꞣ":"k","ⓛ":"l","ｌ":"l","ŀ":"l","ĺ":"l","ľ":"l","ḷ":"l","ḹ":"l","ļ":"l","ḽ":"l","ḻ":"l","ſ":"l","ł":"l","ƚ":"l","ɫ":"l","ⱡ":"l","ꝉ":"l","ꞁ":"l","ꝇ":"l","ǉ":"lj","ⓜ":"m","ｍ":"m","ḿ":"m","ṁ":"m","ṃ":"m","ɱ":"m","ɯ":"m","ⓝ":"n","ｎ":"n","ǹ":"n","ń":"n","ñ":"n","ṅ":"n","ň":"n","ṇ":"n","ņ":"n","ṋ":"n","ṉ":"n","ƞ":"n","ɲ":"n","ŉ":"n","ꞑ":"n","ꞥ":"n","ǌ":"nj","ⓞ":"o","ｏ":"o","ò":"o","ó":"o","ô":"o","ồ":"o","ố":"o","ỗ":"o","ổ":"o","õ":"o","ṍ":"o","ȭ":"o","ṏ":"o","ō":"o","ṑ":"o","ṓ":"o","ŏ":"o","ȯ":"o","ȱ":"o","ö":"o","ȫ":"o","ỏ":"o","ő":"o","ǒ":"o","ȍ":"o","ȏ":"o","ơ":"o","ờ":"o","ớ":"o","ỡ":"o","ở":"o","ợ":"o","ọ":"o","ộ":"o","ǫ":"o","ǭ":"o","ø":"o","ǿ":"o","ɔ":"o","ꝋ":"o","ꝍ":"o","ɵ":"o","ƣ":"oi","ȣ":"ou","ꝏ":"oo","ⓟ":"p","ｐ":"p","ṕ":"p","ṗ":"p","ƥ":"p","ᵽ":"p","ꝑ":"p","ꝓ":"p","ꝕ":"p","ⓠ":"q","ｑ":"q","ɋ":"q","ꝗ":"q","ꝙ":"q","ⓡ":"r","ｒ":"r","ŕ":"r","ṙ":"r","ř":"r","ȑ":"r","ȓ":"r","ṛ":"r","ṝ":"r","ŗ":"r","ṟ":"r","ɍ":"r","ɽ":"r","ꝛ":"r","ꞧ":"r","ꞃ":"r","ⓢ":"s","ｓ":"s","ß":"s","ś":"s","ṥ":"s","ŝ":"s","ṡ":"s","š":"s","ṧ":"s","ṣ":"s","ṩ":"s","ș":"s","ş":"s","ȿ":"s","ꞩ":"s","ꞅ":"s","ẛ":"s","ⓣ":"t","ｔ":"t","ṫ":"t","ẗ":"t","ť":"t","ṭ":"t","ț":"t","ţ":"t","ṱ":"t","ṯ":"t","ŧ":"t","ƭ":"t","ʈ":"t","ⱦ":"t","ꞇ":"t","ꜩ":"tz","ⓤ":"u","ｕ":"u","ù":"u","ú":"u","û":"u","ũ":"u","ṹ":"u","ū":"u","ṻ":"u","ŭ":"u","ü":"u","ǜ":"u","ǘ":"u","ǖ":"u","ǚ":"u","ủ":"u","ů":"u","ű":"u","ǔ":"u","ȕ":"u","ȗ":"u","ư":"u","ừ":"u","ứ":"u","ữ":"u","ử":"u","ự":"u","ụ":"u","ṳ":"u","ų":"u","ṷ":"u","ṵ":"u","ʉ":"u","ⓥ":"v","ｖ":"v","ṽ":"v","ṿ":"v","ʋ":"v","ꝟ":"v","ʌ":"v","ꝡ":"vy","ⓦ":"w","ｗ":"w","ẁ":"w","ẃ":"w","ŵ":"w","ẇ":"w","ẅ":"w","ẘ":"w","ẉ":"w","ⱳ":"w","ⓧ":"x","ｘ":"x","ẋ":"x","ẍ":"x","ⓨ":"y","ｙ":"y","ỳ":"y","ý":"y","ŷ":"y","ỹ":"y","ȳ":"y","ẏ":"y","ÿ":"y","ỷ":"y","ẙ":"y","ỵ":"y","ƴ":"y","ɏ":"y","ỿ":"y","ⓩ":"z","ｚ":"z","ź":"z","ẑ":"z","ż":"z","ž":"z","ẓ":"z","ẕ":"z","ƶ":"z","ȥ":"z","ɀ":"z","ⱬ":"z","ꝣ":"z","Ά":"Α","Έ":"Ε","Ή":"Η","Ί":"Ι","Ϊ":"Ι","Ό":"Ο","Ύ":"Υ","Ϋ":"Υ","Ώ":"Ω","ά":"α","έ":"ε","ή":"η","ί":"ι","ϊ":"ι","ΐ":"ι","ό":"ο","ύ":"υ","ϋ":"υ","ΰ":"υ","ω":"ω","ς":"σ"};return a}),b.define("select2/data/base",["../utils"],function(a){function b(a,c){b.__super__.constructor.call(this)}return a.Extend(b,a.Observable),b.prototype.current=function(a){throw new Error("The `current` method must be defined in child classes.")},b.prototype.query=function(a,b){throw new Error("The `query` method must be defined in child classes.")},b.prototype.bind=function(a,b){},b.prototype.destroy=function(){},b.prototype.generateResultId=function(b,c){var d=b.id+"-result-";return d+=a.generateChars(4),d+=null!=c.id?"-"+c.id.toString():"-"+a.generateChars(4)},b}),b.define("select2/data/select",["./base","../utils","jquery"],function(a,b,c){function d(a,b){this.$element=a,this.options=b,d.__super__.constructor.call(this)}return b.Extend(d,a),d.prototype.current=function(a){var b=[],d=this;this.$element.find(":selected").each(function(){var a=c(this),e=d.item(a);b.push(e)}),a(b)},d.prototype.select=function(a){
var b=this;if(a.selected=!0,c(a.element).is("option"))return a.element.selected=!0,void this.$element.trigger("change");if(this.$element.prop("multiple"))this.current(function(d){var e=[];a=[a],a.push.apply(a,d);for(var f=0;f<a.length;f++){var g=a[f].id;-1===c.inArray(g,e)&&e.push(g)}b.$element.val(e),b.$element.trigger("change")});else{var d=a.id;this.$element.val(d),this.$element.trigger("change")}},d.prototype.unselect=function(a){var b=this;if(this.$element.prop("multiple"))return a.selected=!1,c(a.element).is("option")?(a.element.selected=!1,void this.$element.trigger("change")):void this.current(function(d){for(var e=[],f=0;f<d.length;f++){var g=d[f].id;g!==a.id&&-1===c.inArray(g,e)&&e.push(g)}b.$element.val(e),b.$element.trigger("change")})},d.prototype.bind=function(a,b){var c=this;this.container=a,a.on("select",function(a){c.select(a.data)}),a.on("unselect",function(a){c.unselect(a.data)})},d.prototype.destroy=function(){this.$element.find("*").each(function(){c.removeData(this,"data")})},d.prototype.query=function(a,b){var d=[],e=this,f=this.$element.children();f.each(function(){var b=c(this);if(b.is("option")||b.is("optgroup")){var f=e.item(b),g=e.matches(a,f);null!==g&&d.push(g)}}),b({results:d})},d.prototype.addOptions=function(a){b.appendMany(this.$element,a)},d.prototype.option=function(a){var b;a.children?(b=document.createElement("optgroup"),b.label=a.text):(b=document.createElement("option"),void 0!==b.textContent?b.textContent=a.text:b.innerText=a.text),void 0!==a.id&&(b.value=a.id),a.disabled&&(b.disabled=!0),a.selected&&(b.selected=!0),a.title&&(b.title=a.title);var d=c(b),e=this._normalizeItem(a);return e.element=b,c.data(b,"data",e),d},d.prototype.item=function(a){var b={};if(b=c.data(a[0],"data"),null!=b)return b;if(a.is("option"))b={id:a.val(),text:a.text(),disabled:a.prop("disabled"),selected:a.prop("selected"),title:a.prop("title")};else if(a.is("optgroup")){b={text:a.prop("label"),children:[],title:a.prop("title")};for(var d=a.children("option"),e=[],f=0;f<d.length;f++){var g=c(d[f]),h=this.item(g);e.push(h)}b.children=e}return b=this._normalizeItem(b),b.element=a[0],c.data(a[0],"data",b),b},d.prototype._normalizeItem=function(a){c.isPlainObject(a)||(a={id:a,text:a}),a=c.extend({},{text:""},a);var b={selected:!1,disabled:!1};return null!=a.id&&(a.id=a.id.toString()),null!=a.text&&(a.text=a.text.toString()),null==a._resultId&&a.id&&null!=this.container&&(a._resultId=this.generateResultId(this.container,a)),c.extend({},b,a)},d.prototype.matches=function(a,b){var c=this.options.get("matcher");return c(a,b)},d}),b.define("select2/data/array",["./select","../utils","jquery"],function(a,b,c){function d(a,b){var c=b.get("data")||[];d.__super__.constructor.call(this,a,b),this.addOptions(this.convertToOptions(c))}return b.Extend(d,a),d.prototype.select=function(a){var b=this.$element.find("option").filter(function(b,c){return c.value==a.id.toString()});0===b.length&&(b=this.option(a),this.addOptions(b)),d.__super__.select.call(this,a)},d.prototype.convertToOptions=function(a){function d(a){return function(){return c(this).val()==a.id}}for(var e=this,f=this.$element.find("option"),g=f.map(function(){return e.item(c(this)).id}).get(),h=[],i=0;i<a.length;i++){var j=this._normalizeItem(a[i]);if(c.inArray(j.id,g)>=0){var k=f.filter(d(j)),l=this.item(k),m=c.extend(!0,{},j,l),n=this.option(m);k.replaceWith(n)}else{var o=this.option(j);if(j.children){var p=this.convertToOptions(j.children);b.appendMany(o,p)}h.push(o)}}return h},d}),b.define("select2/data/ajax",["./array","../utils","jquery"],function(a,b,c){function d(a,b){this.ajaxOptions=this._applyDefaults(b.get("ajax")),null!=this.ajaxOptions.processResults&&(this.processResults=this.ajaxOptions.processResults),d.__super__.constructor.call(this,a,b)}return b.Extend(d,a),d.prototype._applyDefaults=function(a){var b={data:function(a){return c.extend({},a,{q:a.term})},transport:function(a,b,d){var e=c.ajax(a);return e.then(b),e.fail(d),e}};return c.extend({},b,a,!0)},d.prototype.processResults=function(a){return a},d.prototype.query=function(a,b){function d(){var d=f.transport(f,function(d){var f=e.processResults(d,a);e.options.get("debug")&&window.console&&console.error&&(f&&f.results&&c.isArray(f.results)||console.error("Select2: The AJAX results did not return an array in the `results` key of the response.")),b(f)},function(){d.status&&"0"===d.status||e.trigger("results:message",{message:"errorLoading"})});e._request=d}var e=this;null!=this._request&&(c.isFunction(this._request.abort)&&this._request.abort(),this._request=null);var f=c.extend({type:"GET"},this.ajaxOptions);"function"==typeof f.url&&(f.url=f.url.call(this.$element,a)),"function"==typeof f.data&&(f.data=f.data.call(this.$element,a)),this.ajaxOptions.delay&&null!=a.term?(this._queryTimeout&&window.clearTimeout(this._queryTimeout),this._queryTimeout=window.setTimeout(d,this.ajaxOptions.delay)):d()},d}),b.define("select2/data/tags",["jquery"],function(a){function b(b,c,d){var e=d.get("tags"),f=d.get("createTag");void 0!==f&&(this.createTag=f);var g=d.get("insertTag");if(void 0!==g&&(this.insertTag=g),b.call(this,c,d),a.isArray(e))for(var h=0;h<e.length;h++){var i=e[h],j=this._normalizeItem(i),k=this.option(j);this.$element.append(k)}}return b.prototype.query=function(a,b,c){function d(a,f){for(var g=a.results,h=0;h<g.length;h++){var i=g[h],j=null!=i.children&&!d({results:i.children},!0),k=(i.text||"").toUpperCase(),l=(b.term||"").toUpperCase(),m=k===l;if(m||j)return f?!1:(a.data=g,void c(a))}if(f)return!0;var n=e.createTag(b);if(null!=n){var o=e.option(n);o.attr("data-select2-tag",!0),e.addOptions([o]),e.insertTag(g,n)}a.results=g,c(a)}var e=this;return this._removeOldTags(),null==b.term||null!=b.page?void a.call(this,b,c):void a.call(this,b,d)},b.prototype.createTag=function(b,c){var d=a.trim(c.term);return""===d?null:{id:d,text:d}},b.prototype.insertTag=function(a,b,c){b.unshift(c)},b.prototype._removeOldTags=function(b){var c=(this._lastTag,this.$element.find("option[data-select2-tag]"));c.each(function(){this.selected||a(this).remove()})},b}),b.define("select2/data/tokenizer",["jquery"],function(a){function b(a,b,c){var d=c.get("tokenizer");void 0!==d&&(this.tokenizer=d),a.call(this,b,c)}return b.prototype.bind=function(a,b,c){a.call(this,b,c),this.$search=b.dropdown.$search||b.selection.$search||c.find(".select2-search__field")},b.prototype.query=function(b,c,d){function e(b){var c=g._normalizeItem(b),d=g.$element.find("option").filter(function(){return a(this).val()===c.id});if(!d.length){var e=g.option(c);e.attr("data-select2-tag",!0),g._removeOldTags(),g.addOptions([e])}f(c)}function f(a){g.trigger("select",{data:a})}var g=this;c.term=c.term||"";var h=this.tokenizer(c,this.options,e);h.term!==c.term&&(this.$search.length&&(this.$search.val(h.term),this.$search.focus()),c.term=h.term),b.call(this,c,d)},b.prototype.tokenizer=function(b,c,d,e){for(var f=d.get("tokenSeparators")||[],g=c.term,h=0,i=this.createTag||function(a){return{id:a.term,text:a.term}};h<g.length;){var j=g[h];if(-1!==a.inArray(j,f)){var k=g.substr(0,h),l=a.extend({},c,{term:k}),m=i(l);null!=m?(e(m),g=g.substr(h+1)||"",h=0):h++}else h++}return{term:g}},b}),b.define("select2/data/minimumInputLength",[],function(){function a(a,b,c){this.minimumInputLength=c.get("minimumInputLength"),a.call(this,b,c)}return a.prototype.query=function(a,b,c){return b.term=b.term||"",b.term.length<this.minimumInputLength?void this.trigger("results:message",{message:"inputTooShort",args:{minimum:this.minimumInputLength,input:b.term,params:b}}):void a.call(this,b,c)},a}),b.define("select2/data/maximumInputLength",[],function(){function a(a,b,c){this.maximumInputLength=c.get("maximumInputLength"),a.call(this,b,c)}return a.prototype.query=function(a,b,c){return b.term=b.term||"",this.maximumInputLength>0&&b.term.length>this.maximumInputLength?void this.trigger("results:message",{message:"inputTooLong",args:{maximum:this.maximumInputLength,input:b.term,params:b}}):void a.call(this,b,c)},a}),b.define("select2/data/maximumSelectionLength",[],function(){function a(a,b,c){this.maximumSelectionLength=c.get("maximumSelectionLength"),a.call(this,b,c)}return a.prototype.query=function(a,b,c){var d=this;this.current(function(e){var f=null!=e?e.length:0;return d.maximumSelectionLength>0&&f>=d.maximumSelectionLength?void d.trigger("results:message",{message:"maximumSelected",args:{maximum:d.maximumSelectionLength}}):void a.call(d,b,c)})},a}),b.define("select2/dropdown",["jquery","./utils"],function(a,b){function c(a,b){this.$element=a,this.options=b,c.__super__.constructor.call(this)}return b.Extend(c,b.Observable),c.prototype.render=function(){var b=a('<span class="select2-dropdown"><span class="select2-results"></span></span>');return b.attr("dir",this.options.get("dir")),this.$dropdown=b,b},c.prototype.bind=function(){},c.prototype.position=function(a,b){},c.prototype.destroy=function(){this.$dropdown.remove()},c}),b.define("select2/dropdown/search",["jquery","../utils"],function(a,b){function c(){}return c.prototype.render=function(b){var c=b.call(this),d=a('<span class="select2-search select2-search--dropdown"><input class="select2-search__field" type="search" tabindex="-1" autocomplete="off" autocorrect="off" autocapitalize="off" spellcheck="false" role="textbox" /></span>');return this.$searchContainer=d,this.$search=d.find("input"),c.prepend(d),c},c.prototype.bind=function(b,c,d){var e=this;b.call(this,c,d),this.$search.on("keydown",function(a){e.trigger("keypress",a),e._keyUpPrevented=a.isDefaultPrevented()}),this.$search.on("input",function(b){a(this).off("keyup")}),this.$search.on("keyup input",function(a){e.handleSearch(a)}),c.on("open",function(){e.$search.attr("tabindex",0),e.$search.focus(),window.setTimeout(function(){e.$search.focus()},0)}),c.on("close",function(){e.$search.attr("tabindex",-1),e.$search.val("")}),c.on("focus",function(){c.isOpen()&&e.$search.focus()}),c.on("results:all",function(a){if(null==a.query.term||""===a.query.term){var b=e.showSearch(a);b?e.$searchContainer.removeClass("select2-search--hide"):e.$searchContainer.addClass("select2-search--hide")}})},c.prototype.handleSearch=function(a){if(!this._keyUpPrevented){var b=this.$search.val();this.trigger("query",{term:b})}this._keyUpPrevented=!1},c.prototype.showSearch=function(a,b){return!0},c}),b.define("select2/dropdown/hidePlaceholder",[],function(){function a(a,b,c,d){this.placeholder=this.normalizePlaceholder(c.get("placeholder")),a.call(this,b,c,d)}return a.prototype.append=function(a,b){b.results=this.removePlaceholder(b.results),a.call(this,b)},a.prototype.normalizePlaceholder=function(a,b){return"string"==typeof b&&(b={id:"",text:b}),b},a.prototype.removePlaceholder=function(a,b){for(var c=b.slice(0),d=b.length-1;d>=0;d--){var e=b[d];this.placeholder.id===e.id&&c.splice(d,1)}return c},a}),b.define("select2/dropdown/infiniteScroll",["jquery"],function(a){function b(a,b,c,d){this.lastParams={},a.call(this,b,c,d),this.$loadingMore=this.createLoadingMore(),this.loading=!1}return b.prototype.append=function(a,b){this.$loadingMore.remove(),this.loading=!1,a.call(this,b),this.showLoadingMore(b)&&this.$results.append(this.$loadingMore)},b.prototype.bind=function(b,c,d){var e=this;b.call(this,c,d),c.on("query",function(a){e.lastParams=a,e.loading=!0}),c.on("query:append",function(a){e.lastParams=a,e.loading=!0}),this.$results.on("scroll",function(){var b=a.contains(document.documentElement,e.$loadingMore[0]);if(!e.loading&&b){var c=e.$results.offset().top+e.$results.outerHeight(!1),d=e.$loadingMore.offset().top+e.$loadingMore.outerHeight(!1);c+50>=d&&e.loadMore()}})},b.prototype.loadMore=function(){this.loading=!0;var b=a.extend({},{page:1},this.lastParams);b.page++,this.trigger("query:append",b)},b.prototype.showLoadingMore=function(a,b){return b.pagination&&b.pagination.more},b.prototype.createLoadingMore=function(){var b=a('<li class="select2-results__option select2-results__option--load-more"role="treeitem" aria-disabled="true"></li>'),c=this.options.get("translations").get("loadingMore");return b.html(c(this.lastParams)),b},b}),b.define("select2/dropdown/attachBody",["jquery","../utils"],function(a,b){function c(b,c,d){this.$dropdownParent=d.get("dropdownParent")||a(document.body),b.call(this,c,d)}return c.prototype.bind=function(a,b,c){var d=this,e=!1;a.call(this,b,c),b.on("open",function(){d._showDropdown(),d._attachPositioningHandler(b),e||(e=!0,b.on("results:all",function(){d._positionDropdown(),d._resizeDropdown()}),b.on("results:append",function(){d._positionDropdown(),d._resizeDropdown()}))}),b.on("close",function(){d._hideDropdown(),d._detachPositioningHandler(b)}),this.$dropdownContainer.on("mousedown",function(a){a.stopPropagation()})},c.prototype.destroy=function(a){a.call(this),this.$dropdownContainer.remove()},c.prototype.position=function(a,b,c){b.attr("class",c.attr("class")),b.removeClass("select2"),b.addClass("select2-container--open"),b.css({position:"absolute",top:-999999}),this.$container=c},c.prototype.render=function(b){var c=a("<span></span>"),d=b.call(this);return c.append(d),this.$dropdownContainer=c,c},c.prototype._hideDropdown=function(a){this.$dropdownContainer.detach()},c.prototype._attachPositioningHandler=function(c,d){var e=this,f="scroll.select2."+d.id,g="resize.select2."+d.id,h="orientationchange.select2."+d.id,i=this.$container.parents().filter(b.hasScroll);i.each(function(){a(this).data("select2-scroll-position",{x:a(this).scrollLeft(),y:a(this).scrollTop()})}),i.on(f,function(b){var c=a(this).data("select2-scroll-position");a(this).scrollTop(c.y)}),a(window).on(f+" "+g+" "+h,function(a){e._positionDropdown(),e._resizeDropdown()})},c.prototype._detachPositioningHandler=function(c,d){var e="scroll.select2."+d.id,f="resize.select2."+d.id,g="orientationchange.select2."+d.id,h=this.$container.parents().filter(b.hasScroll);h.off(e),a(window).off(e+" "+f+" "+g)},c.prototype._positionDropdown=function(){var b=a(window),c=this.$dropdown.hasClass("select2-dropdown--above"),d=this.$dropdown.hasClass("select2-dropdown--below"),e=null,f=this.$container.offset();f.bottom=f.top+this.$container.outerHeight(!1);var g={height:this.$container.outerHeight(!1)};g.top=f.top,g.bottom=f.top+g.height;var h={height:this.$dropdown.outerHeight(!1)},i={top:b.scrollTop(),bottom:b.scrollTop()+b.height()},j=i.top<f.top-h.height,k=i.bottom>f.bottom+h.height,l={left:f.left,top:g.bottom},m=this.$dropdownParent;"static"===m.css("position")&&(m=m.offsetParent());var n=m.offset();l.top-=n.top,l.left-=n.left,c||d||(e="below"),k||!j||c?!j&&k&&c&&(e="below"):e="above",("above"==e||c&&"below"!==e)&&(l.top=g.top-n.top-h.height),null!=e&&(this.$dropdown.removeClass("select2-dropdown--below select2-dropdown--above").addClass("select2-dropdown--"+e),this.$container.removeClass("select2-container--below select2-container--above").addClass("select2-container--"+e)),this.$dropdownContainer.css(l)},c.prototype._resizeDropdown=function(){var a={width:this.$container.outerWidth(!1)+"px"};this.options.get("dropdownAutoWidth")&&(a.minWidth=a.width,a.position="relative",a.width="auto"),this.$dropdown.css(a)},c.prototype._showDropdown=function(a){this.$dropdownContainer.appendTo(this.$dropdownParent),this._positionDropdown(),this._resizeDropdown()},c}),b.define("select2/dropdown/minimumResultsForSearch",[],function(){function a(b){for(var c=0,d=0;d<b.length;d++){var e=b[d];e.children?c+=a(e.children):c++}return c}function b(a,b,c,d){this.minimumResultsForSearch=c.get("minimumResultsForSearch"),this.minimumResultsForSearch<0&&(this.minimumResultsForSearch=1/0),a.call(this,b,c,d)}return b.prototype.showSearch=function(b,c){return a(c.data.results)<this.minimumResultsForSearch?!1:b.call(this,c)},b}),b.define("select2/dropdown/selectOnClose",[],function(){function a(){}return a.prototype.bind=function(a,b,c){var d=this;a.call(this,b,c),b.on("close",function(a){d._handleSelectOnClose(a)})},a.prototype._handleSelectOnClose=function(a,b){if(b&&null!=b.originalSelect2Event){var c=b.originalSelect2Event;if("select"===c._type||"unselect"===c._type)return}var d=this.getHighlightedResults();if(!(d.length<1)){var e=d.data("data");null!=e.element&&e.element.selected||null==e.element&&e.selected||this.trigger("select",{data:e})}},a}),b.define("select2/dropdown/closeOnSelect",[],function(){function a(){}return a.prototype.bind=function(a,b,c){var d=this;a.call(this,b,c),b.on("select",function(a){d._selectTriggered(a)}),b.on("unselect",function(a){d._selectTriggered(a)})},a.prototype._selectTriggered=function(a,b){var c=b.originalEvent;c&&c.ctrlKey||this.trigger("close",{originalEvent:c,originalSelect2Event:b})},a}),b.define("select2/i18n/en",[],function(){return{errorLoading:function(){return"The results could not be loaded."},inputTooLong:function(a){var b=a.input.length-a.maximum,c="Please delete "+b+" character";return 1!=b&&(c+="s"),c},inputTooShort:function(a){var b=a.minimum-a.input.length,c="Please enter "+b+" or more characters";return c},loadingMore:function(){return"Loading more results…"},maximumSelected:function(a){var b="You can only select "+a.maximum+" item";return 1!=a.maximum&&(b+="s"),b},noResults:function(){return"No results found"},searching:function(){return"Searching…"}}}),b.define("select2/defaults",["jquery","require","./results","./selection/single","./selection/multiple","./selection/placeholder","./selection/allowClear","./selection/search","./selection/eventRelay","./utils","./translation","./diacritics","./data/select","./data/array","./data/ajax","./data/tags","./data/tokenizer","./data/minimumInputLength","./data/maximumInputLength","./data/maximumSelectionLength","./dropdown","./dropdown/search","./dropdown/hidePlaceholder","./dropdown/infiniteScroll","./dropdown/attachBody","./dropdown/minimumResultsForSearch","./dropdown/selectOnClose","./dropdown/closeOnSelect","./i18n/en"],function(a,b,c,d,e,f,g,h,i,j,k,l,m,n,o,p,q,r,s,t,u,v,w,x,y,z,A,B,C){function D(){this.reset()}D.prototype.apply=function(l){if(l=a.extend(!0,{},this.defaults,l),null==l.dataAdapter){if(null!=l.ajax?l.dataAdapter=o:null!=l.data?l.dataAdapter=n:l.dataAdapter=m,l.minimumInputLength>0&&(l.dataAdapter=j.Decorate(l.dataAdapter,r)),l.maximumInputLength>0&&(l.dataAdapter=j.Decorate(l.dataAdapter,s)),l.maximumSelectionLength>0&&(l.dataAdapter=j.Decorate(l.dataAdapter,t)),l.tags&&(l.dataAdapter=j.Decorate(l.dataAdapter,p)),(null!=l.tokenSeparators||null!=l.tokenizer)&&(l.dataAdapter=j.Decorate(l.dataAdapter,q)),null!=l.query){var C=b(l.amdBase+"compat/query");l.dataAdapter=j.Decorate(l.dataAdapter,C)}if(null!=l.initSelection){var D=b(l.amdBase+"compat/initSelection");l.dataAdapter=j.Decorate(l.dataAdapter,D)}}if(null==l.resultsAdapter&&(l.resultsAdapter=c,null!=l.ajax&&(l.resultsAdapter=j.Decorate(l.resultsAdapter,x)),null!=l.placeholder&&(l.resultsAdapter=j.Decorate(l.resultsAdapter,w)),l.selectOnClose&&(l.resultsAdapter=j.Decorate(l.resultsAdapter,A))),null==l.dropdownAdapter){if(l.multiple)l.dropdownAdapter=u;else{var E=j.Decorate(u,v);l.dropdownAdapter=E}if(0!==l.minimumResultsForSearch&&(l.dropdownAdapter=j.Decorate(l.dropdownAdapter,z)),l.closeOnSelect&&(l.dropdownAdapter=j.Decorate(l.dropdownAdapter,B)),null!=l.dropdownCssClass||null!=l.dropdownCss||null!=l.adaptDropdownCssClass){var F=b(l.amdBase+"compat/dropdownCss");l.dropdownAdapter=j.Decorate(l.dropdownAdapter,F)}l.dropdownAdapter=j.Decorate(l.dropdownAdapter,y)}if(null==l.selectionAdapter){if(l.multiple?l.selectionAdapter=e:l.selectionAdapter=d,null!=l.placeholder&&(l.selectionAdapter=j.Decorate(l.selectionAdapter,f)),l.allowClear&&(l.selectionAdapter=j.Decorate(l.selectionAdapter,g)),l.multiple&&(l.selectionAdapter=j.Decorate(l.selectionAdapter,h)),null!=l.containerCssClass||null!=l.containerCss||null!=l.adaptContainerCssClass){var G=b(l.amdBase+"compat/containerCss");l.selectionAdapter=j.Decorate(l.selectionAdapter,G)}l.selectionAdapter=j.Decorate(l.selectionAdapter,i)}if("string"==typeof l.language)if(l.language.indexOf("-")>0){var H=l.language.split("-"),I=H[0];l.language=[l.language,I]}else l.language=[l.language];if(a.isArray(l.language)){var J=new k;l.language.push("en");for(var K=l.language,L=0;L<K.length;L++){var M=K[L],N={};try{N=k.loadPath(M)}catch(O){try{M=this.defaults.amdLanguageBase+M,N=k.loadPath(M)}catch(P){l.debug&&window.console&&console.warn&&console.warn('Select2: The language file for "'+M+'" could not be automatically loaded. A fallback will be used instead.');continue}}J.extend(N)}l.translations=J}else{var Q=k.loadPath(this.defaults.amdLanguageBase+"en"),R=new k(l.language);R.extend(Q),l.translations=R}return l},D.prototype.reset=function(){function b(a){function b(a){return l[a]||a}return a.replace(/[^\u0000-\u007E]/g,b)}function c(d,e){if(""===a.trim(d.term))return e;if(e.children&&e.children.length>0){for(var f=a.extend(!0,{},e),g=e.children.length-1;g>=0;g--){var h=e.children[g],i=c(d,h);null==i&&f.children.splice(g,1)}return f.children.length>0?f:c(d,f)}var j=b(e.text).toUpperCase(),k=b(d.term).toUpperCase();return j.indexOf(k)>-1?e:null}this.defaults={amdBase:"./",amdLanguageBase:"./i18n/",closeOnSelect:!0,debug:!1,dropdownAutoWidth:!1,escapeMarkup:j.escapeMarkup,language:C,matcher:c,minimumInputLength:0,maximumInputLength:0,maximumSelectionLength:0,minimumResultsForSearch:0,selectOnClose:!1,sorter:function(a){return a},templateResult:function(a){return a.text},templateSelection:function(a){return a.text},theme:"default",width:"resolve"}},D.prototype.set=function(b,c){var d=a.camelCase(b),e={};e[d]=c;var f=j._convertData(e);a.extend(this.defaults,f)};var E=new D;return E}),b.define("select2/options",["require","jquery","./defaults","./utils"],function(a,b,c,d){function e(b,e){if(this.options=b,null!=e&&this.fromElement(e),this.options=c.apply(this.options),e&&e.is("input")){var f=a(this.get("amdBase")+"compat/inputData");this.options.dataAdapter=d.Decorate(this.options.dataAdapter,f)}}return e.prototype.fromElement=function(a){var c=["select2"];null==this.options.multiple&&(this.options.multiple=a.prop("multiple")),null==this.options.disabled&&(this.options.disabled=a.prop("disabled")),null==this.options.language&&(a.prop("lang")?this.options.language=a.prop("lang").toLowerCase():a.closest("[lang]").prop("lang")&&(this.options.language=a.closest("[lang]").prop("lang"))),null==this.options.dir&&(a.prop("dir")?this.options.dir=a.prop("dir"):a.closest("[dir]").prop("dir")?this.options.dir=a.closest("[dir]").prop("dir"):this.options.dir="ltr"),a.prop("disabled",this.options.disabled),a.prop("multiple",this.options.multiple),a.data("select2Tags")&&(this.options.debug&&window.console&&console.warn&&console.warn('Select2: The `data-select2-tags` attribute has been changed to use the `data-data` and `data-tags="true"` attributes and will be removed in future versions of Select2.'),a.data("data",a.data("select2Tags")),a.data("tags",!0)),a.data("ajaxUrl")&&(this.options.debug&&window.console&&console.warn&&console.warn("Select2: The `data-ajax-url` attribute has been changed to `data-ajax--url` and support for the old attribute will be removed in future versions of Select2."),a.attr("ajax--url",a.data("ajaxUrl")),a.data("ajax--url",a.data("ajaxUrl")));var e={};e=b.fn.jquery&&"1."==b.fn.jquery.substr(0,2)&&a[0].dataset?b.extend(!0,{},a[0].dataset,a.data()):a.data();var f=b.extend(!0,{},e);f=d._convertData(f);for(var g in f)b.inArray(g,c)>-1||(b.isPlainObject(this.options[g])?b.extend(this.options[g],f[g]):this.options[g]=f[g]);return this},e.prototype.get=function(a){return this.options[a]},e.prototype.set=function(a,b){this.options[a]=b},e}),b.define("select2/core",["jquery","./options","./utils","./keys"],function(a,b,c,d){var e=function(a,c){null!=a.data("select2")&&a.data("select2").destroy(),this.$element=a,this.id=this._generateId(a),c=c||{},this.options=new b(c,a),e.__super__.constructor.call(this);var d=a.attr("tabindex")||0;a.data("old-tabindex",d),a.attr("tabindex","-1");var f=this.options.get("dataAdapter");this.dataAdapter=new f(a,this.options);var g=this.render();this._placeContainer(g);var h=this.options.get("selectionAdapter");this.selection=new h(a,this.options),this.$selection=this.selection.render(),this.selection.position(this.$selection,g);var i=this.options.get("dropdownAdapter");this.dropdown=new i(a,this.options),this.$dropdown=this.dropdown.render(),this.dropdown.position(this.$dropdown,g);var j=this.options.get("resultsAdapter");this.results=new j(a,this.options,this.dataAdapter),this.$results=this.results.render(),this.results.position(this.$results,this.$dropdown);var k=this;this._bindAdapters(),this._registerDomEvents(),this._registerDataEvents(),this._registerSelectionEvents(),this._registerDropdownEvents(),this._registerResultsEvents(),this._registerEvents(),this.dataAdapter.current(function(a){k.trigger("selection:update",{data:a})}),a.addClass("select2-hidden-accessible"),a.attr("aria-hidden","true"),this._syncAttributes(),a.data("select2",this)};return c.Extend(e,c.Observable),e.prototype._generateId=function(a){var b="";return b=null!=a.attr("id")?a.attr("id"):null!=a.attr("name")?a.attr("name")+"-"+c.generateChars(2):c.generateChars(4),b=b.replace(/(:|\.|\[|\]|,)/g,""),b="select2-"+b},e.prototype._placeContainer=function(a){a.insertAfter(this.$element);var b=this._resolveWidth(this.$element,this.options.get("width"));null!=b&&a.css("width",b)},e.prototype._resolveWidth=function(a,b){var c=/^width:(([-+]?([0-9]*\.)?[0-9]+)(px|em|ex|%|in|cm|mm|pt|pc))/i;if("resolve"==b){var d=this._resolveWidth(a,"style");return null!=d?d:this._resolveWidth(a,"element")}if("element"==b){var e=a.outerWidth(!1);return 0>=e?"auto":e+"px"}if("style"==b){var f=a.attr("style");if("string"!=typeof f)return null;for(var g=f.split(";"),h=0,i=g.length;i>h;h+=1){var j=g[h].replace(/\s/g,""),k=j.match(c);if(null!==k&&k.length>=1)return k[1]}return null}return b},e.prototype._bindAdapters=function(){this.dataAdapter.bind(this,this.$container),this.selection.bind(this,this.$container),this.dropdown.bind(this,this.$container),this.results.bind(this,this.$container)},e.prototype._registerDomEvents=function(){var b=this;this.$element.on("change.select2",function(){b.dataAdapter.current(function(a){b.trigger("selection:update",{data:a})})}),this.$element.on("focus.select2",function(a){b.trigger("focus",a)}),this._syncA=c.bind(this._syncAttributes,this),this._syncS=c.bind(this._syncSubtree,this),this.$element[0].attachEvent&&this.$element[0].attachEvent("onpropertychange",this._syncA);var d=window.MutationObserver||window.WebKitMutationObserver||window.MozMutationObserver;null!=d?(this._observer=new d(function(c){a.each(c,b._syncA),a.each(c,b._syncS)}),this._observer.observe(this.$element[0],{attributes:!0,childList:!0,subtree:!1})):this.$element[0].addEventListener&&(this.$element[0].addEventListener("DOMAttrModified",b._syncA,!1),this.$element[0].addEventListener("DOMNodeInserted",b._syncS,!1),this.$element[0].addEventListener("DOMNodeRemoved",b._syncS,!1))},e.prototype._registerDataEvents=function(){var a=this;this.dataAdapter.on("*",function(b,c){a.trigger(b,c)})},e.prototype._registerSelectionEvents=function(){var b=this,c=["toggle","focus"];this.selection.on("toggle",function(){b.toggleDropdown()}),this.selection.on("focus",function(a){b.focus(a)}),this.selection.on("*",function(d,e){-1===a.inArray(d,c)&&b.trigger(d,e)})},e.prototype._registerDropdownEvents=function(){var a=this;this.dropdown.on("*",function(b,c){a.trigger(b,c)})},e.prototype._registerResultsEvents=function(){var a=this;this.results.on("*",function(b,c){a.trigger(b,c)})},e.prototype._registerEvents=function(){var a=this;this.on("open",function(){a.$container.addClass("select2-container--open")}),this.on("close",function(){a.$container.removeClass("select2-container--open")}),this.on("enable",function(){a.$container.removeClass("select2-container--disabled")}),this.on("disable",function(){a.$container.addClass("select2-container--disabled")}),this.on("blur",function(){a.$container.removeClass("select2-container--focus")}),this.on("query",function(b){a.isOpen()||a.trigger("open",{}),this.dataAdapter.query(b,function(c){a.trigger("results:all",{data:c,query:b})})}),this.on("query:append",function(b){this.dataAdapter.query(b,function(c){a.trigger("results:append",{data:c,query:b})})}),this.on("keypress",function(b){var c=b.which;a.isOpen()?c===d.ESC||c===d.TAB||c===d.UP&&b.altKey?(a.close(),b.preventDefault()):c===d.ENTER?(a.trigger("results:select",{}),b.preventDefault()):c===d.SPACE&&b.ctrlKey?(a.trigger("results:toggle",{}),b.preventDefault()):c===d.UP?(a.trigger("results:previous",{}),b.preventDefault()):c===d.DOWN&&(a.trigger("results:next",{}),b.preventDefault()):(c===d.ENTER||c===d.SPACE||c===d.DOWN&&b.altKey)&&(a.open(),b.preventDefault())})},e.prototype._syncAttributes=function(){this.options.set("disabled",this.$element.prop("disabled")),this.options.get("disabled")?(this.isOpen()&&this.close(),this.trigger("disable",{})):this.trigger("enable",{})},e.prototype._syncSubtree=function(a,b){var c=!1,d=this;if(!a||!a.target||"OPTION"===a.target.nodeName||"OPTGROUP"===a.target.nodeName){if(b)if(b.addedNodes&&b.addedNodes.length>0)for(var e=0;e<b.addedNodes.length;e++){var f=b.addedNodes[e];f.selected&&(c=!0)}else b.removedNodes&&b.removedNodes.length>0&&(c=!0);else c=!0;c&&this.dataAdapter.current(function(a){d.trigger("selection:update",{data:a})})}},e.prototype.trigger=function(a,b){var c=e.__super__.trigger,d={open:"opening",close:"closing",select:"selecting",unselect:"unselecting"};if(void 0===b&&(b={}),a in d){var f=d[a],g={prevented:!1,name:a,args:b};if(c.call(this,f,g),g.prevented)return void(b.prevented=!0)}c.call(this,a,b)},e.prototype.toggleDropdown=function(){this.options.get("disabled")||(this.isOpen()?this.close():this.open())},e.prototype.open=function(){this.isOpen()||this.trigger("query",{})},e.prototype.close=function(){this.isOpen()&&this.trigger("close",{})},e.prototype.isOpen=function(){return this.$container.hasClass("select2-container--open")},e.prototype.hasFocus=function(){return this.$container.hasClass("select2-container--focus")},e.prototype.focus=function(a){this.hasFocus()||(this.$container.addClass("select2-container--focus"),this.trigger("focus",{}))},e.prototype.enable=function(a){this.options.get("debug")&&window.console&&console.warn&&console.warn('Select2: The `select2("enable")` method has been deprecated and will be removed in later Select2 versions. Use $element.prop("disabled") instead.'),(null==a||0===a.length)&&(a=[!0]);var b=!a[0];this.$element.prop("disabled",b)},e.prototype.data=function(){this.options.get("debug")&&arguments.length>0&&window.console&&console.warn&&console.warn('Select2: Data can no longer be set using `select2("data")`. You should consider setting the value instead using `$element.val()`.');var a=[];return this.dataAdapter.current(function(b){a=b}),a},e.prototype.val=function(b){if(this.options.get("debug")&&window.console&&console.warn&&console.warn('Select2: The `select2("val")` method has been deprecated and will be removed in later Select2 versions. Use $element.val() instead.'),null==b||0===b.length)return this.$element.val();var c=b[0];a.isArray(c)&&(c=a.map(c,function(a){return a.toString()})),this.$element.val(c).trigger("change")},e.prototype.destroy=function(){this.$container.remove(),this.$element[0].detachEvent&&this.$element[0].detachEvent("onpropertychange",this._syncA),null!=this._observer?(this._observer.disconnect(),this._observer=null):this.$element[0].removeEventListener&&(this.$element[0].removeEventListener("DOMAttrModified",this._syncA,!1),this.$element[0].removeEventListener("DOMNodeInserted",this._syncS,!1),this.$element[0].removeEventListener("DOMNodeRemoved",this._syncS,!1)),this._syncA=null,this._syncS=null,this.$element.off(".select2"),this.$element.attr("tabindex",this.$element.data("old-tabindex")),this.$element.removeClass("select2-hidden-accessible"),this.$element.attr("aria-hidden","false"),this.$element.removeData("select2"),
this.dataAdapter.destroy(),this.selection.destroy(),this.dropdown.destroy(),this.results.destroy(),this.dataAdapter=null,this.selection=null,this.dropdown=null,this.results=null},e.prototype.render=function(){var b=a('<span class="select2 select2-container"><span class="selection"></span><span class="dropdown-wrapper" aria-hidden="true"></span></span>');return b.attr("dir",this.options.get("dir")),this.$container=b,this.$container.addClass("select2-container--"+this.options.get("theme")),b.data("element",this.$element),b},e}),b.define("jquery-mousewheel",["jquery"],function(a){return a}),b.define("jquery.select2",["jquery","jquery-mousewheel","./select2/core","./select2/defaults"],function(a,b,c,d){if(null==a.fn.select2){var e=["open","close","destroy"];a.fn.select2=function(b){if(b=b||{},"object"==typeof b)return this.each(function(){var d=a.extend(!0,{},b);new c(a(this),d)}),this;if("string"==typeof b){var d,f=Array.prototype.slice.call(arguments,1);return this.each(function(){var c=a(this).data("select2");null==c&&window.console&&console.error&&console.error("The select2('"+b+"') method was called on an element that is not using Select2."),d=c[b].apply(c,f)}),a.inArray(b,e)>-1?this:d}throw new Error("Invalid arguments for Select2: "+b)}}return null==a.fn.select2.defaults&&(a.fn.select2.defaults=d),c}),{define:b.define,require:b.require}}(),c=b.require("jquery.select2");return a.fn.select2.amd=b,c});


$(document).ready(function() {
	$('#FilterBy, #SortBy, #tag-filter').select2({minimumResultsForSearch: -1,  width: '200px'});
	$('.single-option-selector').select2({minimumResultsForSearch: -1, width: '300px'});
	// bind change event to select
	$('#tag-filter').bind('change',function(){
	  var url = $(this).val(); // get selected value
	  window.location = url; // redirect
	});
	//sticky header
	$(window).on('scroll', function () {
		var scroll = $(window).scrollTop();
		if (scroll >= 100) {
		    $('.site-header').removeClass('clearHeader').addClass('solidHeader');
		} 
		if (scroll == 0) {
		    $('.site-header').removeClass('solidHeader').addClass('clearHeader');
		}
	});
	//autoplay slideshow
	setInterval(function(){
	if($('.slideshow__nav-dot--active').is(':last-child')){
	    $('.slideshow__nav-dot:first-child').click();
	}
	else {
	    $('.slideshow__nav-dot--active').next().click();
	}
	},5000);  
});

$(document).ready(function() {
  var sections = new slate.Sections();
  sections.register('product', theme.Product);

  // Common a11y fixes
  slate.a11y.pageLinkFocus($(window.location.hash));

  $('.in-page-link').on('click', function(evt) {
    slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
  });

  // Wrap videos in div to force responsive layout.
  slate.rte.wrapTable();
  slate.rte.iframeReset();

  // Apply a specific class to the html element for browser support of cookies.
  if (slate.cart.cookiesEnabled()) {
    document.documentElement.className = document.documentElement.className.replace('supports-no-cookies', 'supports-cookies');
  }
});
